import * as pe from "react";
import ke, { createContext as fr, useMemo as ze, createElement as E, useContext as Yo, useRef as U, useEffect as te, useLayoutEffect as qo, useCallback as Q, forwardRef as q, Children as fn, isValidElement as pr, cloneElement as Mr, Fragment as Xo, useState as ue, useReducer as Jo, Component as vd } from "react";
import * as bd from "react-dom";
import Us, { flushSync as Zo } from "react-dom";
import { UserProfile01 as yd, HelpCircleContained as xd, ChevronRight as wd, X03 as _d, ArrowRight as $d, CopyLeft as Ks, CheckContained as Cd, LinkExternal as Ed } from "./icons-16.js";
import { UserProfile01 as Id, Check as Ws, Dash as Sd, ChevronRight as Od, Search01 as Nd, ChevronDown as zs, CopyLeft as Td, CheckContained as Rd, ChevronUp as Pd, X03 as Ad } from "./icons-20.js";
import { UserProfile01 as Wn, Check as Md, Dash as Dd, X03 as kd, ChevronRight as Ld, ArrowRight as Qo, ChevronDown as jd } from "./icons-24.js";
import { motion as gr } from "framer-motion";
import { g as Ln, a as Fd, s as rr } from "./screens-90a4c33b.js";
var bo = { exports: {} }, rn = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Jr, ya;
function ei() {
  if (ya)
    return Jr;
  ya = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var c = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (c.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Jr = i() ? Object.assign : function(o, s) {
    for (var a, c = r(o), u, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var l in a)
        t.call(a, l) && (c[l] = a[l]);
      if (e) {
        u = e(a);
        for (var f = 0; f < u.length; f++)
          n.call(a, u[f]) && (c[u[f]] = a[u[f]]);
      }
    }
    return c;
  }, Jr;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xa;
function Bd() {
  if (xa)
    return rn;
  xa = 1, ei();
  var e = ke, t = 60103;
  if (rn.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), rn.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, c, u) {
    var d, l = {}, f = null, p = null;
    u !== void 0 && (f = "" + u), c.key !== void 0 && (f = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (d in c)
      i.call(c, d) && !o.hasOwnProperty(d) && (l[d] = c[d]);
    if (a && a.defaultProps)
      for (d in c = a.defaultProps, c)
        l[d] === void 0 && (l[d] = c[d]);
    return { $$typeof: t, type: a, key: f, ref: p, props: l, _owner: r.current };
  }
  return rn.jsx = s, rn.jsxs = s, rn;
}
var Zr = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wa;
function Hd() {
  return wa || (wa = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = ke, n = ei(), r = 60103, i = 60106;
      e.Fragment = 60107;
      var o = 60108, s = 60114, a = 60109, c = 60110, u = 60112, d = 60113, l = 60120, f = 60115, p = 60116, m = 60121, v = 60122, _ = 60117, $ = 60129, h = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var b = Symbol.for;
        r = b("react.element"), i = b("react.portal"), e.Fragment = b("react.fragment"), o = b("react.strict_mode"), s = b("react.profiler"), a = b("react.provider"), c = b("react.context"), u = b("react.forward_ref"), d = b("react.suspense"), l = b("react.suspense_list"), f = b("react.memo"), p = b("react.lazy"), m = b("react.block"), v = b("react.server.block"), _ = b("react.fundamental"), b("react.scope"), b("react.opaque.id"), $ = b("react.debug_trace_mode"), b("react.offscreen"), h = b("react.legacy_hidden");
      }
      var w = typeof Symbol == "function" && Symbol.iterator, x = "@@iterator";
      function T(C) {
        if (C === null || typeof C != "object")
          return null;
        var G = w && C[w] || C[x];
        return typeof G == "function" ? G : null;
      }
      var I = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function k(C) {
        {
          for (var G = arguments.length, ae = new Array(G > 1 ? G - 1 : 0), ge = 1; ge < G; ge++)
            ae[ge - 1] = arguments[ge];
          B("error", C, ae);
        }
      }
      function B(C, G, ae) {
        {
          var ge = I.ReactDebugCurrentFrame, Ae = ge.getStackAddendum();
          Ae !== "" && (G += "%s", ae = ae.concat([Ae]));
          var Me = ae.map(function(_e) {
            return "" + _e;
          });
          Me.unshift("Warning: " + G), Function.prototype.apply.call(console[C], console, Me);
        }
      }
      var V = !1;
      function z(C) {
        return !!(typeof C == "string" || typeof C == "function" || C === e.Fragment || C === s || C === $ || C === o || C === d || C === l || C === h || V || typeof C == "object" && C !== null && (C.$$typeof === p || C.$$typeof === f || C.$$typeof === a || C.$$typeof === c || C.$$typeof === u || C.$$typeof === _ || C.$$typeof === m || C[0] === v));
      }
      function ne(C, G, ae) {
        var ge = G.displayName || G.name || "";
        return C.displayName || (ge !== "" ? ae + "(" + ge + ")" : ae);
      }
      function oe(C) {
        return C.displayName || "Context";
      }
      function D(C) {
        if (C == null)
          return null;
        if (typeof C.tag == "number" && k("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof C == "function")
          return C.displayName || C.name || null;
        if (typeof C == "string")
          return C;
        switch (C) {
          case e.Fragment:
            return "Fragment";
          case i:
            return "Portal";
          case s:
            return "Profiler";
          case o:
            return "StrictMode";
          case d:
            return "Suspense";
          case l:
            return "SuspenseList";
        }
        if (typeof C == "object")
          switch (C.$$typeof) {
            case c:
              var G = C;
              return oe(G) + ".Consumer";
            case a:
              var ae = C;
              return oe(ae._context) + ".Provider";
            case u:
              return ne(C, C.render, "ForwardRef");
            case f:
              return D(C.type);
            case m:
              return D(C._render);
            case p: {
              var ge = C, Ae = ge._payload, Me = ge._init;
              try {
                return D(Me(Ae));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var j = 0, J, S, Y, X, A, F, ie;
      function N() {
      }
      N.__reactDisabledLog = !0;
      function R() {
        {
          if (j === 0) {
            J = console.log, S = console.info, Y = console.warn, X = console.error, A = console.group, F = console.groupCollapsed, ie = console.groupEnd;
            var C = {
              configurable: !0,
              enumerable: !0,
              value: N,
              writable: !0
            };
            Object.defineProperties(console, {
              info: C,
              log: C,
              warn: C,
              error: C,
              group: C,
              groupCollapsed: C,
              groupEnd: C
            });
          }
          j++;
        }
      }
      function P() {
        {
          if (j--, j === 0) {
            var C = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: n({}, C, {
                value: J
              }),
              info: n({}, C, {
                value: S
              }),
              warn: n({}, C, {
                value: Y
              }),
              error: n({}, C, {
                value: X
              }),
              group: n({}, C, {
                value: A
              }),
              groupCollapsed: n({}, C, {
                value: F
              }),
              groupEnd: n({}, C, {
                value: ie
              })
            });
          }
          j < 0 && k("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var O = I.ReactCurrentDispatcher, L;
      function W(C, G, ae) {
        {
          if (L === void 0)
            try {
              throw Error();
            } catch (Ae) {
              var ge = Ae.stack.trim().match(/\n( *(at )?)/);
              L = ge && ge[1] || "";
            }
          return `
` + L + C;
        }
      }
      var Z = !1, re;
      {
        var fe = typeof WeakMap == "function" ? WeakMap : Map;
        re = new fe();
      }
      function H(C, G) {
        if (!C || Z)
          return "";
        {
          var ae = re.get(C);
          if (ae !== void 0)
            return ae;
        }
        var ge;
        Z = !0;
        var Ae = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Me;
        Me = O.current, O.current = null, R();
        try {
          if (G) {
            var _e = function() {
              throw Error();
            };
            if (Object.defineProperty(_e.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(_e, []);
              } catch (Ct) {
                ge = Ct;
              }
              Reflect.construct(C, [], _e);
            } else {
              try {
                _e.call();
              } catch (Ct) {
                ge = Ct;
              }
              C.call(_e.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (Ct) {
              ge = Ct;
            }
            C();
          }
        } catch (Ct) {
          if (Ct && ge && typeof Ct.stack == "string") {
            for (var xe = Ct.stack.split(`
`), Je = ge.stack.split(`
`), Fe = xe.length - 1, He = Je.length - 1; Fe >= 1 && He >= 0 && xe[Fe] !== Je[He]; )
              He--;
            for (; Fe >= 1 && He >= 0; Fe--, He--)
              if (xe[Fe] !== Je[He]) {
                if (Fe !== 1 || He !== 1)
                  do
                    if (Fe--, He--, He < 0 || xe[Fe] !== Je[He]) {
                      var $t = `
` + xe[Fe].replace(" at new ", " at ");
                      return typeof C == "function" && re.set(C, $t), $t;
                    }
                  while (Fe >= 1 && He >= 0);
                break;
              }
          }
        } finally {
          Z = !1, O.current = Me, P(), Error.prepareStackTrace = Ae;
        }
        var nn = C ? C.displayName || C.name : "", ba = nn ? W(nn) : "";
        return typeof C == "function" && re.set(C, ba), ba;
      }
      function ve(C, G, ae) {
        return H(C, !1);
      }
      function ee(C) {
        var G = C.prototype;
        return !!(G && G.isReactComponent);
      }
      function be(C, G, ae) {
        if (C == null)
          return "";
        if (typeof C == "function")
          return H(C, ee(C));
        if (typeof C == "string")
          return W(C);
        switch (C) {
          case d:
            return W("Suspense");
          case l:
            return W("SuspenseList");
        }
        if (typeof C == "object")
          switch (C.$$typeof) {
            case u:
              return ve(C.render);
            case f:
              return be(C.type, G, ae);
            case m:
              return ve(C._render);
            case p: {
              var ge = C, Ae = ge._payload, Me = ge._init;
              try {
                return be(Me(Ae), G, ae);
              } catch {
              }
            }
          }
        return "";
      }
      var Te = {}, Ne = I.ReactDebugCurrentFrame;
      function Le(C) {
        if (C) {
          var G = C._owner, ae = be(C.type, C._source, G ? G.type : null);
          Ne.setExtraStackFrame(ae);
        } else
          Ne.setExtraStackFrame(null);
      }
      function je(C, G, ae, ge, Ae) {
        {
          var Me = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var _e in C)
            if (Me(C, _e)) {
              var xe = void 0;
              try {
                if (typeof C[_e] != "function") {
                  var Je = Error((ge || "React class") + ": " + ae + " type `" + _e + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof C[_e] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Je.name = "Invariant Violation", Je;
                }
                xe = C[_e](G, _e, ge, ae, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Fe) {
                xe = Fe;
              }
              xe && !(xe instanceof Error) && (Le(Ae), k("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ge || "React class", ae, _e, typeof xe), Le(null)), xe instanceof Error && !(xe.message in Te) && (Te[xe.message] = !0, Le(Ae), k("Failed %s type: %s", ae, xe.message), Le(null));
            }
        }
      }
      var Ue = I.ReactCurrentOwner, Pe = Object.prototype.hasOwnProperty, de = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Ke, we, ye;
      ye = {};
      function st(C) {
        if (Pe.call(C, "ref")) {
          var G = Object.getOwnPropertyDescriptor(C, "ref").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return C.ref !== void 0;
      }
      function We(C) {
        if (Pe.call(C, "key")) {
          var G = Object.getOwnPropertyDescriptor(C, "key").get;
          if (G && G.isReactWarning)
            return !1;
        }
        return C.key !== void 0;
      }
      function Be(C, G) {
        if (typeof C.ref == "string" && Ue.current && G && Ue.current.stateNode !== G) {
          var ae = D(Ue.current.type);
          ye[ae] || (k('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', D(Ue.current.type), C.ref), ye[ae] = !0);
        }
      }
      function Xe(C, G) {
        {
          var ae = function() {
            Ke || (Ke = !0, k("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          ae.isReactWarning = !0, Object.defineProperty(C, "key", {
            get: ae,
            configurable: !0
          });
        }
      }
      function se(C, G) {
        {
          var ae = function() {
            we || (we = !0, k("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", G));
          };
          ae.isReactWarning = !0, Object.defineProperty(C, "ref", {
            get: ae,
            configurable: !0
          });
        }
      }
      var ce = function(C, G, ae, ge, Ae, Me, _e) {
        var xe = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: r,
          // Built-in properties that belong on the element
          type: C,
          key: G,
          ref: ae,
          props: _e,
          // Record the component responsible for creating this element.
          _owner: Me
        };
        return xe._store = {}, Object.defineProperty(xe._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(xe, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ge
        }), Object.defineProperty(xe, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Ae
        }), Object.freeze && (Object.freeze(xe.props), Object.freeze(xe)), xe;
      };
      function me(C, G, ae, ge, Ae) {
        {
          var Me, _e = {}, xe = null, Je = null;
          ae !== void 0 && (xe = "" + ae), We(G) && (xe = "" + G.key), st(G) && (Je = G.ref, Be(G, Ae));
          for (Me in G)
            Pe.call(G, Me) && !de.hasOwnProperty(Me) && (_e[Me] = G[Me]);
          if (C && C.defaultProps) {
            var Fe = C.defaultProps;
            for (Me in Fe)
              _e[Me] === void 0 && (_e[Me] = Fe[Me]);
          }
          if (xe || Je) {
            var He = typeof C == "function" ? C.displayName || C.name || "Unknown" : C;
            xe && Xe(_e, He), Je && se(_e, He);
          }
          return ce(C, xe, Je, Ae, ge, Ue.current, _e);
        }
      }
      var $e = I.ReactCurrentOwner, Ge = I.ReactDebugCurrentFrame;
      function dt(C) {
        if (C) {
          var G = C._owner, ae = be(C.type, C._source, G ? G.type : null);
          Ge.setExtraStackFrame(ae);
        } else
          Ge.setExtraStackFrame(null);
      }
      var In;
      In = !1;
      function Xr(C) {
        return typeof C == "object" && C !== null && C.$$typeof === r;
      }
      function pa() {
        {
          if ($e.current) {
            var C = D($e.current.type);
            if (C)
              return `

Check the render method of \`` + C + "`.";
          }
          return "";
        }
      }
      function ld(C) {
        {
          if (C !== void 0) {
            var G = C.fileName.replace(/^.*[\\\/]/, ""), ae = C.lineNumber;
            return `

Check your code at ` + G + ":" + ae + ".";
          }
          return "";
        }
      }
      var ga = {};
      function ud(C) {
        {
          var G = pa();
          if (!G) {
            var ae = typeof C == "string" ? C : C.displayName || C.name;
            ae && (G = `

Check the top-level render call using <` + ae + ">.");
          }
          return G;
        }
      }
      function ha(C, G) {
        {
          if (!C._store || C._store.validated || C.key != null)
            return;
          C._store.validated = !0;
          var ae = ud(G);
          if (ga[ae])
            return;
          ga[ae] = !0;
          var ge = "";
          C && C._owner && C._owner !== $e.current && (ge = " It was passed a child from " + D(C._owner.type) + "."), dt(C), k('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ae, ge), dt(null);
        }
      }
      function ma(C, G) {
        {
          if (typeof C != "object")
            return;
          if (Array.isArray(C))
            for (var ae = 0; ae < C.length; ae++) {
              var ge = C[ae];
              Xr(ge) && ha(ge, G);
            }
          else if (Xr(C))
            C._store && (C._store.validated = !0);
          else if (C) {
            var Ae = T(C);
            if (typeof Ae == "function" && Ae !== C.entries)
              for (var Me = Ae.call(C), _e; !(_e = Me.next()).done; )
                Xr(_e.value) && ha(_e.value, G);
          }
        }
      }
      function dd(C) {
        {
          var G = C.type;
          if (G == null || typeof G == "string")
            return;
          var ae;
          if (typeof G == "function")
            ae = G.propTypes;
          else if (typeof G == "object" && (G.$$typeof === u || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          G.$$typeof === f))
            ae = G.propTypes;
          else
            return;
          if (ae) {
            var ge = D(G);
            je(ae, C.props, "prop", ge, C);
          } else if (G.PropTypes !== void 0 && !In) {
            In = !0;
            var Ae = D(G);
            k("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ae || "Unknown");
          }
          typeof G.getDefaultProps == "function" && !G.getDefaultProps.isReactClassApproved && k("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function fd(C) {
        {
          for (var G = Object.keys(C.props), ae = 0; ae < G.length; ae++) {
            var ge = G[ae];
            if (ge !== "children" && ge !== "key") {
              dt(C), k("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ge), dt(null);
              break;
            }
          }
          C.ref !== null && (dt(C), k("Invalid attribute `ref` supplied to `React.Fragment`."), dt(null));
        }
      }
      function va(C, G, ae, ge, Ae, Me) {
        {
          var _e = z(C);
          if (!_e) {
            var xe = "";
            (C === void 0 || typeof C == "object" && C !== null && Object.keys(C).length === 0) && (xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Je = ld(Ae);
            Je ? xe += Je : xe += pa();
            var Fe;
            C === null ? Fe = "null" : Array.isArray(C) ? Fe = "array" : C !== void 0 && C.$$typeof === r ? (Fe = "<" + (D(C.type) || "Unknown") + " />", xe = " Did you accidentally export a JSX literal instead of a component?") : Fe = typeof C, k("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Fe, xe);
          }
          var He = me(C, G, ae, Ae, Me);
          if (He == null)
            return He;
          if (_e) {
            var $t = G.children;
            if ($t !== void 0)
              if (ge)
                if (Array.isArray($t)) {
                  for (var nn = 0; nn < $t.length; nn++)
                    ma($t[nn], C);
                  Object.freeze && Object.freeze($t);
                } else
                  k("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                ma($t, C);
          }
          return C === e.Fragment ? fd(He) : dd(He), He;
        }
      }
      function pd(C, G, ae) {
        return va(C, G, ae, !0);
      }
      function gd(C, G, ae) {
        return va(C, G, ae, !1);
      }
      var hd = gd, md = pd;
      e.jsx = hd, e.jsxs = md;
    }();
  }(Zr)), Zr;
}
process.env.NODE_ENV === "production" ? bo.exports = Bd() : bo.exports = Hd();
var y = bo.exports;
function Gs(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Gs(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function g() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Gs(e)) && (r && (r += " "), r += t);
  return r;
}
function M() {
  return M = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, M.apply(this, arguments);
}
function Ye(e, t = []) {
  let n = [];
  function r(o, s) {
    const a = /* @__PURE__ */ fr(s), c = n.length;
    n = [
      ...n,
      s
    ];
    function u(l) {
      const { scope: f, children: p, ...m } = l, v = (f == null ? void 0 : f[e][c]) || a, _ = ze(
        () => m,
        Object.values(m)
      );
      return /* @__PURE__ */ E(v.Provider, {
        value: _
      }, p);
    }
    function d(l, f) {
      const p = (f == null ? void 0 : f[e][c]) || a, m = Yo(p);
      if (m)
        return m;
      if (s !== void 0)
        return s;
      throw new Error(`\`${l}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [
      u,
      d
    ];
  }
  const i = () => {
    const o = n.map((s) => /* @__PURE__ */ fr(s));
    return function(a) {
      const c = (a == null ? void 0 : a[e]) || o;
      return ze(
        () => ({
          [`__scope${e}`]: {
            ...a,
            [e]: c
          }
        }),
        [
          a,
          c
        ]
      );
    };
  };
  return i.scopeName = e, [
    r,
    Vd(i, ...t)
  ];
}
function Vd(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(o) {
      const s = r.reduce((a, { useScope: c, scopeName: u }) => {
        const l = c(o)[`__scope${u}`];
        return {
          ...a,
          ...l
        };
      }, {});
      return ze(
        () => ({
          [`__scope${t.scopeName}`]: s
        }),
        [
          s
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function Ve(e) {
  const t = U(e);
  return te(() => {
    t.current = e;
  }), ze(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const St = globalThis != null && globalThis.document ? qo : () => {
};
function Ud(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ti(...e) {
  return (t) => e.forEach(
    (n) => Ud(n, t)
  );
}
function Re(...e) {
  return Q(ti(...e), e);
}
const xt = /* @__PURE__ */ q((e, t) => {
  const { children: n, ...r } = e, i = fn.toArray(n), o = i.find(Kd);
  if (o) {
    const s = o.props.children, a = i.map((c) => c === o ? fn.count(s) > 1 ? fn.only(null) : /* @__PURE__ */ pr(s) ? s.props.children : null : c);
    return /* @__PURE__ */ E(yo, M({}, r, {
      ref: t
    }), /* @__PURE__ */ pr(s) ? /* @__PURE__ */ Mr(s, void 0, a) : null);
  }
  return /* @__PURE__ */ E(yo, M({}, r, {
    ref: t
  }), n);
});
xt.displayName = "Slot";
const yo = /* @__PURE__ */ q((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ pr(n) ? /* @__PURE__ */ Mr(n, {
    ...Wd(r, n.props),
    ref: t ? ti(t, n.ref) : n.ref
  }) : fn.count(n) > 1 ? fn.only(null) : null;
});
yo.displayName = "SlotClone";
const Ys = ({ children: e }) => /* @__PURE__ */ E(Xo, null, e);
function Kd(e) {
  return /* @__PURE__ */ pr(e) && e.type === Ys;
}
function Wd(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...a) => {
      o(...a), i(...a);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const zd = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Oe = zd.reduce((e, t) => {
  const n = /* @__PURE__ */ q((r, i) => {
    const { asChild: o, ...s } = r, a = o ? xt : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, M({}, s, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Gd(e, t) {
  e && Zo(
    () => e.dispatchEvent(t)
  );
}
const qs = "Avatar", [Yd, KC] = Ye(qs), [qd, Xs] = Yd(qs), Xd = /* @__PURE__ */ q((e, t) => {
  const { __scopeAvatar: n, ...r } = e, [i, o] = ue("idle");
  return /* @__PURE__ */ E(qd, {
    scope: n,
    imageLoadingStatus: i,
    onImageLoadingStatusChange: o
  }, /* @__PURE__ */ E(Oe.span, M({}, r, {
    ref: t
  })));
}), Jd = "AvatarImage", Zd = /* @__PURE__ */ q((e, t) => {
  const { __scopeAvatar: n, src: r, onLoadingStatusChange: i = () => {
  }, ...o } = e, s = Xs(Jd, n), a = tf(r), c = Ve((u) => {
    i(u), s.onImageLoadingStatusChange(u);
  });
  return St(() => {
    a !== "idle" && c(a);
  }, [
    a,
    c
  ]), a === "loaded" ? /* @__PURE__ */ E(Oe.img, M({}, o, {
    ref: t,
    src: r
  })) : null;
}), Qd = "AvatarFallback", ef = /* @__PURE__ */ q((e, t) => {
  const { __scopeAvatar: n, delayMs: r, ...i } = e, o = Xs(Qd, n), [s, a] = ue(r === void 0);
  return te(() => {
    if (r !== void 0) {
      const c = window.setTimeout(
        () => a(!0),
        r
      );
      return () => window.clearTimeout(c);
    }
  }, [
    r
  ]), s && o.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ E(Oe.span, M({}, i, {
    ref: t
  })) : null;
});
function tf(e) {
  const [t, n] = ue("idle");
  return te(() => {
    if (!e) {
      n("error");
      return;
    }
    let r = !0;
    const i = new window.Image(), o = (s) => () => {
      r && n(s);
    };
    return n("loading"), i.onload = o("loaded"), i.onerror = o("error"), i.src = e, () => {
      r = !1;
    };
  }, [
    e
  ]), t;
}
const nf = Xd, rf = Zd, of = ef, af = {
  xs: g("ui-w-6 ui-border ui-text-paragraph-100-medium"),
  sm: g("ui-w-8 ui-border ui-text-paragraph-200-medium"),
  md: g("ui-w-10 ui-border-[1.5px] ui-text-paragraph-300-medium"),
  lg: g("ui-w-12 ui-border-2 ui-text-heading-h4"),
  xl: g("ui-w-14 ui-border-2 ui-text-heading-h3"),
  "2xl": g("ui-w-16 ui-border-2 ui-text-heading-h2")
}, sf = {
  xs: yd,
  sm: Id,
  md: Wn,
  lg: Wn,
  xl: Wn,
  "2xl": Wn
}, cf = g(
  "ui-flex ui-aspect-square ui-select-none ui-items-center ui-justify-center",
  "ui-rounded-full ui-border-transparent ui-bg-grayscale-100 ui-text-grayscale-700 ui-outline-none ui-transition",
  "hover:ui-border-primary-500 hover:ui-text-primary-500",
  "aria-current-page:ui-border-primary-500 aria-current-page:ui-text-primary-500",
  "focus-visible:ui-shadow-focus"
), lf = g("ui-flex-1 ui-rounded-full"), WC = q(
  ({
    className: e,
    as: t,
    size: n = "md",
    imageUrl: r,
    initials: i,
    ...o
  }, s) => {
    const a = t || "button", c = sf[n];
    return /* @__PURE__ */ y.jsx(nf, { asChild: !0, children: /* @__PURE__ */ y.jsxs(
      a,
      {
        ...o,
        ref: s,
        className: g(e, af[n], cf),
        children: [
          r ? /* @__PURE__ */ y.jsx(
            rf,
            {
              src: r,
              alt: i || "",
              className: lf
            }
          ) : null,
          /* @__PURE__ */ y.jsx(of, { delayMs: r ? 600 : 0, children: i || /* @__PURE__ */ y.jsx(c, { width: "1.33em", height: "1.33em" }) })
        ]
      }
    ) });
  }
);
function le(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function ht({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, i] = uf({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, s = o ? e : r, a = Ve(n), c = Q((u) => {
    if (o) {
      const l = typeof u == "function" ? u(e) : u;
      l !== e && a(l);
    } else
      i(u);
  }, [
    o,
    e,
    i,
    a
  ]);
  return [
    s,
    c
  ];
}
function uf({ defaultProp: e, onChange: t }) {
  const n = ue(e), [r] = n, i = U(r), o = Ve(t);
  return te(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
function ni(e) {
  const t = U({
    value: e,
    previous: e
  });
  return ze(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
function Dr(e) {
  const [t, n] = ue(void 0);
  return St(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let s, a;
        if ("borderBoxSize" in o) {
          const c = o.borderBoxSize, u = Array.isArray(c) ? c[0] : c;
          s = u.inlineSize, a = u.blockSize;
        } else
          s = e.offsetWidth, a = e.offsetHeight;
        n({
          width: s,
          height: a
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Js = "Switch", [df, zC] = Ye(Js), [ff, pf] = df(Js), gf = /* @__PURE__ */ q((e, t) => {
  const { __scopeSwitch: n, name: r, checked: i, defaultChecked: o, required: s, disabled: a, value: c = "on", onCheckedChange: u, ...d } = e, [l, f] = ue(null), p = Re(
    t,
    (h) => f(h)
  ), m = U(!1), v = l ? !!l.closest("form") : !0, [_ = !1, $] = ht({
    prop: i,
    defaultProp: o,
    onChange: u
  });
  return /* @__PURE__ */ E(ff, {
    scope: n,
    checked: _,
    disabled: a
  }, /* @__PURE__ */ E(Oe.button, M({
    type: "button",
    role: "switch",
    "aria-checked": _,
    "aria-required": s,
    "data-state": Zs(_),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: c
  }, d, {
    ref: p,
    onClick: le(e.onClick, (h) => {
      $(
        (b) => !b
      ), v && (m.current = h.isPropagationStopped(), m.current || h.stopPropagation());
    })
  })), v && /* @__PURE__ */ E(vf, {
    control: l,
    bubbles: !m.current,
    name: r,
    value: c,
    checked: _,
    required: s,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), hf = "SwitchThumb", mf = /* @__PURE__ */ q((e, t) => {
  const { __scopeSwitch: n, ...r } = e, i = pf(hf, n);
  return /* @__PURE__ */ E(Oe.span, M({
    "data-state": Zs(i.checked),
    "data-disabled": i.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), vf = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = U(null), s = ni(n), a = Dr(t);
  return te(() => {
    const c = o.current, u = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (s !== n && l) {
      const f = new Event("click", {
        bubbles: r
      });
      l.call(c, n), c.dispatchEvent(f);
    }
  }, [
    s,
    n,
    r
  ]), /* @__PURE__ */ E("input", M({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: n
  }, i, {
    tabIndex: -1,
    ref: o,
    style: {
      ...e.style,
      ...a,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Zs(e) {
  return e ? "checked" : "unchecked";
}
const bf = gf, yf = mf, xf = {
  sm: g("ui-h-4 ui-w-[26px]"),
  md: g("ui-h-5 ui-w-[34px]"),
  lg: g("ui-h-7 ui-w-[50px]")
}, wf = g(
  "ui-group ui-flex ui-rounded-full ui-p-0.5 ui-transition",
  "ui-cursor-pointer disabled:ui-cursor-not-allowed",
  "ui-bg-grayscale-400 disabled:ui-bg-grayscale-300 aria-checked:ui-bg-primary-600 disabled:aria-checked:ui-bg-primary-200"
), _f = g(
  "ui-aspect-square ui-h-full ui-rounded-full ui-bg-white ui-transition group-aria-checked:ui-translate-x-[calc(100%-2px)]"
), GC = q(
  ({ className: e, size: t = "md", ...n }, r) => /* @__PURE__ */ y.jsx(
    bf,
    {
      ...n,
      ref: r,
      className: g(e, xf[t], wf),
      children: /* @__PURE__ */ y.jsx(yf, { className: _f })
    }
  )
);
function $f(e, t) {
  return Jo((n, r) => {
    const i = t[n][r];
    return i ?? n;
  }, e);
}
const tt = (e) => {
  const { present: t, children: n } = e, r = Cf(t), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : fn.only(n), o = Re(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ Mr(i, {
    ref: o
  }) : null;
};
tt.displayName = "Presence";
function Cf(e) {
  const [t, n] = ue(), r = U({}), i = U(e), o = U("none"), s = e ? "mounted" : "unmounted", [a, c] = $f(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return te(() => {
    const u = zn(r.current);
    o.current = a === "mounted" ? u : "none";
  }, [
    a
  ]), St(() => {
    const u = r.current, d = i.current;
    if (d !== e) {
      const f = o.current, p = zn(u);
      e ? c("MOUNT") : p === "none" || (u == null ? void 0 : u.display) === "none" ? c("UNMOUNT") : c(d && f !== p ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [
    e,
    c
  ]), St(() => {
    if (t) {
      const u = (l) => {
        const p = zn(r.current).includes(l.animationName);
        l.target === t && p && Zo(
          () => c("ANIMATION_END")
        );
      }, d = (l) => {
        l.target === t && (o.current = zn(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      c("ANIMATION_END");
  }, [
    t,
    c
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(a),
    ref: Q((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function zn(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
const Qs = "Checkbox", [Ef, YC] = Ye(Qs), [If, qC] = Ef(Qs), Sf = /* @__PURE__ */ q((e, t) => {
  const { __scopeCheckbox: n, name: r, checked: i, defaultChecked: o, required: s, disabled: a, value: c = "on", onCheckedChange: u, ...d } = e, [l, f] = ue(null), p = Re(
    t,
    (b) => f(b)
  ), m = U(!1), v = l ? !!l.closest("form") : !0, [_ = !1, $] = ht({
    prop: i,
    defaultProp: o,
    onChange: u
  }), h = U(_);
  return te(() => {
    const b = l == null ? void 0 : l.form;
    if (b) {
      const w = () => $(h.current);
      return b.addEventListener("reset", w), () => b.removeEventListener("reset", w);
    }
  }, [
    l,
    $
  ]), /* @__PURE__ */ E(If, {
    scope: n,
    state: _,
    disabled: a
  }, /* @__PURE__ */ E(Oe.button, M({
    type: "button",
    role: "checkbox",
    "aria-checked": pn(_) ? "mixed" : _,
    "aria-required": s,
    "data-state": Nf(_),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: c
  }, d, {
    ref: p,
    onKeyDown: le(e.onKeyDown, (b) => {
      b.key === "Enter" && b.preventDefault();
    }),
    onClick: le(e.onClick, (b) => {
      $(
        (w) => pn(w) ? !0 : !w
      ), v && (m.current = b.isPropagationStopped(), m.current || b.stopPropagation());
    })
  })), v && /* @__PURE__ */ E(Of, {
    control: l,
    bubbles: !m.current,
    name: r,
    value: c,
    checked: _,
    required: s,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), Of = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = U(null), s = ni(n), a = Dr(t);
  return te(() => {
    const c = o.current, u = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (s !== n && l) {
      const f = new Event("click", {
        bubbles: r
      });
      c.indeterminate = pn(n), l.call(c, pn(n) ? !1 : n), c.dispatchEvent(f);
    }
  }, [
    s,
    n,
    r
  ]), /* @__PURE__ */ E("input", M({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: pn(n) ? !1 : n
  }, i, {
    tabIndex: -1,
    ref: o,
    style: {
      ...e.style,
      ...a,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function pn(e) {
  return e === "indeterminate";
}
function Nf(e) {
  return pn(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const Tf = Sf, Rf = {
  sm: g("ui-h-4 ui-w-4 ui-rounded"),
  md: g("ui-h-5 ui-w-5 ui-rounded-md")
}, Pf = {
  sm: Ws,
  md: Md
}, Af = {
  sm: Sd,
  md: Dd
}, Mf = g(
  "ui-group ui-relative ui-flex ui-items-center ui-justify-center ui-overflow-hidden",
  "ui-border ui-border-grayscale-300 ui-bg-white ui-text-primary-600 ui-transition",
  "data-hovered:ui-border-primary-600 data-hovered:ui-bg-primary-100",
  "ui-outline-none focus:ui-border-primary-300 focus:ui-shadow-focus",
  "aria-checked:ui-border-primary-600 aria-checked:ui-bg-primary-50",
  "data-[state=indeterminate]:ui-border-primary-600 data-[state=indeterminate]:ui-bg-primary-50",
  "disabled:ui-border-grayscale-300 disabled:ui-bg-grayscale-100 disabled:ui-text-grayscale-300"
), Df = g(
  "ui-absolute ui-opacity-0 ui-transition",
  "group-aria-checked:ui-opacity-100"
), kf = g(
  "ui-absolute ui-scale-75 ui-opacity-0 ui-transition",
  "group-aria-checked:ui-opacity-0 group-data-[state=indeterminate]:ui-opacity-100"
), Lf = ({
  as: e,
  className: t,
  size: n = "md",
  ...r
}) => {
  const i = Pf[n], o = Af[n], s = e || "button";
  return /* @__PURE__ */ y.jsx(
    Tf,
    {
      ...r,
      asChild: !0,
      className: g(t, Rf[n], Mf),
      children: /* @__PURE__ */ y.jsxs(s, { children: [
        /* @__PURE__ */ y.jsx(
          o,
          {
            className: kf,
            "aria-hidden": "true"
          }
        ),
        /* @__PURE__ */ y.jsx(i, { className: Df, "aria-hidden": "true" })
      ] })
    }
  );
}, jf = g(
  "ui-mt-1.5 ui-text-paragraph-200-regular",
  "ui-text-grayscale-500 aria-invalid:ui-text-critical-600"
), kr = ({
  errorMessage: e,
  description: t,
  className: n,
  ...r
}) => !e && !t ? null : /* @__PURE__ */ y.jsx(
  "span",
  {
    ...r,
    "aria-invalid": !!e,
    className: g(n, jf),
    children: e || t
  }
), Ff = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Bf = Ff.reduce((e, t) => {
  const n = /* @__PURE__ */ q((r, i) => {
    const { asChild: o, ...s } = r, a = o ? xt : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, M({}, s, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function Hf(e, t) {
  e && Zo(
    () => e.dispatchEvent(t)
  );
}
function Vf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e);
  te(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const xo = "dismissableLayer.update", Uf = "dismissableLayer.pointerDownOutside", Kf = "dismissableLayer.focusOutside";
let _a;
const Wf = /* @__PURE__ */ fr({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), ri = /* @__PURE__ */ q((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: s, onInteractOutside: a, onDismiss: c, ...u } = e, d = Yo(Wf), [l, f] = ue(null), p = (n = l == null ? void 0 : l.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, m] = ue({}), v = Re(
    t,
    (k) => f(k)
  ), _ = Array.from(d.layers), [$] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), h = _.indexOf($), b = l ? _.indexOf(l) : -1, w = d.layersWithOutsidePointerEventsDisabled.size > 0, x = b >= h, T = zf((k) => {
    const B = k.target, V = [
      ...d.branches
    ].some(
      (z) => z.contains(B)
    );
    !x || V || (o == null || o(k), a == null || a(k), k.defaultPrevented || c == null || c());
  }, p), I = Gf((k) => {
    const B = k.target;
    [
      ...d.branches
    ].some(
      (z) => z.contains(B)
    ) || (s == null || s(k), a == null || a(k), k.defaultPrevented || c == null || c());
  }, p);
  return Vf((k) => {
    b === d.layers.size - 1 && (i == null || i(k), !k.defaultPrevented && c && (k.preventDefault(), c()));
  }, p), te(() => {
    if (l)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (_a = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(l)), d.layers.add(l), $a(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = _a);
      };
  }, [
    l,
    p,
    r,
    d
  ]), te(() => () => {
    l && (d.layers.delete(l), d.layersWithOutsidePointerEventsDisabled.delete(l), $a());
  }, [
    l,
    d
  ]), te(() => {
    const k = () => m({});
    return document.addEventListener(xo, k), () => document.removeEventListener(xo, k);
  }, []), /* @__PURE__ */ E(Bf.div, M({}, u, {
    ref: v,
    style: {
      pointerEvents: w ? x ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: le(e.onFocusCapture, I.onFocusCapture),
    onBlurCapture: le(e.onBlurCapture, I.onBlurCapture),
    onPointerDownCapture: le(e.onPointerDownCapture, T.onPointerDownCapture)
  }));
});
function zf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e), r = U(!1), i = U(() => {
  });
  return te(() => {
    const o = (a) => {
      if (a.target && !r.current) {
        let u = function() {
          ec(Uf, n, c, {
            discrete: !0
          });
        };
        const c = {
          originalEvent: a
        };
        a.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = u, t.addEventListener("click", i.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Gf(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e), r = U(!1);
  return te(() => {
    const i = (o) => {
      o.target && !r.current && ec(Kf, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function $a() {
  const e = new CustomEvent(xo);
  document.dispatchEvent(e);
}
function ec(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && i.addEventListener(e, t, {
    once: !0
  }), r ? Hf(i, o) : i.dispatchEvent(o);
}
const Yf = pe["useId".toString()] || (() => {
});
let qf = 0;
function Ze(e) {
  const [t, n] = pe.useState(Yf());
  return St(() => {
    e || n(
      (r) => r ?? String(qf++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const Xf = ["top", "right", "bottom", "left"], Ft = Math.min, it = Math.max, hr = Math.round, Gn = Math.floor, Bt = (e) => ({
  x: e,
  y: e
}), Jf = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Zf = {
  start: "end",
  end: "start"
};
function wo(e, t, n) {
  return it(e, Ft(t, n));
}
function Ot(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Nt(e) {
  return e.split("-")[0];
}
function yn(e) {
  return e.split("-")[1];
}
function oi(e) {
  return e === "x" ? "y" : "x";
}
function ii(e) {
  return e === "y" ? "height" : "width";
}
function xn(e) {
  return ["top", "bottom"].includes(Nt(e)) ? "y" : "x";
}
function ai(e) {
  return oi(xn(e));
}
function Qf(e, t, n) {
  n === void 0 && (n = !1);
  const r = yn(e), i = ai(e), o = ii(i);
  let s = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (s = mr(s)), [s, mr(s)];
}
function ep(e) {
  const t = mr(e);
  return [_o(e), t, _o(t)];
}
function _o(e) {
  return e.replace(/start|end/g, (t) => Zf[t]);
}
function tp(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : s;
    default:
      return [];
  }
}
function np(e, t, n, r) {
  const i = yn(e);
  let o = tp(Nt(e), n === "start", r);
  return i && (o = o.map((s) => s + "-" + i), t && (o = o.concat(o.map(_o)))), o;
}
function mr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Jf[t]);
}
function rp(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function tc(e) {
  return typeof e != "number" ? rp(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function vr(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Ca(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = xn(t), s = ai(t), a = ii(s), c = Nt(t), u = o === "y", d = r.x + r.width / 2 - i.width / 2, l = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let p;
  switch (c) {
    case "top":
      p = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      p = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: l
      };
      break;
    case "left":
      p = {
        x: r.x - i.width,
        y: l
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (yn(t)) {
    case "start":
      p[s] -= f * (n && u ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const op = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: s
  } = n, a = o.filter(Boolean), c = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let u = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: l
  } = Ca(u, r, c), f = r, p = {}, m = 0;
  for (let v = 0; v < a.length; v++) {
    const {
      name: _,
      fn: $
    } = a[v], {
      x: h,
      y: b,
      data: w,
      reset: x
    } = await $({
      x: d,
      y: l,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: p,
      rects: u,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (d = h ?? d, l = b ?? l, p = {
      ...p,
      [_]: {
        ...p[_],
        ...w
      }
    }, x && m <= 50) {
      m++, typeof x == "object" && (x.placement && (f = x.placement), x.rects && (u = x.rects === !0 ? await s.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : x.rects), {
        x: d,
        y: l
      } = Ca(u, f, c)), v = -1;
      continue;
    }
  }
  return {
    x: d,
    y: l,
    placement: f,
    strategy: i,
    middlewareData: p
  };
};
async function On(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: s,
    elements: a,
    strategy: c
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: l = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = Ot(t, e), m = tc(p), _ = a[f ? l === "floating" ? "reference" : "floating" : l], $ = vr(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(_))) == null || n ? _ : _.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(a.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: c
  })), h = l === "floating" ? {
    ...s.floating,
    x: r,
    y: i
  } : s.reference, b = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(a.floating)), w = await (o.isElement == null ? void 0 : o.isElement(b)) ? await (o.getScale == null ? void 0 : o.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = vr(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: h,
    offsetParent: b,
    strategy: c
  }) : h);
  return {
    top: ($.top - x.top + m.top) / w.y,
    bottom: (x.bottom - $.bottom + m.bottom) / w.y,
    left: ($.left - x.left + m.left) / w.x,
    right: (x.right - $.right + m.right) / w.x
  };
}
const Ea = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: s,
      elements: a
    } = t, {
      element: c,
      padding: u = 0
    } = Ot(e, t) || {};
    if (c == null)
      return {};
    const d = tc(u), l = {
      x: n,
      y: r
    }, f = ai(i), p = ii(f), m = await s.getDimensions(c), v = f === "y", _ = v ? "top" : "left", $ = v ? "bottom" : "right", h = v ? "clientHeight" : "clientWidth", b = o.reference[p] + o.reference[f] - l[f] - o.floating[p], w = l[f] - o.reference[f], x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let T = x ? x[h] : 0;
    (!T || !await (s.isElement == null ? void 0 : s.isElement(x))) && (T = a.floating[h] || o.floating[p]);
    const I = b / 2 - w / 2, k = T / 2 - m[p] / 2 - 1, B = Ft(d[_], k), V = Ft(d[$], k), z = B, ne = T - m[p] - V, oe = T / 2 - m[p] / 2 + I, D = wo(z, oe, ne), J = yn(i) != null && oe != D && o.reference[p] / 2 - (oe < z ? B : V) - m[p] / 2 < 0 ? oe < z ? z - oe : ne - oe : 0;
    return {
      [f]: l[f] - J,
      data: {
        [f]: D,
        centerOffset: oe - D + J
      }
    };
  }
}), ip = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: i,
        rects: o,
        initialPlacement: s,
        platform: a,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: l,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: p = "none",
        flipAlignment: m = !0,
        ...v
      } = Ot(e, t), _ = Nt(r), $ = Nt(s) === s, h = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), b = l || ($ || !m ? [mr(s)] : ep(s));
      !l && p !== "none" && b.push(...np(s, m, p, h));
      const w = [s, ...b], x = await On(t, v), T = [];
      let I = ((n = i.flip) == null ? void 0 : n.overflows) || [];
      if (u && T.push(x[_]), d) {
        const z = Qf(r, o, h);
        T.push(x[z[0]], x[z[1]]);
      }
      if (I = [...I, {
        placement: r,
        overflows: T
      }], !T.every((z) => z <= 0)) {
        var k, B;
        const z = (((k = i.flip) == null ? void 0 : k.index) || 0) + 1, ne = w[z];
        if (ne)
          return {
            data: {
              index: z,
              overflows: I
            },
            reset: {
              placement: ne
            }
          };
        let oe = (B = I.filter((D) => D.overflows[0] <= 0).sort((D, j) => D.overflows[1] - j.overflows[1])[0]) == null ? void 0 : B.placement;
        if (!oe)
          switch (f) {
            case "bestFit": {
              var V;
              const D = (V = I.map((j) => [j.placement, j.overflows.filter((J) => J > 0).reduce((J, S) => J + S, 0)]).sort((j, J) => j[1] - J[1])[0]) == null ? void 0 : V[0];
              D && (oe = D);
              break;
            }
            case "initialPlacement":
              oe = s;
              break;
          }
        if (r !== oe)
          return {
            reset: {
              placement: oe
            }
          };
      }
      return {};
    }
  };
};
function Ia(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function Sa(e) {
  return Xf.some((t) => e[t] >= 0);
}
const ap = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = Ot(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await On(t, {
            ...i,
            elementContext: "reference"
          }), s = Ia(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: Sa(s)
            }
          };
        }
        case "escaped": {
          const o = await On(t, {
            ...i,
            altBoundary: !0
          }), s = Ia(o, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: Sa(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function sp(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), s = Nt(n), a = yn(n), c = xn(n) === "y", u = ["left", "top"].includes(s) ? -1 : 1, d = o && c ? -1 : 1, l = Ot(t, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: m
  } = typeof l == "number" ? {
    mainAxis: l,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...l
  };
  return a && typeof m == "number" && (p = a === "end" ? m * -1 : m), c ? {
    x: p * d,
    y: f * u
  } : {
    x: f * u,
    y: p * d
  };
}
const cp = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, i = await sp(t, e);
      return {
        x: n + i.x,
        y: r + i.y,
        data: i
      };
    }
  };
}, lp = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: s = !1,
        limiter: a = {
          fn: (_) => {
            let {
              x: $,
              y: h
            } = _;
            return {
              x: $,
              y: h
            };
          }
        },
        ...c
      } = Ot(e, t), u = {
        x: n,
        y: r
      }, d = await On(t, c), l = xn(Nt(i)), f = oi(l);
      let p = u[f], m = u[l];
      if (o) {
        const _ = f === "y" ? "top" : "left", $ = f === "y" ? "bottom" : "right", h = p + d[_], b = p - d[$];
        p = wo(h, p, b);
      }
      if (s) {
        const _ = l === "y" ? "top" : "left", $ = l === "y" ? "bottom" : "right", h = m + d[_], b = m - d[$];
        m = wo(h, m, b);
      }
      const v = a.fn({
        ...t,
        [f]: p,
        [l]: m
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r
        }
      };
    }
  };
}, up = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: c = !0,
        crossAxis: u = !0
      } = Ot(e, t), d = {
        x: n,
        y: r
      }, l = xn(i), f = oi(l);
      let p = d[f], m = d[l];
      const v = Ot(a, t), _ = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (c) {
        const b = f === "y" ? "height" : "width", w = o.reference[f] - o.floating[b] + _.mainAxis, x = o.reference[f] + o.reference[b] - _.mainAxis;
        p < w ? p = w : p > x && (p = x);
      }
      if (u) {
        var $, h;
        const b = f === "y" ? "width" : "height", w = ["top", "left"].includes(Nt(i)), x = o.reference[l] - o.floating[b] + (w && (($ = s.offset) == null ? void 0 : $[l]) || 0) + (w ? 0 : _.crossAxis), T = o.reference[l] + o.reference[b] + (w ? 0 : ((h = s.offset) == null ? void 0 : h[l]) || 0) - (w ? _.crossAxis : 0);
        m < x ? m = x : m > T && (m = T);
      }
      return {
        [f]: p,
        [l]: m
      };
    }
  };
}, dp = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: o
      } = t, {
        apply: s = () => {
        },
        ...a
      } = Ot(e, t), c = await On(t, a), u = Nt(n), d = yn(n), l = xn(n) === "y", {
        width: f,
        height: p
      } = r.floating;
      let m, v;
      u === "top" || u === "bottom" ? (m = u, v = d === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (v = u, m = d === "end" ? "top" : "bottom");
      const _ = p - c[m], $ = f - c[v], h = !t.middlewareData.shift;
      let b = _, w = $;
      if (l) {
        const T = f - c.left - c.right;
        w = d || h ? Ft($, T) : T;
      } else {
        const T = p - c.top - c.bottom;
        b = d || h ? Ft(_, T) : T;
      }
      if (h && !d) {
        const T = it(c.left, 0), I = it(c.right, 0), k = it(c.top, 0), B = it(c.bottom, 0);
        l ? w = f - 2 * (T !== 0 || I !== 0 ? T + I : it(c.left, c.right)) : b = p - 2 * (k !== 0 || B !== 0 ? k + B : it(c.top, c.bottom));
      }
      await s({
        ...t,
        availableWidth: w,
        availableHeight: b
      });
      const x = await i.getDimensions(o.floating);
      return f !== x.width || p !== x.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Ht(e) {
  return nc(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function at(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Rt(e) {
  var t;
  return (t = (nc(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function nc(e) {
  return e instanceof Node || e instanceof at(e).Node;
}
function Tt(e) {
  return e instanceof Element || e instanceof at(e).Element;
}
function wt(e) {
  return e instanceof HTMLElement || e instanceof at(e).HTMLElement;
}
function Oa(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof at(e).ShadowRoot;
}
function jn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = ut(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function fp(e) {
  return ["table", "td", "th"].includes(Ht(e));
}
function si(e) {
  const t = ci(), n = ut(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function pp(e) {
  let t = vn(e);
  for (; wt(t) && !Lr(t); ) {
    if (si(t))
      return t;
    t = vn(t);
  }
  return null;
}
function ci() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Lr(e) {
  return ["html", "body", "#document"].includes(Ht(e));
}
function ut(e) {
  return at(e).getComputedStyle(e);
}
function jr(e) {
  return Tt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function vn(e) {
  if (Ht(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Oa(e) && e.host || // Fallback.
    Rt(e)
  );
  return Oa(t) ? t.host : t;
}
function rc(e) {
  const t = vn(e);
  return Lr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : wt(t) && jn(t) ? t : rc(t);
}
function br(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = rc(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = at(r);
  return i ? t.concat(o, o.visualViewport || [], jn(r) ? r : []) : t.concat(r, br(r));
}
function oc(e) {
  const t = ut(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = wt(e), o = i ? e.offsetWidth : n, s = i ? e.offsetHeight : r, a = hr(n) !== o || hr(r) !== s;
  return a && (n = o, r = s), {
    width: n,
    height: r,
    $: a
  };
}
function li(e) {
  return Tt(e) ? e : e.contextElement;
}
function gn(e) {
  const t = li(e);
  if (!wt(t))
    return Bt(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = oc(t);
  let s = (o ? hr(n.width) : n.width) / r, a = (o ? hr(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const gp = /* @__PURE__ */ Bt(0);
function ic(e) {
  const t = at(e);
  return !ci() || !t.visualViewport ? gp : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function hp(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== at(e) ? !1 : t;
}
function Xt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = li(e);
  let s = Bt(1);
  t && (r ? Tt(r) && (s = gn(r)) : s = gn(e));
  const a = hp(o, n, r) ? ic(o) : Bt(0);
  let c = (i.left + a.x) / s.x, u = (i.top + a.y) / s.y, d = i.width / s.x, l = i.height / s.y;
  if (o) {
    const f = at(o), p = r && Tt(r) ? at(r) : r;
    let m = f.frameElement;
    for (; m && r && p !== f; ) {
      const v = gn(m), _ = m.getBoundingClientRect(), $ = ut(m), h = _.left + (m.clientLeft + parseFloat($.paddingLeft)) * v.x, b = _.top + (m.clientTop + parseFloat($.paddingTop)) * v.y;
      c *= v.x, u *= v.y, d *= v.x, l *= v.y, c += h, u += b, m = at(m).frameElement;
    }
  }
  return vr({
    width: d,
    height: l,
    x: c,
    y: u
  });
}
function mp(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const i = wt(n), o = Rt(n);
  if (n === o)
    return t;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = Bt(1);
  const c = Bt(0);
  if ((i || !i && r !== "fixed") && ((Ht(n) !== "body" || jn(o)) && (s = jr(n)), wt(n))) {
    const u = Xt(n);
    a = gn(n), c.x = u.x + n.clientLeft, c.y = u.y + n.clientTop;
  }
  return {
    width: t.width * a.x,
    height: t.height * a.y,
    x: t.x * a.x - s.scrollLeft * a.x + c.x,
    y: t.y * a.y - s.scrollTop * a.y + c.y
  };
}
function vp(e) {
  return Array.from(e.getClientRects());
}
function ac(e) {
  return Xt(Rt(e)).left + jr(e).scrollLeft;
}
function bp(e) {
  const t = Rt(e), n = jr(e), r = e.ownerDocument.body, i = it(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = it(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + ac(e);
  const a = -n.scrollTop;
  return ut(r).direction === "rtl" && (s += it(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: s,
    y: a
  };
}
function yp(e, t) {
  const n = at(e), r = Rt(e), i = n.visualViewport;
  let o = r.clientWidth, s = r.clientHeight, a = 0, c = 0;
  if (i) {
    o = i.width, s = i.height;
    const u = ci();
    (!u || u && t === "fixed") && (a = i.offsetLeft, c = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a,
    y: c
  };
}
function xp(e, t) {
  const n = Xt(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = wt(e) ? gn(e) : Bt(1), s = e.clientWidth * o.x, a = e.clientHeight * o.y, c = i * o.x, u = r * o.y;
  return {
    width: s,
    height: a,
    x: c,
    y: u
  };
}
function Na(e, t, n) {
  let r;
  if (t === "viewport")
    r = yp(e, n);
  else if (t === "document")
    r = bp(Rt(e));
  else if (Tt(t))
    r = xp(t, n);
  else {
    const i = ic(e);
    r = {
      ...t,
      x: t.x - i.x,
      y: t.y - i.y
    };
  }
  return vr(r);
}
function sc(e, t) {
  const n = vn(e);
  return n === t || !Tt(n) || Lr(n) ? !1 : ut(n).position === "fixed" || sc(n, t);
}
function wp(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = br(e).filter((a) => Tt(a) && Ht(a) !== "body"), i = null;
  const o = ut(e).position === "fixed";
  let s = o ? vn(e) : e;
  for (; Tt(s) && !Lr(s); ) {
    const a = ut(s), c = si(s);
    !c && a.position === "fixed" && (i = null), (o ? !c && !i : !c && a.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || jn(s) && !c && sc(e, s)) ? r = r.filter((d) => d !== s) : i = a, s = vn(s);
  }
  return t.set(e, r), r;
}
function _p(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? wp(t, this._c) : [].concat(n), r], a = s[0], c = s.reduce((u, d) => {
    const l = Na(t, d, i);
    return u.top = it(l.top, u.top), u.right = Ft(l.right, u.right), u.bottom = Ft(l.bottom, u.bottom), u.left = it(l.left, u.left), u;
  }, Na(t, a, i));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function $p(e) {
  return oc(e);
}
function Cp(e, t, n) {
  const r = wt(t), i = Rt(t), o = n === "fixed", s = Xt(e, !0, o, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = Bt(0);
  if (r || !r && !o)
    if ((Ht(t) !== "body" || jn(i)) && (a = jr(t)), r) {
      const u = Xt(t, !0, o, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else
      i && (c.x = ac(i));
  return {
    x: s.left + a.scrollLeft - c.x,
    y: s.top + a.scrollTop - c.y,
    width: s.width,
    height: s.height
  };
}
function Ta(e, t) {
  return !wt(e) || ut(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function cc(e, t) {
  const n = at(e);
  if (!wt(e))
    return n;
  let r = Ta(e, t);
  for (; r && fp(r) && ut(r).position === "static"; )
    r = Ta(r, t);
  return r && (Ht(r) === "html" || Ht(r) === "body" && ut(r).position === "static" && !si(r)) ? n : r || pp(e) || n;
}
const Ep = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const i = this.getOffsetParent || cc, o = this.getDimensions;
  return {
    reference: Cp(t, await i(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await o(n)
    }
  };
};
function Ip(e) {
  return ut(e).direction === "rtl";
}
const Sp = {
  convertOffsetParentRelativeRectToViewportRelativeRect: mp,
  getDocumentElement: Rt,
  getClippingRect: _p,
  getOffsetParent: cc,
  getElementRects: Ep,
  getClientRects: vp,
  getDimensions: $p,
  getScale: gn,
  isElement: Tt,
  isRTL: Ip
};
function Op(e, t) {
  let n = null, r;
  const i = Rt(e);
  function o() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function s(a, c) {
    a === void 0 && (a = !1), c === void 0 && (c = 1), o();
    const {
      left: u,
      top: d,
      width: l,
      height: f
    } = e.getBoundingClientRect();
    if (a || t(), !l || !f)
      return;
    const p = Gn(d), m = Gn(i.clientWidth - (u + l)), v = Gn(i.clientHeight - (d + f)), _ = Gn(u), h = {
      rootMargin: -p + "px " + -m + "px " + -v + "px " + -_ + "px",
      threshold: it(0, Ft(1, c)) || 1
    };
    let b = !0;
    function w(x) {
      const T = x[0].intersectionRatio;
      if (T !== c) {
        if (!b)
          return s();
        T ? s(!1, T) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 100);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(w, {
        ...h,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(w, h);
    }
    n.observe(e);
  }
  return s(!0), o;
}
function Np(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = r, u = li(e), d = i || o ? [...u ? br(u) : [], ...br(t)] : [];
  d.forEach(($) => {
    i && $.addEventListener("scroll", n, {
      passive: !0
    }), o && $.addEventListener("resize", n);
  });
  const l = u && a ? Op(u, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver(($) => {
    let [h] = $;
    h && h.target === u && p && (p.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      p && p.observe(t);
    })), n();
  }), u && !c && p.observe(u), p.observe(t));
  let m, v = c ? Xt(e) : null;
  c && _();
  function _() {
    const $ = Xt(e);
    v && ($.x !== v.x || $.y !== v.y || $.width !== v.width || $.height !== v.height) && n(), v = $, m = requestAnimationFrame(_);
  }
  return n(), () => {
    d.forEach(($) => {
      i && $.removeEventListener("scroll", n), o && $.removeEventListener("resize", n);
    }), l && l(), p && p.disconnect(), p = null, c && cancelAnimationFrame(m);
  };
}
const Tp = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Sp,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return op(e, t, {
    ...i,
    platform: o
  });
}, Rp = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Ea({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? Ea({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
};
var or = typeof document < "u" ? qo : te;
function yr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!yr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !yr(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function lc(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ra(e, t) {
  const n = lc(e);
  return Math.round(t * n) / n;
}
function Pa(e) {
  const t = pe.useRef(e);
  return or(() => {
    t.current = e;
  }), t;
}
function Pp(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: a = !0,
    whileElementsMounted: c,
    open: u
  } = e, [d, l] = pe.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = pe.useState(r);
  yr(f, r) || p(r);
  const [m, v] = pe.useState(null), [_, $] = pe.useState(null), h = pe.useCallback((J) => {
    J != T.current && (T.current = J, v(J));
  }, [v]), b = pe.useCallback((J) => {
    J !== I.current && (I.current = J, $(J));
  }, [$]), w = o || m, x = s || _, T = pe.useRef(null), I = pe.useRef(null), k = pe.useRef(d), B = Pa(c), V = Pa(i), z = pe.useCallback(() => {
    if (!T.current || !I.current)
      return;
    const J = {
      placement: t,
      strategy: n,
      middleware: f
    };
    V.current && (J.platform = V.current), Tp(T.current, I.current, J).then((S) => {
      const Y = {
        ...S,
        isPositioned: !0
      };
      ne.current && !yr(k.current, Y) && (k.current = Y, bd.flushSync(() => {
        l(Y);
      }));
    });
  }, [f, t, n, V]);
  or(() => {
    u === !1 && k.current.isPositioned && (k.current.isPositioned = !1, l((J) => ({
      ...J,
      isPositioned: !1
    })));
  }, [u]);
  const ne = pe.useRef(!1);
  or(() => (ne.current = !0, () => {
    ne.current = !1;
  }), []), or(() => {
    if (w && (T.current = w), x && (I.current = x), w && x) {
      if (B.current)
        return B.current(w, x, z);
      z();
    }
  }, [w, x, z, B]);
  const oe = pe.useMemo(() => ({
    reference: T,
    floating: I,
    setReference: h,
    setFloating: b
  }), [h, b]), D = pe.useMemo(() => ({
    reference: w,
    floating: x
  }), [w, x]), j = pe.useMemo(() => {
    const J = {
      position: n,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return J;
    const S = Ra(D.floating, d.x), Y = Ra(D.floating, d.y);
    return a ? {
      ...J,
      transform: "translate(" + S + "px, " + Y + "px)",
      ...lc(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: S,
      top: Y
    };
  }, [n, a, D.floating, d.x, d.y]);
  return pe.useMemo(() => ({
    ...d,
    update: z,
    refs: oe,
    elements: D,
    floatingStyles: j
  }), [d, z, oe, D, j]);
}
const Ap = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], ui = Ap.reduce((e, t) => {
  const n = /* @__PURE__ */ q((r, i) => {
    const { asChild: o, ...s } = r, a = o ? xt : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, M({}, s, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), Mp = /* @__PURE__ */ q((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ E(ui.svg, M({}, o, {
    ref: t,
    width: r,
    height: i,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ E("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), Dp = Mp, uc = "Popper", [dc, wn] = Ye(uc), [kp, fc] = dc(uc), Lp = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = ue(null);
  return /* @__PURE__ */ E(kp, {
    scope: t,
    anchor: r,
    onAnchorChange: i
  }, n);
}, jp = "PopperAnchor", Fp = /* @__PURE__ */ q((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...i } = e, o = fc(jp, n), s = U(null), a = Re(t, s);
  return te(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || s.current);
  }), r ? null : /* @__PURE__ */ E(ui.div, M({}, i, {
    ref: a
  }));
}), pc = "PopperContent", [Bp, Hp] = dc(pc), Vp = /* @__PURE__ */ q((e, t) => {
  var n, r, i, o, s, a, c, u;
  const { __scopePopper: d, side: l = "bottom", sideOffset: f = 0, align: p = "center", alignOffset: m = 0, arrowPadding: v = 0, avoidCollisions: _ = !0, collisionBoundary: $ = [], collisionPadding: h = 0, sticky: b = "partial", hideWhenDetached: w = !1, updatePositionStrategy: x = "optimized", onPlaced: T, ...I } = e, k = fc(pc, d), [B, V] = ue(null), z = Re(
    t,
    (be) => V(be)
  ), [ne, oe] = ue(null), D = Dr(ne), j = (n = D == null ? void 0 : D.width) !== null && n !== void 0 ? n : 0, J = (r = D == null ? void 0 : D.height) !== null && r !== void 0 ? r : 0, S = l + (p !== "center" ? "-" + p : ""), Y = typeof h == "number" ? h : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...h
  }, X = Array.isArray($) ? $ : [
    $
  ], A = X.length > 0, F = {
    padding: Y,
    boundary: X.filter(zp),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: A
  }, { refs: ie, floatingStyles: N, placement: R, isPositioned: P, middlewareData: O } = Pp({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: S,
    whileElementsMounted: (...be) => Np(...be, {
      animationFrame: x === "always"
    }),
    elements: {
      reference: k.anchor
    },
    middleware: [
      cp({
        mainAxis: f + J,
        alignmentAxis: m
      }),
      _ && lp({
        mainAxis: !0,
        crossAxis: !1,
        limiter: b === "partial" ? up() : void 0,
        ...F
      }),
      _ && ip({
        ...F
      }),
      dp({
        ...F,
        apply: ({ elements: be, rects: Te, availableWidth: Ne, availableHeight: Le }) => {
          const { width: je, height: Ue } = Te.reference, Pe = be.floating.style;
          Pe.setProperty("--radix-popper-available-width", `${Ne}px`), Pe.setProperty("--radix-popper-available-height", `${Le}px`), Pe.setProperty("--radix-popper-anchor-width", `${je}px`), Pe.setProperty("--radix-popper-anchor-height", `${Ue}px`);
        }
      }),
      ne && Rp({
        element: ne,
        padding: v
      }),
      Gp({
        arrowWidth: j,
        arrowHeight: J
      }),
      w && ap({
        strategy: "referenceHidden",
        ...F
      })
    ]
  }), [L, W] = gc(R), Z = Ve(T);
  St(() => {
    P && (Z == null || Z());
  }, [
    P,
    Z
  ]);
  const re = (i = O.arrow) === null || i === void 0 ? void 0 : i.x, fe = (o = O.arrow) === null || o === void 0 ? void 0 : o.y, H = ((s = O.arrow) === null || s === void 0 ? void 0 : s.centerOffset) !== 0, [ve, ee] = ue();
  return St(() => {
    B && ee(window.getComputedStyle(B).zIndex);
  }, [
    B
  ]), /* @__PURE__ */ E("div", {
    ref: ie.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...N,
      transform: P ? N.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: ve,
      "--radix-popper-transform-origin": [
        (a = O.transformOrigin) === null || a === void 0 ? void 0 : a.x,
        (c = O.transformOrigin) === null || c === void 0 ? void 0 : c.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ E(Bp, {
    scope: d,
    placedSide: L,
    onArrowChange: oe,
    arrowX: re,
    arrowY: fe,
    shouldHideArrow: H
  }, /* @__PURE__ */ E(ui.div, M({
    "data-side": L,
    "data-align": W
  }, I, {
    ref: z,
    style: {
      ...I.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: P ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = O.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
}), Up = "PopperArrow", Kp = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Wp = /* @__PURE__ */ q(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = Hp(Up, r), s = Kp[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ E("span", {
      ref: o.onArrowChange,
      style: {
        position: "absolute",
        left: o.arrowX,
        top: o.arrowY,
        [s]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[o.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[o.placedSide],
        visibility: o.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ E(Dp, M({}, i, {
      ref: n,
      style: {
        ...i.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function zp(e) {
  return e !== null;
}
const Gp = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, i, o, s;
    const { placement: a, rects: c, middlewareData: u } = t, l = ((n = u.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, f = l ? 0 : e.arrowWidth, p = l ? 0 : e.arrowHeight, [m, v] = gc(a), _ = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[v], $ = ((r = (i = u.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + f / 2, h = ((o = (s = u.arrow) === null || s === void 0 ? void 0 : s.y) !== null && o !== void 0 ? o : 0) + p / 2;
    let b = "", w = "";
    return m === "bottom" ? (b = l ? _ : `${$}px`, w = `${-p}px`) : m === "top" ? (b = l ? _ : `${$}px`, w = `${c.floating.height + p}px`) : m === "right" ? (b = `${-p}px`, w = l ? _ : `${h}px`) : m === "left" && (b = `${c.floating.width + p}px`, w = l ? _ : `${h}px`), {
      data: {
        x: b,
        y: w
      }
    };
  }
});
function gc(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const di = Lp, fi = Fp, pi = Vp, Yp = Wp, qp = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Xp = qp.reduce((e, t) => {
  const n = /* @__PURE__ */ q((r, i) => {
    const { asChild: o, ...s } = r, a = o ? xt : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, M({}, s, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), gi = /* @__PURE__ */ q((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = e;
  return r ? /* @__PURE__ */ Us.createPortal(/* @__PURE__ */ E(Xp.div, M({}, i, {
    ref: t
  })), r) : null;
}), Jp = /* @__PURE__ */ q((e, t) => /* @__PURE__ */ E(Oe.span, M({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), Zp = Jp, [Fr, XC] = Ye("Tooltip", [
  wn
]), Br = wn(), Qp = "TooltipProvider", eg = 700, $o = "tooltip.open", [tg, hi] = Fr(Qp), ng = (e) => {
  const { __scopeTooltip: t, delayDuration: n = eg, skipDelayDuration: r = 300, disableHoverableContent: i = !1, children: o } = e, [s, a] = ue(!0), c = U(!1), u = U(0);
  return te(() => {
    const d = u.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ E(tg, {
    scope: t,
    isOpenDelayed: s,
    delayDuration: n,
    onOpen: Q(() => {
      window.clearTimeout(u.current), a(!1);
    }, []),
    onClose: Q(() => {
      window.clearTimeout(u.current), u.current = window.setTimeout(
        () => a(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: c,
    onPointerInTransitChange: Q((d) => {
      c.current = d;
    }, []),
    disableHoverableContent: i
  }, o);
}, mi = "Tooltip", [rg, Fn] = Fr(mi), og = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: i = !1, onOpenChange: o, disableHoverableContent: s, delayDuration: a } = e, c = hi(mi, e.__scopeTooltip), u = Br(t), [d, l] = ue(null), f = Ze(), p = U(0), m = s ?? c.disableHoverableContent, v = a ?? c.delayDuration, _ = U(!1), [$ = !1, h] = ht({
    prop: r,
    defaultProp: i,
    onChange: (I) => {
      I ? (c.onOpen(), document.dispatchEvent(new CustomEvent($o))) : c.onClose(), o == null || o(I);
    }
  }), b = ze(() => $ ? _.current ? "delayed-open" : "instant-open" : "closed", [
    $
  ]), w = Q(() => {
    window.clearTimeout(p.current), _.current = !1, h(!0);
  }, [
    h
  ]), x = Q(() => {
    window.clearTimeout(p.current), h(!1);
  }, [
    h
  ]), T = Q(() => {
    window.clearTimeout(p.current), p.current = window.setTimeout(() => {
      _.current = !0, h(!0);
    }, v);
  }, [
    v,
    h
  ]);
  return te(() => () => window.clearTimeout(p.current), []), /* @__PURE__ */ E(di, u, /* @__PURE__ */ E(rg, {
    scope: t,
    contentId: f,
    open: $,
    stateAttribute: b,
    trigger: d,
    onTriggerChange: l,
    onTriggerEnter: Q(() => {
      c.isOpenDelayed ? T() : w();
    }, [
      c.isOpenDelayed,
      T,
      w
    ]),
    onTriggerLeave: Q(() => {
      m ? x() : window.clearTimeout(p.current);
    }, [
      x,
      m
    ]),
    onOpen: w,
    onClose: x,
    disableHoverableContent: m
  }, n));
}, Aa = "TooltipTrigger", ig = /* @__PURE__ */ q((e, t) => {
  const { __scopeTooltip: n, ...r } = e, i = Fn(Aa, n), o = hi(Aa, n), s = Br(n), a = U(null), c = Re(t, a, i.onTriggerChange), u = U(!1), d = U(!1), l = Q(
    () => u.current = !1,
    []
  );
  return te(() => () => document.removeEventListener("pointerup", l), [
    l
  ]), /* @__PURE__ */ E(fi, M({
    asChild: !0
  }, s), /* @__PURE__ */ E(Oe.button, M({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": i.open ? i.contentId : void 0,
    "data-state": i.stateAttribute
  }, r, {
    ref: c,
    onPointerMove: le(e.onPointerMove, (f) => {
      f.pointerType !== "touch" && !d.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: le(e.onPointerLeave, () => {
      i.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: le(e.onPointerDown, () => {
      u.current = !0, document.addEventListener("pointerup", l, {
        once: !0
      });
    }),
    onFocus: le(e.onFocus, () => {
      u.current || i.onOpen();
    }),
    onBlur: le(e.onBlur, i.onClose),
    onClick: le(e.onClick, i.onClose)
  })));
}), hc = "TooltipPortal", [ag, sg] = Fr(hc, {
  forceMount: void 0
}), cg = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = Fn(hc, t);
  return /* @__PURE__ */ E(ag, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ E(tt, {
    present: n || o.open
  }, /* @__PURE__ */ E(gi, {
    asChild: !0,
    container: i
  }, r)));
}, Nn = "TooltipContent", lg = /* @__PURE__ */ q((e, t) => {
  const n = sg(Nn, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, s = Fn(Nn, e.__scopeTooltip);
  return /* @__PURE__ */ E(tt, {
    present: r || s.open
  }, s.disableHoverableContent ? /* @__PURE__ */ E(mc, M({
    side: i
  }, o, {
    ref: t
  })) : /* @__PURE__ */ E(ug, M({
    side: i
  }, o, {
    ref: t
  })));
}), ug = /* @__PURE__ */ q((e, t) => {
  const n = Fn(Nn, e.__scopeTooltip), r = hi(Nn, e.__scopeTooltip), i = U(null), o = Re(t, i), [s, a] = ue(null), { trigger: c, onClose: u } = n, d = i.current, { onPointerInTransitChange: l } = r, f = Q(() => {
    a(null), l(!1);
  }, [
    l
  ]), p = Q((m, v) => {
    const _ = m.currentTarget, $ = {
      x: m.clientX,
      y: m.clientY
    }, h = hg($, _.getBoundingClientRect()), b = mg($, h), w = vg(v.getBoundingClientRect()), x = yg([
      ...b,
      ...w
    ]);
    a(x), l(!0);
  }, [
    l
  ]);
  return te(() => () => f(), [
    f
  ]), te(() => {
    if (c && d) {
      const m = (_) => p(_, d), v = (_) => p(_, c);
      return c.addEventListener("pointerleave", m), d.addEventListener("pointerleave", v), () => {
        c.removeEventListener("pointerleave", m), d.removeEventListener("pointerleave", v);
      };
    }
  }, [
    c,
    d,
    p,
    f
  ]), te(() => {
    if (s) {
      const m = (v) => {
        const _ = v.target, $ = {
          x: v.clientX,
          y: v.clientY
        }, h = (c == null ? void 0 : c.contains(_)) || (d == null ? void 0 : d.contains(_)), b = !bg($, s);
        h ? f() : b && (f(), u());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [
    c,
    d,
    s,
    u,
    f
  ]), /* @__PURE__ */ E(mc, M({}, e, {
    ref: o
  }));
}), [dg, fg] = Fr(mi, {
  isInside: !1
}), mc = /* @__PURE__ */ q((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": i, onEscapeKeyDown: o, onPointerDownOutside: s, ...a } = e, c = Fn(Nn, n), u = Br(n), { onClose: d } = c;
  return te(() => (document.addEventListener($o, d), () => document.removeEventListener($o, d)), [
    d
  ]), te(() => {
    if (c.trigger) {
      const l = (f) => {
        const p = f.target;
        p != null && p.contains(c.trigger) && d();
      };
      return window.addEventListener("scroll", l, {
        capture: !0
      }), () => window.removeEventListener("scroll", l, {
        capture: !0
      });
    }
  }, [
    c.trigger,
    d
  ]), /* @__PURE__ */ E(ri, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: o,
    onPointerDownOutside: s,
    onFocusOutside: (l) => l.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ E(pi, M({
    "data-state": c.stateAttribute
  }, u, a, {
    ref: t,
    style: {
      ...a.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ E(Ys, null, r), /* @__PURE__ */ E(dg, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ E(Zp, {
    id: c.contentId,
    role: "tooltip"
  }, i || r))));
}), pg = "TooltipArrow", gg = /* @__PURE__ */ q((e, t) => {
  const { __scopeTooltip: n, ...r } = e, i = Br(n);
  return fg(pg, n).isInside ? null : /* @__PURE__ */ E(Yp, M({}, i, r, {
    ref: t
  }));
});
function hg(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function mg(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function vg(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    {
      x: i,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: i,
      y: r
    }
  ];
}
function bg(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const a = t[o].x, c = t[o].y, u = t[s].x, d = t[s].y;
    c > r != d > r && n < (u - a) * (r - c) / (d - c) + a && (i = !i);
  }
  return i;
}
function yg(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), xg(t);
}
function xg(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], s = t[t.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x))
        t.pop();
      else
        break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], s = n[n.length - 2];
      if ((o.x - s.x) * (i.y - s.y) >= (o.y - s.y) * (i.x - s.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const wg = ng, _g = og, $g = ig, Cg = cg, Eg = lg, Ig = gg, Sg = g(
  "ui-z-30 ui-rounded-lg ui-px-3 ui-py-2 ui-font-sans ui-text-paragraph-100-regular ui-shadow-gray-lg"
), Og = g("ui-outline-none"), Ng = {
  light: g("ui-bg-white ui-text-grayscale-700"),
  dark: g("ui-bg-grayscale-950 ui-text-white")
}, Tg = g("ui-mb-1 ui-text-label-100"), Rg = {
  light: g("ui-text-grayscale-950"),
  dark: g("")
}, Pg = {
  light: g("ui-fill-white"),
  dark: g("ui-fill-grayscale-950")
}, vi = ({
  className: e,
  children: t,
  title: n,
  content: r,
  withArrow: i,
  side: o,
  align: s,
  open: a,
  sideOffset: c = 4,
  theme: u = "dark",
  disabled: d
}) => /* @__PURE__ */ y.jsx(wg, { children: /* @__PURE__ */ y.jsxs(_g, { open: d ? !1 : a, delayDuration: 150, children: [
  /* @__PURE__ */ y.jsx($g, { asChild: !0, className: Og, children: t }),
  /* @__PURE__ */ y.jsx(Cg, { children: /* @__PURE__ */ y.jsxs(
    Eg,
    {
      className: g(
        e,
        Sg,
        Ng[u]
      ),
      side: o,
      align: s,
      collisionPadding: 8,
      arrowPadding: 10,
      sideOffset: c,
      style: {
        maxWidth: "min(320px, var(--radix-popper-available-width))"
      },
      children: [
        n ? /* @__PURE__ */ y.jsx("div", { className: g(Tg, Rg[u]), children: n }) : null,
        r,
        i ? /* @__PURE__ */ y.jsx(Ig, { className: Pg[u] }) : null
      ]
    }
  ) })
] }) }), Ag = g(
  "ui-mb-1.5 ui-block ui-text-label-200 ui-text-grayscale-700"
), Hr = q(
  ({ className: e, label: t, tooltip: n, ...r }, i) => t ? /* @__PURE__ */ y.jsxs("label", { ref: i, ...r, className: g(e, Ag), children: [
    t,
    n != null && n.content ? /* @__PURE__ */ y.jsx(vi, { content: n.content, title: n.title, withArrow: !0, children: /* @__PURE__ */ y.jsx(xd, { className: "-ui-my-0.5 ui-ml-1 ui-inline-block ui-text-grayscale-400" }) }) : null
  ] }) : null
), Mg = g(
  "ui-flex ui-border ui-border-grayscale-200 ui-bg-white ui-transition",
  "focus-within:ui-border-primary-300 focus-within:ui-shadow-focus",
  "data-[disabled=true]:ui-bg-grayscale-100 data-[disabled=true]:ui-shadow-gray-xs",
  "hover:ui-border-primary-500 data-[disabled=true]:ui-border-grayscale-300",
  "data-[invalid=true]:ui-border-critical-300"
), Dg = {
  xs: g("ui-h-8 ui-rounded ui-text-paragraph-200-regular"),
  sm: g("ui-h-10 ui-rounded-lg ui-text-paragraph-200-regular"),
  md: g("ui-h-11 ui-rounded-lg ui-text-paragraph-300-regular")
}, kg = g(
  "ui-block ui-w-full ui-text-ellipsis ui-bg-transparent ui-px-3.5 ui-text-grayscale-950 ui-outline-none",
  "placeholder:ui-text-grayscale-500 disabled:placeholder:ui-text-grayscale-300",
  "disabled:ui-text-grayscale-500"
), Ma = g(
  "ui-relative ui-self-center",
  "first:ui--mr-1.5 first:ui-pl-3.5",
  "last:ui--ml-1.5 last:ui-pr-3.5"
), vc = q(
  ({
    leadingSlot: e,
    leadingElement: t,
    trailingSlot: n,
    trailingElement: r,
    className: i,
    size: o = "md",
    ...s
  }, a) => /* @__PURE__ */ y.jsxs(
    "div",
    {
      "data-disabled": s.disabled,
      "data-invalid": s["aria-invalid"],
      className: g(
        i,
        Mg,
        Dg[o]
      ),
      children: [
        t || (e ? /* @__PURE__ */ y.jsx("div", { className: Ma, children: e }) : null),
        /* @__PURE__ */ y.jsx("input", { ref: a, className: kg, ...s }),
        r || (n ? /* @__PURE__ */ y.jsx("div", { className: Ma, children: n }) : null)
      ]
    }
  )
), Mt = {
  light: g("ui-animate-[loading-light_800ms_0ms_ease-out_infinite_both]"),
  dark: g("ui-animate-[loading-dark_800ms_0ms_ease-out_infinite_both]")
}, bc = ({ theme: e = "dark", ...t }) => /* @__PURE__ */ y.jsxs(
  "svg",
  {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t,
    children: [
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "200ms" },
          className: Mt[e],
          cx: "4",
          cy: "24",
          r: "4"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "600ms" },
          className: Mt[e],
          cx: "44",
          cy: "24",
          r: "4"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "400ms" },
          className: Mt[e],
          cx: "24",
          cy: "4",
          r: "4"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "0ms" },
          className: Mt[e],
          cx: "24",
          cy: "44",
          r: "4"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "500ms" },
          className: Mt[e],
          cx: "38.1421",
          cy: "9.85784",
          r: "4",
          transform: "rotate(45 38.1421 9.85784)"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "100ms" },
          className: Mt[e],
          cx: "9.85791",
          cy: "38.1421",
          r: "4",
          transform: "rotate(45 9.85791 38.1421)"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "700ms" },
          className: Mt[e],
          cx: "38.142",
          cy: "38.1421",
          r: "4",
          transform: "rotate(135 38.142 38.1421)"
        }
      ),
      /* @__PURE__ */ y.jsx(
        "circle",
        {
          style: { animationDelay: "300ms" },
          className: Mt[e],
          cx: "9.85779",
          cy: "9.85785",
          r: "4",
          transform: "rotate(135 9.85779 9.85785)"
        }
      )
    ]
  }
), Lg = g("ui-animate-pulse ui-bg-gradient-linear-gray"), JC = ({
  className: e,
  ...t
}) => /* @__PURE__ */ y.jsx("span", { ...t, className: g(Lg, e) }), jg = /* @__PURE__ */ fr(void 0);
function Qt(e) {
  const t = Yo(jg);
  return e || t || "ltr";
}
function Fg(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Bg(e, t) {
  return Jo((n, r) => {
    const i = t[n][r];
    return i ?? n;
  }, e);
}
const yc = "ScrollArea", [xc, ZC] = Ye(yc), [Hg, _t] = xc(yc), Vg = /* @__PURE__ */ q((e, t) => {
  const { __scopeScrollArea: n, type: r = "hover", dir: i, scrollHideDelay: o = 600, ...s } = e, [a, c] = ue(null), [u, d] = ue(null), [l, f] = ue(null), [p, m] = ue(null), [v, _] = ue(null), [$, h] = ue(0), [b, w] = ue(0), [x, T] = ue(!1), [I, k] = ue(!1), B = Re(
    t,
    (z) => c(z)
  ), V = Qt(i);
  return /* @__PURE__ */ E(Hg, {
    scope: n,
    type: r,
    dir: V,
    scrollHideDelay: o,
    scrollArea: a,
    viewport: u,
    onViewportChange: d,
    content: l,
    onContentChange: f,
    scrollbarX: p,
    onScrollbarXChange: m,
    scrollbarXEnabled: x,
    onScrollbarXEnabledChange: T,
    scrollbarY: v,
    onScrollbarYChange: _,
    scrollbarYEnabled: I,
    onScrollbarYEnabledChange: k,
    onCornerWidthChange: h,
    onCornerHeightChange: w
  }, /* @__PURE__ */ E(Oe.div, M({
    dir: V
  }, s, {
    ref: B,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      "--radix-scroll-area-corner-width": $ + "px",
      "--radix-scroll-area-corner-height": b + "px",
      ...e.style
    }
  })));
}), Ug = "ScrollAreaViewport", Kg = /* @__PURE__ */ q((e, t) => {
  const { __scopeScrollArea: n, children: r, ...i } = e, o = _t(Ug, n), s = U(null), a = Re(t, s, o.onViewportChange);
  return /* @__PURE__ */ E(Xo, null, /* @__PURE__ */ E("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ E(Oe.div, M({
    "data-radix-scroll-area-viewport": ""
  }, i, {
    ref: a,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: o.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: o.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    }
  }), /* @__PURE__ */ E("div", {
    ref: o.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, r)));
}), Pt = "ScrollAreaScrollbar", Wg = /* @__PURE__ */ q((e, t) => {
  const { forceMount: n, ...r } = e, i = _t(Pt, e.__scopeScrollArea), { onScrollbarXEnabledChange: o, onScrollbarYEnabledChange: s } = i, a = e.orientation === "horizontal";
  return te(() => (a ? o(!0) : s(!0), () => {
    a ? o(!1) : s(!1);
  }), [
    a,
    o,
    s
  ]), i.type === "hover" ? /* @__PURE__ */ E(zg, M({}, r, {
    ref: t,
    forceMount: n
  })) : i.type === "scroll" ? /* @__PURE__ */ E(Gg, M({}, r, {
    ref: t,
    forceMount: n
  })) : i.type === "auto" ? /* @__PURE__ */ E(wc, M({}, r, {
    ref: t,
    forceMount: n
  })) : i.type === "always" ? /* @__PURE__ */ E(bi, M({}, r, {
    ref: t
  })) : null;
}), zg = /* @__PURE__ */ q((e, t) => {
  const { forceMount: n, ...r } = e, i = _t(Pt, e.__scopeScrollArea), [o, s] = ue(!1);
  return te(() => {
    const a = i.scrollArea;
    let c = 0;
    if (a) {
      const u = () => {
        window.clearTimeout(c), s(!0);
      }, d = () => {
        c = window.setTimeout(
          () => s(!1),
          i.scrollHideDelay
        );
      };
      return a.addEventListener("pointerenter", u), a.addEventListener("pointerleave", d), () => {
        window.clearTimeout(c), a.removeEventListener("pointerenter", u), a.removeEventListener("pointerleave", d);
      };
    }
  }, [
    i.scrollArea,
    i.scrollHideDelay
  ]), /* @__PURE__ */ E(tt, {
    present: n || o
  }, /* @__PURE__ */ E(wc, M({
    "data-state": o ? "visible" : "hidden"
  }, r, {
    ref: t
  })));
}), Gg = /* @__PURE__ */ q((e, t) => {
  const { forceMount: n, ...r } = e, i = _t(Pt, e.__scopeScrollArea), o = e.orientation === "horizontal", s = Ur(
    () => c("SCROLL_END"),
    100
  ), [a, c] = Bg("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return te(() => {
    if (a === "idle") {
      const u = window.setTimeout(
        () => c("HIDE"),
        i.scrollHideDelay
      );
      return () => window.clearTimeout(u);
    }
  }, [
    a,
    i.scrollHideDelay,
    c
  ]), te(() => {
    const u = i.viewport, d = o ? "scrollLeft" : "scrollTop";
    if (u) {
      let l = u[d];
      const f = () => {
        const p = u[d];
        l !== p && (c("SCROLL"), s()), l = p;
      };
      return u.addEventListener("scroll", f), () => u.removeEventListener("scroll", f);
    }
  }, [
    i.viewport,
    o,
    c,
    s
  ]), /* @__PURE__ */ E(tt, {
    present: n || a !== "hidden"
  }, /* @__PURE__ */ E(bi, M({
    "data-state": a === "hidden" ? "hidden" : "visible"
  }, r, {
    ref: t,
    onPointerEnter: le(
      e.onPointerEnter,
      () => c("POINTER_ENTER")
    ),
    onPointerLeave: le(
      e.onPointerLeave,
      () => c("POINTER_LEAVE")
    )
  })));
}), wc = /* @__PURE__ */ q((e, t) => {
  const n = _t(Pt, e.__scopeScrollArea), { forceMount: r, ...i } = e, [o, s] = ue(!1), a = e.orientation === "horizontal", c = Ur(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, d = n.viewport.offsetHeight < n.viewport.scrollHeight;
      s(a ? u : d);
    }
  }, 10);
  return wr(n.viewport, c), wr(n.content, c), /* @__PURE__ */ E(tt, {
    present: r || o
  }, /* @__PURE__ */ E(bi, M({
    "data-state": o ? "visible" : "hidden"
  }, i, {
    ref: t
  })));
}), bi = /* @__PURE__ */ q((e, t) => {
  const { orientation: n = "vertical", ...r } = e, i = _t(Pt, e.__scopeScrollArea), o = U(null), s = U(0), [a, c] = ue({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), u = Cc(a.viewport, a.content), d = {
    ...r,
    sizes: a,
    onSizesChange: c,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (f) => o.current = f,
    onThumbPointerUp: () => s.current = 0,
    onThumbPointerDown: (f) => s.current = f
  };
  function l(f, p) {
    return Qg(f, s.current, a, p);
  }
  return n === "horizontal" ? /* @__PURE__ */ E(Yg, M({}, d, {
    ref: t,
    onThumbPositionChange: () => {
      if (i.viewport && o.current) {
        const f = i.viewport.scrollLeft, p = Da(f, a, i.dir);
        o.current.style.transform = `translate3d(${p}px, 0, 0)`;
      }
    },
    onWheelScroll: (f) => {
      i.viewport && (i.viewport.scrollLeft = f);
    },
    onDragScroll: (f) => {
      i.viewport && (i.viewport.scrollLeft = l(f, i.dir));
    }
  })) : n === "vertical" ? /* @__PURE__ */ E(qg, M({}, d, {
    ref: t,
    onThumbPositionChange: () => {
      if (i.viewport && o.current) {
        const f = i.viewport.scrollTop, p = Da(f, a);
        o.current.style.transform = `translate3d(0, ${p}px, 0)`;
      }
    },
    onWheelScroll: (f) => {
      i.viewport && (i.viewport.scrollTop = f);
    },
    onDragScroll: (f) => {
      i.viewport && (i.viewport.scrollTop = l(f));
    }
  })) : null;
}), Yg = /* @__PURE__ */ q((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = _t(Pt, e.__scopeScrollArea), [s, a] = ue(), c = U(null), u = Re(t, c, o.onScrollbarXChange);
  return te(() => {
    c.current && a(getComputedStyle(c.current));
  }, [
    c
  ]), /* @__PURE__ */ E($c, M({
    "data-orientation": "horizontal"
  }, i, {
    ref: u,
    sizes: n,
    style: {
      bottom: 0,
      left: o.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: o.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": Vr(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.x),
    onDragScroll: (d) => e.onDragScroll(d.x),
    onWheelScroll: (d, l) => {
      if (o.viewport) {
        const f = o.viewport.scrollLeft + d.deltaX;
        e.onWheelScroll(f), Ic(f, l) && d.preventDefault();
      }
    },
    onResize: () => {
      c.current && o.viewport && s && r({
        content: o.viewport.scrollWidth,
        viewport: o.viewport.offsetWidth,
        scrollbar: {
          size: c.current.clientWidth,
          paddingStart: xr(s.paddingLeft),
          paddingEnd: xr(s.paddingRight)
        }
      });
    }
  }));
}), qg = /* @__PURE__ */ q((e, t) => {
  const { sizes: n, onSizesChange: r, ...i } = e, o = _t(Pt, e.__scopeScrollArea), [s, a] = ue(), c = U(null), u = Re(t, c, o.onScrollbarYChange);
  return te(() => {
    c.current && a(getComputedStyle(c.current));
  }, [
    c
  ]), /* @__PURE__ */ E($c, M({
    "data-orientation": "vertical"
  }, i, {
    ref: u,
    sizes: n,
    style: {
      top: 0,
      right: o.dir === "ltr" ? 0 : void 0,
      left: o.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": Vr(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (d) => e.onThumbPointerDown(d.y),
    onDragScroll: (d) => e.onDragScroll(d.y),
    onWheelScroll: (d, l) => {
      if (o.viewport) {
        const f = o.viewport.scrollTop + d.deltaY;
        e.onWheelScroll(f), Ic(f, l) && d.preventDefault();
      }
    },
    onResize: () => {
      c.current && o.viewport && s && r({
        content: o.viewport.scrollHeight,
        viewport: o.viewport.offsetHeight,
        scrollbar: {
          size: c.current.clientHeight,
          paddingStart: xr(s.paddingTop),
          paddingEnd: xr(s.paddingBottom)
        }
      });
    }
  }));
}), [Xg, _c] = xc(Pt), $c = /* @__PURE__ */ q((e, t) => {
  const { __scopeScrollArea: n, sizes: r, hasThumb: i, onThumbChange: o, onThumbPointerUp: s, onThumbPointerDown: a, onThumbPositionChange: c, onDragScroll: u, onWheelScroll: d, onResize: l, ...f } = e, p = _t(Pt, n), [m, v] = ue(null), _ = Re(
    t,
    (B) => v(B)
  ), $ = U(null), h = U(""), b = p.viewport, w = r.content - r.viewport, x = Ve(d), T = Ve(c), I = Ur(l, 10);
  function k(B) {
    if ($.current) {
      const V = B.clientX - $.current.left, z = B.clientY - $.current.top;
      u({
        x: V,
        y: z
      });
    }
  }
  return te(() => {
    const B = (V) => {
      const z = V.target;
      (m == null ? void 0 : m.contains(z)) && x(V, w);
    };
    return document.addEventListener("wheel", B, {
      passive: !1
    }), () => document.removeEventListener("wheel", B, {
      passive: !1
    });
  }, [
    b,
    m,
    w,
    x
  ]), te(T, [
    r,
    T
  ]), wr(m, I), wr(p.content, I), /* @__PURE__ */ E(Xg, {
    scope: n,
    scrollbar: m,
    hasThumb: i,
    onThumbChange: Ve(o),
    onThumbPointerUp: Ve(s),
    onThumbPositionChange: T,
    onThumbPointerDown: Ve(a)
  }, /* @__PURE__ */ E(Oe.div, M({}, f, {
    ref: _,
    style: {
      position: "absolute",
      ...f.style
    },
    onPointerDown: le(e.onPointerDown, (B) => {
      B.button === 0 && (B.target.setPointerCapture(B.pointerId), $.current = m.getBoundingClientRect(), h.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", k(B));
    }),
    onPointerMove: le(e.onPointerMove, k),
    onPointerUp: le(e.onPointerUp, (B) => {
      const V = B.target;
      V.hasPointerCapture(B.pointerId) && V.releasePointerCapture(B.pointerId), document.body.style.webkitUserSelect = h.current, $.current = null;
    })
  })));
}), Co = "ScrollAreaThumb", Jg = /* @__PURE__ */ q((e, t) => {
  const { forceMount: n, ...r } = e, i = _c(Co, e.__scopeScrollArea);
  return /* @__PURE__ */ E(tt, {
    present: n || i.hasThumb
  }, /* @__PURE__ */ E(Zg, M({
    ref: t
  }, r)));
}), Zg = /* @__PURE__ */ q((e, t) => {
  const { __scopeScrollArea: n, style: r, ...i } = e, o = _t(Co, n), s = _c(Co, n), { onThumbPositionChange: a } = s, c = Re(
    t,
    (l) => s.onThumbChange(l)
  ), u = U(), d = Ur(() => {
    u.current && (u.current(), u.current = void 0);
  }, 100);
  return te(() => {
    const l = o.viewport;
    if (l) {
      const f = () => {
        if (d(), !u.current) {
          const p = eh(l, a);
          u.current = p, a();
        }
      };
      return a(), l.addEventListener("scroll", f), () => l.removeEventListener("scroll", f);
    }
  }, [
    o.viewport,
    d,
    a
  ]), /* @__PURE__ */ E(Oe.div, M({
    "data-state": s.hasThumb ? "visible" : "hidden"
  }, i, {
    ref: c,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...r
    },
    onPointerDownCapture: le(e.onPointerDownCapture, (l) => {
      const p = l.target.getBoundingClientRect(), m = l.clientX - p.left, v = l.clientY - p.top;
      s.onThumbPointerDown({
        x: m,
        y: v
      });
    }),
    onPointerUp: le(e.onPointerUp, s.onThumbPointerUp)
  }));
});
function xr(e) {
  return e ? parseInt(e, 10) : 0;
}
function Cc(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Vr(e) {
  const t = Cc(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function Qg(e, t, n, r = "ltr") {
  const i = Vr(n), o = i / 2, s = t || o, a = i - s, c = n.scrollbar.paddingStart + s, u = n.scrollbar.size - n.scrollbar.paddingEnd - a, d = n.content - n.viewport, l = r === "ltr" ? [
    0,
    d
  ] : [
    d * -1,
    0
  ];
  return Ec([
    c,
    u
  ], l)(e);
}
function Da(e, t, n = "ltr") {
  const r = Vr(t), i = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, o = t.scrollbar.size - i, s = t.content - t.viewport, a = o - r, c = n === "ltr" ? [
    0,
    s
  ] : [
    s * -1,
    0
  ], u = Fg(e, c);
  return Ec([
    0,
    s
  ], [
    0,
    a
  ])(u);
}
function Ec(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Ic(e, t) {
  return e > 0 && e < t;
}
const eh = (e, t = () => {
}) => {
  let n = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, r = 0;
  return function i() {
    const o = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, s = n.left !== o.left, a = n.top !== o.top;
    (s || a) && t(), n = o, r = window.requestAnimationFrame(i);
  }(), () => window.cancelAnimationFrame(r);
};
function Ur(e, t) {
  const n = Ve(e), r = U(0);
  return te(
    () => () => window.clearTimeout(r.current),
    []
  ), Q(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [
    n,
    t
  ]);
}
function wr(e, t) {
  const n = Ve(t);
  St(() => {
    let r = 0;
    if (e) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return i.observe(e), () => {
        window.cancelAnimationFrame(r), i.unobserve(e);
      };
    }
  }, [
    e,
    n
  ]);
}
const Sc = Vg, Oc = Kg, Eo = Wg, ka = Jg, th = g("ui-flex ui-min-w-0 ui-flex-1 ui-flex-col"), La = g("ui-z-20 ui-flex ui-touch-none ui-select-none"), nh = g("ui-flex-col ui-py-0.5"), rh = g("ui-px-0.5"), ja = g("ui-relative ui-rounded ui-transition-colors"), oh = {
  sm: g("ui-w-2 ui-px-0.5"),
  md: g("ui-w-3.5 ui-px-1")
}, ih = {
  sm: g("ui-h-2 ui-py-0.5"),
  md: g("ui-h-3.5 ui-py-1")
}, Fa = {
  dark: g("ui-bg-grayscale-200 hover:ui-bg-grayscale-300"),
  light: g("ui-bg-grayscale-200/70 hover:ui-bg-grayscale-200")
}, Bn = ({
  className: e,
  scrollBarClassName: t,
  children: n,
  size: r = "md",
  theme: i = "dark",
  ...o
}) => /* @__PURE__ */ y.jsxs(Sc, { ...o, className: g(th, e), children: [
  /* @__PURE__ */ y.jsx(Oc, { children: n }),
  /* @__PURE__ */ y.jsx(
    Eo,
    {
      forceMount: !0,
      orientation: "vertical",
      className: g(
        La,
        nh,
        t,
        oh[r]
      ),
      children: /* @__PURE__ */ y.jsx(
        ka,
        {
          className: g(ja, Fa[i])
        }
      )
    }
  ),
  /* @__PURE__ */ y.jsx(
    Eo,
    {
      forceMount: !0,
      orientation: "horizontal",
      className: g(
        La,
        rh,
        t,
        ih[r]
      ),
      children: /* @__PURE__ */ y.jsx(
        ka,
        {
          className: g(ja, Fa[i])
        }
      )
    }
  )
] }), ah = g(
  "ui-group ui-relative ui-isolate ui-flex ui-p-px ui-shadow-gray-md ui-outline-none",
  "ui-transition",
  "ui-rounded-xl before:ui-rounded-xl after:ui-rounded-xl",
  "before:ui-absolute before:ui-inset-0 before:-ui-z-10 after:ui-absolute after:ui-inset-0 after:-ui-z-10",
  "before:ui-content-[''] after:ui-content-['']",
  "before:ui-bg-gradient-radial-gray after:ui-bg-gradient-radial-blue",
  "after:ui-opacity-0"
), sh = g(
  "hover:ui-shadow-gray-2xl hover:before:ui-opacity-0 hover:after:ui-opacity-100",
  "focus-visible:ui-shadow-focus"
), ch = g(
  "ui-relative ui-flex ui-h-full ui-min-w-0 ui-flex-1 ui-flex-col ui-rounded-[11px] ui-bg-white"
), yi = q(
  ({
    as: e,
    children: t,
    className: n,
    interactive: r,
    ...i
  }, o) => {
    const s = e || "div";
    return /* @__PURE__ */ y.jsx(
      s,
      {
        ref: o,
        ...i,
        className: g(ah, n, {
          [sh]: r
        }),
        children: /* @__PURE__ */ y.jsx("div", { className: ch, children: t })
      }
    );
  }
), lh = g(
  "ui-whitespace-nowrap ui-outline-none ui-transition"
), uh = {
  light: g(
    "focus-visible:ui-shadow-focus enabled:hover:ui-bg-primary-50 enabled:active:ui-bg-primary-100"
  ),
  dark: g(
    "focus-visible:ui-shadow-focus-dark enabled:hover:ui-opacity-70 enabled:active:ui-opacity-50 disabled:ui-opacity-60"
  )
}, Nc = q(
  ({
    as: e,
    children: t,
    className: n,
    background: r = "light",
    type: i = "button",
    ...o
  }, s) => {
    const a = e || "button";
    return /* @__PURE__ */ y.jsx(
      a,
      {
        ref: s,
        ...o,
        type: i,
        className: g(
          lh,
          uh[r],
          n
        ),
        children: t
      }
    );
  }
), dh = g(
  "ui-flex ui-flex-col ui-items-center ui-gap-2 ui-text-center"
), fh = g("ui-text-heading-h2 ui-text-warning-900"), ph = g("ui-text-heading-h4 ui-text-grayscale-950"), gh = g(
  "ui-text-paragraph-200-regular ui-text-grayscale-700"
), hh = g(
  "ui-text-paragraph-200-medium ui-text-critical-900 ui-underline ui-underline-offset-2 ui-transition",
  "hover:ui-no-underline",
  "active:ui-text-critical-950"
), mh = ({ title: e, message: t, onRetry: n }) => /* @__PURE__ */ y.jsxs("div", { className: dh, children: [
  /* @__PURE__ */ y.jsx("div", { className: fh, children: "👀" }),
  e ? /* @__PURE__ */ y.jsx("div", { className: ph, children: e }) : null,
  t ? /* @__PURE__ */ y.jsx("div", { className: gh, children: t }) : null,
  n ? /* @__PURE__ */ y.jsx("button", { className: hh, onClick: n, children: "Refresh" }) : null
] });
function Kr(e) {
  const t = e + "CollectionProvider", [n, r] = Ye(t), [i, o] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), s = (p) => {
    const { scope: m, children: v } = p, _ = ke.useRef(null), $ = ke.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ ke.createElement(i, {
      scope: m,
      itemMap: $,
      collectionRef: _
    }, v);
  }, a = e + "CollectionSlot", c = /* @__PURE__ */ ke.forwardRef((p, m) => {
    const { scope: v, children: _ } = p, $ = o(a, v), h = Re(m, $.collectionRef);
    return /* @__PURE__ */ ke.createElement(xt, {
      ref: h
    }, _);
  }), u = e + "CollectionItemSlot", d = "data-radix-collection-item", l = /* @__PURE__ */ ke.forwardRef((p, m) => {
    const { scope: v, children: _, ...$ } = p, h = ke.useRef(null), b = Re(m, h), w = o(u, v);
    return ke.useEffect(() => (w.itemMap.set(h, {
      ref: h,
      ...$
    }), () => void w.itemMap.delete(h))), /* @__PURE__ */ ke.createElement(xt, {
      [d]: "",
      ref: b
    }, _);
  });
  function f(p) {
    const m = o(e + "CollectionConsumer", p);
    return ke.useCallback(() => {
      const _ = m.collectionRef.current;
      if (!_)
        return [];
      const $ = Array.from(_.querySelectorAll(`[${d}]`));
      return Array.from(m.itemMap.values()).sort(
        (w, x) => $.indexOf(w.ref.current) - $.indexOf(x.ref.current)
      );
    }, [
      m.collectionRef,
      m.itemMap
    ]);
  }
  return [
    {
      Provider: s,
      Slot: c,
      ItemSlot: l
    },
    f,
    r
  ];
}
const Qr = "rovingFocusGroup.onEntryFocus", vh = {
  bubbles: !1,
  cancelable: !0
}, xi = "RovingFocusGroup", [Io, Tc, bh] = Kr(xi), [yh, Rc] = Ye(xi, [
  bh
]), [xh, wh] = yh(xi), _h = /* @__PURE__ */ q((e, t) => /* @__PURE__ */ E(Io.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ E(Io.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ E($h, M({}, e, {
  ref: t
}))))), $h = /* @__PURE__ */ q((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: i = !1, dir: o, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: c, onEntryFocus: u, ...d } = e, l = U(null), f = Re(t, l), p = Qt(o), [m = null, v] = ht({
    prop: s,
    defaultProp: a,
    onChange: c
  }), [_, $] = ue(!1), h = Ve(u), b = Tc(n), w = U(!1), [x, T] = ue(0);
  return te(() => {
    const I = l.current;
    if (I)
      return I.addEventListener(Qr, h), () => I.removeEventListener(Qr, h);
  }, [
    h
  ]), /* @__PURE__ */ E(xh, {
    scope: n,
    orientation: r,
    dir: p,
    loop: i,
    currentTabStopId: m,
    onItemFocus: Q(
      (I) => v(I),
      [
        v
      ]
    ),
    onItemShiftTab: Q(
      () => $(!0),
      []
    ),
    onFocusableItemAdd: Q(
      () => T(
        (I) => I + 1
      ),
      []
    ),
    onFocusableItemRemove: Q(
      () => T(
        (I) => I - 1
      ),
      []
    )
  }, /* @__PURE__ */ E(Oe.div, M({
    tabIndex: _ || x === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: le(e.onMouseDown, () => {
      w.current = !0;
    }),
    onFocus: le(e.onFocus, (I) => {
      const k = !w.current;
      if (I.target === I.currentTarget && k && !_) {
        const B = new CustomEvent(Qr, vh);
        if (I.currentTarget.dispatchEvent(B), !B.defaultPrevented) {
          const V = b().filter(
            (j) => j.focusable
          ), z = V.find(
            (j) => j.active
          ), ne = V.find(
            (j) => j.id === m
          ), D = [
            z,
            ne,
            ...V
          ].filter(Boolean).map(
            (j) => j.ref.current
          );
          Pc(D);
        }
      }
      w.current = !1;
    }),
    onBlur: le(
      e.onBlur,
      () => $(!1)
    )
  })));
}), Ch = "RovingFocusGroupItem", Eh = /* @__PURE__ */ q((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: i = !1, tabStopId: o, ...s } = e, a = Ze(), c = o || a, u = wh(Ch, n), d = u.currentTabStopId === c, l = Tc(n), { onFocusableItemAdd: f, onFocusableItemRemove: p } = u;
  return te(() => {
    if (r)
      return f(), () => p();
  }, [
    r,
    f,
    p
  ]), /* @__PURE__ */ E(Io.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: i
  }, /* @__PURE__ */ E(Oe.span, M({
    tabIndex: d ? 0 : -1,
    "data-orientation": u.orientation
  }, s, {
    ref: t,
    onMouseDown: le(e.onMouseDown, (m) => {
      r ? u.onItemFocus(c) : m.preventDefault();
    }),
    onFocus: le(
      e.onFocus,
      () => u.onItemFocus(c)
    ),
    onKeyDown: le(e.onKeyDown, (m) => {
      if (m.key === "Tab" && m.shiftKey) {
        u.onItemShiftTab();
        return;
      }
      if (m.target !== m.currentTarget)
        return;
      const v = Oh(m, u.orientation, u.dir);
      if (v !== void 0) {
        m.preventDefault();
        let $ = l().filter(
          (h) => h.focusable
        ).map(
          (h) => h.ref.current
        );
        if (v === "last")
          $.reverse();
        else if (v === "prev" || v === "next") {
          v === "prev" && $.reverse();
          const h = $.indexOf(m.currentTarget);
          $ = u.loop ? Nh($, h + 1) : $.slice(h + 1);
        }
        setTimeout(
          () => Pc($)
        );
      }
    })
  })));
}), Ih = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Sh(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Oh(e, t, n) {
  const r = Sh(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return Ih[r];
}
function Pc(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Nh(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const Th = _h, Rh = Eh, Ac = "Radio", [Ph, Mc] = Ye(Ac), [Ah, Mh] = Ph(Ac), Dh = /* @__PURE__ */ q((e, t) => {
  const { __scopeRadio: n, name: r, checked: i = !1, required: o, disabled: s, value: a = "on", onCheck: c, ...u } = e, [d, l] = ue(null), f = Re(
    t,
    (v) => l(v)
  ), p = U(!1), m = d ? !!d.closest("form") : !0;
  return /* @__PURE__ */ E(Ah, {
    scope: n,
    checked: i,
    disabled: s
  }, /* @__PURE__ */ E(Oe.button, M({
    type: "button",
    role: "radio",
    "aria-checked": i,
    "data-state": Dc(i),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: a
  }, u, {
    ref: f,
    onClick: le(e.onClick, (v) => {
      i || c == null || c(), m && (p.current = v.isPropagationStopped(), p.current || v.stopPropagation());
    })
  })), m && /* @__PURE__ */ E(jh, {
    control: d,
    bubbles: !p.current,
    name: r,
    value: a,
    checked: i,
    required: o,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), kh = "RadioIndicator", Lh = /* @__PURE__ */ q((e, t) => {
  const { __scopeRadio: n, forceMount: r, ...i } = e, o = Mh(kh, n);
  return /* @__PURE__ */ E(tt, {
    present: r || o.checked
  }, /* @__PURE__ */ E(Oe.span, M({
    "data-state": Dc(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, i, {
    ref: t
  })));
}), jh = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = U(null), s = ni(n), a = Dr(t);
  return te(() => {
    const c = o.current, u = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (s !== n && l) {
      const f = new Event("click", {
        bubbles: r
      });
      l.call(c, n), c.dispatchEvent(f);
    }
  }, [
    s,
    n,
    r
  ]), /* @__PURE__ */ E("input", M({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, i, {
    tabIndex: -1,
    ref: o,
    style: {
      ...e.style,
      ...a,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function Dc(e) {
  return e ? "checked" : "unchecked";
}
const Fh = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], kc = "RadioGroup", [Bh, QC] = Ye(kc, [
  Rc,
  Mc
]), Lc = Rc(), jc = Mc(), [Hh, Vh] = Bh(kc), Uh = /* @__PURE__ */ q((e, t) => {
  const { __scopeRadioGroup: n, name: r, defaultValue: i, value: o, required: s = !1, disabled: a = !1, orientation: c, dir: u, loop: d = !0, onValueChange: l, ...f } = e, p = Lc(n), m = Qt(u), [v, _] = ht({
    prop: o,
    defaultProp: i,
    onChange: l
  });
  return /* @__PURE__ */ E(Hh, {
    scope: n,
    name: r,
    required: s,
    disabled: a,
    value: v,
    onValueChange: _
  }, /* @__PURE__ */ E(Th, M({
    asChild: !0
  }, p, {
    orientation: c,
    dir: m,
    loop: d
  }), /* @__PURE__ */ E(Oe.div, M({
    role: "radiogroup",
    "aria-required": s,
    "aria-orientation": c,
    "data-disabled": a ? "" : void 0,
    dir: m
  }, f, {
    ref: t
  }))));
}), Kh = "RadioGroupItem", Wh = /* @__PURE__ */ q((e, t) => {
  const { __scopeRadioGroup: n, disabled: r, ...i } = e, o = Vh(Kh, n), s = o.disabled || r, a = Lc(n), c = jc(n), u = U(null), d = Re(t, u), l = o.value === i.value, f = U(!1);
  return te(() => {
    const p = (v) => {
      Fh.includes(v.key) && (f.current = !0);
    }, m = () => f.current = !1;
    return document.addEventListener("keydown", p), document.addEventListener("keyup", m), () => {
      document.removeEventListener("keydown", p), document.removeEventListener("keyup", m);
    };
  }, []), /* @__PURE__ */ E(Rh, M({
    asChild: !0
  }, a, {
    focusable: !s,
    active: l
  }), /* @__PURE__ */ E(Dh, M({
    disabled: s,
    required: o.required,
    checked: l
  }, c, i, {
    name: o.name,
    ref: d,
    onCheck: () => o.onValueChange(i.value),
    onKeyDown: le((p) => {
      p.key === "Enter" && p.preventDefault();
    }),
    onFocus: le(i.onFocus, () => {
      var p;
      f.current && ((p = u.current) === null || p === void 0 || p.click());
    })
  })));
}), zh = /* @__PURE__ */ q((e, t) => {
  const { __scopeRadioGroup: n, ...r } = e, i = jc(n);
  return /* @__PURE__ */ E(Lh, M({}, i, r, {
    ref: t
  }));
}), Gh = Wh, Yh = zh, qh = {
  sm: g("ui-h-4 ui-w-4 ui-p-1"),
  md: g("ui-h-5 ui-w-5 ui-p-[5px]")
}, Xh = g(
  "ui-group ui-peer ui-rounded-full ui-border ui-border-grayscale-300 ui-bg-white ui-transition",
  "hover:ui-border-primary-600 hover:ui-bg-primary-100",
  "enabled:aria-checked:ui-border-primary-600 enabled:aria-checked:ui-bg-primary-50",
  "ui-outline-none focus-visible:ui-shadow-focus",
  "disabled:ui-border-grayscale-300 disabled:ui-bg-grayscale-100"
), Jh = g(
  "ui-block ui-h-full ui-w-full ui-rounded-full ui-bg-primary-600",
  "group-disabled:ui-bg-grayscale-300"
), Zh = g("ui-flex ui-items-center ui-gap-2"), Qh = g(
  "ui-text-paragraph-200-regular ui-text-grayscale-950",
  "peer-enabled:peer-aria-checked:ui-text-paragraph-200-medium"
), em = ({ ...e }) => /* @__PURE__ */ y.jsx(Uh, { ...e }), tm = ({
  className: e,
  children: t,
  size: n = "md",
  ...r
}) => /* @__PURE__ */ y.jsxs("label", { className: g(Zh, e), children: [
  /* @__PURE__ */ y.jsx(
    Gh,
    {
      className: g(qh[n], Xh),
      ...r,
      children: /* @__PURE__ */ y.jsx(Yh, { className: Jh })
    }
  ),
  /* @__PURE__ */ y.jsx("span", { className: Qh, children: t })
] }), eE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Group: em,
  Item: tm
}, Symbol.toStringTag, { value: "Module" })), nm = g("ui-flex ui-items-start ui-gap-2 ui-rounded-lg"), rm = {
  info: g("ui-bg-grayscale-50 ui-text-grayscale-700"),
  error: g("ui-bg-critical-50 ui-text-critical-700"),
  warning: g("ui-bg-warning-50 ui-text-warning-700"),
  success: g("ui-bg-success-50 ui-text-success-700")
}, om = {
  sm: g("ui-p-1 ui-pr-2.5 ui-text-xs"),
  md: g("ui-p-1.5 ui-pr-3 ui-text-sm")
}, im = g(
  "ui-rounded ui-px-2 ui-py-1 ui-text-label-100"
), am = {
  info: g("ui-bg-grayscale-100 ui-text-grayscale-700"),
  error: g("ui-bg-critical-600 ui-text-white"),
  warning: g("ui-bg-warning-600 ui-text-white"),
  success: g("ui-bg-success-600 ui-text-white")
}, sm = (e) => /* @__PURE__ */ y.jsx(
  "div",
  {
    className: g(
      im,
      am[e.intent]
    ),
    children: e.text
  }
), cm = {
  info: "Info",
  error: "Error",
  warning: "Warning",
  success: "Success"
}, tE = ({
  intent: e = "info",
  size: t = "md",
  children: n,
  className: r,
  leadingLabel: i,
  leadingLabelText: o,
  trailingIcon: s
}) => /* @__PURE__ */ y.jsxs(
  "div",
  {
    className: g(
      r,
      om[t],
      rm[e],
      nm
    ),
    children: [
      i && /* @__PURE__ */ y.jsx(
        sm,
        {
          intent: e,
          text: o !== void 0 ? o : cm[e]
        }
      ),
      /* @__PURE__ */ y.jsx("div", { className: "ui-grow ui-self-center", children: n }),
      s && /* @__PURE__ */ y.jsx("div", { children: s })
    ]
  }
);
var So = { exports: {} }, Jt = {}, Oo = { exports: {} }, Yn = { exports: {} }, Ce = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ba;
function lm() {
  if (Ba)
    return Ce;
  Ba = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, h = e ? Symbol.for("react.scope") : 60119;
  function b(x) {
    if (typeof x == "object" && x !== null) {
      var T = x.$$typeof;
      switch (T) {
        case t:
          switch (x = x.type, x) {
            case c:
            case u:
            case r:
            case o:
            case i:
            case l:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case a:
                case d:
                case m:
                case p:
                case s:
                  return x;
                default:
                  return T;
              }
          }
        case n:
          return T;
      }
    }
  }
  function w(x) {
    return b(x) === u;
  }
  return Ce.AsyncMode = c, Ce.ConcurrentMode = u, Ce.ContextConsumer = a, Ce.ContextProvider = s, Ce.Element = t, Ce.ForwardRef = d, Ce.Fragment = r, Ce.Lazy = m, Ce.Memo = p, Ce.Portal = n, Ce.Profiler = o, Ce.StrictMode = i, Ce.Suspense = l, Ce.isAsyncMode = function(x) {
    return w(x) || b(x) === c;
  }, Ce.isConcurrentMode = w, Ce.isContextConsumer = function(x) {
    return b(x) === a;
  }, Ce.isContextProvider = function(x) {
    return b(x) === s;
  }, Ce.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, Ce.isForwardRef = function(x) {
    return b(x) === d;
  }, Ce.isFragment = function(x) {
    return b(x) === r;
  }, Ce.isLazy = function(x) {
    return b(x) === m;
  }, Ce.isMemo = function(x) {
    return b(x) === p;
  }, Ce.isPortal = function(x) {
    return b(x) === n;
  }, Ce.isProfiler = function(x) {
    return b(x) === o;
  }, Ce.isStrictMode = function(x) {
    return b(x) === i;
  }, Ce.isSuspense = function(x) {
    return b(x) === l;
  }, Ce.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === r || x === u || x === o || x === i || x === l || x === f || typeof x == "object" && x !== null && (x.$$typeof === m || x.$$typeof === p || x.$$typeof === s || x.$$typeof === a || x.$$typeof === d || x.$$typeof === _ || x.$$typeof === $ || x.$$typeof === h || x.$$typeof === v);
  }, Ce.typeOf = b, Ce;
}
var Ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ha;
function um() {
  return Ha || (Ha = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, c = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, l = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, _ = e ? Symbol.for("react.fundamental") : 60117, $ = e ? Symbol.for("react.responder") : 60118, h = e ? Symbol.for("react.scope") : 60119;
    function b(H) {
      return typeof H == "string" || typeof H == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      H === r || H === u || H === o || H === i || H === l || H === f || typeof H == "object" && H !== null && (H.$$typeof === m || H.$$typeof === p || H.$$typeof === s || H.$$typeof === a || H.$$typeof === d || H.$$typeof === _ || H.$$typeof === $ || H.$$typeof === h || H.$$typeof === v);
    }
    function w(H) {
      if (typeof H == "object" && H !== null) {
        var ve = H.$$typeof;
        switch (ve) {
          case t:
            var ee = H.type;
            switch (ee) {
              case c:
              case u:
              case r:
              case o:
              case i:
              case l:
                return ee;
              default:
                var be = ee && ee.$$typeof;
                switch (be) {
                  case a:
                  case d:
                  case m:
                  case p:
                  case s:
                    return be;
                  default:
                    return ve;
                }
            }
          case n:
            return ve;
        }
      }
    }
    var x = c, T = u, I = a, k = s, B = t, V = d, z = r, ne = m, oe = p, D = n, j = o, J = i, S = l, Y = !1;
    function X(H) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), A(H) || w(H) === c;
    }
    function A(H) {
      return w(H) === u;
    }
    function F(H) {
      return w(H) === a;
    }
    function ie(H) {
      return w(H) === s;
    }
    function N(H) {
      return typeof H == "object" && H !== null && H.$$typeof === t;
    }
    function R(H) {
      return w(H) === d;
    }
    function P(H) {
      return w(H) === r;
    }
    function O(H) {
      return w(H) === m;
    }
    function L(H) {
      return w(H) === p;
    }
    function W(H) {
      return w(H) === n;
    }
    function Z(H) {
      return w(H) === o;
    }
    function re(H) {
      return w(H) === i;
    }
    function fe(H) {
      return w(H) === l;
    }
    Ee.AsyncMode = x, Ee.ConcurrentMode = T, Ee.ContextConsumer = I, Ee.ContextProvider = k, Ee.Element = B, Ee.ForwardRef = V, Ee.Fragment = z, Ee.Lazy = ne, Ee.Memo = oe, Ee.Portal = D, Ee.Profiler = j, Ee.StrictMode = J, Ee.Suspense = S, Ee.isAsyncMode = X, Ee.isConcurrentMode = A, Ee.isContextConsumer = F, Ee.isContextProvider = ie, Ee.isElement = N, Ee.isForwardRef = R, Ee.isFragment = P, Ee.isLazy = O, Ee.isMemo = L, Ee.isPortal = W, Ee.isProfiler = Z, Ee.isStrictMode = re, Ee.isSuspense = fe, Ee.isValidElementType = b, Ee.typeOf = w;
  }()), Ee;
}
var Va;
function Fc() {
  return Va || (Va = 1, process.env.NODE_ENV === "production" ? Yn.exports = lm() : Yn.exports = um()), Yn.exports;
}
var eo, Ua;
function wi() {
  if (Ua)
    return eo;
  Ua = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return eo = e, eo;
}
var to, Ka;
function Bc() {
  return Ka || (Ka = 1, to = Function.call.bind(Object.prototype.hasOwnProperty)), to;
}
var no, Wa;
function dm() {
  if (Wa)
    return no;
  Wa = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = wi(), n = {}, r = Bc();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, c, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in o)
        if (r(o, d)) {
          var l;
          try {
            if (typeof o[d] != "function") {
              var f = Error(
                (c || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            l = o[d](s, d, c, a, null, t);
          } catch (m) {
            l = m;
          }
          if (l && !(l instanceof Error) && e(
            (c || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof l + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), l instanceof Error && !(l.message in n)) {
            n[l.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + a + " type: " + l.message + (p ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, no = i, no;
}
var ro, za;
function fm() {
  if (za)
    return ro;
  za = 1;
  var e = Fc(), t = ei(), n = wi(), r = Bc(), i = dm(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var c = "Warning: " + a;
    typeof console < "u" && console.error(c);
    try {
      throw new Error(c);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return ro = function(a, c) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function l(A) {
      var F = A && (u && A[u] || A[d]);
      if (typeof F == "function")
        return F;
    }
    var f = "<<anonymous>>", p = {
      array: $("array"),
      bigint: $("bigint"),
      bool: $("boolean"),
      func: $("function"),
      number: $("number"),
      object: $("object"),
      string: $("string"),
      symbol: $("symbol"),
      any: h(),
      arrayOf: b,
      element: w(),
      elementType: x(),
      instanceOf: T,
      node: V(),
      objectOf: k,
      oneOf: I,
      oneOfType: B,
      shape: ne,
      exact: oe
    };
    function m(A, F) {
      return A === F ? A !== 0 || 1 / A === 1 / F : A !== A && F !== F;
    }
    function v(A, F) {
      this.message = A, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function _(A) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, ie = 0;
      function N(P, O, L, W, Z, re, fe) {
        if (W = W || f, re = re || L, fe !== n) {
          if (c) {
            var H = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw H.name = "Invariant Violation", H;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ve = W + ":" + L;
            !F[ve] && // Avoid spamming the console because they are often not actionable except for lib authors
            ie < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + re + "` prop on `" + W + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[ve] = !0, ie++);
          }
        }
        return O[L] == null ? P ? O[L] === null ? new v("The " + Z + " `" + re + "` is marked as required " + ("in `" + W + "`, but its value is `null`.")) : new v("The " + Z + " `" + re + "` is marked as required in " + ("`" + W + "`, but its value is `undefined`.")) : null : A(O, L, W, Z, re);
      }
      var R = N.bind(null, !1);
      return R.isRequired = N.bind(null, !0), R;
    }
    function $(A) {
      function F(ie, N, R, P, O, L) {
        var W = ie[N], Z = J(W);
        if (Z !== A) {
          var re = S(W);
          return new v(
            "Invalid " + P + " `" + O + "` of type " + ("`" + re + "` supplied to `" + R + "`, expected ") + ("`" + A + "`."),
            { expectedType: A }
          );
        }
        return null;
      }
      return _(F);
    }
    function h() {
      return _(s);
    }
    function b(A) {
      function F(ie, N, R, P, O) {
        if (typeof A != "function")
          return new v("Property `" + O + "` of component `" + R + "` has invalid PropType notation inside arrayOf.");
        var L = ie[N];
        if (!Array.isArray(L)) {
          var W = J(L);
          return new v("Invalid " + P + " `" + O + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected an array."));
        }
        for (var Z = 0; Z < L.length; Z++) {
          var re = A(L, Z, R, P, O + "[" + Z + "]", n);
          if (re instanceof Error)
            return re;
        }
        return null;
      }
      return _(F);
    }
    function w() {
      function A(F, ie, N, R, P) {
        var O = F[ie];
        if (!a(O)) {
          var L = J(O);
          return new v("Invalid " + R + " `" + P + "` of type " + ("`" + L + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return _(A);
    }
    function x() {
      function A(F, ie, N, R, P) {
        var O = F[ie];
        if (!e.isValidElementType(O)) {
          var L = J(O);
          return new v("Invalid " + R + " `" + P + "` of type " + ("`" + L + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return _(A);
    }
    function T(A) {
      function F(ie, N, R, P, O) {
        if (!(ie[N] instanceof A)) {
          var L = A.name || f, W = X(ie[N]);
          return new v("Invalid " + P + " `" + O + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected ") + ("instance of `" + L + "`."));
        }
        return null;
      }
      return _(F);
    }
    function I(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function F(ie, N, R, P, O) {
        for (var L = ie[N], W = 0; W < A.length; W++)
          if (m(L, A[W]))
            return null;
        var Z = JSON.stringify(A, function(fe, H) {
          var ve = S(H);
          return ve === "symbol" ? String(H) : H;
        });
        return new v("Invalid " + P + " `" + O + "` of value `" + String(L) + "` " + ("supplied to `" + R + "`, expected one of " + Z + "."));
      }
      return _(F);
    }
    function k(A) {
      function F(ie, N, R, P, O) {
        if (typeof A != "function")
          return new v("Property `" + O + "` of component `" + R + "` has invalid PropType notation inside objectOf.");
        var L = ie[N], W = J(L);
        if (W !== "object")
          return new v("Invalid " + P + " `" + O + "` of type " + ("`" + W + "` supplied to `" + R + "`, expected an object."));
        for (var Z in L)
          if (r(L, Z)) {
            var re = A(L, Z, R, P, O + "." + Z, n);
            if (re instanceof Error)
              return re;
          }
        return null;
      }
      return _(F);
    }
    function B(A) {
      if (!Array.isArray(A))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var F = 0; F < A.length; F++) {
        var ie = A[F];
        if (typeof ie != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + Y(ie) + " at index " + F + "."
          ), s;
      }
      function N(R, P, O, L, W) {
        for (var Z = [], re = 0; re < A.length; re++) {
          var fe = A[re], H = fe(R, P, O, L, W, n);
          if (H == null)
            return null;
          H.data && r(H.data, "expectedType") && Z.push(H.data.expectedType);
        }
        var ve = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new v("Invalid " + L + " `" + W + "` supplied to " + ("`" + O + "`" + ve + "."));
      }
      return _(N);
    }
    function V() {
      function A(F, ie, N, R, P) {
        return D(F[ie]) ? null : new v("Invalid " + R + " `" + P + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return _(A);
    }
    function z(A, F, ie, N, R) {
      return new v(
        (A || "React class") + ": " + F + " type `" + ie + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + R + "`."
      );
    }
    function ne(A) {
      function F(ie, N, R, P, O) {
        var L = ie[N], W = J(L);
        if (W !== "object")
          return new v("Invalid " + P + " `" + O + "` of type `" + W + "` " + ("supplied to `" + R + "`, expected `object`."));
        for (var Z in A) {
          var re = A[Z];
          if (typeof re != "function")
            return z(R, P, O, Z, S(re));
          var fe = re(L, Z, R, P, O + "." + Z, n);
          if (fe)
            return fe;
        }
        return null;
      }
      return _(F);
    }
    function oe(A) {
      function F(ie, N, R, P, O) {
        var L = ie[N], W = J(L);
        if (W !== "object")
          return new v("Invalid " + P + " `" + O + "` of type `" + W + "` " + ("supplied to `" + R + "`, expected `object`."));
        var Z = t({}, ie[N], A);
        for (var re in Z) {
          var fe = A[re];
          if (r(A, re) && typeof fe != "function")
            return z(R, P, O, re, S(fe));
          if (!fe)
            return new v(
              "Invalid " + P + " `" + O + "` key `" + re + "` supplied to `" + R + "`.\nBad object: " + JSON.stringify(ie[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(A), null, "  ")
            );
          var H = fe(L, re, R, P, O + "." + re, n);
          if (H)
            return H;
        }
        return null;
      }
      return _(F);
    }
    function D(A) {
      switch (typeof A) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !A;
        case "object":
          if (Array.isArray(A))
            return A.every(D);
          if (A === null || a(A))
            return !0;
          var F = l(A);
          if (F) {
            var ie = F.call(A), N;
            if (F !== A.entries) {
              for (; !(N = ie.next()).done; )
                if (!D(N.value))
                  return !1;
            } else
              for (; !(N = ie.next()).done; ) {
                var R = N.value;
                if (R && !D(R[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function j(A, F) {
      return A === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function J(A) {
      var F = typeof A;
      return Array.isArray(A) ? "array" : A instanceof RegExp ? "object" : j(F, A) ? "symbol" : F;
    }
    function S(A) {
      if (typeof A > "u" || A === null)
        return "" + A;
      var F = J(A);
      if (F === "object") {
        if (A instanceof Date)
          return "date";
        if (A instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function Y(A) {
      var F = S(A);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function X(A) {
      return !A.constructor || !A.constructor.name ? f : A.constructor.name;
    }
    return p.checkPropTypes = i, p.resetWarningCache = i.resetWarningCache, p.PropTypes = p, p;
  }, ro;
}
var oo, Ga;
function pm() {
  if (Ga)
    return oo;
  Ga = 1;
  var e = wi();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, oo = function() {
    function r(s, a, c, u, d, l) {
      if (l !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, oo;
}
if (process.env.NODE_ENV !== "production") {
  var gm = Fc(), hm = !0;
  Oo.exports = fm()(gm.isElement, hm);
} else
  Oo.exports = pm()();
var _i = Oo.exports;
const K = /* @__PURE__ */ Ln(_i);
var No = { exports: {} }, mt = {}, To = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  /*!
   * Adapted from jQuery UI core
   *
   * http://jqueryui.com
   *
   * Copyright 2014 jQuery Foundation and other contributors
   * Released under the MIT license.
   * http://jquery.org/license
   *
   * http://api.jqueryui.com/category/ui-core/
   */
  var n = "none", r = "contents", i = /input|select|textarea|button|object|iframe/;
  function o(l, f) {
    return f.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    l.scrollWidth <= 0 && l.scrollHeight <= 0;
  }
  function s(l) {
    var f = l.offsetWidth <= 0 && l.offsetHeight <= 0;
    if (f && !l.innerHTML)
      return !0;
    try {
      var p = window.getComputedStyle(l), m = p.getPropertyValue("display");
      return f ? m !== r && o(l, p) : m === n;
    } catch {
      return console.warn("Failed to inspect element style"), !1;
    }
  }
  function a(l) {
    for (var f = l, p = l.getRootNode && l.getRootNode(); f && f !== document.body; ) {
      if (p && f === p && (f = p.host.parentNode), s(f))
        return !1;
      f = f.parentNode;
    }
    return !0;
  }
  function c(l, f) {
    var p = l.nodeName.toLowerCase(), m = i.test(p) && !l.disabled || p === "a" && l.href || f;
    return m && a(l);
  }
  function u(l) {
    var f = l.getAttribute("tabindex");
    f === null && (f = void 0);
    var p = isNaN(f);
    return (p || f >= 0) && c(l, !p);
  }
  function d(l) {
    var f = [].slice.call(l.querySelectorAll("*"), 0).reduce(function(p, m) {
      return p.concat(m.shadowRoot ? d(m.shadowRoot) : [m]);
    }, []);
    return f.filter(u);
  }
  e.exports = t.default;
})(To, To.exports);
var Hc = To.exports;
Object.defineProperty(mt, "__esModule", {
  value: !0
});
mt.resetState = ym;
mt.log = xm;
mt.handleBlur = Tn;
mt.handleFocus = Rn;
mt.markForFocusLater = wm;
mt.returnFocus = _m;
mt.popWithoutFocus = $m;
mt.setupScopedFocus = Cm;
mt.teardownScopedFocus = Em;
var mm = Hc, vm = bm(mm);
function bm(e) {
  return e && e.__esModule ? e : { default: e };
}
var Zt = [], cn = null, Ro = !1;
function ym() {
  Zt = [];
}
function xm() {
  process.env.NODE_ENV !== "production" && (console.log("focusManager ----------"), Zt.forEach(function(e) {
    var t = e || {};
    console.log(t.nodeName, t.className, t.id);
  }), console.log("end focusManager ----------"));
}
function Tn() {
  Ro = !0;
}
function Rn() {
  if (Ro) {
    if (Ro = !1, !cn)
      return;
    setTimeout(function() {
      if (!cn.contains(document.activeElement)) {
        var e = (0, vm.default)(cn)[0] || cn;
        e.focus();
      }
    }, 0);
  }
}
function wm() {
  Zt.push(document.activeElement);
}
function _m() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, t = null;
  try {
    Zt.length !== 0 && (t = Zt.pop(), t.focus({ preventScroll: e }));
    return;
  } catch {
    console.warn(["You tried to return focus to", t, "but it is not in the DOM anymore"].join(" "));
  }
}
function $m() {
  Zt.length > 0 && Zt.pop();
}
function Cm(e) {
  cn = e, window.addEventListener ? (window.addEventListener("blur", Tn, !1), document.addEventListener("focus", Rn, !0)) : (window.attachEvent("onBlur", Tn), document.attachEvent("onFocus", Rn));
}
function Em() {
  cn = null, window.addEventListener ? (window.removeEventListener("blur", Tn), document.removeEventListener("focus", Rn)) : (window.detachEvent("onBlur", Tn), document.detachEvent("onFocus", Rn));
}
var Po = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = s;
  var n = Hc, r = i(n);
  function i(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function o() {
    var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
    return a.activeElement.shadowRoot ? o(a.activeElement.shadowRoot) : a.activeElement;
  }
  function s(a, c) {
    var u = (0, r.default)(a);
    if (!u.length) {
      c.preventDefault();
      return;
    }
    var d = void 0, l = c.shiftKey, f = u[0], p = u[u.length - 1], m = o();
    if (a === m) {
      if (!l)
        return;
      d = p;
    }
    if (p === m && !l && (d = f), f === m && l && (d = p), d) {
      c.preventDefault(), d.focus();
      return;
    }
    var v = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent), _ = v != null && v[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    if (_) {
      var $ = u.indexOf(m);
      if ($ > -1 && ($ += l ? -1 : 1), d = u[$], typeof d > "u") {
        c.preventDefault(), d = l ? p : f, d.focus();
        return;
      }
      c.preventDefault(), d.focus();
    }
  }
  e.exports = t.default;
})(Po, Po.exports);
var Im = Po.exports, vt = {}, Sm = process.env.NODE_ENV !== "production", Vc = function() {
};
if (Sm) {
  var Om = function(t, n) {
    var r = arguments.length;
    n = new Array(r > 1 ? r - 1 : 0);
    for (var i = 1; i < r; i++)
      n[i - 1] = arguments[i];
    var o = 0, s = "Warning: " + t.replace(/%s/g, function() {
      return n[o++];
    });
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  };
  Vc = function(e, t, n) {
    var r = arguments.length;
    n = new Array(r > 2 ? r - 2 : 0);
    for (var i = 2; i < r; i++)
      n[i - 2] = arguments[i];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || Om.apply(null, [t].concat(n));
  };
}
var Nm = Vc, gt = {}, Uc = { exports: {} };
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
(function(e) {
  (function() {
    var t = !!(typeof window < "u" && window.document && window.document.createElement), n = {
      canUseDOM: t,
      canUseWorkers: typeof Worker < "u",
      canUseEventListeners: t && !!(window.addEventListener || window.attachEvent),
      canUseViewport: t && !!window.screen
    };
    e.exports ? e.exports = n : window.ExecutionEnvironment = n;
  })();
})(Uc);
var Tm = Uc.exports;
Object.defineProperty(gt, "__esModule", {
  value: !0
});
gt.canUseDOM = gt.SafeNodeList = gt.SafeHTMLCollection = void 0;
var Rm = Tm, Pm = Am(Rm);
function Am(e) {
  return e && e.__esModule ? e : { default: e };
}
var Wr = Pm.default, Mm = Wr.canUseDOM ? window.HTMLElement : {};
gt.SafeHTMLCollection = Wr.canUseDOM ? window.HTMLCollection : {};
gt.SafeNodeList = Wr.canUseDOM ? window.NodeList : {};
gt.canUseDOM = Wr.canUseDOM;
gt.default = Mm;
Object.defineProperty(vt, "__esModule", {
  value: !0
});
vt.resetState = Fm;
vt.log = Bm;
vt.assertNodeList = Kc;
vt.setElement = Hm;
vt.validateElement = $i;
vt.hide = Vm;
vt.show = Um;
vt.documentNotReadyOrSSRTesting = Km;
var Dm = Nm, km = jm(Dm), Lm = gt;
function jm(e) {
  return e && e.__esModule ? e : { default: e };
}
var rt = null;
function Fm() {
  rt && (rt.removeAttribute ? rt.removeAttribute("aria-hidden") : rt.length != null ? rt.forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  }) : document.querySelectorAll(rt).forEach(function(e) {
    return e.removeAttribute("aria-hidden");
  })), rt = null;
}
function Bm() {
  if (process.env.NODE_ENV !== "production") {
    var e = rt || {};
    console.log("ariaAppHider ----------"), console.log(e.nodeName, e.className, e.id), console.log("end ariaAppHider ----------");
  }
}
function Kc(e, t) {
  if (!e || !e.length)
    throw new Error("react-modal: No elements were found for selector " + t + ".");
}
function Hm(e) {
  var t = e;
  if (typeof t == "string" && Lm.canUseDOM) {
    var n = document.querySelectorAll(t);
    Kc(n, t), t = n;
  }
  return rt = t || rt, rt;
}
function $i(e) {
  var t = e || rt;
  return t ? Array.isArray(t) || t instanceof HTMLCollection || t instanceof NodeList ? t : [t] : ((0, km.default)(!1, ["react-modal: App element is not defined.", "Please use `Modal.setAppElement(el)` or set `appElement={el}`.", "This is needed so screen readers don't see main content", "when modal is opened. It is not recommended, but you can opt-out", "by setting `ariaHideApp={false}`."].join(" ")), []);
}
function Vm(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var i = $i(e)[Symbol.iterator](), o; !(t = (o = i.next()).done); t = !0) {
      var s = o.value;
      s.setAttribute("aria-hidden", "true");
    }
  } catch (a) {
    n = !0, r = a;
  } finally {
    try {
      !t && i.return && i.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Um(e) {
  var t = !0, n = !1, r = void 0;
  try {
    for (var i = $i(e)[Symbol.iterator](), o; !(t = (o = i.next()).done); t = !0) {
      var s = o.value;
      s.removeAttribute("aria-hidden");
    }
  } catch (a) {
    n = !0, r = a;
  } finally {
    try {
      !t && i.return && i.return();
    } finally {
      if (n)
        throw r;
    }
  }
}
function Km() {
  rt = null;
}
var _n = {};
Object.defineProperty(_n, "__esModule", {
  value: !0
});
_n.resetState = Wm;
_n.log = zm;
var zt = {}, Gt = {};
function Ya(e, t) {
  e.classList.remove(t);
}
function Wm() {
  var e = document.getElementsByTagName("html")[0];
  for (var t in zt)
    Ya(e, zt[t]);
  var n = document.body;
  for (var r in Gt)
    Ya(n, Gt[r]);
  zt = {}, Gt = {};
}
function zm() {
  if (process.env.NODE_ENV !== "production") {
    var e = document.getElementsByTagName("html")[0].className, t = `Show tracked classes:

`;
    t += "<html /> (" + e + `):
  `;
    for (var n in zt)
      t += "  " + n + " " + zt[n] + `
  `;
    e = document.body.className, t += `

doc.body (` + e + `):
  `;
    for (var r in Gt)
      t += "  " + r + " " + Gt[r] + `
  `;
    t += `
`, console.log(t);
  }
}
var Gm = function(t, n) {
  return t[n] || (t[n] = 0), t[n] += 1, n;
}, Ym = function(t, n) {
  return t[n] && (t[n] -= 1), n;
}, qm = function(t, n, r) {
  r.forEach(function(i) {
    Gm(n, i), t.add(i);
  });
}, Xm = function(t, n, r) {
  r.forEach(function(i) {
    Ym(n, i), n[i] === 0 && t.remove(i);
  });
};
_n.add = function(t, n) {
  return qm(t.classList, t.nodeName.toLowerCase() == "html" ? zt : Gt, n.split(" "));
};
_n.remove = function(t, n) {
  return Xm(t.classList, t.nodeName.toLowerCase() == "html" ? zt : Gt, n.split(" "));
};
var $n = {};
Object.defineProperty($n, "__esModule", {
  value: !0
});
$n.log = Zm;
$n.resetState = Qm;
function Jm(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
var Wc = function e() {
  var t = this;
  Jm(this, e), this.register = function(n) {
    if (t.openInstances.indexOf(n) !== -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Cannot register modal instance that's already open");
      return;
    }
    t.openInstances.push(n), t.emit("register");
  }, this.deregister = function(n) {
    var r = t.openInstances.indexOf(n);
    if (r === -1) {
      process.env.NODE_ENV !== "production" && console.warn("React-Modal: Unable to deregister " + n + " as it was never registered");
      return;
    }
    t.openInstances.splice(r, 1), t.emit("deregister");
  }, this.subscribe = function(n) {
    t.subscribers.push(n);
  }, this.emit = function(n) {
    t.subscribers.forEach(function(r) {
      return r(
        n,
        // shallow copy to avoid accidental mutation
        t.openInstances.slice()
      );
    });
  }, this.openInstances = [], this.subscribers = [];
}, _r = new Wc();
function Zm() {
  console.log("portalOpenInstances ----------"), console.log(_r.openInstances.length), _r.openInstances.forEach(function(e) {
    return console.log(e);
  }), console.log("end portalOpenInstances ----------");
}
function Qm() {
  _r = new Wc();
}
$n.default = _r;
var Ci = {};
Object.defineProperty(Ci, "__esModule", {
  value: !0
});
Ci.resetState = rv;
Ci.log = ov;
var ev = $n, tv = nv(ev);
function nv(e) {
  return e && e.__esModule ? e : { default: e };
}
var qe = void 0, ft = void 0, Yt = [];
function rv() {
  for (var e = [qe, ft], t = 0; t < e.length; t++) {
    var n = e[t];
    n && n.parentNode && n.parentNode.removeChild(n);
  }
  qe = ft = null, Yt = [];
}
function ov() {
  console.log("bodyTrap ----------"), console.log(Yt.length);
  for (var e = [qe, ft], t = 0; t < e.length; t++) {
    var n = e[t], r = n || {};
    console.log(r.nodeName, r.className, r.id);
  }
  console.log("edn bodyTrap ----------");
}
function qa() {
  if (Yt.length === 0) {
    process.env.NODE_ENV !== "production" && console.warn("React-Modal: Open instances > 0 expected");
    return;
  }
  Yt[Yt.length - 1].focusContent();
}
function iv(e, t) {
  !qe && !ft && (qe = document.createElement("div"), qe.setAttribute("data-react-modal-body-trap", ""), qe.style.position = "absolute", qe.style.opacity = "0", qe.setAttribute("tabindex", "0"), qe.addEventListener("focus", qa), ft = qe.cloneNode(), ft.addEventListener("focus", qa)), Yt = t, Yt.length > 0 ? (document.body.firstChild !== qe && document.body.insertBefore(qe, document.body.firstChild), document.body.lastChild !== ft && document.body.appendChild(ft)) : (qe.parentElement && qe.parentElement.removeChild(qe), ft.parentElement && ft.parentElement.removeChild(ft));
}
tv.default.subscribe(iv);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Object.assign || function(D) {
    for (var j = 1; j < arguments.length; j++) {
      var J = arguments[j];
      for (var S in J)
        Object.prototype.hasOwnProperty.call(J, S) && (D[S] = J[S]);
    }
    return D;
  }, r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(D) {
    return typeof D;
  } : function(D) {
    return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
  }, i = function() {
    function D(j, J) {
      for (var S = 0; S < J.length; S++) {
        var Y = J[S];
        Y.enumerable = Y.enumerable || !1, Y.configurable = !0, "value" in Y && (Y.writable = !0), Object.defineProperty(j, Y.key, Y);
      }
    }
    return function(j, J, S) {
      return J && D(j.prototype, J), S && D(j, S), j;
    };
  }(), o = ke, s = _i, a = x(s), c = mt, u = w(c), d = Im, l = x(d), f = vt, p = w(f), m = _n, v = w(m), _ = gt, $ = x(_), h = $n, b = x(h);
  function w(D) {
    if (D && D.__esModule)
      return D;
    var j = {};
    if (D != null)
      for (var J in D)
        Object.prototype.hasOwnProperty.call(D, J) && (j[J] = D[J]);
    return j.default = D, j;
  }
  function x(D) {
    return D && D.__esModule ? D : { default: D };
  }
  function T(D, j) {
    if (!(D instanceof j))
      throw new TypeError("Cannot call a class as a function");
  }
  function I(D, j) {
    if (!D)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return j && (typeof j == "object" || typeof j == "function") ? j : D;
  }
  function k(D, j) {
    if (typeof j != "function" && j !== null)
      throw new TypeError("Super expression must either be null or a function, not " + typeof j);
    D.prototype = Object.create(j && j.prototype, { constructor: { value: D, enumerable: !1, writable: !0, configurable: !0 } }), j && (Object.setPrototypeOf ? Object.setPrototypeOf(D, j) : D.__proto__ = j);
  }
  var B = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
  }, V = function(j) {
    return j.code === "Tab" || j.keyCode === 9;
  }, z = function(j) {
    return j.code === "Escape" || j.keyCode === 27;
  }, ne = 0, oe = function(D) {
    k(j, D);
    function j(J) {
      T(this, j);
      var S = I(this, (j.__proto__ || Object.getPrototypeOf(j)).call(this, J));
      return S.setOverlayRef = function(Y) {
        S.overlay = Y, S.props.overlayRef && S.props.overlayRef(Y);
      }, S.setContentRef = function(Y) {
        S.content = Y, S.props.contentRef && S.props.contentRef(Y);
      }, S.afterClose = function() {
        var Y = S.props, X = Y.appElement, A = Y.ariaHideApp, F = Y.htmlOpenClassName, ie = Y.bodyOpenClassName, N = Y.parentSelector, R = N && N().ownerDocument || document;
        ie && v.remove(R.body, ie), F && v.remove(R.getElementsByTagName("html")[0], F), A && ne > 0 && (ne -= 1, ne === 0 && p.show(X)), S.props.shouldFocusAfterRender && (S.props.shouldReturnFocusAfterClose ? (u.returnFocus(S.props.preventScroll), u.teardownScopedFocus()) : u.popWithoutFocus()), S.props.onAfterClose && S.props.onAfterClose(), b.default.deregister(S);
      }, S.open = function() {
        S.beforeOpen(), S.state.afterOpen && S.state.beforeClose ? (clearTimeout(S.closeTimer), S.setState({ beforeClose: !1 })) : (S.props.shouldFocusAfterRender && (u.setupScopedFocus(S.node), u.markForFocusLater()), S.setState({ isOpen: !0 }, function() {
          S.openAnimationFrame = requestAnimationFrame(function() {
            S.setState({ afterOpen: !0 }), S.props.isOpen && S.props.onAfterOpen && S.props.onAfterOpen({
              overlayEl: S.overlay,
              contentEl: S.content
            });
          });
        }));
      }, S.close = function() {
        S.props.closeTimeoutMS > 0 ? S.closeWithTimeout() : S.closeWithoutTimeout();
      }, S.focusContent = function() {
        return S.content && !S.contentHasFocus() && S.content.focus({ preventScroll: !0 });
      }, S.closeWithTimeout = function() {
        var Y = Date.now() + S.props.closeTimeoutMS;
        S.setState({ beforeClose: !0, closesAt: Y }, function() {
          S.closeTimer = setTimeout(S.closeWithoutTimeout, S.state.closesAt - Date.now());
        });
      }, S.closeWithoutTimeout = function() {
        S.setState({
          beforeClose: !1,
          isOpen: !1,
          afterOpen: !1,
          closesAt: null
        }, S.afterClose);
      }, S.handleKeyDown = function(Y) {
        V(Y) && (0, l.default)(S.content, Y), S.props.shouldCloseOnEsc && z(Y) && (Y.stopPropagation(), S.requestClose(Y));
      }, S.handleOverlayOnClick = function(Y) {
        S.shouldClose === null && (S.shouldClose = !0), S.shouldClose && S.props.shouldCloseOnOverlayClick && (S.ownerHandlesClose() ? S.requestClose(Y) : S.focusContent()), S.shouldClose = null;
      }, S.handleContentOnMouseUp = function() {
        S.shouldClose = !1;
      }, S.handleOverlayOnMouseDown = function(Y) {
        !S.props.shouldCloseOnOverlayClick && Y.target == S.overlay && Y.preventDefault();
      }, S.handleContentOnClick = function() {
        S.shouldClose = !1;
      }, S.handleContentOnMouseDown = function() {
        S.shouldClose = !1;
      }, S.requestClose = function(Y) {
        return S.ownerHandlesClose() && S.props.onRequestClose(Y);
      }, S.ownerHandlesClose = function() {
        return S.props.onRequestClose;
      }, S.shouldBeClosed = function() {
        return !S.state.isOpen && !S.state.beforeClose;
      }, S.contentHasFocus = function() {
        return document.activeElement === S.content || S.content.contains(document.activeElement);
      }, S.buildClassName = function(Y, X) {
        var A = (typeof X > "u" ? "undefined" : r(X)) === "object" ? X : {
          base: B[Y],
          afterOpen: B[Y] + "--after-open",
          beforeClose: B[Y] + "--before-close"
        }, F = A.base;
        return S.state.afterOpen && (F = F + " " + A.afterOpen), S.state.beforeClose && (F = F + " " + A.beforeClose), typeof X == "string" && X ? F + " " + X : F;
      }, S.attributesFromObject = function(Y, X) {
        return Object.keys(X).reduce(function(A, F) {
          return A[Y + "-" + F] = X[F], A;
        }, {});
      }, S.state = {
        afterOpen: !1,
        beforeClose: !1
      }, S.shouldClose = null, S.moveFromContentToOverlay = null, S;
    }
    return i(j, [{
      key: "componentDidMount",
      value: function() {
        this.props.isOpen && this.open();
      }
    }, {
      key: "componentDidUpdate",
      value: function(S, Y) {
        process.env.NODE_ENV !== "production" && (S.bodyOpenClassName !== this.props.bodyOpenClassName && console.warn('React-Modal: "bodyOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.'), S.htmlOpenClassName !== this.props.htmlOpenClassName && console.warn('React-Modal: "htmlOpenClassName" prop has been modified. This may cause unexpected behavior when multiple modals are open.')), this.props.isOpen && !S.isOpen ? this.open() : !this.props.isOpen && S.isOpen && this.close(), this.props.shouldFocusAfterRender && this.state.isOpen && !Y.isOpen && this.focusContent();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.state.isOpen && this.afterClose(), clearTimeout(this.closeTimer), cancelAnimationFrame(this.openAnimationFrame);
      }
    }, {
      key: "beforeOpen",
      value: function() {
        var S = this.props, Y = S.appElement, X = S.ariaHideApp, A = S.htmlOpenClassName, F = S.bodyOpenClassName, ie = S.parentSelector, N = ie && ie().ownerDocument || document;
        F && v.add(N.body, F), A && v.add(N.getElementsByTagName("html")[0], A), X && (ne += 1, p.hide(Y)), b.default.register(this);
      }
      // Don't steal focus from inner elements
    }, {
      key: "render",
      value: function() {
        var S = this.props, Y = S.id, X = S.className, A = S.overlayClassName, F = S.defaultStyles, ie = S.children, N = X ? {} : F.content, R = A ? {} : F.overlay;
        if (this.shouldBeClosed())
          return null;
        var P = {
          ref: this.setOverlayRef,
          className: this.buildClassName("overlay", A),
          style: n({}, R, this.props.style.overlay),
          onClick: this.handleOverlayOnClick,
          onMouseDown: this.handleOverlayOnMouseDown
        }, O = n({
          id: Y,
          ref: this.setContentRef,
          style: n({}, N, this.props.style.content),
          className: this.buildClassName("content", X),
          tabIndex: "-1",
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleContentOnMouseDown,
          onMouseUp: this.handleContentOnMouseUp,
          onClick: this.handleContentOnClick,
          role: this.props.role,
          "aria-label": this.props.contentLabel
        }, this.attributesFromObject("aria", n({ modal: !0 }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
          "data-testid": this.props.testId
        }), L = this.props.contentElement(O, ie);
        return this.props.overlayElement(P, L);
      }
    }]), j;
  }(o.Component);
  oe.defaultProps = {
    style: {
      overlay: {},
      content: {}
    },
    defaultStyles: {}
  }, oe.propTypes = {
    isOpen: a.default.bool.isRequired,
    defaultStyles: a.default.shape({
      content: a.default.object,
      overlay: a.default.object
    }),
    style: a.default.shape({
      content: a.default.object,
      overlay: a.default.object
    }),
    className: a.default.oneOfType([a.default.string, a.default.object]),
    overlayClassName: a.default.oneOfType([a.default.string, a.default.object]),
    parentSelector: a.default.func,
    bodyOpenClassName: a.default.string,
    htmlOpenClassName: a.default.string,
    ariaHideApp: a.default.bool,
    appElement: a.default.oneOfType([a.default.instanceOf($.default), a.default.instanceOf(_.SafeHTMLCollection), a.default.instanceOf(_.SafeNodeList), a.default.arrayOf(a.default.instanceOf($.default))]),
    onAfterOpen: a.default.func,
    onAfterClose: a.default.func,
    onRequestClose: a.default.func,
    closeTimeoutMS: a.default.number,
    shouldFocusAfterRender: a.default.bool,
    shouldCloseOnOverlayClick: a.default.bool,
    shouldReturnFocusAfterClose: a.default.bool,
    preventScroll: a.default.bool,
    role: a.default.string,
    contentLabel: a.default.string,
    aria: a.default.object,
    data: a.default.object,
    children: a.default.node,
    shouldCloseOnEsc: a.default.bool,
    overlayRef: a.default.func,
    contentRef: a.default.func,
    id: a.default.string,
    overlayElement: a.default.func,
    contentElement: a.default.func,
    testId: a.default.string
  }, t.default = oe, e.exports = t.default;
})(No, No.exports);
var av = No.exports;
function zc() {
  var e = this.constructor.getDerivedStateFromProps(this.props, this.state);
  e != null && this.setState(e);
}
function Gc(e) {
  function t(n) {
    var r = this.constructor.getDerivedStateFromProps(e, n);
    return r ?? null;
  }
  this.setState(t.bind(this));
}
function Yc(e, t) {
  try {
    var n = this.props, r = this.state;
    this.props = e, this.state = t, this.__reactInternalSnapshotFlag = !0, this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      n,
      r
    );
  } finally {
    this.props = n, this.state = r;
  }
}
zc.__suppressDeprecationWarning = !0;
Gc.__suppressDeprecationWarning = !0;
Yc.__suppressDeprecationWarning = !0;
function sv(e) {
  var t = e.prototype;
  if (!t || !t.isReactComponent)
    throw new Error("Can only polyfill class components");
  if (typeof e.getDerivedStateFromProps != "function" && typeof t.getSnapshotBeforeUpdate != "function")
    return e;
  var n = null, r = null, i = null;
  if (typeof t.componentWillMount == "function" ? n = "componentWillMount" : typeof t.UNSAFE_componentWillMount == "function" && (n = "UNSAFE_componentWillMount"), typeof t.componentWillReceiveProps == "function" ? r = "componentWillReceiveProps" : typeof t.UNSAFE_componentWillReceiveProps == "function" && (r = "UNSAFE_componentWillReceiveProps"), typeof t.componentWillUpdate == "function" ? i = "componentWillUpdate" : typeof t.UNSAFE_componentWillUpdate == "function" && (i = "UNSAFE_componentWillUpdate"), n !== null || r !== null || i !== null) {
    var o = e.displayName || e.name, s = typeof e.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
    throw Error(
      `Unsafe legacy lifecycles will not be called for components using new component APIs.

` + o + " uses " + s + " but also contains the following legacy lifecycles:" + (n !== null ? `
  ` + n : "") + (r !== null ? `
  ` + r : "") + (i !== null ? `
  ` + i : "") + `

The above lifecycles should be removed. Learn more about this warning here:
https://fb.me/react-async-component-lifecycle-hooks`
    );
  }
  if (typeof e.getDerivedStateFromProps == "function" && (t.componentWillMount = zc, t.componentWillReceiveProps = Gc), typeof t.getSnapshotBeforeUpdate == "function") {
    if (typeof t.componentDidUpdate != "function")
      throw new Error(
        "Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype"
      );
    t.componentWillUpdate = Yc;
    var a = t.componentDidUpdate;
    t.componentDidUpdate = function(u, d, l) {
      var f = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : l;
      a.call(this, u, d, f);
    };
  }
  return e;
}
const cv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  polyfill: sv
}, Symbol.toStringTag, { value: "Module" })), lv = /* @__PURE__ */ Fd(cv);
Object.defineProperty(Jt, "__esModule", {
  value: !0
});
Jt.bodyOpenClassName = Jt.portalClassName = void 0;
var Xa = Object.assign || function(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
  }
  return e;
}, uv = function() {
  function e(t, n) {
    for (var r = 0; r < n.length; r++) {
      var i = n[r];
      i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
    }
  }
  return function(t, n, r) {
    return n && e(t.prototype, n), r && e(t, r), t;
  };
}(), qc = ke, $r = Hn(qc), dv = Us, Cr = Hn(dv), fv = _i, he = Hn(fv), pv = av, Ja = Hn(pv), gv = vt, hv = vv(gv), kt = gt, Za = Hn(kt), mv = lv;
function vv(e) {
  if (e && e.__esModule)
    return e;
  var t = {};
  if (e != null)
    for (var n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
}
function Hn(e) {
  return e && e.__esModule ? e : { default: e };
}
function bv(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Qa(e, t) {
  if (!e)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t && (typeof t == "object" || typeof t == "function") ? t : e;
}
function yv(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof t);
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, enumerable: !1, writable: !0, configurable: !0 } }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
var xv = Jt.portalClassName = "ReactModalPortal", wv = Jt.bodyOpenClassName = "ReactModal__Body--open", Wt = kt.canUseDOM && Cr.default.createPortal !== void 0, Ao = function(t) {
  return document.createElement(t);
}, es = function() {
  return Wt ? Cr.default.createPortal : Cr.default.unstable_renderSubtreeIntoContainer;
};
function qn(e) {
  return e();
}
var Cn = function(e) {
  yv(t, e);
  function t() {
    var n, r, i, o;
    bv(this, t);
    for (var s = arguments.length, a = Array(s), c = 0; c < s; c++)
      a[c] = arguments[c];
    return o = (r = (i = Qa(this, (n = t.__proto__ || Object.getPrototypeOf(t)).call.apply(n, [this].concat(a))), i), i.removePortal = function() {
      !Wt && Cr.default.unmountComponentAtNode(i.node);
      var u = qn(i.props.parentSelector);
      u && u.contains(i.node) ? u.removeChild(i.node) : console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
    }, i.portalRef = function(u) {
      i.portal = u;
    }, i.renderPortal = function(u) {
      var d = es(), l = d(i, $r.default.createElement(Ja.default, Xa({ defaultStyles: t.defaultStyles }, u)), i.node);
      i.portalRef(l);
    }, r), Qa(i, o);
  }
  return uv(t, [{
    key: "componentDidMount",
    value: function() {
      if (kt.canUseDOM) {
        Wt || (this.node = Ao("div")), this.node.className = this.props.portalClassName;
        var r = qn(this.props.parentSelector);
        r.appendChild(this.node), !Wt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function(r) {
      var i = qn(r.parentSelector), o = qn(this.props.parentSelector);
      return { prevParent: i, nextParent: o };
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, i, o) {
      if (kt.canUseDOM) {
        var s = this.props, a = s.isOpen, c = s.portalClassName;
        r.portalClassName !== c && (this.node.className = c);
        var u = o.prevParent, d = o.nextParent;
        d !== u && (u.removeChild(this.node), d.appendChild(this.node)), !(!r.isOpen && !a) && !Wt && this.renderPortal(this.props);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      if (!(!kt.canUseDOM || !this.node || !this.portal)) {
        var r = this.portal.state, i = Date.now(), o = r.isOpen && this.props.closeTimeoutMS && (r.closesAt || i + this.props.closeTimeoutMS);
        o ? (r.beforeClose || this.portal.closeWithTimeout(), setTimeout(this.removePortal, o - i)) : this.removePortal();
      }
    }
  }, {
    key: "render",
    value: function() {
      if (!kt.canUseDOM || !Wt)
        return null;
      !this.node && Wt && (this.node = Ao("div"));
      var r = es();
      return r($r.default.createElement(Ja.default, Xa({
        ref: this.portalRef,
        defaultStyles: t.defaultStyles
      }, this.props)), this.node);
    }
  }], [{
    key: "setAppElement",
    value: function(r) {
      hv.setElement(r);
    }
    /* eslint-disable react/no-unused-prop-types */
    /* eslint-enable react/no-unused-prop-types */
  }]), t;
}(qc.Component);
Cn.propTypes = {
  isOpen: he.default.bool.isRequired,
  style: he.default.shape({
    content: he.default.object,
    overlay: he.default.object
  }),
  portalClassName: he.default.string,
  bodyOpenClassName: he.default.string,
  htmlOpenClassName: he.default.string,
  className: he.default.oneOfType([he.default.string, he.default.shape({
    base: he.default.string.isRequired,
    afterOpen: he.default.string.isRequired,
    beforeClose: he.default.string.isRequired
  })]),
  overlayClassName: he.default.oneOfType([he.default.string, he.default.shape({
    base: he.default.string.isRequired,
    afterOpen: he.default.string.isRequired,
    beforeClose: he.default.string.isRequired
  })]),
  appElement: he.default.oneOfType([he.default.instanceOf(Za.default), he.default.instanceOf(kt.SafeHTMLCollection), he.default.instanceOf(kt.SafeNodeList), he.default.arrayOf(he.default.instanceOf(Za.default))]),
  onAfterOpen: he.default.func,
  onRequestClose: he.default.func,
  closeTimeoutMS: he.default.number,
  ariaHideApp: he.default.bool,
  shouldFocusAfterRender: he.default.bool,
  shouldCloseOnOverlayClick: he.default.bool,
  shouldReturnFocusAfterClose: he.default.bool,
  preventScroll: he.default.bool,
  parentSelector: he.default.func,
  aria: he.default.object,
  data: he.default.object,
  role: he.default.string,
  contentLabel: he.default.string,
  shouldCloseOnEsc: he.default.bool,
  overlayRef: he.default.func,
  contentRef: he.default.func,
  id: he.default.string,
  overlayElement: he.default.func,
  contentElement: he.default.func
};
Cn.defaultProps = {
  isOpen: !1,
  portalClassName: xv,
  bodyOpenClassName: wv,
  role: "dialog",
  ariaHideApp: !0,
  closeTimeoutMS: 0,
  shouldFocusAfterRender: !0,
  shouldCloseOnEsc: !0,
  shouldCloseOnOverlayClick: !0,
  shouldReturnFocusAfterClose: !0,
  preventScroll: !1,
  parentSelector: function() {
    return document.body;
  },
  overlayElement: function(t, n) {
    return $r.default.createElement(
      "div",
      t,
      n
    );
  },
  contentElement: function(t, n) {
    return $r.default.createElement(
      "div",
      t,
      n
    );
  }
};
Cn.defaultStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(255, 255, 255, 0.75)"
  },
  content: {
    position: "absolute",
    top: "40px",
    left: "40px",
    right: "40px",
    bottom: "40px",
    border: "1px solid #ccc",
    background: "#fff",
    overflow: "auto",
    WebkitOverflowScrolling: "touch",
    borderRadius: "4px",
    outline: "none",
    padding: "20px"
  }
};
(0, mv.polyfill)(Cn);
process.env.NODE_ENV !== "production" && (Cn.setCreateHTMLElement = function(e) {
  return Ao = e;
});
Jt.default = Cn;
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = Jt, r = i(n);
  function i(o) {
    return o && o.__esModule ? o : { default: o };
  }
  t.default = r.default, e.exports = t.default;
})(So, So.exports);
var _v = So.exports;
const Xc = /* @__PURE__ */ Ln(_v), $v = g("ui-opacity-0"), Cv = g(
  "ui-fixed ui-inset-0 ui-z-30 ui-bg-black ui-bg-opacity-80",
  "ui-flex ui-overflow-y-auto",
  "ui-px-4 ui-py-5"
), Jc = g("ui-translate-y-5 ui-opacity-0"), Ev = g("!ui-translate-y-0 !ui-opacity-100"), Iv = g(
  "ui-m-auto ui-w-full ui-max-w-[726px]",
  "ui-inline-block ui-rounded-2xl ui-bg-white ui-px-6 ui-py-8",
  "ui-border ui-border-grayscale-200 ui-outline-none ui-transition",
  Jc
), Sv = g("ui-overflow-hidden"), Zc = ({
  title: e,
  isOpen: t,
  shouldDisableClose: n,
  children: r,
  onClose: i,
  onAfterClose: o,
  className: s,
  headerClassName: a
}) => /* @__PURE__ */ y.jsxs(
  Xc,
  {
    isOpen: t,
    className: {
      base: g(Iv, s),
      afterOpen: t ? Ev : "",
      beforeClose: Jc
    },
    overlayClassName: {
      base: Cv,
      afterOpen: "",
      beforeClose: $v
    },
    htmlOpenClassName: Sv,
    shouldCloseOnEsc: !n,
    shouldCloseOnOverlayClick: !n,
    onAfterClose: o,
    onRequestClose: i,
    closeTimeoutMS: 150,
    children: [
      e !== void 0 && /* @__PURE__ */ y.jsxs(
        "div",
        {
          className: g(
            "-ui-mt-1 ui-mb-6 ui-flex ui-items-center ui-justify-between",
            a
          ),
          children: [
            /* @__PURE__ */ y.jsx("span", { className: "ui-text-heading-h2 ui-text-grayscale-950", children: e }),
            /* @__PURE__ */ y.jsx(al, { onClick: i, children: /* @__PURE__ */ y.jsx(kd, { className: "ui-text-grayscale-500" }) })
          ]
        }
      ),
      r
    ]
  }
), Ov = Zc;
Ov.setAppElement = Xc.setAppElement.bind(Zc);
const Nv = {
  sm: wd,
  md: Od,
  lg: Ld
}, Tv = {
  lg: g("ui-text-label-300"),
  md: g("ui-text-label-300"),
  sm: g("ui-text-label-200")
}, Rv = {
  black: g(
    "ui-text-grayscale-950",
    "aria-disabled:ui-text-grayscale-300",
    "hover:ui-text-primary-500",
    "active:ui-text-primary-800",
    "focus-visible:ui-shadow-focus"
  ),
  white: g(
    "ui-text-white",
    "aria-disabled:ui-text-grayscale-500",
    "hover:ui-text-alpha-white-800",
    "active:ui-text-alpha-white-600",
    "focus-visible:ui-shadow-focus-dark"
  ),
  blue: g(
    "ui-text-primary-600",
    "aria-disabled:ui-text-grayscale-300",
    "hover:ui-text-primary-500",
    "active:ui-text-primary-800",
    "focus-visible:ui-text-grayscale-950 focus-visible:ui-shadow-focus"
  )
}, Pv = g(
  "ui-group -ui-m-1 ui-inline-flex ui-cursor-pointer ui-items-center ui-rounded-lg ui-p-1 ui-outline-none ui-transition"
), Av = g("ui-transition group-hover:ui-translate-x-1"), nE = ({
  as: e,
  children: t,
  className: n,
  size: r = "md",
  variant: i = "blue",
  showArrowIcon: o,
  disabled: s,
  ...a
}) => {
  const c = e || "a", u = Nv[r];
  return /* @__PURE__ */ y.jsxs(
    c,
    {
      ...a,
      "aria-disabled": s,
      className: g(
        n,
        Pv,
        Tv[r],
        Rv[i]
      ),
      children: [
        t,
        o ? /* @__PURE__ */ y.jsx(u, { className: Av }) : null
      ]
    }
  );
}, io = "rovingFocusGroup.onEntryFocus", Mv = {
  bubbles: !1,
  cancelable: !0
}, Ei = "RovingFocusGroup", [Mo, Qc, Dv] = Kr(Ei), [kv, el] = Ye(Ei, [
  Dv
]), [Lv, jv] = kv(Ei), Fv = /* @__PURE__ */ q((e, t) => /* @__PURE__ */ E(Mo.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ E(Mo.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ E(Bv, M({}, e, {
  ref: t
}))))), Bv = /* @__PURE__ */ q((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: i = !1, dir: o, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: c, onEntryFocus: u, ...d } = e, l = U(null), f = Re(t, l), p = Qt(o), [m = null, v] = ht({
    prop: s,
    defaultProp: a,
    onChange: c
  }), [_, $] = ue(!1), h = Ve(u), b = Qc(n), w = U(!1), [x, T] = ue(0);
  return te(() => {
    const I = l.current;
    if (I)
      return I.addEventListener(io, h), () => I.removeEventListener(io, h);
  }, [
    h
  ]), /* @__PURE__ */ E(Lv, {
    scope: n,
    orientation: r,
    dir: p,
    loop: i,
    currentTabStopId: m,
    onItemFocus: Q(
      (I) => v(I),
      [
        v
      ]
    ),
    onItemShiftTab: Q(
      () => $(!0),
      []
    ),
    onFocusableItemAdd: Q(
      () => T(
        (I) => I + 1
      ),
      []
    ),
    onFocusableItemRemove: Q(
      () => T(
        (I) => I - 1
      ),
      []
    )
  }, /* @__PURE__ */ E(Oe.div, M({
    tabIndex: _ || x === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: le(e.onMouseDown, () => {
      w.current = !0;
    }),
    onFocus: le(e.onFocus, (I) => {
      const k = !w.current;
      if (I.target === I.currentTarget && k && !_) {
        const B = new CustomEvent(io, Mv);
        if (I.currentTarget.dispatchEvent(B), !B.defaultPrevented) {
          const V = b().filter(
            (j) => j.focusable
          ), z = V.find(
            (j) => j.active
          ), ne = V.find(
            (j) => j.id === m
          ), D = [
            z,
            ne,
            ...V
          ].filter(Boolean).map(
            (j) => j.ref.current
          );
          tl(D);
        }
      }
      w.current = !1;
    }),
    onBlur: le(
      e.onBlur,
      () => $(!1)
    )
  })));
}), Hv = "RovingFocusGroupItem", Vv = /* @__PURE__ */ q((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: i = !1, tabStopId: o, ...s } = e, a = Ze(), c = o || a, u = jv(Hv, n), d = u.currentTabStopId === c, l = Qc(n), { onFocusableItemAdd: f, onFocusableItemRemove: p } = u;
  return te(() => {
    if (r)
      return f(), () => p();
  }, [
    r,
    f,
    p
  ]), /* @__PURE__ */ E(Mo.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: i
  }, /* @__PURE__ */ E(Oe.span, M({
    tabIndex: d ? 0 : -1,
    "data-orientation": u.orientation
  }, s, {
    ref: t,
    onMouseDown: le(e.onMouseDown, (m) => {
      r ? u.onItemFocus(c) : m.preventDefault();
    }),
    onFocus: le(
      e.onFocus,
      () => u.onItemFocus(c)
    ),
    onKeyDown: le(e.onKeyDown, (m) => {
      if (m.key === "Tab" && m.shiftKey) {
        u.onItemShiftTab();
        return;
      }
      if (m.target !== m.currentTarget)
        return;
      const v = Wv(m, u.orientation, u.dir);
      if (v !== void 0) {
        m.preventDefault();
        let $ = l().filter(
          (h) => h.focusable
        ).map(
          (h) => h.ref.current
        );
        if (v === "last")
          $.reverse();
        else if (v === "prev" || v === "next") {
          v === "prev" && $.reverse();
          const h = $.indexOf(m.currentTarget);
          $ = u.loop ? zv($, h + 1) : $.slice(h + 1);
        }
        setTimeout(
          () => tl($)
        );
      }
    })
  })));
}), Uv = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Kv(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Wv(e, t, n) {
  const r = Kv(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return Uv[r];
}
function tl(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function zv(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const Gv = Fv, Yv = Vv, nl = "Tabs", [qv, rE] = Ye(nl, [
  el
]), rl = el(), [Xv, Ii] = qv(nl), Jv = /* @__PURE__ */ q((e, t) => {
  const { __scopeTabs: n, value: r, onValueChange: i, defaultValue: o, orientation: s = "horizontal", dir: a, activationMode: c = "automatic", ...u } = e, d = Qt(a), [l, f] = ht({
    prop: r,
    onChange: i,
    defaultProp: o
  });
  return /* @__PURE__ */ E(Xv, {
    scope: n,
    baseId: Ze(),
    value: l,
    onValueChange: f,
    orientation: s,
    dir: d,
    activationMode: c
  }, /* @__PURE__ */ E(Oe.div, M({
    dir: d,
    "data-orientation": s
  }, u, {
    ref: t
  })));
}), Zv = "TabsList", Qv = /* @__PURE__ */ q((e, t) => {
  const { __scopeTabs: n, loop: r = !0, ...i } = e, o = Ii(Zv, n), s = rl(n);
  return /* @__PURE__ */ E(Gv, M({
    asChild: !0
  }, s, {
    orientation: o.orientation,
    dir: o.dir,
    loop: r
  }), /* @__PURE__ */ E(Oe.div, M({
    role: "tablist",
    "aria-orientation": o.orientation
  }, i, {
    ref: t
  })));
}), eb = "TabsTrigger", tb = /* @__PURE__ */ q((e, t) => {
  const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = e, s = Ii(eb, n), a = rl(n), c = ol(s.baseId, r), u = il(s.baseId, r), d = r === s.value;
  return /* @__PURE__ */ E(Yv, M({
    asChild: !0
  }, a, {
    focusable: !i,
    active: d
  }), /* @__PURE__ */ E(Oe.button, M({
    type: "button",
    role: "tab",
    "aria-selected": d,
    "aria-controls": u,
    "data-state": d ? "active" : "inactive",
    "data-disabled": i ? "" : void 0,
    disabled: i,
    id: c
  }, o, {
    ref: t,
    onMouseDown: le(e.onMouseDown, (l) => {
      !i && l.button === 0 && l.ctrlKey === !1 ? s.onValueChange(r) : l.preventDefault();
    }),
    onKeyDown: le(e.onKeyDown, (l) => {
      [
        " ",
        "Enter"
      ].includes(l.key) && s.onValueChange(r);
    }),
    onFocus: le(e.onFocus, () => {
      const l = s.activationMode !== "manual";
      !d && !i && l && s.onValueChange(r);
    })
  })));
}), nb = "TabsContent", rb = /* @__PURE__ */ q((e, t) => {
  const { __scopeTabs: n, value: r, forceMount: i, children: o, ...s } = e, a = Ii(nb, n), c = ol(a.baseId, r), u = il(a.baseId, r), d = r === a.value, l = U(d);
  return te(() => {
    const f = requestAnimationFrame(
      () => l.current = !1
    );
    return () => cancelAnimationFrame(f);
  }, []), /* @__PURE__ */ E(
    tt,
    {
      present: i || d
    },
    ({ present: f }) => /* @__PURE__ */ E(Oe.div, M({
      "data-state": d ? "active" : "inactive",
      "data-orientation": a.orientation,
      role: "tabpanel",
      "aria-labelledby": c,
      hidden: !f,
      id: u,
      tabIndex: 0
    }, s, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: l.current ? "0s" : void 0
      }
    }), f && o)
  );
});
function ol(e, t) {
  return `${e}-trigger-${t}`;
}
function il(e, t) {
  return `${e}-content-${t}`;
}
const ob = Jv, ib = Qv, ab = tb, sb = rb, cb = g("ui-relative ui-flex ui-flex-col"), lb = g(
  "ui-relative ui-z-10 ui-flex ui-shrink-0 ui-gap-8 ui-overflow-x-auto",
  "focus-visible-within:ui-shadow-focus"
), ub = g(
  "ui-relative ui-flex ui-h-8 ui-items-center ui-gap-2 ui-whitespace-nowrap",
  "ui-outline-none focus-visible:ui-shadow-focus"
), db = {
  dark: g(
    "ui-text-grayscale-700 hover:ui-text-grayscale-950 aria-selected:ui-text-grayscale-950"
  ),
  light: g(
    "ui-text-alpha-white-500 hover:ui-text-white aria-selected:ui-text-white"
  )
}, fb = {
  sm: g("ui-text-label-100 ui-font-normal aria-selected:ui-font-semibold"),
  md: g("ui-text-label-200 ui-font-normal aria-selected:ui-font-semibold")
}, pb = g(
  "ui-min-h-0 ui-flex-1 ui-flex-col ui-py-3 ui-outline-none",
  "data-[state=active]:ui-flex"
), gb = g("ui-absolute ui-bottom-0 ui-h-0.5 ui-w-full"), hb = {
  dark: g("ui-bg-grayscale-950"),
  light: g("ui-bg-white")
}, mb = g(
  "ui-absolute ui-inset-x-0 ui-bottom-0 -ui-mt-px ui-border-b "
), vb = {
  dark: g("ui-border-grayscale-300"),
  light: g("ui-border-grayscale-700")
}, bb = ({
  className: e,
  tabs: t,
  size: n = "md",
  theme: r = "dark",
  activeTab: i,
  onActiveTabChange: o
}) => /* @__PURE__ */ y.jsxs(
  ob,
  {
    className: g(e, cb),
    defaultValue: t[0].value,
    value: i,
    onValueChange: o,
    children: [
      /* @__PURE__ */ y.jsxs(ib, { className: lb, children: [
        /* @__PURE__ */ y.jsx("div", { className: g(mb, vb[r]) }),
        t.map((s) => /* @__PURE__ */ y.jsx(
          ab,
          {
            asChild: !0,
            className: g(
              ub,
              db[r],
              fb[n]
            ),
            value: s.value,
            children: /* @__PURE__ */ y.jsx(yb, { tab: s, theme: r })
          },
          s.value
        ))
      ] }),
      t.map((s) => /* @__PURE__ */ y.jsx(
        sb,
        {
          className: pb,
          value: s.value,
          children: s.content
        },
        s.value
      ))
    ]
  }
), yb = q(
  ({ tab: e, theme: t, ...n }, r) => {
    const i = n["aria-selected"];
    return /* @__PURE__ */ y.jsxs("button", { ref: r, ...n, children: [
      e.icon,
      e.title,
      e.trailingIcon,
      i ? /* @__PURE__ */ y.jsx(
        gr.div,
        {
          layoutId: "slider",
          className: g(gb, hb[t]),
          initial: !1
        }
      ) : null
    ] });
  }
), xb = {
  lg: g("ui-px-3 ui-py-2 ui-text-label-200"),
  md: g("ui-px-2 ui-py-1 ui-text-label-200"),
  sm: g("ui-px-2 ui-py-1 ui-text-label-100")
}, wb = {
  outlined: g(
    "ui-text-grayscale-700 ui-shadow-border ui-shadow-grayscale-200"
  ),
  gray: g("ui-bg-grayscale-100 ui-text-grayscale-700"),
  overlay: g("ui-text-grayscale-700"),
  primary: g("ui-bg-primary-50 ui-text-primary-700"),
  secondary: g("ui-bg-secondary-50 ui-text-secondary-500"),
  "accent-green": g("ui-bg-accent-green-50 ui-text-accent-green-700"),
  "accent-blue": g("ui-bg-accent-blue-50 ui-text-accent-blue-700"),
  "accent-orange": g("ui-bg-accent-orange-50 ui-text-accent-orange-700"),
  "accent-yellow": g("ui-bg-accent-yellow-50 ui-text-accent-yellow-700"),
  "accent-pink": g("ui-bg-accent-pink-50 ui-text-accent-pink-700"),
  critical: g("ui-bg-critical-50 ui-text-critical-700"),
  warning: g("ui-bg-warning-50 ui-text-warning-700"),
  success: g("ui-bg-success-50 ui-text-success-700")
}, _b = g("ui-inline-flex ui-gap-1 ui-rounded"), $b = ({
  children: e,
  className: t,
  size: n = "md",
  variant: r = "outlined",
  ...i
}) => /* @__PURE__ */ y.jsx(
  "div",
  {
    ...i,
    className: g(
      t,
      _b,
      xb[n],
      wb[r]
    ),
    children: e
  }
), Cb = {
  primary: g(
    "ui-border-transparent ui-bg-primary-600 ui-text-white",
    "hover:ui-bg-primary-500",
    "active:ui-bg-primary-800",
    "disabled:ui-bg-primary-100",
    "aria-[busy]:ui-bg-primary-200",
    "focus-visible:ui-shadow-focus-offset"
  ),
  secondary: g(
    "ui-border-transparent ui-bg-grayscale-100 ui-text-primary-600",
    "hover:ui-bg-grayscale-50 enabled:hover:ui-border-grayscale-300",
    "active:ui-border-transparent active:ui-bg-grayscale-200",
    "disabled:ui-bg-grayscale-100 disabled:ui-text-grayscale-300",
    "focus-visible:ui-shadow-focus-offset"
  ),
  tertiary: g(
    "ui-border-grayscale-200 ui-bg-white ui-text-grayscale-700",
    "hover:ui-border-grayscale-300 hover:ui-text-grayscale-600",
    "active:ui-border-grayscale-400 active:ui-text-grayscale-700",
    "disabled:ui-border-grayscale-300 disabled:ui-text-grayscale-300",
    "aria-[busy]:ui-border-grayscale-400 aria-[busy]:ui-text-grayscale-400",
    "focus-visible:ui-shadow-focus"
  ),
  destructive: g(
    "ui-border-critical-300 ui-bg-white ui-text-critical-700",
    "enabled:hover:ui-bg-critical-50",
    "enabled:active:ui-bg-critical-100",
    "disabled:ui-text-critical-300",
    "focus-visible:ui-shadow-focus"
  )
}, Eb = {
  sm: g("ui-h-8 ui-px-2 ui-text-label-200"),
  md: g("ui-h-10 ui-px-3 ui-text-label-200"),
  lg: g("ui-h-12 ui-px-4 ui-text-label-300")
}, Ib = {
  sm: g("ui-h-4 ui-w-4"),
  md: g("ui-h-4 ui-w-4"),
  lg: g("ui-h-6 ui-w-6")
}, Sb = {
  primary: "light",
  secondary: "dark",
  tertiary: "dark",
  destructive: "dark"
}, Ob = g(
  "ui-flex ui-items-center ui-justify-center ui-gap-2 ui-whitespace-nowrap ui-rounded-lg ui-border ui-outline-none ui-transition"
), ts = g("only:-ui-mx-px"), oE = q(
  ({
    as: e,
    size: t = "md",
    intent: n = "primary",
    children: r,
    icon: i,
    loading: o,
    disabled: s,
    leadingIcon: a,
    trailingIcon: c,
    className: u,
    type: d = "button",
    ...l
  }, f) => {
    const p = e || "button", m = o ? /* @__PURE__ */ y.jsx(
      bc,
      {
        className: Ib[t],
        theme: Sb[n]
      }
    ) : null;
    return /* @__PURE__ */ y.jsxs(
      p,
      {
        ...l,
        type: d,
        disabled: s || o,
        "aria-busy": o || void 0,
        ref: f,
        className: g(
          u,
          Eb[t],
          Cb[n],
          Ob
        ),
        children: [
          m || a || i ? /* @__PURE__ */ y.jsx("span", { className: ts, children: m || a || i }) : null,
          r ? /* @__PURE__ */ y.jsx("span", { children: r }) : null,
          c ? /* @__PURE__ */ y.jsx("span", { className: ts, children: c }) : null
        ]
      }
    );
  }
), Nb = g("ui-flex ui-flex-col"), Tb = q(
  ({
    className: e,
    label: t,
    tooltip: n,
    description: r,
    errorMessage: i,
    inputContainerClassName: o,
    ...s
  }, a) => {
    const c = Ze(), u = Ze(), d = Ze();
    return /* @__PURE__ */ y.jsxs("div", { className: g(e, Nb), children: [
      /* @__PURE__ */ y.jsx(
        Hr,
        {
          label: t,
          tooltip: n,
          htmlFor: u,
          id: c
        }
      ),
      /* @__PURE__ */ y.jsx(
        vc,
        {
          ...s,
          id: u,
          ref: a,
          className: o,
          "aria-invalid": !!i,
          "aria-labelledby": c,
          "aria-describedby": d
        }
      ),
      /* @__PURE__ */ y.jsx(kr, { errorMessage: i, description: r })
    ] });
  }
), Rb = g(
  "ui-flex ui-border ui-border-grayscale-200 ui-bg-white ui-transition",
  "focus-within:ui-border-primary-300 focus-within:ui-shadow-focus",
  "data-[disabled=true]:ui-bg-grayscale-100 data-[disabled=true]:ui-shadow-gray-xs",
  "hover:ui-border-primary-500 data-[disabled=true]:ui-border-grayscale-300",
  "data-[invalid=true]:ui-border-critical-300"
), Pb = {
  xs: g("ui-rounded ui-text-paragraph-200-regular"),
  sm: g("ui-rounded-lg ui-text-paragraph-200-regular"),
  md: g("ui-rounded-lg ui-text-paragraph-300-regular")
}, Ab = g(
  "ui-block ui-w-full ui-text-ellipsis ui-bg-transparent ui-px-3.5 ui-text-grayscale-950 ui-outline-none",
  "placeholder:ui-text-grayscale-500 disabled:placeholder:ui-text-grayscale-300",
  "disabled:ui-text-grayscale-500"
), Mb = q(
  ({ className: e, size: t = "md", ...n }, r) => /* @__PURE__ */ y.jsx(
    "div",
    {
      "data-disabled": n.disabled,
      "data-invalid": n["aria-invalid"],
      className: g(
        e,
        Rb,
        Pb[t]
      ),
      children: /* @__PURE__ */ y.jsx("textarea", { ref: r, className: Ab, ...n })
    }
  )
), Db = g("ui-flex ui-flex-col"), iE = q(
  ({
    className: e,
    label: t,
    tooltip: n,
    description: r,
    errorMessage: i,
    inputContainerClassName: o,
    ...s
  }, a) => {
    const c = Ze(), u = Ze(), d = Ze();
    return /* @__PURE__ */ y.jsxs("div", { className: g(e, Db), children: [
      /* @__PURE__ */ y.jsx(
        Hr,
        {
          label: t,
          tooltip: n,
          htmlFor: u,
          id: c
        }
      ),
      /* @__PURE__ */ y.jsx(
        Mb,
        {
          ...s,
          id: u,
          ref: a,
          className: o,
          "aria-invalid": !!i,
          "aria-labelledby": c,
          "aria-describedby": d
        }
      ),
      /* @__PURE__ */ y.jsx(kr, { errorMessage: i, description: r })
    ] });
  }
), kb = {
  none: g(""),
  slight: g("ui-rounded"),
  full: g("ui-rounded-full")
}, Lb = {
  none: g(""),
  sm: g("-ui-m-0.5 ui-p-0.5"),
  md: g("-ui-m-1 ui-p-1"),
  lg: g("-ui-m-1.5 ui-p-1.5")
}, al = ({
  className: e,
  rounded: t = "full",
  padding: n = "md",
  ...r
}) => /* @__PURE__ */ y.jsx(
  Nc,
  {
    ...r,
    className: g(
      e,
      kb[t],
      Lb[n]
    )
  }
), jb = (e) => {
  e && (e.preventDefault && e.preventDefault(), e.stopPropagation ? e.stopPropagation() : window.event && (window.event.cancelBubble = !0));
}, Fb = (e) => {
  for (var t = {}, n = [], r = e.length, i = 0, o = 0; o < r; o++) {
    var s = e[o];
    t[s] !== 1 && (t[s] = 1, n[i++] = s);
  }
  return n;
}, sl = (e, t = 0, n, r) => {
  const i = n.indexOf(e);
  if (!(n.indexOf(e) >= 0))
    return !1;
  const s = Math.max(r.length - 1, 0);
  if (r.length && r[s] !== n[s])
    return !1;
  if (i === 0)
    return t > 0 ? r.indexOf(e) >= 0 : !0;
  const a = i - 1, c = n[a];
  return r[a] === c ? sl(
    c,
    i,
    n,
    r
  ) : !1;
}, Bb = ["TEXTAREA", "INPUT"], Hb = {
  overrideSystem: !1,
  ignoreInputFields: !0,
  repeatOnHold: !0
}, Vb = (e, t, n) => {
  const r = { ...Hb, ...n };
  if (!Array.isArray(e))
    throw new Error(
      "The first parameter to `useKeyboardShortcut` must be an ordered array of `KeyboardEvent.key` strings."
    );
  if (!e.length)
    throw new Error(
      "The first parameter to `useKeyboardShortcut` must contain atleast one `KeyboardEvent.key` string."
    );
  if (!t || typeof t != "function")
    throw new Error(
      "The second parameter to `useKeyboardShortcut` must be a function that will be envoked when the keys are pressed."
    );
  const i = ze(() => e.join(), [e]), o = ze(
    () => Fb(e).map((d) => String(d).toLowerCase()),
    // While using .join() is bad for most larger objects, this shortcut
    // array is fine as it's small, according to the answer below.
    // https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i]
  ), s = U([]), a = Q(
    (d) => {
      const l = String(d.key).toLowerCase();
      if (!(o.indexOf(l) >= 0) || r.ignoreInputFields && Bb.indexOf(d.target.tagName) >= 0 || d.repeat && !r.repeatOnHold || (r.overrideSystem && jb(d), !sl(
        l,
        null,
        o,
        s.current
      )))
        return;
      const p = [...s.current, l];
      return p.join() === o.join() ? (t(e), !1) : (s.current = p, !1);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      i,
      t,
      r.overrideSystem,
      r.ignoreInputFields
    ]
  ), c = Q(
    (d) => {
      const l = String(d.key).toLowerCase();
      if (!(o.indexOf(l) >= 0))
        return;
      const f = s.current.indexOf(l);
      if (!(f >= 0))
        return;
      let p = [], m;
      for (m = 0; m < s.current.length; ++m)
        m !== f && p.push(s.current[m]);
      return s.current = p, !1;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [i]
  ), u = Q(() => {
    s.current = [];
  }, []);
  return te(() => (window.addEventListener("keydown", a), window.addEventListener("keyup", c), () => {
    window.removeEventListener("keydown", a), window.removeEventListener("keyup", c);
  }), [a, c, i]), te(() => {
    u();
  }, [i, u]), {
    flushHeldKeys: u
  };
}, Ub = Vb;
let ao = 0;
function cl() {
  te(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : ns()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : ns()), ao++, () => {
      ao === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), ao--;
    };
  }, []);
}
function ns() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Kb = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Wb = Kb.reduce((e, t) => {
  const n = /* @__PURE__ */ q((r, i) => {
    const { asChild: o, ...s } = r, a = o ? xt : t;
    return te(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ E(a, M({}, s, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {}), so = "focusScope.autoFocusOnMount", co = "focusScope.autoFocusOnUnmount", rs = {
  bubbles: !1,
  cancelable: !0
}, ll = /* @__PURE__ */ q((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...s } = e, [a, c] = ue(null), u = Ve(i), d = Ve(o), l = U(null), f = Re(
    t,
    (v) => c(v)
  ), p = U({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  te(() => {
    if (r) {
      let v = function(b) {
        if (p.paused || !a)
          return;
        const w = b.target;
        a.contains(w) ? l.current = w : Dt(l.current, {
          select: !0
        });
      }, _ = function(b) {
        if (p.paused || !a)
          return;
        const w = b.relatedTarget;
        w !== null && (a.contains(w) || Dt(l.current, {
          select: !0
        }));
      }, $ = function(b) {
        if (document.activeElement === document.body)
          for (const x of b)
            x.removedNodes.length > 0 && Dt(a);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", _);
      const h = new MutationObserver($);
      return a && h.observe(a, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", _), h.disconnect();
      };
    }
  }, [
    r,
    a,
    p.paused
  ]), te(() => {
    if (a) {
      is.add(p);
      const v = document.activeElement;
      if (!a.contains(v)) {
        const $ = new CustomEvent(so, rs);
        a.addEventListener(so, u), a.dispatchEvent($), $.defaultPrevented || (zb(Jb(ul(a)), {
          select: !0
        }), document.activeElement === v && Dt(a));
      }
      return () => {
        a.removeEventListener(so, u), setTimeout(() => {
          const $ = new CustomEvent(co, rs);
          a.addEventListener(co, d), a.dispatchEvent($), $.defaultPrevented || Dt(v ?? document.body, {
            select: !0
          }), a.removeEventListener(co, d), is.remove(p);
        }, 0);
      };
    }
  }, [
    a,
    u,
    d,
    p
  ]);
  const m = Q((v) => {
    if (!n && !r || p.paused)
      return;
    const _ = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, $ = document.activeElement;
    if (_ && $) {
      const h = v.currentTarget, [b, w] = Gb(h);
      b && w ? !v.shiftKey && $ === w ? (v.preventDefault(), n && Dt(b, {
        select: !0
      })) : v.shiftKey && $ === b && (v.preventDefault(), n && Dt(w, {
        select: !0
      })) : $ === h && v.preventDefault();
    }
  }, [
    n,
    r,
    p.paused
  ]);
  return /* @__PURE__ */ E(Wb.div, M({
    tabIndex: -1
  }, s, {
    ref: f,
    onKeyDown: m
  }));
});
function zb(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Dt(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Gb(e) {
  const t = ul(e), n = os(t, e), r = os(t.reverse(), e);
  return [
    n,
    r
  ];
}
function ul(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function os(e, t) {
  for (const n of e)
    if (!Yb(n, {
      upTo: t
    }))
      return n;
}
function Yb(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function qb(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Dt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && qb(e) && t && e.select();
  }
}
const is = Xb();
function Xb() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = as(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = as(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function as(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Jb(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
var Zb = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, on = /* @__PURE__ */ new WeakMap(), Xn = /* @__PURE__ */ new WeakMap(), Jn = {}, lo = 0, dl = function(e) {
  return e && (e.host || dl(e.parentNode));
}, Qb = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = dl(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, e0 = function(e, t, n, r) {
  var i = Qb(t, Array.isArray(e) ? e : [e]);
  Jn[n] || (Jn[n] = /* @__PURE__ */ new WeakMap());
  var o = Jn[n], s = [], a = /* @__PURE__ */ new Set(), c = new Set(i), u = function(l) {
    !l || a.has(l) || (a.add(l), u(l.parentNode));
  };
  i.forEach(u);
  var d = function(l) {
    !l || c.has(l) || Array.prototype.forEach.call(l.children, function(f) {
      if (a.has(f))
        d(f);
      else {
        var p = f.getAttribute(r), m = p !== null && p !== "false", v = (on.get(f) || 0) + 1, _ = (o.get(f) || 0) + 1;
        on.set(f, v), o.set(f, _), s.push(f), v === 1 && m && Xn.set(f, !0), _ === 1 && f.setAttribute(n, "true"), m || f.setAttribute(r, "true");
      }
    });
  };
  return d(t), a.clear(), lo++, function() {
    s.forEach(function(l) {
      var f = on.get(l) - 1, p = o.get(l) - 1;
      on.set(l, f), o.set(l, p), f || (Xn.has(l) || l.removeAttribute(r), Xn.delete(l)), p || l.removeAttribute(n);
    }), lo--, lo || (on = /* @__PURE__ */ new WeakMap(), on = /* @__PURE__ */ new WeakMap(), Xn = /* @__PURE__ */ new WeakMap(), Jn = {});
  };
}, fl = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = t || Zb(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), e0(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, Qe = function() {
  return Qe = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Qe.apply(this, arguments);
};
function pl(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function t0(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var ir = "right-scroll-bar-position", ar = "width-before-scroll-bar", n0 = "with-scroll-bars-hidden", r0 = "--removed-body-scroll-bar-size";
function o0(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function i0(e, t) {
  var n = ue(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function a0(e, t) {
  return i0(t || null, function(n) {
    return e.forEach(function(r) {
      return o0(r, n);
    });
  });
}
function s0(e) {
  return e;
}
function c0(e, t) {
  t === void 0 && (t = s0);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var s = t(o, r);
      return n.push(s), function() {
        n = n.filter(function(a) {
          return a !== s;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(o);
      }
      n = {
        push: function(a) {
          return o(a);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var s = [];
      if (n.length) {
        var a = n;
        n = [], a.forEach(o), s = n;
      }
      var c = function() {
        var d = s;
        s = [], d.forEach(o);
      }, u = function() {
        return Promise.resolve().then(c);
      };
      u(), n = {
        push: function(d) {
          s.push(d), u();
        },
        filter: function(d) {
          return s = s.filter(d), n;
        }
      };
    }
  };
  return i;
}
function l0(e) {
  e === void 0 && (e = {});
  var t = c0(null);
  return t.options = Qe({ async: !0, ssr: !1 }, e), t;
}
var gl = function(e) {
  var t = e.sideCar, n = pl(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return pe.createElement(r, Qe({}, n));
};
gl.isSideCarExport = !0;
function u0(e, t) {
  return e.useMedium(t), gl;
}
var hl = l0(), uo = function() {
}, zr = pe.forwardRef(function(e, t) {
  var n = pe.useRef(null), r = pe.useState({
    onScrollCapture: uo,
    onWheelCapture: uo,
    onTouchMoveCapture: uo
  }), i = r[0], o = r[1], s = e.forwardProps, a = e.children, c = e.className, u = e.removeScrollBar, d = e.enabled, l = e.shards, f = e.sideCar, p = e.noIsolation, m = e.inert, v = e.allowPinchZoom, _ = e.as, $ = _ === void 0 ? "div" : _, h = pl(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), b = f, w = a0([n, t]), x = Qe(Qe({}, h), i);
  return pe.createElement(
    pe.Fragment,
    null,
    d && pe.createElement(b, { sideCar: hl, removeScrollBar: u, shards: l, noIsolation: p, inert: m, setCallbacks: o, allowPinchZoom: !!v, lockRef: n }),
    s ? pe.cloneElement(pe.Children.only(a), Qe(Qe({}, x), { ref: w })) : pe.createElement($, Qe({}, x, { className: c, ref: w }), a)
  );
});
zr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
zr.classNames = {
  fullWidth: ar,
  zeroRight: ir
};
var ss, d0 = function() {
  if (ss)
    return ss;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function f0() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = d0();
  return t && e.setAttribute("nonce", t), e;
}
function p0(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function g0(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var h0 = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = f0()) && (p0(t, n), g0(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, m0 = function() {
  var e = h0();
  return function(t, n) {
    pe.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ml = function() {
  var e = m0(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, v0 = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, fo = function(e) {
  return parseInt(e || "", 10) || 0;
}, b0 = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [fo(n), fo(r), fo(i)];
}, y0 = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return v0;
  var t = b0(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, x0 = ml(), w0 = function(e, t, n, r) {
  var i = e.left, o = e.top, s = e.right, a = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(n0, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ir, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ar, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(ir, " .").concat(ir, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(ar, " .").concat(ar, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(r0, ": ").concat(a, `px;
  }
`);
}, _0 = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r, o = pe.useMemo(function() {
    return y0(i);
  }, [i]);
  return pe.createElement(x0, { styles: w0(o, !t, i, n ? "" : "!important") });
}, Do = !1;
if (typeof window < "u")
  try {
    var Zn = Object.defineProperty({}, "passive", {
      get: function() {
        return Do = !0, !0;
      }
    });
    window.addEventListener("test", Zn, Zn), window.removeEventListener("test", Zn, Zn);
  } catch {
    Do = !1;
  }
var an = Do ? { passive: !1 } : !1, $0 = function(e) {
  return e.tagName === "TEXTAREA";
}, vl = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !$0(e) && n[t] === "visible")
  );
}, C0 = function(e) {
  return vl(e, "overflowY");
}, E0 = function(e) {
  return vl(e, "overflowX");
}, cs = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = bl(e, n);
    if (r) {
      var i = yl(e, n), o = i[1], s = i[2];
      if (o > s)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, I0 = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, S0 = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, bl = function(e, t) {
  return e === "v" ? C0(t) : E0(t);
}, yl = function(e, t) {
  return e === "v" ? I0(t) : S0(t);
}, O0 = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, N0 = function(e, t, n, r, i) {
  var o = O0(e, window.getComputedStyle(t).direction), s = o * r, a = n.target, c = t.contains(a), u = !1, d = s > 0, l = 0, f = 0;
  do {
    var p = yl(e, a), m = p[0], v = p[1], _ = p[2], $ = v - _ - o * m;
    (m || $) && bl(e, a) && (l += $, f += m), a = a.parentNode;
  } while (
    // portaled content
    !c && a !== document.body || // self content
    c && (t.contains(a) || t === a)
  );
  return (d && (i && l === 0 || !i && s > l) || !d && (i && f === 0 || !i && -s > f)) && (u = !0), u;
}, Qn = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ls = function(e) {
  return [e.deltaX, e.deltaY];
}, us = function(e) {
  return e && "current" in e ? e.current : e;
}, T0 = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, R0 = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, P0 = 0, sn = [];
function A0(e) {
  var t = pe.useRef([]), n = pe.useRef([0, 0]), r = pe.useRef(), i = pe.useState(P0++)[0], o = pe.useState(function() {
    return ml();
  })[0], s = pe.useRef(e);
  pe.useEffect(function() {
    s.current = e;
  }, [e]), pe.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var v = t0([e.lockRef.current], (e.shards || []).map(us), !0).filter(Boolean);
      return v.forEach(function(_) {
        return _.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), v.forEach(function(_) {
          return _.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var a = pe.useCallback(function(v, _) {
    if ("touches" in v && v.touches.length === 2)
      return !s.current.allowPinchZoom;
    var $ = Qn(v), h = n.current, b = "deltaX" in v ? v.deltaX : h[0] - $[0], w = "deltaY" in v ? v.deltaY : h[1] - $[1], x, T = v.target, I = Math.abs(b) > Math.abs(w) ? "h" : "v";
    if ("touches" in v && I === "h" && T.type === "range")
      return !1;
    var k = cs(I, T);
    if (!k)
      return !0;
    if (k ? x = I : (x = I === "v" ? "h" : "v", k = cs(I, T)), !k)
      return !1;
    if (!r.current && "changedTouches" in v && (b || w) && (r.current = x), !x)
      return !0;
    var B = r.current || x;
    return N0(B, _, v, B === "h" ? b : w, !0);
  }, []), c = pe.useCallback(function(v) {
    var _ = v;
    if (!(!sn.length || sn[sn.length - 1] !== o)) {
      var $ = "deltaY" in _ ? ls(_) : Qn(_), h = t.current.filter(function(x) {
        return x.name === _.type && x.target === _.target && T0(x.delta, $);
      })[0];
      if (h && h.should) {
        _.cancelable && _.preventDefault();
        return;
      }
      if (!h) {
        var b = (s.current.shards || []).map(us).filter(Boolean).filter(function(x) {
          return x.contains(_.target);
        }), w = b.length > 0 ? a(_, b[0]) : !s.current.noIsolation;
        w && _.cancelable && _.preventDefault();
      }
    }
  }, []), u = pe.useCallback(function(v, _, $, h) {
    var b = { name: v, delta: _, target: $, should: h };
    t.current.push(b), setTimeout(function() {
      t.current = t.current.filter(function(w) {
        return w !== b;
      });
    }, 1);
  }, []), d = pe.useCallback(function(v) {
    n.current = Qn(v), r.current = void 0;
  }, []), l = pe.useCallback(function(v) {
    u(v.type, ls(v), v.target, a(v, e.lockRef.current));
  }, []), f = pe.useCallback(function(v) {
    u(v.type, Qn(v), v.target, a(v, e.lockRef.current));
  }, []);
  pe.useEffect(function() {
    return sn.push(o), e.setCallbacks({
      onScrollCapture: l,
      onWheelCapture: l,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", c, an), document.addEventListener("touchmove", c, an), document.addEventListener("touchstart", d, an), function() {
      sn = sn.filter(function(v) {
        return v !== o;
      }), document.removeEventListener("wheel", c, an), document.removeEventListener("touchmove", c, an), document.removeEventListener("touchstart", d, an);
    };
  }, []);
  var p = e.removeScrollBar, m = e.inert;
  return pe.createElement(
    pe.Fragment,
    null,
    m ? pe.createElement(o, { styles: R0(i) }) : null,
    p ? pe.createElement(_0, { gapMode: "margin" }) : null
  );
}
const M0 = u0(hl, A0);
var xl = pe.forwardRef(function(e, t) {
  return pe.createElement(zr, Qe({}, e, { ref: t, sideCar: M0 }));
});
xl.classNames = zr.classNames;
const wl = xl, _l = "Popover", [$l, aE] = Ye(_l, [
  wn
]), Si = wn(), [D0, En] = $l(_l), k0 = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: s = !1 } = e, a = Si(t), c = U(null), [u, d] = ue(!1), [l = !1, f] = ht({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ E(di, a, /* @__PURE__ */ E(D0, {
    scope: t,
    contentId: Ze(),
    triggerRef: c,
    open: l,
    onOpenChange: f,
    onOpenToggle: Q(
      () => f(
        (p) => !p
      ),
      [
        f
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: Q(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: Q(
      () => d(!1),
      []
    ),
    modal: s
  }, n));
}, L0 = "PopoverAnchor", j0 = /* @__PURE__ */ q((e, t) => {
  const { __scopePopover: n, ...r } = e, i = En(L0, n), o = Si(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: a } = i;
  return te(() => (s(), () => a()), [
    s,
    a
  ]), /* @__PURE__ */ E(fi, M({}, o, r, {
    ref: t
  }));
}), Cl = "PopoverPortal", [F0, B0] = $l(Cl, {
  forceMount: void 0
}), H0 = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, o = En(Cl, t);
  return /* @__PURE__ */ E(F0, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ E(tt, {
    present: n || o.open
  }, /* @__PURE__ */ E(gi, {
    asChild: !0,
    container: i
  }, r)));
}, Pn = "PopoverContent", V0 = /* @__PURE__ */ q((e, t) => {
  const n = B0(Pn, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, o = En(Pn, e.__scopePopover);
  return /* @__PURE__ */ E(tt, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ E(U0, M({}, i, {
    ref: t
  })) : /* @__PURE__ */ E(K0, M({}, i, {
    ref: t
  })));
}), U0 = /* @__PURE__ */ q((e, t) => {
  const n = En(Pn, e.__scopePopover), r = U(null), i = Re(t, r), o = U(!1);
  return te(() => {
    const s = r.current;
    if (s)
      return fl(s);
  }, []), /* @__PURE__ */ E(wl, {
    as: xt,
    allowPinchZoom: !0
  }, /* @__PURE__ */ E(El, M({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: le(e.onCloseAutoFocus, (s) => {
      var a;
      s.preventDefault(), o.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: le(e.onPointerDownOutside, (s) => {
      const a = s.detail.originalEvent, c = a.button === 0 && a.ctrlKey === !0, u = a.button === 2 || c;
      o.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: le(
      e.onFocusOutside,
      (s) => s.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), K0 = /* @__PURE__ */ q((e, t) => {
  const n = En(Pn, e.__scopePopover), r = U(!1), i = U(!1);
  return /* @__PURE__ */ E(El, M({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, o), !o.defaultPrevented) {
        var a;
        r.current || (a = n.triggerRef.current) === null || a === void 0 || a.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var s, a;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const c = o.target;
      ((a = n.triggerRef.current) === null || a === void 0 ? void 0 : a.contains(c)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), El = /* @__PURE__ */ q((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, disableOutsidePointerEvents: s, onEscapeKeyDown: a, onPointerDownOutside: c, onFocusOutside: u, onInteractOutside: d, ...l } = e, f = En(Pn, n), p = Si(n);
  return cl(), /* @__PURE__ */ E(ll, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ E(ri, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onInteractOutside: d,
    onEscapeKeyDown: a,
    onPointerDownOutside: c,
    onFocusOutside: u,
    onDismiss: () => f.onOpenChange(!1)
  }, /* @__PURE__ */ E(pi, M({
    "data-state": W0(f.open),
    role: "dialog",
    id: f.contentId
  }, p, l, {
    ref: t,
    style: {
      ...l.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
});
function W0(e) {
  return e ? "open" : "closed";
}
const Il = k0, Sl = j0, Ol = H0, Nl = V0;
function et(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function ds(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function ko(e, t) {
  return ko = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ko(e, t);
}
function z0(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ko(e, t);
}
var Lo = { exports: {} }, Ie = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fs;
function G0() {
  if (fs)
    return Ie;
  fs = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(_) {
    if (typeof _ == "object" && _ !== null) {
      var $ = _.$$typeof;
      switch ($) {
        case e:
          switch (_ = _.type, _) {
            case n:
            case i:
            case r:
            case u:
            case d:
              return _;
            default:
              switch (_ = _ && _.$$typeof, _) {
                case a:
                case s:
                case c:
                case f:
                case l:
                case o:
                  return _;
                default:
                  return $;
              }
          }
        case t:
          return $;
      }
    }
  }
  return Ie.ContextConsumer = s, Ie.ContextProvider = o, Ie.Element = e, Ie.ForwardRef = c, Ie.Fragment = n, Ie.Lazy = f, Ie.Memo = l, Ie.Portal = t, Ie.Profiler = i, Ie.StrictMode = r, Ie.Suspense = u, Ie.SuspenseList = d, Ie.isAsyncMode = function() {
    return !1;
  }, Ie.isConcurrentMode = function() {
    return !1;
  }, Ie.isContextConsumer = function(_) {
    return v(_) === s;
  }, Ie.isContextProvider = function(_) {
    return v(_) === o;
  }, Ie.isElement = function(_) {
    return typeof _ == "object" && _ !== null && _.$$typeof === e;
  }, Ie.isForwardRef = function(_) {
    return v(_) === c;
  }, Ie.isFragment = function(_) {
    return v(_) === n;
  }, Ie.isLazy = function(_) {
    return v(_) === f;
  }, Ie.isMemo = function(_) {
    return v(_) === l;
  }, Ie.isPortal = function(_) {
    return v(_) === t;
  }, Ie.isProfiler = function(_) {
    return v(_) === i;
  }, Ie.isStrictMode = function(_) {
    return v(_) === r;
  }, Ie.isSuspense = function(_) {
    return v(_) === u;
  }, Ie.isSuspenseList = function(_) {
    return v(_) === d;
  }, Ie.isValidElementType = function(_) {
    return typeof _ == "string" || typeof _ == "function" || _ === n || _ === i || _ === r || _ === u || _ === d || _ === p || typeof _ == "object" && _ !== null && (_.$$typeof === f || _.$$typeof === l || _.$$typeof === o || _.$$typeof === s || _.$$typeof === c || _.$$typeof === m || _.getModuleId !== void 0);
  }, Ie.typeOf = v, Ie;
}
var Se = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ps;
function Y0() {
  return ps || (ps = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), c = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), m = !1, v = !1, _ = !1, $ = !1, h = !1, b;
    b = Symbol.for("react.module.reference");
    function w(ee) {
      return !!(typeof ee == "string" || typeof ee == "function" || ee === n || ee === i || h || ee === r || ee === u || ee === d || $ || ee === p || m || v || _ || typeof ee == "object" && ee !== null && (ee.$$typeof === f || ee.$$typeof === l || ee.$$typeof === o || ee.$$typeof === s || ee.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ee.$$typeof === b || ee.getModuleId !== void 0));
    }
    function x(ee) {
      if (typeof ee == "object" && ee !== null) {
        var be = ee.$$typeof;
        switch (be) {
          case e:
            var Te = ee.type;
            switch (Te) {
              case n:
              case i:
              case r:
              case u:
              case d:
                return Te;
              default:
                var Ne = Te && Te.$$typeof;
                switch (Ne) {
                  case a:
                  case s:
                  case c:
                  case f:
                  case l:
                  case o:
                    return Ne;
                  default:
                    return be;
                }
            }
          case t:
            return be;
        }
      }
    }
    var T = s, I = o, k = e, B = c, V = n, z = f, ne = l, oe = t, D = i, j = r, J = u, S = d, Y = !1, X = !1;
    function A(ee) {
      return Y || (Y = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(ee) {
      return X || (X = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ie(ee) {
      return x(ee) === s;
    }
    function N(ee) {
      return x(ee) === o;
    }
    function R(ee) {
      return typeof ee == "object" && ee !== null && ee.$$typeof === e;
    }
    function P(ee) {
      return x(ee) === c;
    }
    function O(ee) {
      return x(ee) === n;
    }
    function L(ee) {
      return x(ee) === f;
    }
    function W(ee) {
      return x(ee) === l;
    }
    function Z(ee) {
      return x(ee) === t;
    }
    function re(ee) {
      return x(ee) === i;
    }
    function fe(ee) {
      return x(ee) === r;
    }
    function H(ee) {
      return x(ee) === u;
    }
    function ve(ee) {
      return x(ee) === d;
    }
    Se.ContextConsumer = T, Se.ContextProvider = I, Se.Element = k, Se.ForwardRef = B, Se.Fragment = V, Se.Lazy = z, Se.Memo = ne, Se.Portal = oe, Se.Profiler = D, Se.StrictMode = j, Se.Suspense = J, Se.SuspenseList = S, Se.isAsyncMode = A, Se.isConcurrentMode = F, Se.isContextConsumer = ie, Se.isContextProvider = N, Se.isElement = R, Se.isForwardRef = P, Se.isFragment = O, Se.isLazy = L, Se.isMemo = W, Se.isPortal = Z, Se.isProfiler = re, Se.isStrictMode = fe, Se.isSuspense = H, Se.isSuspenseList = ve, Se.isValidElementType = w, Se.typeOf = x;
  }()), Se;
}
process.env.NODE_ENV === "production" ? Lo.exports = G0() : Lo.exports = Y0();
var gs = Lo.exports;
const hs = (e) => typeof e == "object" && e != null && e.nodeType === 1, ms = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", po = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const n = getComputedStyle(e, null);
    return ms(n.overflowY, t) || ms(n.overflowX, t) || ((r) => {
      const i = ((o) => {
        if (!o.ownerDocument || !o.ownerDocument.defaultView)
          return null;
        try {
          return o.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(r);
      return !!i && (i.clientHeight < r.scrollHeight || i.clientWidth < r.scrollWidth);
    })(e);
  }
  return !1;
}, er = (e, t, n, r, i, o, s, a) => o < e && s > t || o > e && s < t ? 0 : o <= e && a <= n || s >= t && a >= n ? o - e - r : s > t && a < n || o < e && a > n ? s - t + i : 0, q0 = (e) => {
  const t = e.parentElement;
  return t ?? (e.getRootNode().host || null);
}, X0 = (e, t) => {
  var n, r, i, o;
  if (typeof document > "u")
    return [];
  const { scrollMode: s, block: a, inline: c, boundary: u, skipOverflowHiddenElements: d } = t, l = typeof u == "function" ? u : (J) => J !== u;
  if (!hs(e))
    throw new TypeError("Invalid target");
  const f = document.scrollingElement || document.documentElement, p = [];
  let m = e;
  for (; hs(m) && l(m); ) {
    if (m = q0(m), m === f) {
      p.push(m);
      break;
    }
    m != null && m === document.body && po(m) && !po(document.documentElement) || m != null && po(m, d) && p.push(m);
  }
  const v = (r = (n = window.visualViewport) == null ? void 0 : n.width) != null ? r : innerWidth, _ = (o = (i = window.visualViewport) == null ? void 0 : i.height) != null ? o : innerHeight, { scrollX: $, scrollY: h } = window, { height: b, width: w, top: x, right: T, bottom: I, left: k } = e.getBoundingClientRect(), { top: B, right: V, bottom: z, left: ne } = ((J) => {
    const S = window.getComputedStyle(J);
    return { top: parseFloat(S.scrollMarginTop) || 0, right: parseFloat(S.scrollMarginRight) || 0, bottom: parseFloat(S.scrollMarginBottom) || 0, left: parseFloat(S.scrollMarginLeft) || 0 };
  })(e);
  let oe = a === "start" || a === "nearest" ? x - B : a === "end" ? I + z : x + b / 2 - B + z, D = c === "center" ? k + w / 2 - ne + V : c === "end" ? T + V : k - ne;
  const j = [];
  for (let J = 0; J < p.length; J++) {
    const S = p[J], { height: Y, width: X, top: A, right: F, bottom: ie, left: N } = S.getBoundingClientRect();
    if (s === "if-needed" && x >= 0 && k >= 0 && I <= _ && T <= v && x >= A && I <= ie && k >= N && T <= F)
      return j;
    const R = getComputedStyle(S), P = parseInt(R.borderLeftWidth, 10), O = parseInt(R.borderTopWidth, 10), L = parseInt(R.borderRightWidth, 10), W = parseInt(R.borderBottomWidth, 10);
    let Z = 0, re = 0;
    const fe = "offsetWidth" in S ? S.offsetWidth - S.clientWidth - P - L : 0, H = "offsetHeight" in S ? S.offsetHeight - S.clientHeight - O - W : 0, ve = "offsetWidth" in S ? S.offsetWidth === 0 ? 0 : X / S.offsetWidth : 0, ee = "offsetHeight" in S ? S.offsetHeight === 0 ? 0 : Y / S.offsetHeight : 0;
    if (f === S)
      Z = a === "start" ? oe : a === "end" ? oe - _ : a === "nearest" ? er(h, h + _, _, O, W, h + oe, h + oe + b, b) : oe - _ / 2, re = c === "start" ? D : c === "center" ? D - v / 2 : c === "end" ? D - v : er($, $ + v, v, P, L, $ + D, $ + D + w, w), Z = Math.max(0, Z + h), re = Math.max(0, re + $);
    else {
      Z = a === "start" ? oe - A - O : a === "end" ? oe - ie + W + H : a === "nearest" ? er(A, ie, Y, O, W + H, oe, oe + b, b) : oe - (A + Y / 2) + H / 2, re = c === "start" ? D - N - P : c === "center" ? D - (N + X / 2) + fe / 2 : c === "end" ? D - F + L + fe : er(N, F, X, P, L + fe, D, D + w, w);
      const { scrollLeft: be, scrollTop: Te } = S;
      Z = ee === 0 ? 0 : Math.max(0, Math.min(Te + Z / ee, S.scrollHeight - Y / ee + H)), re = ve === 0 ? 0 : Math.max(0, Math.min(be + re / ve, S.scrollWidth - X / ve + fe)), oe += Te - Z, D += be - re;
    }
    j.push({ el: S, top: Z, left: re });
  }
  return j;
};
var J0 = 0;
function vs(e) {
  return typeof e == "function" ? e : ot;
}
function ot() {
}
function Tl(e, t) {
  if (e) {
    var n = X0(e, {
      boundary: t,
      block: "nearest",
      scrollMode: "if-needed"
    });
    n.forEach(function(r) {
      var i = r.el, o = r.top, s = r.left;
      i.scrollTop = o, i.scrollLeft = s;
    });
  }
}
function bs(e, t, n) {
  var r = e === t || t instanceof n.Node && e.contains && e.contains(t);
  return r;
}
function Gr(e, t) {
  var n;
  function r() {
    n && clearTimeout(n);
  }
  function i() {
    for (var o = arguments.length, s = new Array(o), a = 0; a < o; a++)
      s[a] = arguments[a];
    r(), n = setTimeout(function() {
      n = null, e.apply(void 0, s);
    }, t);
  }
  return i.cancel = r, i;
}
function De() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var i = arguments.length, o = new Array(i > 1 ? i - 1 : 0), s = 1; s < i; s++)
      o[s - 1] = arguments[s];
    return t.some(function(a) {
      return a && a.apply(void 0, [r].concat(o)), r.preventDownshiftDefault || r.hasOwnProperty("nativeEvent") && r.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Et() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    t.forEach(function(i) {
      typeof i == "function" ? i(r) : i && (i.current = r);
    });
  };
}
function Rl() {
  return String(J0++);
}
function Pl(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? n + " result" + (n === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function ys(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function Al(e) {
  return typeof e.type == "string";
}
function Ml(e) {
  return e.props;
}
function Z0(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var Q0 = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function tr(e) {
  e === void 0 && (e = {});
  var t = {};
  return Q0.forEach(function(n) {
    e.hasOwnProperty(n) && (t[n] = e[n]);
  }), t;
}
function An(e, t) {
  return Object.keys(e).reduce(function(n, r) {
    return n[r] = Er(t, r) ? t[r] : e[r], n;
  }, {});
}
function Er(e, t) {
  return e[t] !== void 0;
}
function Ir(e) {
  var t = e.key, n = e.keyCode;
  return n >= 37 && n <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function ey(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function pt(e, t, n, r, i) {
  i === void 0 && (i = !1);
  var o = n.length;
  if (o === 0)
    return -1;
  var s = o - 1;
  (typeof e != "number" || e < 0 || e > s) && (e = t > 0 ? -1 : s + 1);
  var a = e + t;
  a < 0 ? a = i ? s : 0 : a > s && (a = i ? 0 : s);
  var c = Vt(a, t < 0, n, r, i);
  return c === -1 ? e >= o ? -1 : e : c;
}
function Vt(e, t, n, r, i) {
  i === void 0 && (i = !1);
  var o = n.length;
  if (t) {
    for (var s = e; s >= 0; s--)
      if (!r(n[s], s))
        return s;
  } else
    for (var a = e; a < o; a++)
      if (!r(n[a], a))
        return a;
  return i ? Vt(t ? o - 1 : 0, t, n, r) : -1;
}
function Sr(e, t, n, r) {
  return r === void 0 && (r = !0), n && t.some(function(i) {
    return i && (bs(i, e, n) || r && bs(i, n.document.activeElement, n));
  });
}
var Oi = ot;
process.env.NODE_ENV !== "production" && (Oi = function(t, n, r) {
  var i = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(t).forEach(function(o) {
    n[o] !== void 0 && r[o] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + o + '" to be uncontrolled. ' + i) : n[o] === void 0 && r[o] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + o + '" to be controlled. ' + i);
  });
});
var ty = Gr(function(e) {
  Dl(e).textContent = "";
}, 500);
function Dl(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function kl(e, t) {
  if (!(!e || !t)) {
    var n = Dl(t);
    n.textContent = e, ty(t);
  }
}
var Ll = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, jl = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Fl = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, sr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, cr = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Bl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, Hl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Vl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, Ul = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, Kl = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, Wl = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, zl = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, Gl = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, jo = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, Yl = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, ql = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, Xl = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, ny = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  unknown: Ll,
  mouseUp: jl,
  itemMouseEnter: Fl,
  keyDownArrowUp: sr,
  keyDownArrowDown: cr,
  keyDownEscape: Bl,
  keyDownEnter: Hl,
  keyDownHome: Vl,
  keyDownEnd: Ul,
  clickItem: Kl,
  blurInput: Wl,
  changeInput: zl,
  keyDownSpaceButton: Gl,
  clickButton: jo,
  blurButton: Yl,
  controlledPropUpdatedSelectedItem: ql,
  touchEnd: Xl
}), ry = ["refKey", "ref"], oy = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], iy = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], ay = ["refKey", "ref"], sy = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], cy = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    z0(n, t);
    function n(i) {
      var o;
      o = t.call(this, i) || this, o.id = o.props.id || "downshift-" + Rl(), o.menuId = o.props.menuId || o.id + "-menu", o.labelId = o.props.labelId || o.id + "-label", o.inputId = o.props.inputId || o.id + "-input", o.getItemId = o.props.getItemId || function(h) {
        return o.id + "-item-" + h;
      }, o.items = [], o.itemCount = null, o.previousResultCount = 0, o.timeoutIds = [], o.internalSetTimeout = function(h, b) {
        var w = setTimeout(function() {
          o.timeoutIds = o.timeoutIds.filter(function(x) {
            return x !== w;
          }), h();
        }, b);
        o.timeoutIds.push(w);
      }, o.setItemCount = function(h) {
        o.itemCount = h;
      }, o.unsetItemCount = function() {
        o.itemCount = null;
      }, o.isItemDisabled = function(h, b) {
        var w = o.getItemNodeFromIndex(b);
        return w && w.hasAttribute("disabled");
      }, o.setHighlightedIndex = function(h, b) {
        h === void 0 && (h = o.props.defaultHighlightedIndex), b === void 0 && (b = {}), b = tr(b), o.internalSetState(M({
          highlightedIndex: h
        }, b));
      }, o.clearSelection = function(h) {
        o.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: o.props.defaultHighlightedIndex,
          isOpen: o.props.defaultIsOpen
        }, h);
      }, o.selectItem = function(h, b, w) {
        b = tr(b), o.internalSetState(M({
          isOpen: o.props.defaultIsOpen,
          highlightedIndex: o.props.defaultHighlightedIndex,
          selectedItem: h,
          inputValue: o.props.itemToString(h)
        }, b), w);
      }, o.selectItemAtIndex = function(h, b, w) {
        var x = o.items[h];
        x != null && o.selectItem(x, b, w);
      }, o.selectHighlightedItem = function(h, b) {
        return o.selectItemAtIndex(o.getState().highlightedIndex, h, b);
      }, o.internalSetState = function(h, b) {
        var w, x, T = {}, I = typeof h == "function";
        return !I && h.hasOwnProperty("inputValue") && o.props.onInputValueChange(h.inputValue, M({}, o.getStateAndHelpers(), h)), o.setState(function(k) {
          var B;
          k = o.getState(k);
          var V = I ? h(k) : h;
          V = o.props.stateReducer(k, V), w = V.hasOwnProperty("selectedItem");
          var z = {};
          return w && V.selectedItem !== k.selectedItem && (x = V.selectedItem), (B = V).type || (B.type = Ll), Object.keys(V).forEach(function(ne) {
            k[ne] !== V[ne] && (T[ne] = V[ne]), ne !== "type" && (V[ne], Er(o.props, ne) || (z[ne] = V[ne]));
          }), I && V.hasOwnProperty("inputValue") && o.props.onInputValueChange(V.inputValue, M({}, o.getStateAndHelpers(), V)), z;
        }, function() {
          vs(b)();
          var k = Object.keys(T).length > 1;
          k && o.props.onStateChange(T, o.getStateAndHelpers()), w && o.props.onSelect(h.selectedItem, o.getStateAndHelpers()), x !== void 0 && o.props.onChange(x, o.getStateAndHelpers()), o.props.onUserAction(T, o.getStateAndHelpers());
        });
      }, o.rootRef = function(h) {
        return o._rootNode = h;
      }, o.getRootProps = function(h, b) {
        var w, x = h === void 0 ? {} : h, T = x.refKey, I = T === void 0 ? "ref" : T, k = x.ref, B = et(x, ry), V = b === void 0 ? {} : b, z = V.suppressRefError, ne = z === void 0 ? !1 : z;
        o.getRootProps.called = !0, o.getRootProps.refKey = I, o.getRootProps.suppressRefError = ne;
        var oe = o.getState(), D = oe.isOpen;
        return M((w = {}, w[I] = Et(k, o.rootRef), w.role = "combobox", w["aria-expanded"] = D, w["aria-haspopup"] = "listbox", w["aria-owns"] = D ? o.menuId : void 0, w["aria-labelledby"] = o.labelId, w), B);
      }, o.keyDownHandlers = {
        ArrowDown: function(b) {
          var w = this;
          if (b.preventDefault(), this.getState().isOpen) {
            var x = b.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(x, {
              type: cr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: cr
            }, function() {
              var T = w.getItemCount();
              if (T > 0) {
                var I = w.getState(), k = I.highlightedIndex, B = pt(k, 1, {
                  length: T
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(B, {
                  type: cr
                });
              }
            });
        },
        ArrowUp: function(b) {
          var w = this;
          if (b.preventDefault(), this.getState().isOpen) {
            var x = b.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(x, {
              type: sr
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: sr
            }, function() {
              var T = w.getItemCount();
              if (T > 0) {
                var I = w.getState(), k = I.highlightedIndex, B = pt(k, -1, {
                  length: T
                }, w.isItemDisabled, !0);
                w.setHighlightedIndex(B, {
                  type: sr
                });
              }
            });
        },
        Enter: function(b) {
          if (b.which !== 229) {
            var w = this.getState(), x = w.isOpen, T = w.highlightedIndex;
            if (x && T != null) {
              b.preventDefault();
              var I = this.items[T], k = this.getItemNodeFromIndex(T);
              if (I == null || k && k.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: Hl
              });
            }
          }
        },
        Escape: function(b) {
          b.preventDefault(), this.reset(M({
            type: Bl
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, o.buttonKeyDownHandlers = M({}, o.keyDownHandlers, {
        " ": function(b) {
          b.preventDefault(), this.toggleMenu({
            type: Gl
          });
        }
      }), o.inputKeyDownHandlers = M({}, o.keyDownHandlers, {
        Home: function(b) {
          var w = this.getState(), x = w.isOpen;
          if (x) {
            b.preventDefault();
            var T = this.getItemCount();
            if (!(T <= 0 || !x)) {
              var I = Vt(0, !1, {
                length: T
              }, this.isItemDisabled);
              this.setHighlightedIndex(I, {
                type: Vl
              });
            }
          }
        },
        End: function(b) {
          var w = this.getState(), x = w.isOpen;
          if (x) {
            b.preventDefault();
            var T = this.getItemCount();
            if (!(T <= 0 || !x)) {
              var I = Vt(T - 1, !0, {
                length: T
              }, this.isItemDisabled);
              this.setHighlightedIndex(I, {
                type: Ul
              });
            }
          }
        }
      }), o.getToggleButtonProps = function(h) {
        var b = h === void 0 ? {} : h, w = b.onClick;
        b.onPress;
        var x = b.onKeyDown, T = b.onKeyUp, I = b.onBlur, k = et(b, oy), B = o.getState(), V = B.isOpen, z = {
          onClick: De(w, o.buttonHandleClick),
          onKeyDown: De(x, o.buttonHandleKeyDown),
          onKeyUp: De(T, o.buttonHandleKeyUp),
          onBlur: De(I, o.buttonHandleBlur)
        }, ne = k.disabled ? {} : z;
        return M({
          type: "button",
          role: "button",
          "aria-label": V ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, ne, k);
      }, o.buttonHandleKeyUp = function(h) {
        h.preventDefault();
      }, o.buttonHandleKeyDown = function(h) {
        var b = Ir(h);
        o.buttonKeyDownHandlers[b] && o.buttonKeyDownHandlers[b].call(ds(o), h);
      }, o.buttonHandleClick = function(h) {
        if (h.preventDefault(), o.props.environment) {
          var b = o.props.environment.document, w = b.body, x = b.activeElement;
          w && w === x && h.target.focus();
        }
        process.env.NODE_ENV === "test" ? o.toggleMenu({
          type: jo
        }) : o.internalSetTimeout(function() {
          return o.toggleMenu({
            type: jo
          });
        });
      }, o.buttonHandleBlur = function(h) {
        var b = h.target;
        o.internalSetTimeout(function() {
          if (!(o.isMouseDown || !o.props.environment)) {
            var w = o.props.environment.document.activeElement;
            (w == null || w.id !== o.inputId) && w !== b && o.reset({
              type: Yl
            });
          }
        });
      }, o.getLabelProps = function(h) {
        return M({
          htmlFor: o.inputId,
          id: o.labelId
        }, h);
      }, o.getInputProps = function(h) {
        var b = h === void 0 ? {} : h, w = b.onKeyDown, x = b.onBlur, T = b.onChange, I = b.onInput;
        b.onChangeText;
        var k = et(b, iy), B, V = {};
        B = "onChange";
        var z = o.getState(), ne = z.inputValue, oe = z.isOpen, D = z.highlightedIndex;
        if (!k.disabled) {
          var j;
          V = (j = {}, j[B] = De(T, I, o.inputHandleChange), j.onKeyDown = De(w, o.inputHandleKeyDown), j.onBlur = De(x, o.inputHandleBlur), j);
        }
        return M({
          "aria-autocomplete": "list",
          "aria-activedescendant": oe && typeof D == "number" && D >= 0 ? o.getItemId(D) : void 0,
          "aria-controls": oe ? o.menuId : void 0,
          "aria-labelledby": k && k["aria-label"] ? void 0 : o.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: ne,
          id: o.inputId
        }, V, k);
      }, o.inputHandleKeyDown = function(h) {
        var b = Ir(h);
        b && o.inputKeyDownHandlers[b] && o.inputKeyDownHandlers[b].call(ds(o), h);
      }, o.inputHandleChange = function(h) {
        o.internalSetState({
          type: zl,
          isOpen: !0,
          inputValue: h.target.value,
          highlightedIndex: o.props.defaultHighlightedIndex
        });
      }, o.inputHandleBlur = function() {
        o.internalSetTimeout(function() {
          var h;
          if (!(o.isMouseDown || !o.props.environment)) {
            var b = o.props.environment.document.activeElement, w = (b == null || (h = b.dataset) == null ? void 0 : h.toggle) && o._rootNode && o._rootNode.contains(b);
            w || o.reset({
              type: Wl
            });
          }
        });
      }, o.menuRef = function(h) {
        o._menuNode = h;
      }, o.getMenuProps = function(h, b) {
        var w, x = h === void 0 ? {} : h, T = x.refKey, I = T === void 0 ? "ref" : T, k = x.ref, B = et(x, ay), V = b === void 0 ? {} : b, z = V.suppressRefError, ne = z === void 0 ? !1 : z;
        return o.getMenuProps.called = !0, o.getMenuProps.refKey = I, o.getMenuProps.suppressRefError = ne, M((w = {}, w[I] = Et(k, o.menuRef), w.role = "listbox", w["aria-labelledby"] = B && B["aria-label"] ? void 0 : o.labelId, w.id = o.menuId, w), B);
      }, o.getItemProps = function(h) {
        var b, w = h === void 0 ? {} : h, x = w.onMouseMove, T = w.onMouseDown, I = w.onClick;
        w.onPress;
        var k = w.index, B = w.item, V = B === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : Z0("getItemProps", "item") : B, z = et(w, sy);
        k === void 0 ? (o.items.push(V), k = o.items.indexOf(V)) : o.items[k] = V;
        var ne = "onClick", oe = I, D = (b = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: De(x, function() {
            k !== o.getState().highlightedIndex && (o.setHighlightedIndex(k, {
              type: Fl
            }), o.avoidScrolling = !0, o.internalSetTimeout(function() {
              return o.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: De(T, function(J) {
            J.preventDefault();
          })
        }, b[ne] = De(oe, function() {
          o.selectItemAtIndex(k, {
            type: Kl
          });
        }), b), j = z.disabled ? {
          onMouseDown: D.onMouseDown
        } : D;
        return M({
          id: o.getItemId(k),
          role: "option",
          "aria-selected": o.getState().highlightedIndex === k
        }, j, z);
      }, o.clearItems = function() {
        o.items = [];
      }, o.reset = function(h, b) {
        h === void 0 && (h = {}), h = tr(h), o.internalSetState(function(w) {
          var x = w.selectedItem;
          return M({
            isOpen: o.props.defaultIsOpen,
            highlightedIndex: o.props.defaultHighlightedIndex,
            inputValue: o.props.itemToString(x)
          }, h);
        }, b);
      }, o.toggleMenu = function(h, b) {
        h === void 0 && (h = {}), h = tr(h), o.internalSetState(function(w) {
          var x = w.isOpen;
          return M({
            isOpen: !x
          }, x && {
            highlightedIndex: o.props.defaultHighlightedIndex
          }, h);
        }, function() {
          var w = o.getState(), x = w.isOpen, T = w.highlightedIndex;
          x && o.getItemCount() > 0 && typeof T == "number" && o.setHighlightedIndex(T, h), vs(b)();
        });
      }, o.openMenu = function(h) {
        o.internalSetState({
          isOpen: !0
        }, h);
      }, o.closeMenu = function(h) {
        o.internalSetState({
          isOpen: !1
        }, h);
      }, o.updateStatus = Gr(function() {
        var h;
        if ((h = o.props) != null && (h = h.environment) != null && h.document) {
          var b = o.getState(), w = o.items[b.highlightedIndex], x = o.getItemCount(), T = o.props.getA11yStatusMessage(M({
            itemToString: o.props.itemToString,
            previousResultCount: o.previousResultCount,
            resultCount: x,
            highlightedItem: w
          }, b));
          o.previousResultCount = x, kl(T, o.props.environment.document);
        }
      }, 200);
      var s = o.props, a = s.defaultHighlightedIndex, c = s.initialHighlightedIndex, u = c === void 0 ? a : c, d = s.defaultIsOpen, l = s.initialIsOpen, f = l === void 0 ? d : l, p = s.initialInputValue, m = p === void 0 ? "" : p, v = s.initialSelectedItem, _ = v === void 0 ? null : v, $ = o.getState({
        highlightedIndex: u,
        isOpen: f,
        inputValue: m,
        selectedItem: _
      });
      return $.selectedItem != null && o.props.initialInputValue === void 0 && ($.inputValue = o.props.itemToString($.selectedItem)), o.state = $, o;
    }
    var r = n.prototype;
    return r.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(o) {
        clearTimeout(o);
      }), this.timeoutIds = [];
    }, r.getState = function(o) {
      return o === void 0 && (o = this.state), An(o, this.props);
    }, r.getItemCount = function() {
      var o = this.items.length;
      return this.itemCount != null ? o = this.itemCount : this.props.itemCount !== void 0 && (o = this.props.itemCount), o;
    }, r.getItemNodeFromIndex = function(o) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(o)) : null;
    }, r.scrollHighlightedItemIntoView = function() {
      {
        var o = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(o, this._menuNode);
      }
    }, r.moveHighlightedIndex = function(o, s) {
      var a = this.getItemCount(), c = this.getState(), u = c.highlightedIndex;
      if (a > 0) {
        var d = pt(u, o, {
          length: a
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(d, s);
      }
    }, r.getStateAndHelpers = function() {
      var o = this.getState(), s = o.highlightedIndex, a = o.inputValue, c = o.selectedItem, u = o.isOpen, d = this.props.itemToString, l = this.id, f = this.getRootProps, p = this.getToggleButtonProps, m = this.getLabelProps, v = this.getMenuProps, _ = this.getInputProps, $ = this.getItemProps, h = this.openMenu, b = this.closeMenu, w = this.toggleMenu, x = this.selectItem, T = this.selectItemAtIndex, I = this.selectHighlightedItem, k = this.setHighlightedIndex, B = this.clearSelection, V = this.clearItems, z = this.reset, ne = this.setItemCount, oe = this.unsetItemCount, D = this.internalSetState;
      return {
        // prop getters
        getRootProps: f,
        getToggleButtonProps: p,
        getLabelProps: m,
        getMenuProps: v,
        getInputProps: _,
        getItemProps: $,
        // actions
        reset: z,
        openMenu: h,
        closeMenu: b,
        toggleMenu: w,
        selectItem: x,
        selectItemAtIndex: T,
        selectHighlightedItem: I,
        setHighlightedIndex: k,
        clearSelection: B,
        clearItems: V,
        setItemCount: ne,
        unsetItemCount: oe,
        setState: D,
        // props
        itemToString: d,
        // derived
        id: l,
        // state
        highlightedIndex: s,
        inputValue: a,
        isOpen: u,
        selectedItem: c
      };
    }, r.componentDidMount = function() {
      var o = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && xs(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          o.internalClearTimeouts();
        };
      else {
        var s = function() {
          o.isMouseDown = !0;
        }, a = function(p) {
          o.isMouseDown = !1;
          var m = Sr(p.target, [o._rootNode, o._menuNode], o.props.environment);
          !m && o.getState().isOpen && o.reset({
            type: jl
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, c = function() {
          o.isTouchMove = !1;
        }, u = function() {
          o.isTouchMove = !0;
        }, d = function(p) {
          var m = Sr(p.target, [o._rootNode, o._menuNode], o.props.environment, !1);
          !o.isTouchMove && !m && o.getState().isOpen && o.reset({
            type: Xl
          }, function() {
            return o.props.onOuterClick(o.getStateAndHelpers());
          });
        }, l = this.props.environment;
        l.addEventListener("mousedown", s), l.addEventListener("mouseup", a), l.addEventListener("touchstart", c), l.addEventListener("touchmove", u), l.addEventListener("touchend", d), this.cleanup = function() {
          o.internalClearTimeouts(), o.updateStatus.cancel(), l.removeEventListener("mousedown", s), l.removeEventListener("mouseup", a), l.removeEventListener("touchstart", c), l.removeEventListener("touchmove", u), l.removeEventListener("touchend", d);
        };
      }
    }, r.shouldScroll = function(o, s) {
      var a = this.props.highlightedIndex === void 0 ? this.getState() : this.props, c = a.highlightedIndex, u = s.highlightedIndex === void 0 ? o : s, d = u.highlightedIndex, l = c && this.getState().isOpen && !o.isOpen, f = c !== d;
      return l || f;
    }, r.componentDidUpdate = function(o, s) {
      process.env.NODE_ENV !== "production" && (Oi(this.state, o, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && xs(this._menuNode, this.getMenuProps)), Er(this.props, "selectedItem") && this.props.selectedItemChanged(o.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: ql,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(s, o) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, r.componentWillUnmount = function() {
      this.cleanup();
    }, r.render = function() {
      var o = ys(this.props.children, ot);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var s = ys(o(this.getStateAndHelpers()));
      if (!s)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && ly(s, this.getRootProps), s;
      if (Al(s))
        return /* @__PURE__ */ Mr(s, this.getRootProps(Ml(s)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, n;
  }(vd);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: Pl,
    itemToString: function(n) {
      return n == null ? "" : (process.env.NODE_ENV !== "production" && ey(n) && !n.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", n), String(n));
    },
    onStateChange: ot,
    onInputValueChange: ot,
    onUserAction: ot,
    onChange: ot,
    onSelect: ot,
    onOuterClick: ot,
    selectedItemChanged: function(n, r) {
      return n !== r;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(n, r) {
      return r;
    },
    suppressRefError: !1,
    scrollIntoView: Tl
  }, e.stateChangeTypes = ny, e;
}();
process.env.NODE_ENV !== "production" && (cy.propTypes = {
  children: K.func,
  defaultHighlightedIndex: K.number,
  defaultIsOpen: K.bool,
  initialHighlightedIndex: K.number,
  initialSelectedItem: K.any,
  initialInputValue: K.string,
  initialIsOpen: K.bool,
  getA11yStatusMessage: K.func,
  itemToString: K.func,
  onChange: K.func,
  onSelect: K.func,
  onStateChange: K.func,
  onInputValueChange: K.func,
  onUserAction: K.func,
  onOuterClick: K.func,
  selectedItemChanged: K.func,
  stateReducer: K.func,
  itemCount: K.number,
  id: K.string,
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  suppressRefError: K.bool,
  scrollIntoView: K.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: K.any,
  isOpen: K.bool,
  inputValue: K.string,
  highlightedIndex: K.number,
  labelId: K.string,
  inputId: K.string,
  menuId: K.string,
  getItemId: K.func
  /* eslint-enable react/no-unused-prop-types */
});
function xs(e, t) {
  var n = t.refKey;
  e || console.error('downshift: The ref prop "' + n + '" from getMenuProps was not applied correctly on your menu element.');
}
function ly(e, t) {
  var n = t.refKey, r = n !== "ref", i = !Al(e);
  i && !r && !gs.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !i && r && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + n + '"'), !gs.isForwardRef(e) && !Ml(e)[n] && console.error('downshift: You must apply the ref prop "' + n + '" from getRootProps onto your root element.');
}
var uy = ["isInitialMount", "highlightedIndex", "items", "environment"], Jl = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function dy(e, t, n) {
  var r = e.props, i = e.type, o = {};
  Object.keys(t).forEach(function(s) {
    fy(s, e, t, n), n[s] !== t[s] && (o[s] = n[s]);
  }), r.onStateChange && Object.keys(o).length && r.onStateChange(M({
    type: i
  }, o));
}
function fy(e, t, n, r) {
  var i = t.props, o = t.type, s = "on" + Ni(e) + "Change";
  i[s] && r[e] !== void 0 && r[e] !== n[e] && i[s](M({
    type: o
  }, r));
}
function py(e, t) {
  return t.changes;
}
function gy(e) {
  var t = e.selectedItem, n = e.itemToString;
  return t ? n(t) + " has been selected." : "";
}
var hy = Gr(function(e, t) {
  kl(e(), t);
}, 200), my = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? qo : te, Zl = "useId" in ke ? function(t) {
  var n = t.id, r = t.labelId, i = t.menuId, o = t.getItemId, s = t.toggleButtonId, a = t.inputId, c = "downshift-" + ke.useId();
  n || (n = c);
  var u = U({
    labelId: r || n + "-label",
    menuId: i || n + "-menu",
    getItemId: o || function(d) {
      return n + "-item-" + d;
    },
    toggleButtonId: s || n + "-toggle-button",
    inputId: a || n + "-input"
  });
  return u.current;
} : function(t) {
  var n = t.id, r = n === void 0 ? "downshift-" + Rl() : n, i = t.labelId, o = t.menuId, s = t.getItemId, a = t.toggleButtonId, c = t.inputId, u = U({
    labelId: i || r + "-label",
    menuId: o || r + "-menu",
    getItemId: s || function(d) {
      return r + "-item-" + d;
    },
    toggleButtonId: a || r + "-toggle-button",
    inputId: c || r + "-input"
  });
  return u.current;
};
function Ql(e, t, n, r) {
  var i, o;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(r);
    i = n[t], o = t;
  } else
    o = t === void 0 ? n.indexOf(e) : t, i = e;
  return [i, o];
}
function vy(e) {
  return e ? String(e) : "";
}
function by(e) {
  return /^\S{1}$/.test(e);
}
function Ni(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function Ti(e) {
  var t = U(e);
  return t.current = e, t;
}
function eu(e, t, n) {
  var r = U(), i = U(), o = Q(function(f, p) {
    i.current = p, f = An(f, p.props);
    var m = e(f, p), v = p.props.stateReducer(f, M({}, p, {
      changes: m
    }));
    return v;
  }, [e]), s = Jo(o, t), a = s[0], c = s[1], u = Ti(n), d = Q(function(f) {
    return c(M({
      props: u.current
    }, f));
  }, [u]), l = i.current;
  return te(function() {
    l && r.current && r.current !== a && dy(l, An(r.current, l.props), a), r.current = a;
  }, [a, n, l]), [a, d];
}
function yy(e, t, n) {
  var r = eu(e, t, n), i = r[0], o = r[1];
  return [An(i, n), o];
}
var Sn = {
  itemToString: vy,
  stateReducer: py,
  getA11ySelectionMessage: gy,
  scrollIntoView: Tl,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function lt(e, t, n) {
  n === void 0 && (n = Jl);
  var r = e["default" + Ni(t)];
  return r !== void 0 ? r : n[t];
}
function ln(e, t, n) {
  n === void 0 && (n = Jl);
  var r = e[t];
  if (r !== void 0)
    return r;
  var i = e["initial" + Ni(t)];
  return i !== void 0 ? i : lt(e, t, n);
}
function tu(e) {
  var t = ln(e, "selectedItem"), n = ln(e, "isOpen"), r = ln(e, "highlightedIndex"), i = ln(e, "inputValue");
  return {
    highlightedIndex: r < 0 && t && n ? e.items.indexOf(t) : r,
    isOpen: n,
    selectedItem: t,
    inputValue: i
  };
}
function qt(e, t, n) {
  var r = e.items, i = e.initialHighlightedIndex, o = e.defaultHighlightedIndex, s = t.selectedItem, a = t.highlightedIndex;
  return r.length === 0 ? -1 : i !== void 0 && a === i ? i : o !== void 0 ? o : s ? r.indexOf(s) : n === 0 ? -1 : n < 0 ? r.length - 1 : 0;
}
function nu(e, t, n, r) {
  var i = U({
    isMouseDown: !1,
    isTouchMove: !1
  });
  return te(function() {
    if (n) {
      var o = function() {
        i.current.isMouseDown = !0;
      }, s = function(l) {
        i.current.isMouseDown = !1, e && !Sr(l.target, t.map(function(f) {
          return f.current;
        }), n) && r();
      }, a = function() {
        i.current.isTouchMove = !1;
      }, c = function() {
        i.current.isTouchMove = !0;
      }, u = function(l) {
        e && !i.current.isTouchMove && !Sr(l.target, t.map(function(f) {
          return f.current;
        }), n, !1) && r();
      };
      return n.addEventListener("mousedown", o), n.addEventListener("mouseup", s), n.addEventListener("touchstart", a), n.addEventListener("touchmove", c), n.addEventListener("touchend", u), function() {
        n.removeEventListener("mousedown", o), n.removeEventListener("mouseup", s), n.removeEventListener("touchstart", a), n.removeEventListener("touchmove", c), n.removeEventListener("touchend", u);
      };
    }
  }, [e, n]), i;
}
var Ri = function() {
  return ot;
};
process.env.NODE_ENV !== "production" && (Ri = function() {
  for (var t = U(!0), n = arguments.length, r = new Array(n), i = 0; i < n; i++)
    r[i] = arguments[i];
  var o = U(r.reduce(function(a, c) {
    return a[c] = {}, a;
  }, {}));
  te(function() {
    Object.keys(o.current).forEach(function(a) {
      var c = o.current[a];
      if (t.current && !Object.keys(c).length) {
        console.error("downshift: You forgot to call the " + a + " getter function on your component / element.");
        return;
      }
      var u = c.suppressRefError, d = c.refKey, l = c.elementRef;
      (!l || !l.current) && !u && console.error('downshift: The ref prop "' + d + '" from ' + a + " was not applied correctly on your element.");
    }), t.current = !1;
  });
  var s = Q(function(a, c, u, d) {
    o.current[a] = {
      suppressRefError: c,
      refKey: u,
      elementRef: d
    };
  }, []);
  return s;
});
function Or(e, t, n) {
  var r = n.isInitialMount, i = n.highlightedIndex, o = n.items, s = n.environment, a = et(n, uy);
  te(function() {
    r || !(s != null && s.document) || hy(function() {
      return e(M({
        highlightedIndex: i,
        highlightedItem: o[i],
        resultCount: o.length
      }, a));
    }, s.document);
  }, t);
}
function ru(e) {
  var t = e.highlightedIndex, n = e.isOpen, r = e.itemRefs, i = e.getItemNodeFromIndex, o = e.menuElement, s = e.scrollIntoView, a = U(!0);
  return my(function() {
    t < 0 || !n || !Object.keys(r.current).length || (a.current === !1 ? a.current = !0 : s(i(t), o));
  }, [t]), a;
}
var Pi = ot;
process.env.NODE_ENV !== "production" && (Pi = function(t) {
  var n = t.isInitialMount, r = t.props, i = t.state, o = U(r);
  te(function() {
    n || (Oi(i, o.current, r), o.current = r);
  }, [i, r, n]);
});
function Nr(e, t, n) {
  var r;
  n === void 0 && (n = !0);
  var i = ((r = e.items) == null ? void 0 : r.length) && t >= 0;
  return M({
    isOpen: !1,
    highlightedIndex: -1
  }, i && M({
    selectedItem: e.items[t],
    isOpen: lt(e, "isOpen"),
    highlightedIndex: lt(e, "highlightedIndex")
  }, n && {
    inputValue: e.itemToString(e.items[t])
  }));
}
var ou = {
  environment: K.shape({
    addEventListener: K.func.isRequired,
    removeEventListener: K.func.isRequired,
    document: K.shape({
      createElement: K.func.isRequired,
      getElementById: K.func.isRequired,
      activeElement: K.any.isRequired,
      body: K.any.isRequired
    }).isRequired,
    Node: K.func.isRequired
  }),
  itemToString: K.func,
  stateReducer: K.func
}, iu = M({}, ou, {
  getA11yStatusMessage: K.func,
  highlightedIndex: K.number,
  defaultHighlightedIndex: K.number,
  initialHighlightedIndex: K.number,
  isOpen: K.bool,
  defaultIsOpen: K.bool,
  initialIsOpen: K.bool,
  selectedItem: K.any,
  initialSelectedItem: K.any,
  defaultSelectedItem: K.any,
  id: K.string,
  labelId: K.string,
  menuId: K.string,
  getItemId: K.func,
  toggleButtonId: K.string,
  onSelectedItemChange: K.func,
  onHighlightedIndexChange: K.func,
  onStateChange: K.func,
  onIsOpenChange: K.func,
  scrollIntoView: K.func
});
function au(e, t, n) {
  var r = t.type, i = t.props, o;
  switch (r) {
    case n.ItemMouseMove:
      o = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case n.MenuMouseLeave:
      o = {
        highlightedIndex: -1
      };
      break;
    case n.ToggleButtonClick:
    case n.FunctionToggleMenu:
      o = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : qt(i, e, 0)
      };
      break;
    case n.FunctionOpenMenu:
      o = {
        isOpen: !0,
        highlightedIndex: qt(i, e, 0)
      };
      break;
    case n.FunctionCloseMenu:
      o = {
        isOpen: !1
      };
      break;
    case n.FunctionSetHighlightedIndex:
      o = {
        highlightedIndex: t.highlightedIndex
      };
      break;
    case n.FunctionSetInputValue:
      o = {
        inputValue: t.inputValue
      };
      break;
    case n.FunctionReset:
      o = {
        highlightedIndex: lt(i, "highlightedIndex"),
        isOpen: lt(i, "isOpen"),
        selectedItem: lt(i, "selectedItem"),
        inputValue: lt(i, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return M({}, e, o);
}
function xy(e) {
  for (var t = e.keysSoFar, n = e.highlightedIndex, r = e.items, i = e.itemToString, o = e.isItemDisabled, s = t.toLowerCase(), a = 0; a < r.length; a++) {
    var c = (a + n + (t.length < 2 ? 1 : 0)) % r.length, u = r[c];
    if (u !== void 0 && i(u).toLowerCase().startsWith(s) && !o(u, c))
      return c;
  }
  return n;
}
var wy = Qe(Qe({}, iu), { items: K.array.isRequired, isItemDisabled: K.func, getA11ySelectionMessage: K.func });
function _y(e) {
  var t = e.isOpen, n = e.resultCount, r = e.previousResultCount;
  return t ? n ? n !== r ? "".concat(n, " result").concat(n === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.") : "" : "No results are available." : "";
}
var $y = Qe(Qe({}, Sn), { getA11yStatusMessage: _y, isItemDisabled: function() {
  return !1;
} }), su = ot;
process.env.NODE_ENV !== "production" && (su = function(e, t) {
  K.checkPropTypes(wy, e, "prop", t.name);
});
var lr = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 0, Ai = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_down__" : 1, Mi = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_arrow_up__" : 2, Tr = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_character__" : 3, Di = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_escape__" : 4, ki = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_home__" : 5, Li = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_end__" : 6, ji = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_enter__" : 7, Fi = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_space_button__" : 8, Bi = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_up__" : 9, Hi = process.env.NODE_ENV !== "production" ? "__togglebutton_keydown_page_down__" : 10, Rr = process.env.NODE_ENV !== "production" ? "__togglebutton_blur__" : 11, cu = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 12, lu = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 13, Vi = process.env.NODE_ENV !== "production" ? "__item_click__" : 14, uu = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, du = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, fu = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, pu = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Ui = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, Fo = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, gu = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, hu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ToggleButtonClick: lr,
  ToggleButtonKeyDownArrowDown: Ai,
  ToggleButtonKeyDownArrowUp: Mi,
  ToggleButtonKeyDownCharacter: Tr,
  ToggleButtonKeyDownEscape: Di,
  ToggleButtonKeyDownHome: ki,
  ToggleButtonKeyDownEnd: Li,
  ToggleButtonKeyDownEnter: ji,
  ToggleButtonKeyDownSpaceButton: Fi,
  ToggleButtonKeyDownPageUp: Bi,
  ToggleButtonKeyDownPageDown: Hi,
  ToggleButtonBlur: Rr,
  MenuMouseLeave: cu,
  ItemMouseMove: lu,
  ItemClick: Vi,
  FunctionToggleMenu: uu,
  FunctionOpenMenu: du,
  FunctionCloseMenu: fu,
  FunctionSetHighlightedIndex: pu,
  FunctionSelectItem: Ui,
  FunctionSetInputValue: Fo,
  FunctionReset: gu
});
function Cy(e, t) {
  var n, r = t.type, i = t.props, o = t.altKey, s;
  switch (r) {
    case Vi:
      s = {
        isOpen: lt(i, "isOpen"),
        highlightedIndex: lt(i, "highlightedIndex"),
        selectedItem: i.items[t.index]
      };
      break;
    case Tr:
      {
        var a = t.key, c = "" + e.inputValue + a, u = !e.isOpen && e.selectedItem ? i.items.indexOf(e.selectedItem) : e.highlightedIndex, d = xy({
          keysSoFar: c,
          highlightedIndex: u,
          items: i.items,
          itemToString: i.itemToString,
          isItemDisabled: i.isItemDisabled
        });
        s = {
          inputValue: c,
          highlightedIndex: d,
          isOpen: !0
        };
      }
      break;
    case Ai:
      {
        var l = e.isOpen ? pt(e.highlightedIndex, 1, i.items, i.isItemDisabled) : o && e.selectedItem == null ? -1 : qt(i, e, 1);
        s = {
          highlightedIndex: l,
          isOpen: !0
        };
      }
      break;
    case Mi:
      if (e.isOpen && o)
        s = Nr(i, e.highlightedIndex, !1);
      else {
        var f = e.isOpen ? pt(e.highlightedIndex, -1, i.items, i.isItemDisabled) : qt(i, e, -1);
        s = {
          highlightedIndex: f,
          isOpen: !0
        };
      }
      break;
    case ji:
    case Fi:
      s = Nr(i, e.highlightedIndex, !1);
      break;
    case ki:
      s = {
        highlightedIndex: Vt(0, !1, i.items, i.isItemDisabled),
        isOpen: !0
      };
      break;
    case Li:
      s = {
        highlightedIndex: Vt(i.items.length - 1, !0, i.items, i.isItemDisabled),
        isOpen: !0
      };
      break;
    case Bi:
      s = {
        highlightedIndex: pt(e.highlightedIndex, -10, i.items, i.isItemDisabled)
      };
      break;
    case Hi:
      s = {
        highlightedIndex: pt(e.highlightedIndex, 10, i.items, i.isItemDisabled)
      };
      break;
    case Di:
      s = {
        isOpen: !1,
        highlightedIndex: -1
      };
      break;
    case Rr:
      s = M({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && {
        selectedItem: i.items[e.highlightedIndex]
      });
      break;
    case Ui:
      s = {
        selectedItem: t.selectedItem
      };
      break;
    default:
      return au(e, t, hu);
  }
  return M({}, e, s);
}
var Ey = ["onMouseLeave", "refKey", "ref"], Iy = ["onBlur", "onClick", "onPress", "onKeyDown", "refKey", "ref"], Sy = ["item", "index", "onMouseMove", "onClick", "onMouseDown", "onPress", "refKey", "disabled", "ref"];
un.stateChangeTypes = hu;
function un(e) {
  e === void 0 && (e = {}), su(e, un);
  var t = M({}, $y, e), n = t.items, r = t.scrollIntoView, i = t.environment, o = t.itemToString, s = t.getA11ySelectionMessage, a = t.getA11yStatusMessage, c = tu(t), u = yy(Cy, c, t), d = u[0], l = u[1], f = d.isOpen, p = d.highlightedIndex, m = d.selectedItem, v = d.inputValue, _ = U(null), $ = U(null), h = U({}), b = U(null), w = Zl(t), x = U(), T = U(!0), I = Ti({
    state: d,
    props: t
  }), k = Q(function(R) {
    return h.current[w.getItemId(R)];
  }, [w]);
  Or(a, [f, p, v, n], M({
    isInitialMount: T.current,
    previousResultCount: x.current,
    items: n,
    environment: i,
    itemToString: o
  }, d)), Or(s, [m], M({
    isInitialMount: T.current,
    previousResultCount: x.current,
    items: n,
    environment: i,
    itemToString: o
  }, d));
  var B = ru({
    menuElement: $.current,
    highlightedIndex: p,
    isOpen: f,
    itemRefs: h,
    scrollIntoView: r,
    getItemNodeFromIndex: k
  });
  te(function() {
    return b.current = Gr(function(R) {
      R({
        type: Fo,
        inputValue: ""
      });
    }, 500), function() {
      b.current.cancel();
    };
  }, []), te(function() {
    v && b.current(l);
  }, [l, v]), Pi({
    isInitialMount: T.current,
    props: t,
    state: d
  }), te(function() {
    T.current || (x.current = n.length);
  }), te(function() {
    var R = ln(t, "isOpen");
    R && _.current && _.current.focus();
  }, []);
  var V = nu(f, [$, _], i, function() {
    l({
      type: Rr
    });
  }), z = Ri("getMenuProps", "getToggleButtonProps");
  te(function() {
    return T.current = !1, function() {
      T.current = !0;
    };
  }, []), te(function() {
    f || (h.current = {});
  }, [f]);
  var ne = ze(function() {
    return {
      ArrowDown: function(P) {
        P.preventDefault(), l({
          type: Ai,
          altKey: P.altKey
        });
      },
      ArrowUp: function(P) {
        P.preventDefault(), l({
          type: Mi,
          altKey: P.altKey
        });
      },
      Home: function(P) {
        P.preventDefault(), l({
          type: ki
        });
      },
      End: function(P) {
        P.preventDefault(), l({
          type: Li
        });
      },
      Escape: function() {
        I.current.state.isOpen && l({
          type: Di
        });
      },
      Enter: function(P) {
        P.preventDefault(), l({
          type: I.current.state.isOpen ? ji : lr
        });
      },
      PageUp: function(P) {
        I.current.state.isOpen && (P.preventDefault(), l({
          type: Bi
        }));
      },
      PageDown: function(P) {
        I.current.state.isOpen && (P.preventDefault(), l({
          type: Hi
        }));
      },
      " ": function(P) {
        P.preventDefault();
        var O = I.current.state;
        if (!O.isOpen) {
          l({
            type: lr
          });
          return;
        }
        O.inputValue ? l({
          type: Tr,
          key: " "
        }) : l({
          type: Fi
        });
      }
    };
  }, [l, I]), oe = Q(function() {
    l({
      type: uu
    });
  }, [l]), D = Q(function() {
    l({
      type: fu
    });
  }, [l]), j = Q(function() {
    l({
      type: du
    });
  }, [l]), J = Q(function(R) {
    l({
      type: pu,
      highlightedIndex: R
    });
  }, [l]), S = Q(function(R) {
    l({
      type: Ui,
      selectedItem: R
    });
  }, [l]), Y = Q(function() {
    l({
      type: gu
    });
  }, [l]), X = Q(function(R) {
    l({
      type: Fo,
      inputValue: R
    });
  }, [l]), A = Q(function(R) {
    return M({
      id: w.labelId,
      htmlFor: w.toggleButtonId
    }, R);
  }, [w]), F = Q(function(R, P) {
    var O, L = R === void 0 ? {} : R, W = L.onMouseLeave, Z = L.refKey, re = Z === void 0 ? "ref" : Z, fe = L.ref, H = et(L, Ey), ve = P === void 0 ? {} : P, ee = ve.suppressRefError, be = ee === void 0 ? !1 : ee, Te = function() {
      l({
        type: cu
      });
    };
    return z("getMenuProps", be, re, $), M((O = {}, O[re] = Et(fe, function(Ne) {
      $.current = Ne;
    }), O.id = w.menuId, O.role = "listbox", O["aria-labelledby"] = H && H["aria-label"] ? void 0 : "" + w.labelId, O.onMouseLeave = De(W, Te), O), H);
  }, [l, z, w]), ie = Q(function(R, P) {
    var O, L = R === void 0 ? {} : R, W = L.onBlur, Z = L.onClick;
    L.onPress;
    var re = L.onKeyDown, fe = L.refKey, H = fe === void 0 ? "ref" : fe, ve = L.ref, ee = et(L, Iy), be = P === void 0 ? {} : P, Te = be.suppressRefError, Ne = Te === void 0 ? !1 : Te, Le = I.current.state, je = function() {
      l({
        type: lr
      });
    }, Ue = function() {
      Le.isOpen && !V.current.isMouseDown && l({
        type: Rr
      });
    }, Pe = function(we) {
      var ye = Ir(we);
      ye && ne[ye] ? ne[ye](we) : by(ye) && l({
        type: Tr,
        key: ye
      });
    }, de = M((O = {}, O[H] = Et(ve, function(Ke) {
      _.current = Ke;
    }), O["aria-activedescendant"] = Le.isOpen && Le.highlightedIndex > -1 ? w.getItemId(Le.highlightedIndex) : "", O["aria-controls"] = w.menuId, O["aria-expanded"] = I.current.state.isOpen, O["aria-haspopup"] = "listbox", O["aria-labelledby"] = ee && ee["aria-label"] ? void 0 : "" + w.labelId, O.id = w.toggleButtonId, O.role = "combobox", O.tabIndex = 0, O.onBlur = De(W, Ue), O), ee);
    return ee.disabled || (de.onClick = De(Z, je), de.onKeyDown = De(re, Pe)), z("getToggleButtonProps", Ne, H, _), de;
  }, [I, w, z, l, V, ne]), N = Q(function(R) {
    var P, O = R === void 0 ? {} : R, L = O.item, W = O.index, Z = O.onMouseMove, re = O.onClick, fe = O.onMouseDown;
    O.onPress;
    var H = O.refKey, ve = H === void 0 ? "ref" : H, ee = O.disabled, be = O.ref, Te = et(O, Sy);
    ee !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useSelect.');
    var Ne = I.current, Le = Ne.state, je = Ne.props, Ue = Ql(L, W, je.items, "Pass either item or index to getItemProps!"), Pe = Ue[0], de = Ue[1], Ke = je.isItemDisabled(Pe, de), we = function() {
      de !== Le.highlightedIndex && (B.current = !1, l({
        type: lu,
        index: de,
        disabled: Ke
      }));
    }, ye = function() {
      l({
        type: Vi,
        index: de
      });
    }, st = function(Xe) {
      return Xe.preventDefault();
    }, We = M((P = {}, P[ve] = Et(be, function(Be) {
      Be && (h.current[w.getItemId(de)] = Be);
    }), P["aria-disabled"] = Ke, P["aria-selected"] = "" + (Pe === Le.selectedItem), P.id = w.getItemId(de), P.role = "option", P), Te);
    return Ke || (We.onClick = De(re, ye)), We.onMouseMove = De(Z, we), We.onMouseDown = De(fe, st), We;
  }, [I, w, B, l]);
  return {
    // prop getters.
    getToggleButtonProps: ie,
    getLabelProps: A,
    getMenuProps: F,
    getItemProps: N,
    // actions.
    toggleMenu: oe,
    openMenu: j,
    closeMenu: D,
    setHighlightedIndex: J,
    selectItem: S,
    reset: Y,
    setInputValue: X,
    // state.
    highlightedIndex: p,
    isOpen: f,
    selectedItem: m,
    inputValue: v
  };
}
var Ki = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Wi = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, zi = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Gi = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, Yi = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, qi = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Xi = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Ji = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Zi = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Pr = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Qi = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, mu = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, vu = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, ea = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, bu = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, yu = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, xu = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, wu = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, _u = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, ta = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, $u = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, Cu = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, na = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, Eu = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  InputKeyDownArrowDown: Ki,
  InputKeyDownArrowUp: Wi,
  InputKeyDownEscape: zi,
  InputKeyDownHome: Gi,
  InputKeyDownEnd: Yi,
  InputKeyDownPageUp: qi,
  InputKeyDownPageDown: Xi,
  InputKeyDownEnter: Ji,
  InputChange: Zi,
  InputBlur: Pr,
  InputClick: Qi,
  MenuMouseLeave: mu,
  ItemMouseMove: vu,
  ItemClick: ea,
  ToggleButtonClick: bu,
  FunctionToggleMenu: yu,
  FunctionOpenMenu: xu,
  FunctionCloseMenu: wu,
  FunctionSetHighlightedIndex: _u,
  FunctionSelectItem: ta,
  FunctionSetInputValue: $u,
  FunctionReset: Cu,
  ControlledPropUpdatedSelectedItem: na
});
function Oy(e) {
  var t = tu(e), n = t.selectedItem, r = t.inputValue;
  return r === "" && n && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (r = e.itemToString(n)), M({}, t, {
    inputValue: r
  });
}
var Ny = M({}, iu, {
  items: K.array.isRequired,
  isItemDisabled: K.func,
  selectedItemChanged: K.func,
  getA11ySelectionMessage: K.func,
  inputValue: K.string,
  defaultInputValue: K.string,
  initialInputValue: K.string,
  inputId: K.string,
  onInputValueChange: K.func
});
function Ty(e, t, n) {
  var r = U(), i = eu(e, t, n), o = i[0], s = i[1];
  return te(function() {
    Er(n, "selectedItem") && (n.selectedItemChanged(r.current, n.selectedItem) && s({
      type: na,
      inputValue: n.itemToString(n.selectedItem)
    }), r.current = o.selectedItem === r.current ? n.selectedItem : o.selectedItem);
  }, [o.selectedItem, n.selectedItem]), [An(o, n), s];
}
var Iu = ot;
process.env.NODE_ENV !== "production" && (Iu = function(t, n) {
  K.checkPropTypes(Ny, t, "prop", n.name);
});
var Ry = M({}, Sn, {
  selectedItemChanged: function(t, n) {
    return t !== n;
  },
  getA11yStatusMessage: Pl,
  isItemDisabled: function() {
    return !1;
  }
});
function Py(e, t) {
  var n, r = t.type, i = t.props, o = t.altKey, s;
  switch (r) {
    case ea:
      s = {
        isOpen: lt(i, "isOpen"),
        highlightedIndex: lt(i, "highlightedIndex"),
        selectedItem: i.items[t.index],
        inputValue: i.itemToString(i.items[t.index])
      };
      break;
    case Ki:
      e.isOpen ? s = {
        highlightedIndex: pt(e.highlightedIndex, 1, i.items, i.isItemDisabled, !0)
      } : s = {
        highlightedIndex: o && e.selectedItem == null ? -1 : qt(i, e, 1),
        isOpen: i.items.length >= 0
      };
      break;
    case Wi:
      e.isOpen ? o ? s = Nr(i, e.highlightedIndex) : s = {
        highlightedIndex: pt(e.highlightedIndex, -1, i.items, i.isItemDisabled, !0)
      } : s = {
        highlightedIndex: qt(i, e, -1),
        isOpen: i.items.length >= 0
      };
      break;
    case Ji:
      s = Nr(i, e.highlightedIndex);
      break;
    case zi:
      s = M({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case qi:
      s = {
        highlightedIndex: pt(e.highlightedIndex, -10, i.items, i.isItemDisabled, !0)
      };
      break;
    case Xi:
      s = {
        highlightedIndex: pt(e.highlightedIndex, 10, i.items, i.isItemDisabled, !0)
      };
      break;
    case Gi:
      s = {
        highlightedIndex: Vt(0, !1, i.items, i.isItemDisabled)
      };
      break;
    case Yi:
      s = {
        highlightedIndex: Vt(i.items.length - 1, !0, i.items, i.isItemDisabled)
      };
      break;
    case Pr:
      s = M({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((n = i.items) == null ? void 0 : n.length) && t.selectItem && {
        selectedItem: i.items[e.highlightedIndex],
        inputValue: i.itemToString(i.items[e.highlightedIndex])
      });
      break;
    case Zi:
      s = {
        isOpen: !0,
        highlightedIndex: lt(i, "highlightedIndex"),
        inputValue: t.inputValue
      };
      break;
    case Qi:
      s = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : qt(i, e, 0)
      };
      break;
    case ta:
      s = {
        selectedItem: t.selectedItem,
        inputValue: i.itemToString(t.selectedItem)
      };
      break;
    case na:
      s = {
        inputValue: t.inputValue
      };
      break;
    default:
      return au(e, t, Eu);
  }
  return M({}, e, s);
}
var Ay = ["onMouseLeave", "refKey", "ref"], My = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], Dy = ["onClick", "onPress", "refKey", "ref"], ky = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
It.stateChangeTypes = Eu;
function It(e) {
  e === void 0 && (e = {}), Iu(e, It);
  var t = M({}, Ry, e), n = t.items, r = t.scrollIntoView, i = t.environment, o = t.getA11yStatusMessage, s = t.getA11ySelectionMessage, a = t.itemToString, c = Oy(t), u = Ty(Py, c, t), d = u[0], l = u[1], f = d.isOpen, p = d.highlightedIndex, m = d.selectedItem, v = d.inputValue, _ = U(null), $ = U({}), h = U(null), b = U(null), w = U(!0), x = Zl(t), T = U(), I = Ti({
    state: d,
    props: t
  }), k = Q(function(P) {
    return $.current[x.getItemId(P)];
  }, [x]);
  Or(o, [f, p, v, n], M({
    isInitialMount: w.current,
    previousResultCount: T.current,
    items: n,
    environment: i,
    itemToString: a
  }, d)), Or(s, [m], M({
    isInitialMount: w.current,
    previousResultCount: T.current,
    items: n,
    environment: i,
    itemToString: a
  }, d));
  var B = ru({
    menuElement: _.current,
    highlightedIndex: p,
    isOpen: f,
    itemRefs: $,
    scrollIntoView: r,
    getItemNodeFromIndex: k
  });
  Pi({
    isInitialMount: w.current,
    props: t,
    state: d
  }), te(function() {
    var P = ln(t, "isOpen");
    P && h.current && h.current.focus();
  }, []), te(function() {
    w.current || (T.current = n.length);
  });
  var V = nu(f, [h, _, b], i, function() {
    l({
      type: Pr,
      selectItem: !1
    });
  }), z = Ri("getInputProps", "getMenuProps");
  te(function() {
    return w.current = !1, function() {
      w.current = !0;
    };
  }, []), te(function() {
    f || ($.current = {});
  }, [f]), te(function() {
    var P;
    !f || !(i != null && i.document) || !(h != null && (P = h.current) != null && P.focus) || i.document.activeElement !== h.current && h.current.focus();
  }, [f, i]);
  var ne = ze(function() {
    return {
      ArrowDown: function(O) {
        O.preventDefault(), l({
          type: Ki,
          altKey: O.altKey
        });
      },
      ArrowUp: function(O) {
        O.preventDefault(), l({
          type: Wi,
          altKey: O.altKey
        });
      },
      Home: function(O) {
        I.current.state.isOpen && (O.preventDefault(), l({
          type: Gi
        }));
      },
      End: function(O) {
        I.current.state.isOpen && (O.preventDefault(), l({
          type: Yi
        }));
      },
      Escape: function(O) {
        var L = I.current.state;
        (L.isOpen || L.inputValue || L.selectedItem || L.highlightedIndex > -1) && (O.preventDefault(), l({
          type: zi
        }));
      },
      Enter: function(O) {
        var L = I.current.state;
        !L.isOpen || O.which === 229 || (O.preventDefault(), l({
          type: Ji
        }));
      },
      PageUp: function(O) {
        I.current.state.isOpen && (O.preventDefault(), l({
          type: qi
        }));
      },
      PageDown: function(O) {
        I.current.state.isOpen && (O.preventDefault(), l({
          type: Xi
        }));
      }
    };
  }, [l, I]), oe = Q(function(P) {
    return M({
      id: x.labelId,
      htmlFor: x.inputId
    }, P);
  }, [x]), D = Q(function(P, O) {
    var L, W = P === void 0 ? {} : P, Z = W.onMouseLeave, re = W.refKey, fe = re === void 0 ? "ref" : re, H = W.ref, ve = et(W, Ay), ee = O === void 0 ? {} : O, be = ee.suppressRefError, Te = be === void 0 ? !1 : be;
    return z("getMenuProps", Te, fe, _), M((L = {}, L[fe] = Et(H, function(Ne) {
      _.current = Ne;
    }), L.id = x.menuId, L.role = "listbox", L["aria-labelledby"] = ve && ve["aria-label"] ? void 0 : "" + x.labelId, L.onMouseLeave = De(Z, function() {
      l({
        type: mu
      });
    }), L), ve);
  }, [l, z, x]), j = Q(function(P) {
    var O, L, W = P === void 0 ? {} : P, Z = W.item, re = W.index, fe = W.refKey, H = fe === void 0 ? "ref" : fe, ve = W.ref, ee = W.onMouseMove, be = W.onMouseDown, Te = W.onClick;
    W.onPress;
    var Ne = W.disabled, Le = et(W, My);
    Ne !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var je = I.current, Ue = je.props, Pe = je.state, de = Ql(Z, re, Ue.items, "Pass either item or index to getItemProps!"), Ke = de[0], we = de[1], ye = Ue.isItemDisabled(Ke, we), st = "onClick", We = Te, Be = function() {
      we !== Pe.highlightedIndex && (B.current = !1, l({
        type: vu,
        index: we,
        disabled: ye
      }));
    }, Xe = function() {
      l({
        type: ea,
        index: we
      });
    }, se = function(me) {
      return me.preventDefault();
    };
    return M((O = {}, O[H] = Et(ve, function(ce) {
      ce && ($.current[x.getItemId(we)] = ce);
    }), O["aria-disabled"] = ye, O["aria-selected"] = "" + (we === Pe.highlightedIndex), O.id = x.getItemId(we), O.role = "option", O), !ye && (L = {}, L[st] = De(We, Xe), L), {
      onMouseMove: De(ee, Be),
      onMouseDown: De(be, se)
    }, Le);
  }, [l, I, B, x]), J = Q(function(P) {
    var O, L = P === void 0 ? {} : P, W = L.onClick;
    L.onPress;
    var Z = L.refKey, re = Z === void 0 ? "ref" : Z, fe = L.ref, H = et(L, Dy), ve = I.current.state, ee = function() {
      l({
        type: bu
      });
    };
    return M((O = {}, O[re] = Et(fe, function(be) {
      b.current = be;
    }), O["aria-controls"] = x.menuId, O["aria-expanded"] = ve.isOpen, O.id = x.toggleButtonId, O.tabIndex = -1, O), !H.disabled && M({}, {
      onClick: De(W, ee)
    }), H);
  }, [l, I, x]), S = Q(function(P, O) {
    var L, W = P === void 0 ? {} : P, Z = W.onKeyDown, re = W.onChange, fe = W.onInput, H = W.onBlur;
    W.onChangeText;
    var ve = W.onClick, ee = W.refKey, be = ee === void 0 ? "ref" : ee, Te = W.ref, Ne = et(W, ky), Le = O === void 0 ? {} : O, je = Le.suppressRefError, Ue = je === void 0 ? !1 : je;
    z("getInputProps", Ue, be, h);
    var Pe = I.current.state, de = function(se) {
      var ce = Ir(se);
      ce && ne[ce] && ne[ce](se);
    }, Ke = function(se) {
      l({
        type: Zi,
        inputValue: se.target.value
      });
    }, we = function(se) {
      if (i != null && i.document && Pe.isOpen && !V.current.isMouseDown) {
        var ce = se.relatedTarget === null && i.document.activeElement !== i.document.body;
        l({
          type: Pr,
          selectItem: !ce
        });
      }
    }, ye = function() {
      l({
        type: Qi
      });
    }, st = "onChange", We = {};
    if (!Ne.disabled) {
      var Be;
      We = (Be = {}, Be[st] = De(re, fe, Ke), Be.onKeyDown = De(Z, de), Be.onBlur = De(H, we), Be.onClick = De(ve, ye), Be);
    }
    return M((L = {}, L[be] = Et(Te, function(Xe) {
      h.current = Xe;
    }), L["aria-activedescendant"] = Pe.isOpen && Pe.highlightedIndex > -1 ? x.getItemId(Pe.highlightedIndex) : "", L["aria-autocomplete"] = "list", L["aria-controls"] = x.menuId, L["aria-expanded"] = Pe.isOpen, L["aria-labelledby"] = Ne && Ne["aria-label"] ? void 0 : x.labelId, L.autoComplete = "off", L.id = x.inputId, L.role = "combobox", L.value = Pe.inputValue, L), We, Ne);
  }, [z, I, x, ne, l, V, i]), Y = Q(function() {
    l({
      type: yu
    });
  }, [l]), X = Q(function() {
    l({
      type: wu
    });
  }, [l]), A = Q(function() {
    l({
      type: xu
    });
  }, [l]), F = Q(function(P) {
    l({
      type: _u,
      highlightedIndex: P
    });
  }, [l]), ie = Q(function(P) {
    l({
      type: ta,
      selectedItem: P
    });
  }, [l]), N = Q(function(P) {
    l({
      type: $u,
      inputValue: P
    });
  }, [l]), R = Q(function() {
    l({
      type: Cu
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: j,
    getLabelProps: oe,
    getMenuProps: D,
    getInputProps: S,
    getToggleButtonProps: J,
    // actions.
    toggleMenu: Y,
    openMenu: A,
    closeMenu: X,
    setHighlightedIndex: F,
    setInputValue: N,
    selectItem: ie,
    reset: R,
    // state.
    highlightedIndex: p,
    isOpen: f,
    selectedItem: m,
    inputValue: v
  };
}
function Ly(e) {
  var t = e.removedSelectedItem, n = e.itemToString;
  return n(t) + " has been removed.";
}
M({}, ou, {
  selectedItems: K.array,
  initialSelectedItems: K.array,
  defaultSelectedItems: K.array,
  getA11yRemovalMessage: K.func,
  activeIndex: K.number,
  initialActiveIndex: K.number,
  defaultActiveIndex: K.number,
  onActiveIndexChange: K.func,
  onSelectedItemsChange: K.func,
  keyNavigationNext: K.string,
  keyNavigationPrevious: K.string
});
Sn.itemToString, Sn.stateReducer, Sn.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const jy = g("ui-group"), Fy = g(
  "-ui-ml-1 ui-transition",
  "group-hover:ui-text-primary-500 group-data-[disabled=true]:ui-text-grayscale-300"
), ws = g(
  "-ui-mr-1 ui-flex ui-h-5 ui-w-5 ui-items-center ui-justify-center ui-rounded ui-bg-grayscale-100",
  "ui-text-paragraph-200-regular ui-text-grayscale-500",
  "group-data-[disabled=true]:ui-bg-grayscale-200 group-data-[disabled=true]:ui-text-grayscale-300"
), By = g(
  "ui-z-20 ui-flex ui-max-h-[360px] ui-overflow-hidden",
  "ui-rounded-lg ui-border ui-border-grayscale-200 ui-bg-white ui-shadow-gray-lg"
), Hy = g(
  "ui-bg-grayscale-100 ui-p-3 ui-text-label-100 ui-text-grayscale-500"
), Vy = g(
  "ui-flex ui-cursor-pointer ui-flex-col ui-border-b ui-border-grayscale-200 ui-p-3 last:ui-border-b-0",
  "ui-w-full ui-text-left ui-outline-none data-[active-item=true]:ui-bg-grayscale-50"
), Uy = g(
  "ui-line-clamp-2 ui-text-paragraph-200-medium ui-text-grayscale-950"
), Ky = g(
  "ui-mt-1 ui-line-clamp-3 ui-text-paragraph-200-regular ui-text-grayscale-700"
), sE = ({
  className: e,
  label: t,
  errorMessage: n,
  description: r,
  results: i,
  value: o,
  onValueChange: s,
  onResultSelect: a,
  ...c
}) => {
  const u = ze(
    () => i.flatMap((p) => p.items).map((p) => p.value),
    [i]
  ), d = It({
    items: u,
    selectedItem: null,
    inputValue: o,
    defaultHighlightedIndex: 0,
    onInputValueChange: ({ inputValue: p }) => s(p || ""),
    onSelectedItemChange: ({ selectedItem: p }) => a(p || ""),
    stateReducer: (p, { changes: m, type: v }) => {
      switch (v) {
        case It.stateChangeTypes.ItemClick:
        case It.stateChangeTypes.InputKeyDownEnter:
        case It.stateChangeTypes.InputBlur:
          return { ...m, inputValue: "" };
        default:
          return m;
      }
    }
  }), l = Q(() => {
    d.openMenu();
  }, [d]);
  Ub(["/"], l, { overrideSystem: !0 });
  let f = 0;
  return /* @__PURE__ */ y.jsx(Il, { open: d.isOpen, children: /* @__PURE__ */ y.jsxs("div", { className: e, children: [
    /* @__PURE__ */ y.jsx(Hr, { ...d.getLabelProps(), label: t }),
    /* @__PURE__ */ y.jsx(Sl, { asChild: !0, children: /* @__PURE__ */ y.jsx("div", { children: /* @__PURE__ */ y.jsx(
      vc,
      {
        type: "search",
        ...c,
        ...d.getInputProps(),
        className: jy,
        leadingSlot: /* @__PURE__ */ y.jsx(Nd, { className: Fy }),
        trailingSlot: d.inputValue ? /* @__PURE__ */ y.jsx(
          "button",
          {
            className: ws,
            onClick: d.reset,
            children: /* @__PURE__ */ y.jsx(_d, {})
          }
        ) : /* @__PURE__ */ y.jsx(
          "button",
          {
            className: ws,
            ...d.getToggleButtonProps(),
            children: "/"
          }
        )
      }
    ) }) }),
    /* @__PURE__ */ y.jsx(kr, { errorMessage: n, description: r }),
    u.length > 0 ? /* @__PURE__ */ y.jsx(Ol, { children: /* @__PURE__ */ y.jsx(
      Nl,
      {
        onOpenAutoFocus: Wy,
        sideOffset: 8,
        align: "start",
        style: { width: "var(--radix-popper-anchor-width)" },
        collisionPadding: 8,
        className: By,
        ...d.getMenuProps({}, { suppressRefError: !0 }),
        children: /* @__PURE__ */ y.jsx(Bn, { children: i.map(
          (p) => p.items.length > 0 ? /* @__PURE__ */ y.jsxs("div", { children: [
            /* @__PURE__ */ y.jsx("div", { className: Hy, children: p.title }),
            p.items.map((m) => /* @__PURE__ */ y.jsxs(
              "button",
              {
                value: m.value,
                className: Vy,
                ...d.getItemProps({
                  item: m.value,
                  "data-active-item": d.highlightedIndex === f,
                  index: f++
                }),
                children: [
                  /* @__PURE__ */ y.jsx("div", { className: Uy, children: m.label }),
                  m.description ? /* @__PURE__ */ y.jsx("div", { className: Ky, children: m.description }) : null
                ]
              },
              m.value
            ))
          ] }, p.title) : null
        ) })
      }
    ) }) : null
  ] }) });
}, Wy = (e) => e.preventDefault(), _s = (e) => e == null ? [] : Array.isArray(e) ? e : [e], Ar = (e, t, n) => {
  if (!e)
    return t[0];
  const r = t.reduce((i, o) => {
    const s = n.find((u) => u.value === o), a = hn(s == null ? void 0 : s.items).filter(
      (u) => !Bo(u)
    );
    if (a.length === 0)
      return i;
    i.delete(o);
    const c = a.every(
      (u) => t.includes(u.value)
    );
    for (const u of a)
      c ? i.delete(u.value) : i.add(u.value);
    return i;
  }, /* @__PURE__ */ new Set([...t]));
  return Array.from(r);
}, hn = (e) => !e || e.length === 0 ? [] : e.flatMap((t) => [t, ...hn(t.items)]), Bo = (e) => {
  var t;
  return (((t = e.items) == null ? void 0 : t.length) || 0) > 0;
}, zy = g(
  "ui-group ui-h-10 ui-w-full ui-cursor-default ui-bg-white ui-px-3.5",
  "ui-rounded-lg ui-border ui-border-grayscale-200 ui-outline-none ui-transition",
  "ui-whitespace-nowrap ui-text-grayscale-950",
  "data-[placeholder=true]:ui-text-grayscale-700",
  "focus-visible:ui-border-primary-600 focus-visible:ui-shadow-focus",
  "disabled:ui-border-grayscale-300 disabled:ui-bg-grayscale-100",
  "aria-expanded:ui-border-primary-600"
), Gy = g(
  "ui-flex ui-h-full ui-items-center ui-justify-between ui-gap-2"
), Yy = g("ui-opacity-50"), qy = {
  md: "ui-text-paragraph-300-regular",
  sm: "ui-text-paragraph-200-regular"
}, Xy = g(
  "ui-ml-auto ui-text-grayscale-500 ui-transition",
  "group-aria-expanded:ui-rotate-180"
), Jy = g("ui-truncate"), Zy = g("ui-min-w-0 ui-flex-1 ui-outline-none"), Qy = q(
  ({
    multiselect: e,
    disabled: t,
    size: n = "md",
    downshift: r,
    selectedValues: i,
    renderSelectedValue: o,
    searchable: s,
    items: a,
    filteredFlatItems: c,
    placeholder: u = "Select",
    ...d
  }, l) => {
    const f = i[0] != null && a.find((m) => m.value === i[0]), p = s && r.isOpen;
    return /* @__PURE__ */ y.jsx(
      "button",
      {
        ...d,
        type: "button",
        disabled: t,
        className: g(zy, qy[n]),
        "data-placeholder": !f && !o,
        ...r.getToggleButtonProps({ ref: l }),
        children: /* @__PURE__ */ y.jsxs(
          "div",
          {
            className: g(
              Gy,
              t && Yy
            ),
            children: [
              "getInputProps" in r ? /* @__PURE__ */ y.jsx(
                "input",
                {
                  className: Zy,
                  hidden: !p,
                  placeholder: u,
                  ...r.getInputProps()
                }
              ) : null,
              /* @__PURE__ */ y.jsx("span", { className: "ui-flex ui-min-w-0", children: p ? null : o ? o(
                Ar(
                  e,
                  i,
                  c
                )
              ) : f ? /* @__PURE__ */ y.jsx("span", { className: Jy, children: f.displayLabel || f.label }) : u }),
              /* @__PURE__ */ y.jsx(zs, { className: Xy })
            ]
          }
        )
      }
    );
  }
), ex = g(
  "ui-group ui-flex ui-cursor-default ui-select-none ui-items-center ui-gap-2 ui-px-3.5 ui-py-2.5 ui-outline-none ui-transition",
  "ui-w-full ui-text-left ui-text-grayscale-950",
  "data-[active-item=true]:ui-bg-primary-50"
), tx = {
  md: g("ui-text-paragraph-300-regular"),
  sm: g("ui-text-paragraph-200-regular")
}, nx = g("ui-ml-auto ui-text-primary-600"), Su = ({
  item: e,
  depth: t = 0,
  ...n
}) => {
  var f;
  const {
    downshift: r,
    size: i = "md",
    selectedValues: o,
    multiselect: s,
    filteredFlatItems: a
  } = n, c = ze(
    () => a.findIndex(
      (p) => p.value === e.value
    ),
    [a, e.value]
  ), u = ze(
    () => hn(e.items).filter((p) => !Bo(p)),
    [e.items]
  ), d = ze(
    () => u.filter(
      (p) => o.includes(p.value)
    ),
    [u, o]
  ), l = Bo(e) ? d.length > 0 && d.length < u.length ? "indeterminate" : d.length !== 0 : o.includes(e.value);
  return /* @__PURE__ */ y.jsxs(y.Fragment, { children: [
    /* @__PURE__ */ y.jsxs(
      "button",
      {
        type: "button",
        className: g(ex, tx[i]),
        style: { paddingLeft: 14 * (t + 1) },
        ...r.getItemProps({
          item: e.value,
          index: c,
          "aria-selected": l === !0,
          "data-active-item": r.highlightedIndex === c
        }),
        children: [
          s ? /* @__PURE__ */ y.jsx(Lf, { as: "div", size: "sm", checked: l }) : null,
          /* @__PURE__ */ y.jsx("div", { children: e.displayLabel || e.label }),
          !s && o.includes(e.value) ? /* @__PURE__ */ y.jsx(Ws, { className: nx }) : null
        ]
      }
    ),
    (f = e.items) == null ? void 0 : f.map((p) => /* @__PURE__ */ y.jsx(
      Su,
      {
        item: p,
        depth: t + 1,
        ...n
      },
      p.value
    ))
  ] });
}, rx = g(
  "ui-z-30 ui-flex ui-max-h-[320px] ui-overflow-hidden",
  "ui-rounded-lg ui-border ui-border-grayscale-300 ui-bg-white ui-shadow-gray-lg ui-outline-none"
), ox = q(
  ({
    downshift: e,
    items: t,
    popoverMinWidth: n,
    filteredFlatItems: r,
    ...i
  }, o) => {
    const s = U(null);
    return te(() => {
      var u;
      if (!e.isOpen)
        return;
      const a = (u = s.current) == null ? void 0 : u.children, c = a == null ? void 0 : a[e.highlightedIndex];
      c == null || c.scrollIntoView({ block: "nearest" });
    }, [e.isOpen]), /* @__PURE__ */ y.jsx(
      "div",
      {
        ...e.getMenuProps({ ref: o }),
        className: rx,
        style: {
          minWidth: n,
          display: t.length === 0 ? "none" : void 0
        },
        children: /* @__PURE__ */ y.jsx(Bn, { children: /* @__PURE__ */ y.jsx("div", { ref: s, children: t.map((a) => /* @__PURE__ */ y.jsx(
          Su,
          {
            item: a,
            downshift: e,
            filteredFlatItems: r,
            ...i
          },
          a.value
        )) }) })
      }
    );
  }
), ix = ({
  multiselect: e,
  flatItems: t,
  filteredFlatItems: n,
  onSearch: r,
  onSelect: i,
  onHighlight: o,
  onOpenChange: s,
  selectedValues: a,
  inputValue: c
}) => {
  const u = ze(
    () => n.map(($) => $.value),
    [n]
  ), d = Q(
    ({ selectedItem: $ }) => {
      if ($ == null)
        return;
      if (!e) {
        i(
          Ar(e, [$], t)
        ), s == null || s(!1);
        return;
      }
      const h = a.findIndex(
        (w) => $ === w
      ), b = h === -1 ? [...a, $] : [
        ...a.slice(0, h),
        ...a.slice(h + 1)
      ];
      return i(
        Ar(e, b, t)
      );
    },
    [e, i, a, t, s]
  ), l = Q(
    ({ highlightedIndex: $, isOpen: h }) => {
      if (!o)
        return;
      const b = h ? u[$ ?? -1] : void 0;
      o(b);
    },
    [o, u]
  ), f = Q(
    ({ inputValue: $, isOpen: h }) => {
      r == null || r(h && $ || "");
    },
    [r]
  ), p = Q(
    ($) => {
      l($), $.selectedItem || s == null || s($.isOpen || !1), !$.isOpen && (r == null || r(""));
    },
    [r, l, s]
  ), m = Q(
    ($, {
      changes: h,
      type: b
    }) => {
      if (e)
        switch (b) {
          case (r ? It.stateChangeTypes.ItemClick : un.stateChangeTypes.ItemClick):
          case (r ? It.stateChangeTypes.InputKeyDownEnter : un.stateChangeTypes.ToggleButtonKeyDownEnter):
            return {
              ...h,
              isOpen: !0,
              inputValue: "",
              highlightedIndex: $.highlightedIndex
            };
          case (r ? void 0 : un.stateChangeTypes.ToggleButtonBlur):
            return { ...h, selectedItem: void 0 };
          default:
            return h;
        }
      if (h.isOpen && !$.isOpen && a.length > 0) {
        const w = u.findIndex(
          (x) => a.includes(x)
        );
        if (w !== -1)
          return { ...h, highlightedIndex: w };
      }
      return h;
    },
    [e, r, a, u]
  );
  return (r ? It : un)({
    items: u,
    selectedItem: null,
    defaultHighlightedIndex: 0,
    inputValue: c,
    stateReducer: m,
    onSelectedItemChange: d,
    onHighlightedIndexChange: l,
    onIsOpenChange: p,
    onInputValueChange: f
  });
}, cE = q(
  ({
    multiselect: e,
    label: t,
    description: n,
    errorMessage: r,
    items: i,
    className: o,
    defaultValue: s,
    value: a,
    onSelect: c,
    onHighlight: u,
    onOpenChange: d,
    onSearch: l,
    popoverMinWidth: f,
    size: p,
    disabled: m,
    renderSelectedValue: v,
    placeholder: _,
    tooltip: $,
    ...h
  }, b) => {
    const [w, x] = ue(""), T = ze(() => {
      const D = w.toLowerCase().trim();
      return D ? hn(i).filter(
        (j) => j.label.toLowerCase().includes(D)
      ) : i;
    }, [i, w]), [I, k] = ue(
      s ? _s(s) : []
    ), B = ze(() => hn(i), [i]), V = ze(
      () => hn(T),
      [T]
    ), z = Q(
      (D) => {
        if (c)
          return c(D);
        if (Array.isArray(D))
          return k(D);
        k(Ar(!1, [D], B));
      },
      [c, B]
    ), ne = Q(
      (D) => {
        x(D), l == null || l(D);
      },
      [l]
    ), oe = ix({
      multiselect: e,
      flatItems: B,
      filteredFlatItems: V,
      onSearch: h.searchable ? ne : void 0,
      onSelect: z,
      onHighlight: u,
      onOpenChange: d,
      selectedValues: I,
      inputValue: w
    });
    return te(() => {
      k(_s(a));
    }, [a]), /* @__PURE__ */ y.jsx(Il, { open: oe.isOpen, children: /* @__PURE__ */ y.jsxs("div", { className: o, children: [
      /* @__PURE__ */ y.jsx(
        Hr,
        {
          ...oe.getLabelProps(),
          label: t,
          tooltip: $
        }
      ),
      /* @__PURE__ */ y.jsx(Sl, { asChild: !0, children: /* @__PURE__ */ y.jsx(
        Qy,
        {
          ref: b,
          downshift: oe,
          multiselect: e,
          disabled: m,
          size: p,
          selectedValues: I,
          filteredFlatItems: V,
          renderSelectedValue: v,
          items: i,
          placeholder: _,
          ...h
        }
      ) }),
      /* @__PURE__ */ y.jsx(kr, { errorMessage: r, description: n }),
      /* @__PURE__ */ y.jsx(Ol, { children: /* @__PURE__ */ y.jsx(
        Nl,
        {
          asChild: !0,
          onOpenAutoFocus: ax,
          sideOffset: 8,
          collisionPadding: 8,
          align: "start",
          ref: oe.getMenuProps({}, { suppressRefError: !0 }).ref,
          children: /* @__PURE__ */ y.jsx(
            ox,
            {
              downshift: oe,
              items: T,
              selectedValues: I,
              filteredFlatItems: V,
              size: p,
              multiselect: e,
              popoverMinWidth: f || "var(--radix-popper-anchor-width)"
            }
          )
        }
      ) })
    ] }) });
  }
), ax = (e) => e.preventDefault(), sx = g("ui-relative ui-h-9 ui-w-9"), $s = g("ui-absolute"), cx = ({ animate: e, className: t, ...n }) => {
  const [r, i] = ue(!1), o = r ? { type: "spring", delay: 0.1, mass: 1, stiffness: 600, damping: 15 } : { type: "spring", delay: 7.2, mass: 1, stiffness: 300, damping: 20 }, s = Q(() => {
    i((a) => !a);
  }, []);
  return /* @__PURE__ */ y.jsxs("div", { ...n, className: g(sx, t), children: [
    /* @__PURE__ */ y.jsxs(
      gr.svg,
      {
        animate: e ? { rotate: r ? 0 : "-30deg" } : void 0,
        transition: o,
        className: $s,
        style: { top: 5, left: 2, zIndex: 1 },
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        onAnimationComplete: s,
        children: [
          /* @__PURE__ */ y.jsx("circle", { cx: "8.91667", cy: "8.91667", r: "8.91667", fill: "#9AB7FF" }),
          /* @__PURE__ */ y.jsx(
            "ellipse",
            {
              cx: "7.34297",
              cy: "7.08081",
              rx: "1.04902",
              ry: "1.31127",
              fill: "#020617"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "ellipse",
            {
              cx: "13.6369",
              cy: "8.12997",
              rx: "1.04902",
              ry: "1.31127",
              fill: "#020617"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M13.4786 11.8789C13.0951 14.0544 11.0205 15.5072 8.84493 15.1237C6.66933 14.7402 5.21657 12.6656 5.6001 10.49C8.7515 11.0456 7.36376 10.8009 9.53936 11.1844C11.715 11.5679 9.93328 11.2539 13.4786 11.8789Z",
              fill: "#020617"
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ y.jsxs(
      gr.svg,
      {
        animate: e ? { rotate: r ? 0 : "15deg" } : void 0,
        transition: o,
        className: $s,
        style: { top: 13, left: 15 },
        width: "19",
        height: "19",
        viewBox: "0 0 19 19",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
          /* @__PURE__ */ y.jsx("circle", { cx: "9.55387", cy: "9.8332", r: "8.91667", fill: "#C4B5FD" }),
          /* @__PURE__ */ y.jsx(
            "ellipse",
            {
              cx: "5.35761",
              cy: "8.52209",
              rx: "1.04902",
              ry: "1.31127",
              fill: "#020617"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "ellipse",
            {
              cx: "11.6516",
              cy: "9.57125",
              rx: "1.04902",
              ry: "1.31127",
              fill: "#020617"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M5.80679 11.8316C6.16152 11.691 6.56634 11.8566 6.711 12.2014C6.8974 12.6459 7.29411 12.9735 7.78579 13.0541C8.27748 13.1348 8.76277 12.9517 9.08878 12.5913C9.34177 12.3116 9.78006 12.2843 10.0677 12.5303C10.3554 12.7762 10.3835 13.2023 10.1305 13.482C9.50892 14.1692 8.55207 14.5476 7.5551 14.3841C6.55813 14.2206 5.78184 13.5581 5.42643 12.7107C5.28177 12.3659 5.45207 11.9723 5.80679 11.8316Z",
              fill: "#020617"
            }
          )
        ]
      }
    )
  ] });
}, lx = g(
  "ui-group ui-flex ui-h-10 ui-items-center ui-gap-2 ui-rounded-full ui-p-3 ui-outline-none ui-transition",
  "ui-bg-primary-100 ui-text-label-200 ui-text-grayscale-950",
  "hover:ui-bg-primary-50 hover:ui-text-primary-600",
  "active:ui-bg-primary-200 active:ui-text-primary-800",
  "focus-visible:ui-shadow-focus",
  "disabled:ui-bg-primary-50 disabled:ui-text-grayscale-500"
), ux = g("-ui-my-3 -ui-ml-1 group-disabled:ui-opacity-30"), lE = ({
  className: e,
  children: t,
  ...n
}) => /* @__PURE__ */ y.jsxs("button", { className: g(lx, e), ...n, children: [
  /* @__PURE__ */ y.jsx(cx, { className: ux, animate: !n.disabled }),
  t
] }), dx = g(
  "ui-flex ui-items-center ui-gap-1 ui-rounded ui-bg-alpha-white-100 ui-p-3 ui-outline-none ui-transition",
  "ui-text-label-200 ui-text-white",
  "hover:ui-bg-alpha-white-200",
  "active:ui-bg-alpha-white-50",
  "focus-visible:ui-bg-alpha-white-50 focus-visible:ui-shadow-focus-dark"
), fx = g("only:-ui-mx-px"), uE = q(
  ({
    as: e,
    children: t,
    icon: n,
    className: r,
    ...i
  }, o) => {
    const s = e || "button";
    return /* @__PURE__ */ y.jsxs(
      s,
      {
        ...i,
        ref: o,
        className: g(r, dx),
        children: [
          n ? /* @__PURE__ */ y.jsx("span", { className: fx, children: n }) : null,
          t ? /* @__PURE__ */ y.jsx("span", { children: t }) : null
        ]
      }
    );
  }
), px = g(
  "ui-relative ui-isolate ui-overflow-hidden ui-rounded-t-[11px] ui-px-4 ui-py-1.5",
  "ui-text-label-200 ui-text-grayscale-500",
  "before:ui-absolute before:ui-inset-0 before:-ui-z-10 before:ui-bg-gradient-linear-gray before:ui-content-['']",
  "group-hover:ui-bg-primary-50 group-hover:before:ui-opacity-0"
), gx = g("ui-mt-auto ui-flex ui-items-center ui-p-4"), hx = g(
  "ui-ml-auto ui-text-grayscale-400 ui-transition group-hover:ui-text-primary-500 group-active:ui-text-primary-900"
), mx = g("ui-p-4"), dE = ({ as: e, header: t, footer: n, children: r, ...i }) => /* @__PURE__ */ y.jsxs(yi, { as: e || "a", ...i, interactive: !0, children: [
  t ? /* @__PURE__ */ y.jsx("header", { className: px, children: t }) : null,
  /* @__PURE__ */ y.jsx("main", { className: mx, children: r }),
  n ? /* @__PURE__ */ y.jsxs("footer", { className: gx, children: [
    n,
    /* @__PURE__ */ y.jsx(Qo, { className: hx })
  ] }) : null
] }), vx = g(
  "ui-flex ui-items-center ui-justify-between ui-gap-2 empty:ui-hidden"
), bx = g("ui-flex ui-items-end empty:ui-hidden"), yx = g(
  "ui-ml-auto ui-shrink-0 ui-text-grayscale-400 ui-transition",
  "group-hover:ui-translate-x-[2px] group-hover:ui-text-primary-500",
  "group-active:ui-text-primary-900"
), xx = g("ui-flex ui-h-full ui-flex-col ui-gap-4 ui-p-5"), wx = g("ui-flex-1"), _x = g("ui-text-heading-h4 ui-text-grayscale-700"), $x = g(
  "ui-whitespace-nowrap ui-text-paragraph-200-regular ui-text-grayscale-500"
), Cx = g("ui-flex ui-flex-wrap ui-gap-x-6 ui-gap-y-1"), Ex = g("ui-flex ui-items-center ui-gap-1"), Ix = g(
  "ui-text-paragraph-100-regular ui-text-grayscale-700"
), Cs = g(
  "ui-absolute ui-inset-0 ui-flex ui-items-center ui-justify-center ui-rounded-[11px] ui-bg-white ui-p-5"
), Sx = g("ui-bg-critical-300 before:ui-hidden"), fE = ({
  className: e,
  as: t,
  interactive: n,
  title: r,
  timePeriod: i,
  legend: o,
  children: s,
  showLoading: a,
  error: c,
  ...u
}) => /* @__PURE__ */ y.jsx(
  yi,
  {
    ...u,
    as: a || c ? void 0 : t,
    interactive: n && !a && !c,
    className: g(e, {
      [Sx]: c && !a
    }),
    children: /* @__PURE__ */ y.jsxs("div", { className: xx, children: [
      /* @__PURE__ */ y.jsxs("header", { className: vx, children: [
        r ? /* @__PURE__ */ y.jsx("div", { className: _x, children: r }) : null,
        i ? /* @__PURE__ */ y.jsx("span", { className: $x, children: i }) : null
      ] }),
      /* @__PURE__ */ y.jsx("div", { className: wx, children: s }),
      /* @__PURE__ */ y.jsxs("footer", { className: bx, children: [
        o ? /* @__PURE__ */ y.jsx("ul", { className: Cx, children: o.map((d, l) => /* @__PURE__ */ y.jsxs("li", { className: Ex, children: [
          /* @__PURE__ */ y.jsx(
            "svg",
            {
              width: "12",
              height: "13",
              viewBox: "0 0 12 13",
              className: d.colorClassName,
              children: /* @__PURE__ */ y.jsx(
                "rect",
                {
                  y: "0.359955",
                  width: "12",
                  height: "12",
                  rx: "3",
                  fill: "currentColor"
                }
              )
            }
          ),
          /* @__PURE__ */ y.jsx("span", { className: Ix, children: d.label })
        ] }, l)) }) : null,
        n ? /* @__PURE__ */ y.jsx(Qo, { className: yx }) : null
      ] }),
      a ? /* @__PURE__ */ y.jsx("div", { className: Cs, children: /* @__PURE__ */ y.jsx(bc, {}) }) : null,
      c && !a ? /* @__PURE__ */ y.jsx("div", { className: Cs, children: /* @__PURE__ */ y.jsx(mh, { ...c }) }) : null
    ] })
  }
), Ox = (e) => /* @__PURE__ */ y.jsxs(
  "svg",
  {
    width: "844",
    height: "794",
    viewBox: "0 0 844 794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: [
      /* @__PURE__ */ y.jsxs("g", { children: [
        /* @__PURE__ */ y.jsxs("g", { filter: "url(#filter0_d_489_7126)", children: [
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M564.27 27.2648L193.751 654.907C191.937 657.984 190.965 661.504 190.931 665.113C190.897 668.721 191.802 672.291 193.557 675.465C195.311 678.64 197.854 681.307 200.927 683.197C204.001 685.088 207.498 686.136 211.069 686.237L429.232 692.35C436.387 692.541 443.434 690.829 449.665 687.384C455.897 683.94 461.096 678.884 464.739 672.723L706.508 263.367C710.152 257.217 712.109 250.176 712.181 242.954C712.254 235.732 710.438 228.586 706.919 222.237L599.659 28.188C597.908 24.9826 595.356 22.2888 592.263 20.3804C589.17 18.472 585.647 17.4174 582.051 17.3236C578.456 17.2298 574.916 18.1001 571.793 19.8463C568.669 21.5926 566.074 24.1521 564.27 27.2648Z",
              fill: "url(#paint0_linear_489_7126)",
              shapeRendering: "crispEdges"
            }
          ),
          /* @__PURE__ */ y.jsx(
            "path",
            {
              d: "M564.411 27.3464L564.41 27.3476L193.891 654.989C192.092 658.042 191.128 661.534 191.094 665.114C191.06 668.694 191.958 672.237 193.699 675.387C195.44 678.536 197.963 681.183 201.013 683.059C204.062 684.934 207.532 685.974 211.073 686.074L429.237 692.187C436.363 692.378 443.38 690.672 449.587 687.242C455.793 683.811 460.97 678.776 464.599 672.64L706.368 263.284L706.504 263.364L706.368 263.284C709.997 257.159 711.947 250.146 712.019 242.952C712.09 235.759 710.282 228.64 706.776 222.316L599.516 28.2668C597.778 25.0854 595.246 22.4125 592.178 20.519C589.109 18.6255 585.614 17.5794 582.047 17.4864C578.48 17.3933 574.97 18.2566 571.872 19.9885C568.775 21.7204 566.2 24.2589 564.411 27.3464Z",
              stroke: "white",
              strokeWidth: "0.325789",
              shapeRendering: "crispEdges"
            }
          )
        ] }),
        /* @__PURE__ */ y.jsx(
          "path",
          {
            d: "M422.878 163.05L142.973 637.196C141.603 639.52 140.869 642.179 140.843 644.906C140.817 647.632 141.501 650.328 142.827 652.726C144.152 655.124 146.073 657.139 148.395 658.567C150.717 659.996 153.359 660.787 156.056 660.864L320.866 665.481C326.271 665.626 331.594 664.332 336.301 661.73C341.009 659.128 344.936 655.309 347.689 650.655L530.33 341.411C533.083 336.765 534.562 331.446 534.617 325.99C534.671 320.535 533.299 315.136 530.641 310.34L449.612 163.748C448.29 161.326 446.362 159.291 444.026 157.849C441.689 156.408 439.027 155.611 436.311 155.54C433.595 155.469 430.921 156.127 428.561 157.446C426.202 158.765 424.241 160.699 422.878 163.05Z",
            fill: "url(#paint1_linear_489_7126)"
          }
        )
      ] }),
      /* @__PURE__ */ y.jsxs("defs", { children: [
        /* @__PURE__ */ y.jsxs(
          "filter",
          {
            id: "filter0_d_489_7126",
            x: "172.252",
            y: "0.133101",
            width: "558.609",
            height: "712.403",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ y.jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ y.jsx(
                "feColorMatrix",
                {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                  result: "hardAlpha"
                }
              ),
              /* @__PURE__ */ y.jsx("feOffset", { dy: "1.49423" }),
              /* @__PURE__ */ y.jsx("feGaussianBlur", { stdDeviation: "9.33892" }),
              /* @__PURE__ */ y.jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
              /* @__PURE__ */ y.jsx(
                "feColorMatrix",
                {
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
                }
              ),
              /* @__PURE__ */ y.jsx(
                "feBlend",
                {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow_489_7126"
                }
              ),
              /* @__PURE__ */ y.jsx(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow_489_7126",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ y.jsxs(
          "linearGradient",
          {
            id: "paint0_linear_489_7126",
            x1: "676.382",
            y1: "240.112",
            x2: "421.192",
            y2: "548.53",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ y.jsx("stop", { stopColor: "#F59842", stopOpacity: "0" }),
              /* @__PURE__ */ y.jsx("stop", { offset: "0.695163", stopColor: "white" })
            ]
          }
        ),
        /* @__PURE__ */ y.jsxs(
          "linearGradient",
          {
            id: "paint1_linear_489_7126",
            x1: "507.572",
            y1: "323.843",
            x2: "314.792",
            y2: "556.834",
            gradientUnits: "userSpaceOnUse",
            children: [
              /* @__PURE__ */ y.jsx("stop", { stopColor: "#F5CE42", stopOpacity: "0" }),
              /* @__PURE__ */ y.jsx("stop", { offset: "0.695163", stopColor: "#E3B278" })
            ]
          }
        )
      ] })
    ]
  }
), Nx = g(
  "ui-group ui-relative ui-isolate ui-flex ui-snap-start ui-flex-col ui-items-start",
  "ui-overflow-hidden ui-rounded-2xl ui-bg-grayscale-200 ui-p-6 ui-pb-5 ui-outline-none ui-transition",
  "focus-visible:ui-shadow-focus"
), Tx = {
  green: g("ui-bg-gradient-linear-bold-green"),
  blue: g("ui-bg-gradient-linear-bold-blue"),
  pink: g("ui-bg-gradient-linear-bold-pink"),
  orange: g("ui-bg-gradient-linear-bold-orange")
}, Rx = g(
  "ui-my-4 ui-text-heading-h4 ui-text-white ui-transition ui-duration-500 group-hover:ui-drop-shadow-glow"
), Px = g(
  "ui-mb-1 ui-text-paragraph-200-regular ui-text-grayscale-50"
), Ax = g(
  "ui-mt-auto ui-self-end ui-text-white ui-transition ui-duration-500",
  "group-hover:-ui-translate-y-0.5 group-hover:ui-translate-x-0.5 group-hover:ui-drop-shadow-glow"
), Es = g(
  "ui-absolute ui-inset-0 ui-isolate -ui-z-10 ui-overflow-hidden ui-rounded-2xl ui-mix-blend-soft-light"
), Mx = g(
  "ui-absolute -ui-left-60 -ui-top-40 ui-opacity-40 ui-transition ui-duration-500",
  "group-hover:-ui-translate-x-4"
), Dx = g(
  "ui-absolute ui-inset-0 ui-opacity-0 ui-transition-opacity ui-duration-500",
  "group-hover:ui-opacity-60 group-active:ui-opacity-0"
), kx = {
  green: "ui-bg-accent-green-400",
  blue: "ui-bg-accent-blue-400",
  pink: "ui-bg-accent-pink-400",
  orange: "ui-bg-accent-orange-400"
}, Lx = {
  green: "accent-green",
  blue: "accent-blue",
  pink: "accent-pink",
  orange: "accent-orange"
}, pE = ({
  as: e,
  className: t,
  variant: n,
  badge: r,
  title: i,
  description: o,
  ...s
}) => {
  const a = e || "a";
  return /* @__PURE__ */ y.jsxs(
    a,
    {
      className: g(
        Nx,
        Tx[n],
        t
      ),
      ...s,
      children: [
        /* @__PURE__ */ y.jsx("div", { className: Es, children: /* @__PURE__ */ y.jsx(
          "div",
          {
            className: g(Dx, kx[n])
          }
        ) }),
        /* @__PURE__ */ y.jsx("div", { className: Es, children: /* @__PURE__ */ y.jsx(Ox, { className: Mx }) }),
        /* @__PURE__ */ y.jsx($b, { size: "sm", variant: Lx[n], children: r }),
        /* @__PURE__ */ y.jsx("div", { className: Rx, children: i }),
        /* @__PURE__ */ y.jsx("div", { className: Px, children: o }),
        /* @__PURE__ */ y.jsx(Qo, { className: Ax })
      ]
    }
  );
}, jx = g("ui-group ui-w-full"), Fx = g("ui-flex"), Bx = g(
  "ui-flex ui-items-center ui-rounded-l-[11px]",
  "ui-bg-primary-50 ui-p-4 ui-text-primary-400 ui-transition",
  "group-hover:ui-text-primary-500"
), Hx = g("ui-flex-1 ui-p-3 ui-pr-0 ui-text-left"), Vx = g(
  "ui-text-paragraph-200-medium ui-text-grayscale-950"
), Ux = g(
  "ui-text-paragraph-200-regular ui-text-grayscale-500"
), Kx = g(
  "ui-mx-3 ui-mb-3 ui-mt-auto ui-text-grayscale-400 ui-transition",
  "group-hover:ui-text-primary-500",
  "group-active:ui-text-primary-900"
), gE = q(
  ({
    as: e = "button",
    className: t,
    title: n,
    description: r,
    icon: i,
    interactive: o = !0,
    ...s
  }, a) => /* @__PURE__ */ y.jsx(
    yi,
    {
      as: e,
      ref: a,
      interactive: o,
      className: g(jx, t),
      ...s,
      children: /* @__PURE__ */ y.jsxs("div", { className: Fx, children: [
        /* @__PURE__ */ y.jsx("div", { className: Bx, children: i }),
        /* @__PURE__ */ y.jsxs("div", { className: Hx, children: [
          /* @__PURE__ */ y.jsx("div", { className: Vx, children: n }),
          /* @__PURE__ */ y.jsx("div", { className: Ux, children: r })
        ] }),
        /* @__PURE__ */ y.jsx($d, { className: Kx })
      ] })
    }
  )
), go = "rovingFocusGroup.onEntryFocus", Wx = {
  bubbles: !1,
  cancelable: !0
}, ra = "RovingFocusGroup", [Ho, Ou, zx] = Kr(ra), [Gx, Nu] = Ye(ra, [
  zx
]), [Yx, qx] = Gx(ra), Xx = /* @__PURE__ */ q((e, t) => /* @__PURE__ */ E(Ho.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ E(Ho.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ E(Jx, M({}, e, {
  ref: t
}))))), Jx = /* @__PURE__ */ q((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: i = !1, dir: o, currentTabStopId: s, defaultCurrentTabStopId: a, onCurrentTabStopIdChange: c, onEntryFocus: u, ...d } = e, l = U(null), f = Re(t, l), p = Qt(o), [m = null, v] = ht({
    prop: s,
    defaultProp: a,
    onChange: c
  }), [_, $] = ue(!1), h = Ve(u), b = Ou(n), w = U(!1), [x, T] = ue(0);
  return te(() => {
    const I = l.current;
    if (I)
      return I.addEventListener(go, h), () => I.removeEventListener(go, h);
  }, [
    h
  ]), /* @__PURE__ */ E(Yx, {
    scope: n,
    orientation: r,
    dir: p,
    loop: i,
    currentTabStopId: m,
    onItemFocus: Q(
      (I) => v(I),
      [
        v
      ]
    ),
    onItemShiftTab: Q(
      () => $(!0),
      []
    ),
    onFocusableItemAdd: Q(
      () => T(
        (I) => I + 1
      ),
      []
    ),
    onFocusableItemRemove: Q(
      () => T(
        (I) => I - 1
      ),
      []
    )
  }, /* @__PURE__ */ E(Oe.div, M({
    tabIndex: _ || x === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: f,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: le(e.onMouseDown, () => {
      w.current = !0;
    }),
    onFocus: le(e.onFocus, (I) => {
      const k = !w.current;
      if (I.target === I.currentTarget && k && !_) {
        const B = new CustomEvent(go, Wx);
        if (I.currentTarget.dispatchEvent(B), !B.defaultPrevented) {
          const V = b().filter(
            (j) => j.focusable
          ), z = V.find(
            (j) => j.active
          ), ne = V.find(
            (j) => j.id === m
          ), D = [
            z,
            ne,
            ...V
          ].filter(Boolean).map(
            (j) => j.ref.current
          );
          Tu(D);
        }
      }
      w.current = !1;
    }),
    onBlur: le(
      e.onBlur,
      () => $(!1)
    )
  })));
}), Zx = "RovingFocusGroupItem", Qx = /* @__PURE__ */ q((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: i = !1, tabStopId: o, ...s } = e, a = Ze(), c = o || a, u = qx(Zx, n), d = u.currentTabStopId === c, l = Ou(n), { onFocusableItemAdd: f, onFocusableItemRemove: p } = u;
  return te(() => {
    if (r)
      return f(), () => p();
  }, [
    r,
    f,
    p
  ]), /* @__PURE__ */ E(Ho.ItemSlot, {
    scope: n,
    id: c,
    focusable: r,
    active: i
  }, /* @__PURE__ */ E(Oe.span, M({
    tabIndex: d ? 0 : -1,
    "data-orientation": u.orientation
  }, s, {
    ref: t,
    onMouseDown: le(e.onMouseDown, (m) => {
      r ? u.onItemFocus(c) : m.preventDefault();
    }),
    onFocus: le(
      e.onFocus,
      () => u.onItemFocus(c)
    ),
    onKeyDown: le(e.onKeyDown, (m) => {
      if (m.key === "Tab" && m.shiftKey) {
        u.onItemShiftTab();
        return;
      }
      if (m.target !== m.currentTarget)
        return;
      const v = nw(m, u.orientation, u.dir);
      if (v !== void 0) {
        m.preventDefault();
        let $ = l().filter(
          (h) => h.focusable
        ).map(
          (h) => h.ref.current
        );
        if (v === "last")
          $.reverse();
        else if (v === "prev" || v === "next") {
          v === "prev" && $.reverse();
          const h = $.indexOf(m.currentTarget);
          $ = u.loop ? rw($, h + 1) : $.slice(h + 1);
        }
        setTimeout(
          () => Tu($)
        );
      }
    })
  })));
}), ew = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function tw(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function nw(e, t, n) {
  const r = tw(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return ew[r];
}
function Tu(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function rw(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const ow = Xx, iw = Qx, aw = [
  "Enter",
  " "
], sw = [
  "ArrowDown",
  "PageUp",
  "Home"
], Ru = [
  "ArrowUp",
  "PageDown",
  "End"
], cw = [
  ...sw,
  ...Ru
], Yr = "Menu", [Vo, lw, uw] = Kr(Yr), [en, Pu] = Ye(Yr, [
  uw,
  wn,
  Nu
]), oa = wn(), Au = Nu(), [dw, Vn] = en(Yr), [fw, ia] = en(Yr), pw = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: s = !0 } = e, a = oa(t), [c, u] = ue(null), d = U(!1), l = Ve(o), f = Qt(i);
  return te(() => {
    const p = () => {
      d.current = !0, document.addEventListener("pointerdown", m, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", m, {
        capture: !0,
        once: !0
      });
    }, m = () => d.current = !1;
    return document.addEventListener("keydown", p, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", p, {
        capture: !0
      }), document.removeEventListener("pointerdown", m, {
        capture: !0
      }), document.removeEventListener("pointermove", m, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ E(di, a, /* @__PURE__ */ E(dw, {
    scope: t,
    open: n,
    onOpenChange: l,
    content: c,
    onContentChange: u
  }, /* @__PURE__ */ E(fw, {
    scope: t,
    onClose: Q(
      () => l(!1),
      [
        l
      ]
    ),
    isUsingKeyboardRef: d,
    dir: f,
    modal: s
  }, r)));
}, gw = /* @__PURE__ */ q((e, t) => {
  const { __scopeMenu: n, ...r } = e, i = oa(n);
  return /* @__PURE__ */ E(fi, M({}, i, r, {
    ref: t
  }));
}), Mu = "MenuPortal", [hw, mw] = en(Mu, {
  forceMount: void 0
}), vw = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Vn(Mu, t);
  return /* @__PURE__ */ E(hw, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ E(tt, {
    present: n || o.open
  }, /* @__PURE__ */ E(gi, {
    asChild: !0,
    container: i
  }, r)));
}, jt = "MenuContent", [bw, Du] = en(jt), yw = /* @__PURE__ */ q((e, t) => {
  const n = mw(jt, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Vn(jt, e.__scopeMenu), s = ia(jt, e.__scopeMenu);
  return /* @__PURE__ */ E(Vo.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ E(tt, {
    present: r || o.open
  }, /* @__PURE__ */ E(Vo.Slot, {
    scope: e.__scopeMenu
  }, s.modal ? /* @__PURE__ */ E(xw, M({}, i, {
    ref: t
  })) : /* @__PURE__ */ E(ww, M({}, i, {
    ref: t
  })))));
}), xw = /* @__PURE__ */ q((e, t) => {
  const n = Vn(jt, e.__scopeMenu), r = U(null), i = Re(t, r);
  return te(() => {
    const o = r.current;
    if (o)
      return fl(o);
  }, []), /* @__PURE__ */ E(ku, M({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: le(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), ww = /* @__PURE__ */ q((e, t) => {
  const n = Vn(jt, e.__scopeMenu);
  return /* @__PURE__ */ E(ku, M({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), ku = /* @__PURE__ */ q((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: i, onOpenAutoFocus: o, onCloseAutoFocus: s, disableOutsidePointerEvents: a, onEntryFocus: c, onEscapeKeyDown: u, onPointerDownOutside: d, onFocusOutside: l, onInteractOutside: f, onDismiss: p, disableOutsideScroll: m, ...v } = e, _ = Vn(jt, n), $ = ia(jt, n), h = oa(n), b = Au(n), w = lw(n), [x, T] = ue(null), I = U(null), k = Re(t, I, _.onContentChange), B = U(0), V = U(""), z = U(0), ne = U(null), oe = U("right"), D = U(0), j = m ? wl : Xo, J = m ? {
    as: xt,
    allowPinchZoom: !0
  } : void 0, S = (X) => {
    var A, F;
    const ie = V.current + X, N = w().filter(
      (Z) => !Z.disabled
    ), R = document.activeElement, P = (A = N.find(
      (Z) => Z.ref.current === R
    )) === null || A === void 0 ? void 0 : A.textValue, O = N.map(
      (Z) => Z.textValue
    ), L = Tw(O, ie, P), W = (F = N.find(
      (Z) => Z.textValue === L
    )) === null || F === void 0 ? void 0 : F.ref.current;
    (function Z(re) {
      V.current = re, window.clearTimeout(B.current), re !== "" && (B.current = window.setTimeout(
        () => Z(""),
        1e3
      ));
    })(ie), W && setTimeout(
      () => W.focus()
    );
  };
  te(() => () => window.clearTimeout(B.current), []), cl();
  const Y = Q((X) => {
    var A, F;
    return oe.current === ((A = ne.current) === null || A === void 0 ? void 0 : A.side) && Pw(X, (F = ne.current) === null || F === void 0 ? void 0 : F.area);
  }, []);
  return /* @__PURE__ */ E(bw, {
    scope: n,
    searchRef: V,
    onItemEnter: Q((X) => {
      Y(X) && X.preventDefault();
    }, [
      Y
    ]),
    onItemLeave: Q((X) => {
      var A;
      Y(X) || ((A = I.current) === null || A === void 0 || A.focus(), T(null));
    }, [
      Y
    ]),
    onTriggerLeave: Q((X) => {
      Y(X) && X.preventDefault();
    }, [
      Y
    ]),
    pointerGraceTimerRef: z,
    onPointerGraceIntentChange: Q((X) => {
      ne.current = X;
    }, [])
  }, /* @__PURE__ */ E(j, J, /* @__PURE__ */ E(ll, {
    asChild: !0,
    trapped: i,
    onMountAutoFocus: le(o, (X) => {
      var A;
      X.preventDefault(), (A = I.current) === null || A === void 0 || A.focus();
    }),
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ E(ri, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onEscapeKeyDown: u,
    onPointerDownOutside: d,
    onFocusOutside: l,
    onInteractOutside: f,
    onDismiss: p
  }, /* @__PURE__ */ E(ow, M({
    asChild: !0
  }, b, {
    dir: $.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: x,
    onCurrentTabStopIdChange: T,
    onEntryFocus: le(c, (X) => {
      $.isUsingKeyboardRef.current || X.preventDefault();
    })
  }), /* @__PURE__ */ E(pi, M({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": Sw(_.open),
    "data-radix-menu-content": "",
    dir: $.dir
  }, h, v, {
    ref: k,
    style: {
      outline: "none",
      ...v.style
    },
    onKeyDown: le(v.onKeyDown, (X) => {
      const F = X.target.closest("[data-radix-menu-content]") === X.currentTarget, ie = X.ctrlKey || X.altKey || X.metaKey, N = X.key.length === 1;
      F && (X.key === "Tab" && X.preventDefault(), !ie && N && S(X.key));
      const R = I.current;
      if (X.target !== R || !cw.includes(X.key))
        return;
      X.preventDefault();
      const O = w().filter(
        (L) => !L.disabled
      ).map(
        (L) => L.ref.current
      );
      Ru.includes(X.key) && O.reverse(), Ow(O);
    }),
    onBlur: le(e.onBlur, (X) => {
      X.currentTarget.contains(X.target) || (window.clearTimeout(B.current), V.current = "");
    }),
    onPointerMove: le(e.onPointerMove, Ko((X) => {
      const A = X.target, F = D.current !== X.clientX;
      if (X.currentTarget.contains(A) && F) {
        const ie = X.clientX > D.current ? "right" : "left";
        oe.current = ie, D.current = X.clientX;
      }
    }))
  })))))));
}), Uo = "MenuItem", Is = "menu.itemSelect", _w = /* @__PURE__ */ q((e, t) => {
  const { disabled: n = !1, onSelect: r, ...i } = e, o = U(null), s = ia(Uo, e.__scopeMenu), a = Du(Uo, e.__scopeMenu), c = Re(t, o), u = U(!1), d = () => {
    const l = o.current;
    if (!n && l) {
      const f = new CustomEvent(Is, {
        bubbles: !0,
        cancelable: !0
      });
      l.addEventListener(
        Is,
        (p) => r == null ? void 0 : r(p),
        {
          once: !0
        }
      ), Gd(l, f), f.defaultPrevented ? u.current = !1 : s.onClose();
    }
  };
  return /* @__PURE__ */ E($w, M({}, i, {
    ref: c,
    disabled: n,
    onClick: le(e.onClick, d),
    onPointerDown: (l) => {
      var f;
      (f = e.onPointerDown) === null || f === void 0 || f.call(e, l), u.current = !0;
    },
    onPointerUp: le(e.onPointerUp, (l) => {
      var f;
      u.current || (f = l.currentTarget) === null || f === void 0 || f.click();
    }),
    onKeyDown: le(e.onKeyDown, (l) => {
      const f = a.searchRef.current !== "";
      n || f && l.key === " " || aw.includes(l.key) && (l.currentTarget.click(), l.preventDefault());
    })
  }));
}), $w = /* @__PURE__ */ q((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, s = Du(Uo, n), a = Au(n), c = U(null), u = Re(t, c), [d, l] = ue(!1), [f, p] = ue("");
  return te(() => {
    const m = c.current;
    if (m) {
      var v;
      p(((v = m.textContent) !== null && v !== void 0 ? v : "").trim());
    }
  }, [
    o.children
  ]), /* @__PURE__ */ E(Vo.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: i ?? f
  }, /* @__PURE__ */ E(iw, M({
    asChild: !0
  }, a, {
    focusable: !r
  }), /* @__PURE__ */ E(Oe.div, M({
    role: "menuitem",
    "data-highlighted": d ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, o, {
    ref: u,
    onPointerMove: le(e.onPointerMove, Ko((m) => {
      r ? s.onItemLeave(m) : (s.onItemEnter(m), m.defaultPrevented || m.currentTarget.focus());
    })),
    onPointerLeave: le(e.onPointerLeave, Ko(
      (m) => s.onItemLeave(m)
    )),
    onFocus: le(
      e.onFocus,
      () => l(!0)
    ),
    onBlur: le(
      e.onBlur,
      () => l(!1)
    )
  }))));
}), Cw = "MenuRadioGroup";
en(Cw, {
  value: void 0,
  onValueChange: () => {
  }
});
const Ew = "MenuItemIndicator";
en(Ew, {
  checked: !1
});
const Iw = "MenuSub";
en(Iw);
function Sw(e) {
  return e ? "open" : "closed";
}
function Ow(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function Nw(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function Tw(e, t, n) {
  const i = t.length > 1 && Array.from(t).every(
    (u) => u === t[0]
  ) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let s = Nw(e, Math.max(o, 0));
  i.length === 1 && (s = s.filter(
    (u) => u !== n
  ));
  const c = s.find(
    (u) => u.toLowerCase().startsWith(i.toLowerCase())
  );
  return c !== n ? c : void 0;
}
function Rw(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, s = t.length - 1; o < t.length; s = o++) {
    const a = t[o].x, c = t[o].y, u = t[s].x, d = t[s].y;
    c > r != d > r && n < (u - a) * (r - c) / (d - c) + a && (i = !i);
  }
  return i;
}
function Pw(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return Rw(n, t);
}
function Ko(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const Aw = pw, Mw = gw, Dw = vw, kw = yw, Lw = _w, Lu = "DropdownMenu", [jw, hE] = Ye(Lu, [
  Pu
]), Un = Pu(), [Fw, ju] = jw(Lu), Bw = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: i, defaultOpen: o, onOpenChange: s, modal: a = !0 } = e, c = Un(t), u = U(null), [d = !1, l] = ht({
    prop: i,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ E(Fw, {
    scope: t,
    triggerId: Ze(),
    triggerRef: u,
    contentId: Ze(),
    open: d,
    onOpenChange: l,
    onOpenToggle: Q(
      () => l(
        (f) => !f
      ),
      [
        l
      ]
    ),
    modal: a
  }, /* @__PURE__ */ E(Aw, M({}, c, {
    open: d,
    onOpenChange: l,
    dir: r,
    modal: a
  }), n));
}, Hw = "DropdownMenuTrigger", Vw = /* @__PURE__ */ q((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, o = ju(Hw, n), s = Un(n);
  return /* @__PURE__ */ E(Mw, M({
    asChild: !0
  }, s), /* @__PURE__ */ E(Oe.button, M({
    type: "button",
    id: o.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": o.open,
    "aria-controls": o.open ? o.contentId : void 0,
    "data-state": o.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, i, {
    ref: ti(t, o.triggerRef),
    onPointerDown: le(e.onPointerDown, (a) => {
      !r && a.button === 0 && a.ctrlKey === !1 && (o.onOpenToggle(), o.open || a.preventDefault());
    }),
    onKeyDown: le(e.onKeyDown, (a) => {
      r || ([
        "Enter",
        " "
      ].includes(a.key) && o.onOpenToggle(), a.key === "ArrowDown" && o.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(a.key) && a.preventDefault());
    })
  })));
}), Uw = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Un(t);
  return /* @__PURE__ */ E(Dw, M({}, r, n));
}, Kw = "DropdownMenuContent", Ww = /* @__PURE__ */ q((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = ju(Kw, n), o = Un(n), s = U(!1);
  return /* @__PURE__ */ E(kw, M({
    id: i.contentId,
    "aria-labelledby": i.triggerId
  }, o, r, {
    ref: t,
    onCloseAutoFocus: le(e.onCloseAutoFocus, (a) => {
      var c;
      s.current || (c = i.triggerRef.current) === null || c === void 0 || c.focus(), s.current = !1, a.preventDefault();
    }),
    onInteractOutside: le(e.onInteractOutside, (a) => {
      const c = a.detail.originalEvent, u = c.button === 0 && c.ctrlKey === !0, d = c.button === 2 || u;
      (!i.modal || d) && (s.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), zw = /* @__PURE__ */ q((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Un(n);
  return /* @__PURE__ */ E(Lw, M({}, i, r, {
    ref: t
  }));
}), Gw = Bw, Yw = Vw, qw = Uw, Xw = Ww, Jw = zw, Zw = g(
  "ui-z-30 ui-flex ui-max-h-[320px] ui-overflow-hidden",
  "ui-rounded-lg ui-border ui-border-grayscale-200 ui-bg-white ui-shadow-gray-lg ui-outline-none"
), Qw = g(
  "ui-group ui-flex ui-cursor-pointer ui-items-center ui-gap-2 ui-px-3.5 ui-py-2.5 ui-outline-none ui-transition",
  "ui-text-paragraph-200-regular ui-text-grayscale-700 data-[highlighted]:ui-bg-primary-50"
), mE = ({
  children: e,
  options: t,
  sameWidth: n,
  onSelect: r,
  align: i = "start"
}) => /* @__PURE__ */ y.jsxs(Gw, { modal: !0, children: [
  /* @__PURE__ */ y.jsx(Yw, { asChild: !0, children: e }),
  /* @__PURE__ */ y.jsx(qw, { children: /* @__PURE__ */ y.jsx(
    Xw,
    {
      className: Zw,
      align: i,
      sideOffset: 8,
      collisionPadding: 8,
      onCloseAutoFocus: e1,
      style: {
        width: n ? "var(--radix-popper-anchor-width)" : void 0
      },
      children: /* @__PURE__ */ y.jsx(Bn, { children: t.map(({ displayLabel: o, label: s, id: a }) => /* @__PURE__ */ y.jsx(
        Jw,
        {
          className: Qw,
          onClick: () => r(a),
          children: o || s
        },
        a
      )) })
    }
  ) })
] }), e1 = (e) => e == null ? void 0 : e.preventDefault(), t1 = "ui-overflow-hidden", n1 = g("ui-border-l ui-border-grayscale-200"), r1 = g(
  "ui-h-full ui-rounded-none ui-border-none ui-px-4"
);
function vE({ label: e, value: t, size: n }) {
  return /* @__PURE__ */ y.jsx(
    Tb,
    {
      label: e,
      value: t,
      size: n,
      readOnly: !0,
      trailingElement: /* @__PURE__ */ y.jsx("div", { className: n1, children: /* @__PURE__ */ y.jsx(
        g1,
        {
          size: "sm",
          value: t,
          type: "button",
          className: r1
        }
      ) }),
      inputContainerClassName: t1
    }
  );
}
const o1 = {
  light: g(
    "ui-bg-grayscale-100 ui-text-grayscale-700",
    "aria-pressed:ui-bg-grayscale-700 aria-pressed:ui-text-success-200",
    "focus-visible:ui-shadow-focus",
    "disabled:ui-text-grayscale-300"
  ),
  dark: g(
    "ui-bg-alpha-white-100 ui-text-white",
    "enabled:hover:ui-bg-alpha-white-200",
    "enabled:aria-pressed:ui-bg-white enabled:aria-pressed:ui-text-success-600",
    "focus-visible:ui-shadow-focus-dark",
    "disabled:ui-text-alpha-white-300"
  )
}, i1 = g(
  "ui-rounded ui-p-1.5 ui-outline-none ui-transition"
), a1 = ({
  value: e,
  theme: t = "light",
  className: n,
  ...r
}) => {
  const { isCopiedToClipboard: i, handleCopyToClipboard: o } = cd(), s = Q(() => {
    o(e);
  }, [e, o]);
  return /* @__PURE__ */ y.jsx(
    vi,
    {
      content: i ? "Copied" : "Copy",
      withArrow: !0,
      side: "top",
      open: i || void 0,
      children: /* @__PURE__ */ y.jsx(
        "button",
        {
          type: "button",
          ...r,
          className: g(i1, o1[t], n),
          onClick: s,
          "aria-pressed": i,
          children: /* @__PURE__ */ y.jsx(Ks, {})
        }
      )
    }
  );
}, s1 = {
  sm: Ks,
  md: Td
}, c1 = {
  sm: Cd,
  md: Rd
}, l1 = {
  light: g(
    "ui-border-grayscale-300 ui-bg-white ui-text-grayscale-700",
    "hover:ui-text-grayscale-600 enabled:hover:ui-border-grayscale-200",
    "focus-visible:ui-shadow-focus",
    "aria-pressed:ui-bg-grayscale-800 aria-pressed:ui-text-white",
    "disabled:ui-text-grayscale-300"
  ),
  dark: g(
    "ui-border-grayscale-500 ui-bg-alpha-white-100 ui-text-white",
    "enabled:hover:ui-border-grayscale-400 enabled:hover:ui-bg-alpha-white-200",
    "focus-visible:ui-shadow-focus-dark",
    "enabled:aria-pressed:ui-bg-white enabled:aria-pressed:ui-text-grayscale-700",
    "disabled:ui-text-alpha-white-300"
  )
}, u1 = {
  sm: g("ui-h-8 ui-px-2"),
  md: g("ui-h-10 ui-px-3")
}, d1 = g(
  "ui-flex ui-items-center ui-gap-2 ui-rounded-lg ui-border ui-text-left ui-text-label-200 ui-outline-none ui-transition"
), f1 = {
  light: g("ui-text-success-200"),
  dark: g("ui-text-success-600")
}, p1 = g("ui-relative"), Ss = g("first:ui-absolute"), g1 = ({
  value: e,
  theme: t = "light",
  size: n = "md",
  className: r,
  children: i = "Copy",
  ...o
}) => {
  const s = s1[n], a = c1[n], { isCopiedToClipboard: c, handleCopyToClipboard: u } = cd(), d = Q(() => {
    u(e);
  }, [e, u]);
  return /* @__PURE__ */ y.jsx(vi, { content: "Copied", withArrow: !0, side: "top", open: c, children: /* @__PURE__ */ y.jsxs(
    "button",
    {
      ...o,
      className: g(
        d1,
        l1[t],
        u1[n],
        r
      ),
      onClick: d,
      "aria-pressed": c,
      children: [
        /* @__PURE__ */ y.jsxs("span", { className: p1, children: [
          /* @__PURE__ */ y.jsx(
            s,
            {
              className: Ss,
              style: { opacity: c ? 0 : 1 }
            }
          ),
          /* @__PURE__ */ y.jsx(
            a,
            {
              className: g(Ss, f1[t]),
              style: { opacity: c ? 1 : 0 }
            }
          )
        ] }),
        i
      ]
    }
  ) });
}, Fu = "Collapsible", [h1, bE] = Ye(Fu), [m1, aa] = h1(Fu), v1 = /* @__PURE__ */ q((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: i, disabled: o, onOpenChange: s, ...a } = e, [c = !1, u] = ht({
    prop: r,
    defaultProp: i,
    onChange: s
  });
  return /* @__PURE__ */ E(m1, {
    scope: n,
    disabled: o,
    contentId: Ze(),
    open: c,
    onOpenToggle: Q(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    )
  }, /* @__PURE__ */ E(Oe.div, M({
    "data-state": sa(c),
    "data-disabled": o ? "" : void 0
  }, a, {
    ref: t
  })));
}), b1 = "CollapsibleTrigger", y1 = /* @__PURE__ */ q((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, i = aa(b1, n);
  return /* @__PURE__ */ E(Oe.button, M({
    type: "button",
    "aria-controls": i.contentId,
    "aria-expanded": i.open || !1,
    "data-state": sa(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    disabled: i.disabled
  }, r, {
    ref: t,
    onClick: le(e.onClick, i.onOpenToggle)
  }));
}), Bu = "CollapsibleContent", x1 = /* @__PURE__ */ q((e, t) => {
  const { forceMount: n, ...r } = e, i = aa(Bu, e.__scopeCollapsible);
  return /* @__PURE__ */ E(
    tt,
    {
      present: n || i.open
    },
    ({ present: o }) => /* @__PURE__ */ E(w1, M({}, r, {
      ref: t,
      present: o
    }))
  );
}), w1 = /* @__PURE__ */ q((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, s = aa(Bu, n), [a, c] = ue(r), u = U(null), d = Re(t, u), l = U(0), f = l.current, p = U(0), m = p.current, v = s.open || a, _ = U(v), $ = U();
  return te(() => {
    const h = requestAnimationFrame(
      () => _.current = !1
    );
    return () => cancelAnimationFrame(h);
  }, []), St(() => {
    const h = u.current;
    if (h) {
      $.current = $.current || {
        transitionDuration: h.style.transitionDuration,
        animationName: h.style.animationName
      }, h.style.transitionDuration = "0s", h.style.animationName = "none";
      const b = h.getBoundingClientRect();
      l.current = b.height, p.current = b.width, _.current || (h.style.transitionDuration = $.current.transitionDuration, h.style.animationName = $.current.animationName), c(r);
    }
  }, [
    s.open,
    r
  ]), /* @__PURE__ */ E(Oe.div, M({
    "data-state": sa(s.open),
    "data-disabled": s.disabled ? "" : void 0,
    id: s.contentId,
    hidden: !v
  }, o, {
    ref: d,
    style: {
      "--radix-collapsible-content-height": f ? `${f}px` : void 0,
      "--radix-collapsible-content-width": m ? `${m}px` : void 0,
      ...e.style
    }
  }), v && i);
});
function sa(e) {
  return e ? "open" : "closed";
}
const _1 = v1, $1 = y1, C1 = x1, E1 = g("ui-rounded-lg ui-bg-grayscale-100"), I1 = g(
  "ui-group ui-px-3.5 ui-py-3 ui-text-left ui-outline-none",
  "ui-flex ui-w-full ui-items-center ui-justify-between",
  "ui-text-heading-h4 ui-text-grayscale-700",
  "ui-rounded-lg focus-visible:ui-shadow-focus"
), S1 = g(
  "ui-h-5 ui-w-5 ui-shrink-0 ui-transition",
  "group-aria-expanded:ui-rotate-180"
), O1 = g(
  "ui-px-3.5 ui-pb-3 ui-text-paragraph-200-regular"
);
function yE({
  title: e,
  className: t,
  titleContainerClassName: n,
  innerContainerClassName: r,
  children: i,
  open: o,
  setOpen: s
}) {
  const [a, c] = ue(!1), u = o ?? a;
  return /* @__PURE__ */ y.jsxs(
    _1,
    {
      className: g(t, E1),
      open: u,
      onOpenChange: s ?? c,
      children: [
        /* @__PURE__ */ y.jsxs(
          $1,
          {
            className: g(n, I1),
            children: [
              e,
              /* @__PURE__ */ y.jsx(jd, { className: S1 })
            ]
          }
        ),
        /* @__PURE__ */ y.jsx(C1, { asChild: !0, forceMount: !0, children: /* @__PURE__ */ y.jsx(
          gr.div,
          {
            initial: !1,
            transition: { duration: 0.15 },
            animate: {
              opacity: u ? 1 : 0,
              height: u ? "auto" : 0,
              visibility: u ? "visible" : void 0,
              overflow: u ? "visible" : void 0,
              transitionEnd: {
                visibility: u ? "visible" : "hidden",
                overflow: u ? "visible" : "hidden"
              }
            },
            children: /* @__PURE__ */ y.jsx("div", { className: g(r, O1), children: i })
          }
        ) })
      ]
    }
  );
}
function N1(e, t) {
  if (e == null)
    return {};
  var n = et(e, t), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (i = 0; i < o.length; i++)
      r = o[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function Wo(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function T1(e) {
  if (Array.isArray(e))
    return Wo(e);
}
function R1(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null)
    return Array.from(e);
}
function P1(e, t) {
  if (e) {
    if (typeof e == "string")
      return Wo(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return Wo(e, t);
  }
}
function A1() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function M1(e) {
  return T1(e) || R1(e) || P1(e) || A1();
}
function Mn(e) {
  "@babel/helpers - typeof";
  return Mn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Mn(e);
}
function D1(e, t) {
  if (Mn(e) !== "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (Mn(r) !== "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function k1(e) {
  var t = D1(e, "string");
  return Mn(t) === "symbol" ? t : String(t);
}
function Hu(e, t, n) {
  return t = k1(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Os(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function dn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Os(Object(n), !0).forEach(function(r) {
      Hu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Os(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function L1(e) {
  var t = e.length;
  if (t === 0 || t === 1)
    return e;
  if (t === 2)
    return [e[0], e[1], "".concat(e[0], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0])];
  if (t === 3)
    return [e[0], e[1], e[2], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0])];
  if (t >= 4)
    return [e[0], e[1], e[2], e[3], "".concat(e[0], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3]), "".concat(e[3], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[0], ".").concat(e[1], ".").concat(e[2], ".").concat(e[3]), "".concat(e[0], ".").concat(e[1], ".").concat(e[3], ".").concat(e[2]), "".concat(e[0], ".").concat(e[2], ".").concat(e[1], ".").concat(e[3]), "".concat(e[0], ".").concat(e[2], ".").concat(e[3], ".").concat(e[1]), "".concat(e[0], ".").concat(e[3], ".").concat(e[1], ".").concat(e[2]), "".concat(e[0], ".").concat(e[3], ".").concat(e[2], ".").concat(e[1]), "".concat(e[1], ".").concat(e[0], ".").concat(e[2], ".").concat(e[3]), "".concat(e[1], ".").concat(e[0], ".").concat(e[3], ".").concat(e[2]), "".concat(e[1], ".").concat(e[2], ".").concat(e[0], ".").concat(e[3]), "".concat(e[1], ".").concat(e[2], ".").concat(e[3], ".").concat(e[0]), "".concat(e[1], ".").concat(e[3], ".").concat(e[0], ".").concat(e[2]), "".concat(e[1], ".").concat(e[3], ".").concat(e[2], ".").concat(e[0]), "".concat(e[2], ".").concat(e[0], ".").concat(e[1], ".").concat(e[3]), "".concat(e[2], ".").concat(e[0], ".").concat(e[3], ".").concat(e[1]), "".concat(e[2], ".").concat(e[1], ".").concat(e[0], ".").concat(e[3]), "".concat(e[2], ".").concat(e[1], ".").concat(e[3], ".").concat(e[0]), "".concat(e[2], ".").concat(e[3], ".").concat(e[0], ".").concat(e[1]), "".concat(e[2], ".").concat(e[3], ".").concat(e[1], ".").concat(e[0]), "".concat(e[3], ".").concat(e[0], ".").concat(e[1], ".").concat(e[2]), "".concat(e[3], ".").concat(e[0], ".").concat(e[2], ".").concat(e[1]), "".concat(e[3], ".").concat(e[1], ".").concat(e[0], ".").concat(e[2]), "".concat(e[3], ".").concat(e[1], ".").concat(e[2], ".").concat(e[0]), "".concat(e[3], ".").concat(e[2], ".").concat(e[0], ".").concat(e[1]), "".concat(e[3], ".").concat(e[2], ".").concat(e[1], ".").concat(e[0])];
}
var ho = {};
function j1(e) {
  if (e.length === 0 || e.length === 1)
    return e;
  var t = e.join(".");
  return ho[t] || (ho[t] = L1(e)), ho[t];
}
function F1(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, r = e.filter(function(o) {
    return o !== "token";
  }), i = j1(r);
  return i.reduce(function(o, s) {
    return dn(dn({}, o), n[s]);
  }, t);
}
function Ns(e) {
  return e.join(" ");
}
function B1(e, t) {
  var n = 0;
  return function(r) {
    return n += 1, r.map(function(i, o) {
      return Vu({
        node: i,
        stylesheet: e,
        useInlineStyles: t,
        key: "code-segment-".concat(n, "-").concat(o)
      });
    });
  };
}
function Vu(e) {
  var t = e.node, n = e.stylesheet, r = e.style, i = r === void 0 ? {} : r, o = e.useInlineStyles, s = e.key, a = t.properties, c = t.type, u = t.tagName, d = t.value;
  if (c === "text")
    return d;
  if (u) {
    var l = B1(n, o), f;
    if (!o)
      f = dn(dn({}, a), {}, {
        className: Ns(a.className)
      });
    else {
      var p = Object.keys(n).reduce(function($, h) {
        return h.split(".").forEach(function(b) {
          $.includes(b) || $.push(b);
        }), $;
      }, []), m = a.className && a.className.includes("token") ? ["token"] : [], v = a.className && m.concat(a.className.filter(function($) {
        return !p.includes($);
      }));
      f = dn(dn({}, a), {}, {
        className: Ns(v) || void 0,
        style: F1(a.className, Object.assign({}, a.style, i), n)
      });
    }
    var _ = l(t.children);
    return /* @__PURE__ */ ke.createElement(u, M({
      key: s
    }, f), _);
  }
}
const H1 = function(e, t) {
  var n = e.listLanguages();
  return n.indexOf(t) !== -1;
};
var V1 = ["language", "children", "style", "customStyle", "codeTagProps", "useInlineStyles", "showLineNumbers", "showInlineLineNumbers", "startingLineNumber", "lineNumberContainerStyle", "lineNumberStyle", "wrapLines", "wrapLongLines", "lineProps", "renderer", "PreTag", "CodeTag", "code", "astGenerator"];
function Ts(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function bt(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ts(Object(n), !0).forEach(function(r) {
      Hu(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ts(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var U1 = /\n/g;
function K1(e) {
  return e.match(U1);
}
function W1(e) {
  var t = e.lines, n = e.startingLineNumber, r = e.style;
  return t.map(function(i, o) {
    var s = o + n;
    return /* @__PURE__ */ ke.createElement("span", {
      key: "line-".concat(o),
      className: "react-syntax-highlighter-line-number",
      style: typeof r == "function" ? r(s) : r
    }, "".concat(s, `
`));
  });
}
function z1(e) {
  var t = e.codeString, n = e.codeStyle, r = e.containerStyle, i = r === void 0 ? {
    float: "left",
    paddingRight: "10px"
  } : r, o = e.numberStyle, s = o === void 0 ? {} : o, a = e.startingLineNumber;
  return /* @__PURE__ */ ke.createElement("code", {
    style: Object.assign({}, n, i)
  }, W1({
    lines: t.replace(/\n$/, "").split(`
`),
    style: s,
    startingLineNumber: a
  }));
}
function G1(e) {
  return "".concat(e.toString().length, ".25em");
}
function Uu(e, t) {
  return {
    type: "element",
    tagName: "span",
    properties: {
      key: "line-number--".concat(e),
      className: ["comment", "linenumber", "react-syntax-highlighter-line-number"],
      style: t
    },
    children: [{
      type: "text",
      value: e
    }]
  };
}
function Ku(e, t, n) {
  var r = {
    display: "inline-block",
    minWidth: G1(n),
    paddingRight: "1em",
    textAlign: "right",
    userSelect: "none"
  }, i = typeof e == "function" ? e(t) : e, o = bt(bt({}, r), i);
  return o;
}
function ur(e) {
  var t = e.children, n = e.lineNumber, r = e.lineNumberStyle, i = e.largestLineNumber, o = e.showInlineLineNumbers, s = e.lineProps, a = s === void 0 ? {} : s, c = e.className, u = c === void 0 ? [] : c, d = e.showLineNumbers, l = e.wrapLongLines, f = typeof a == "function" ? a(n) : a;
  if (f.className = u, n && o) {
    var p = Ku(r, n, i);
    t.unshift(Uu(n, p));
  }
  return l & d && (f.style = bt(bt({}, f.style), {}, {
    display: "flex"
  })), {
    type: "element",
    tagName: "span",
    properties: f,
    children: t
  };
}
function Wu(e) {
  for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], r = 0; r < e.length; r++) {
    var i = e[r];
    if (i.type === "text")
      n.push(ur({
        children: [i],
        className: M1(new Set(t))
      }));
    else if (i.children) {
      var o = t.concat(i.properties.className);
      Wu(i.children, o).forEach(function(s) {
        return n.push(s);
      });
    }
  }
  return n;
}
function Y1(e, t, n, r, i, o, s, a, c) {
  var u, d = Wu(e.value), l = [], f = -1, p = 0;
  function m(x, T) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return ur({
      children: x,
      lineNumber: T,
      lineNumberStyle: a,
      largestLineNumber: s,
      showInlineLineNumbers: i,
      lineProps: n,
      className: I,
      showLineNumbers: r,
      wrapLongLines: c
    });
  }
  function v(x, T) {
    if (r && T && i) {
      var I = Ku(a, T, s);
      x.unshift(Uu(T, I));
    }
    return x;
  }
  function _(x, T) {
    var I = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    return t || I.length > 0 ? m(x, T, I) : v(x, T);
  }
  for (var $ = function() {
    var T = d[p], I = T.children[0].value, k = K1(I);
    if (k) {
      var B = I.split(`
`);
      B.forEach(function(V, z) {
        var ne = r && l.length + o, oe = {
          type: "text",
          value: "".concat(V, `
`)
        };
        if (z === 0) {
          var D = d.slice(f + 1, p).concat(ur({
            children: [oe],
            className: T.properties.className
          })), j = _(D, ne);
          l.push(j);
        } else if (z === B.length - 1) {
          var J = d[p + 1] && d[p + 1].children && d[p + 1].children[0], S = {
            type: "text",
            value: "".concat(V)
          };
          if (J) {
            var Y = ur({
              children: [S],
              className: T.properties.className
            });
            d.splice(p + 1, 0, Y);
          } else {
            var X = [S], A = _(X, ne, T.properties.className);
            l.push(A);
          }
        } else {
          var F = [oe], ie = _(F, ne, T.properties.className);
          l.push(ie);
        }
      }), f = p;
    }
    p++;
  }; p < d.length; )
    $();
  if (f !== d.length - 1) {
    var h = d.slice(f + 1, d.length);
    if (h && h.length) {
      var b = r && l.length + o, w = _(h, b);
      l.push(w);
    }
  }
  return t ? l : (u = []).concat.apply(u, l);
}
function q1(e) {
  var t = e.rows, n = e.stylesheet, r = e.useInlineStyles;
  return t.map(function(i, o) {
    return Vu({
      node: i,
      stylesheet: n,
      useInlineStyles: r,
      key: "code-segement".concat(o)
    });
  });
}
function zu(e) {
  return e && typeof e.highlightAuto < "u";
}
function X1(e) {
  var t = e.astGenerator, n = e.language, r = e.code, i = e.defaultCodeValue;
  if (zu(t)) {
    var o = H1(t, n);
    return n === "text" ? {
      value: i,
      language: "text"
    } : o ? t.highlight(n, r) : t.highlightAuto(r);
  }
  try {
    return n && n !== "text" ? {
      value: t.highlight(r, n)
    } : {
      value: i
    };
  } catch {
    return {
      value: i
    };
  }
}
function J1(e, t) {
  return function(r) {
    var i = r.language, o = r.children, s = r.style, a = s === void 0 ? t : s, c = r.customStyle, u = c === void 0 ? {} : c, d = r.codeTagProps, l = d === void 0 ? {
      className: i ? "language-".concat(i) : void 0,
      style: bt(bt({}, a['code[class*="language-"]']), a['code[class*="language-'.concat(i, '"]')])
    } : d, f = r.useInlineStyles, p = f === void 0 ? !0 : f, m = r.showLineNumbers, v = m === void 0 ? !1 : m, _ = r.showInlineLineNumbers, $ = _ === void 0 ? !0 : _, h = r.startingLineNumber, b = h === void 0 ? 1 : h, w = r.lineNumberContainerStyle, x = r.lineNumberStyle, T = x === void 0 ? {} : x, I = r.wrapLines, k = r.wrapLongLines, B = k === void 0 ? !1 : k, V = r.lineProps, z = V === void 0 ? {} : V, ne = r.renderer, oe = r.PreTag, D = oe === void 0 ? "pre" : oe, j = r.CodeTag, J = j === void 0 ? "code" : j, S = r.code, Y = S === void 0 ? (Array.isArray(o) ? o[0] : o) || "" : S, X = r.astGenerator, A = N1(r, V1);
    X = X || e;
    var F = v ? /* @__PURE__ */ ke.createElement(z1, {
      containerStyle: w,
      codeStyle: l.style || {},
      numberStyle: T,
      startingLineNumber: b,
      codeString: Y
    }) : null, ie = a.hljs || a['pre[class*="language-"]'] || {
      backgroundColor: "#fff"
    }, N = zu(X) ? "hljs" : "prismjs", R = p ? Object.assign({}, A, {
      style: Object.assign({}, ie, u)
    }) : Object.assign({}, A, {
      className: A.className ? "".concat(N, " ").concat(A.className) : N,
      style: Object.assign({}, u)
    });
    if (B ? l.style = bt(bt({}, l.style), {}, {
      whiteSpace: "pre-wrap"
    }) : l.style = bt(bt({}, l.style), {}, {
      whiteSpace: "pre"
    }), !X)
      return /* @__PURE__ */ ke.createElement(D, R, F, /* @__PURE__ */ ke.createElement(J, l, Y));
    (I === void 0 && ne || B) && (I = !0), ne = ne || q1;
    var P = [{
      type: "text",
      value: Y
    }], O = X1({
      astGenerator: X,
      language: i,
      code: Y,
      defaultCodeValue: P
    });
    O.language === null && (O.value = P);
    var L = O.value.length + b, W = Y1(O, I, z, v, $, b, L, T, B);
    return /* @__PURE__ */ ke.createElement(D, R, /* @__PURE__ */ ke.createElement(J, l, !$ && F, ne({
      rows: W,
      stylesheet: a,
      useInlineStyles: p
    })));
  };
}
var tn = {};
function ca(e) {
  return e instanceof Map ? e.clear = e.delete = e.set = function() {
    throw new Error("map is read-only");
  } : e instanceof Set && (e.add = e.clear = e.delete = function() {
    throw new Error("set is read-only");
  }), Object.freeze(e), Object.getOwnPropertyNames(e).forEach(function(t) {
    var n = e[t];
    typeof n == "object" && !Object.isFrozen(n) && ca(n);
  }), e;
}
var Gu = ca, Z1 = ca;
Gu.default = Z1;
class Rs {
  /**
   * @param {CompiledMode} mode
   */
  constructor(t) {
    t.data === void 0 && (t.data = {}), this.data = t.data, this.isMatchIgnored = !1;
  }
  ignoreMatch() {
    this.isMatchIgnored = !0;
  }
}
function mn(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
}
function Lt(e, ...t) {
  const n = /* @__PURE__ */ Object.create(null);
  for (const r in e)
    n[r] = e[r];
  return t.forEach(function(r) {
    for (const i in r)
      n[i] = r[i];
  }), /** @type {T} */
  n;
}
const Q1 = "</span>", Ps = (e) => !!e.kind;
class e_ {
  /**
   * Creates a new HTMLRenderer
   *
   * @param {Tree} parseTree - the parse tree (must support `walk` API)
   * @param {{classPrefix: string}} options
   */
  constructor(t, n) {
    this.buffer = "", this.classPrefix = n.classPrefix, t.walk(this);
  }
  /**
   * Adds texts to the output stream
   *
   * @param {string} text */
  addText(t) {
    this.buffer += mn(t);
  }
  /**
   * Adds a node open to the output stream (if needed)
   *
   * @param {Node} node */
  openNode(t) {
    if (!Ps(t))
      return;
    let n = t.kind;
    t.sublanguage || (n = `${this.classPrefix}${n}`), this.span(n);
  }
  /**
   * Adds a node close to the output stream (if needed)
   *
   * @param {Node} node */
  closeNode(t) {
    Ps(t) && (this.buffer += Q1);
  }
  /**
   * returns the accumulated buffer
  */
  value() {
    return this.buffer;
  }
  // helpers
  /**
   * Builds a span element
   *
   * @param {string} className */
  span(t) {
    this.buffer += `<span class="${t}">`;
  }
}
class la {
  constructor() {
    this.rootNode = { children: [] }, this.stack = [this.rootNode];
  }
  get top() {
    return this.stack[this.stack.length - 1];
  }
  get root() {
    return this.rootNode;
  }
  /** @param {Node} node */
  add(t) {
    this.top.children.push(t);
  }
  /** @param {string} kind */
  openNode(t) {
    const n = { kind: t, children: [] };
    this.add(n), this.stack.push(n);
  }
  closeNode() {
    if (this.stack.length > 1)
      return this.stack.pop();
  }
  closeAllNodes() {
    for (; this.closeNode(); )
      ;
  }
  toJSON() {
    return JSON.stringify(this.rootNode, null, 4);
  }
  /**
   * @typedef { import("./html_renderer").Renderer } Renderer
   * @param {Renderer} builder
   */
  walk(t) {
    return this.constructor._walk(t, this.rootNode);
  }
  /**
   * @param {Renderer} builder
   * @param {Node} node
   */
  static _walk(t, n) {
    return typeof n == "string" ? t.addText(n) : n.children && (t.openNode(n), n.children.forEach((r) => this._walk(t, r)), t.closeNode(n)), t;
  }
  /**
   * @param {Node} node
   */
  static _collapse(t) {
    typeof t != "string" && t.children && (t.children.every((n) => typeof n == "string") ? t.children = [t.children.join("")] : t.children.forEach((n) => {
      la._collapse(n);
    }));
  }
}
class t_ extends la {
  /**
   * @param {*} options
   */
  constructor(t) {
    super(), this.options = t;
  }
  /**
   * @param {string} text
   * @param {string} kind
   */
  addKeyword(t, n) {
    t !== "" && (this.openNode(n), this.addText(t), this.closeNode());
  }
  /**
   * @param {string} text
   */
  addText(t) {
    t !== "" && this.add(t);
  }
  /**
   * @param {Emitter & {root: DataNode}} emitter
   * @param {string} name
   */
  addSublanguage(t, n) {
    const r = t.root;
    r.kind = n, r.sublanguage = !0, this.add(r);
  }
  toHTML() {
    return new e_(this, this.options).value();
  }
  finalize() {
    return !0;
  }
}
function n_(e) {
  return new RegExp(e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "m");
}
function Dn(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function r_(...e) {
  return e.map((n) => Dn(n)).join("");
}
function o_(...e) {
  return "(" + e.map((n) => Dn(n)).join("|") + ")";
}
function i_(e) {
  return new RegExp(e.toString() + "|").exec("").length - 1;
}
function a_(e, t) {
  const n = e && e.exec(t);
  return n && n.index === 0;
}
const s_ = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
function c_(e, t = "|") {
  let n = 0;
  return e.map((r) => {
    n += 1;
    const i = n;
    let o = Dn(r), s = "";
    for (; o.length > 0; ) {
      const a = s_.exec(o);
      if (!a) {
        s += o;
        break;
      }
      s += o.substring(0, a.index), o = o.substring(a.index + a[0].length), a[0][0] === "\\" && a[1] ? s += "\\" + String(Number(a[1]) + i) : (s += a[0], a[0] === "(" && n++);
    }
    return s;
  }).map((r) => `(${r})`).join(t);
}
const l_ = /\b\B/, Yu = "[a-zA-Z]\\w*", ua = "[a-zA-Z_]\\w*", da = "\\b\\d+(\\.\\d+)?", qu = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", Xu = "\\b(0b[01]+)", u_ = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", d_ = (e = {}) => {
  const t = /^#![ ]*\//;
  return e.binary && (e.begin = r_(
    t,
    /.*\b/,
    e.binary,
    /\b.*/
  )), Lt({
    className: "meta",
    begin: t,
    end: /$/,
    relevance: 0,
    /** @type {ModeCallback} */
    "on:begin": (n, r) => {
      n.index !== 0 && r.ignoreMatch();
    }
  }, e);
}, kn = {
  begin: "\\\\[\\s\\S]",
  relevance: 0
}, f_ = {
  className: "string",
  begin: "'",
  end: "'",
  illegal: "\\n",
  contains: [kn]
}, p_ = {
  className: "string",
  begin: '"',
  end: '"',
  illegal: "\\n",
  contains: [kn]
}, Ju = {
  begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
}, qr = function(e, t, n = {}) {
  const r = Lt(
    {
      className: "comment",
      begin: e,
      end: t,
      contains: []
    },
    n
  );
  return r.contains.push(Ju), r.contains.push({
    className: "doctag",
    begin: "(?:TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):",
    relevance: 0
  }), r;
}, g_ = qr("//", "$"), h_ = qr("/\\*", "\\*/"), m_ = qr("#", "$"), v_ = {
  className: "number",
  begin: da,
  relevance: 0
}, b_ = {
  className: "number",
  begin: qu,
  relevance: 0
}, y_ = {
  className: "number",
  begin: Xu,
  relevance: 0
}, x_ = {
  className: "number",
  begin: da + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
  relevance: 0
}, w_ = {
  // this outer rule makes sure we actually have a WHOLE regex and not simply
  // an expression such as:
  //
  //     3 / something
  //
  // (which will then blow up when regex's `illegal` sees the newline)
  begin: /(?=\/[^/\n]*\/)/,
  contains: [{
    className: "regexp",
    begin: /\//,
    end: /\/[gimuy]*/,
    illegal: /\n/,
    contains: [
      kn,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [kn]
      }
    ]
  }]
}, __ = {
  className: "title",
  begin: Yu,
  relevance: 0
}, $_ = {
  className: "title",
  begin: ua,
  relevance: 0
}, C_ = {
  // excludes method names from keyword processing
  begin: "\\.\\s*" + ua,
  relevance: 0
}, E_ = function(e) {
  return Object.assign(
    e,
    {
      /** @type {ModeCallback} */
      "on:begin": (t, n) => {
        n.data._beginMatch = t[1];
      },
      /** @type {ModeCallback} */
      "on:end": (t, n) => {
        n.data._beginMatch !== t[1] && n.ignoreMatch();
      }
    }
  );
};
var nr = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MATCH_NOTHING_RE: l_,
  IDENT_RE: Yu,
  UNDERSCORE_IDENT_RE: ua,
  NUMBER_RE: da,
  C_NUMBER_RE: qu,
  BINARY_NUMBER_RE: Xu,
  RE_STARTERS_RE: u_,
  SHEBANG: d_,
  BACKSLASH_ESCAPE: kn,
  APOS_STRING_MODE: f_,
  QUOTE_STRING_MODE: p_,
  PHRASAL_WORDS_MODE: Ju,
  COMMENT: qr,
  C_LINE_COMMENT_MODE: g_,
  C_BLOCK_COMMENT_MODE: h_,
  HASH_COMMENT_MODE: m_,
  NUMBER_MODE: v_,
  C_NUMBER_MODE: b_,
  BINARY_NUMBER_MODE: y_,
  CSS_NUMBER_MODE: x_,
  REGEXP_MODE: w_,
  TITLE_MODE: __,
  UNDERSCORE_TITLE_MODE: $_,
  METHOD_GUARD: C_,
  END_SAME_AS_BEGIN: E_
});
function I_(e, t) {
  e.input[e.index - 1] === "." && t.ignoreMatch();
}
function S_(e, t) {
  t && e.beginKeywords && (e.begin = "\\b(" + e.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", e.__beforeBegin = I_, e.keywords = e.keywords || e.beginKeywords, delete e.beginKeywords, e.relevance === void 0 && (e.relevance = 0));
}
function O_(e, t) {
  Array.isArray(e.illegal) && (e.illegal = o_(...e.illegal));
}
function N_(e, t) {
  if (e.match) {
    if (e.begin || e.end)
      throw new Error("begin & end are not supported with match");
    e.begin = e.match, delete e.match;
  }
}
function T_(e, t) {
  e.relevance === void 0 && (e.relevance = 1);
}
const R_ = [
  "of",
  "and",
  "for",
  "in",
  "not",
  "or",
  "if",
  "then",
  "parent",
  // common variable name
  "list",
  // common variable name
  "value"
  // common variable name
], P_ = "keyword";
function Zu(e, t, n = P_) {
  const r = {};
  return typeof e == "string" ? i(n, e.split(" ")) : Array.isArray(e) ? i(n, e) : Object.keys(e).forEach(function(o) {
    Object.assign(
      r,
      Zu(e[o], t, o)
    );
  }), r;
  function i(o, s) {
    t && (s = s.map((a) => a.toLowerCase())), s.forEach(function(a) {
      const c = a.split("|");
      r[c[0]] = [o, A_(c[0], c[1])];
    });
  }
}
function A_(e, t) {
  return t ? Number(t) : M_(e) ? 0 : 1;
}
function M_(e) {
  return R_.includes(e.toLowerCase());
}
function D_(e, { plugins: t }) {
  function n(a, c) {
    return new RegExp(
      Dn(a),
      "m" + (e.case_insensitive ? "i" : "") + (c ? "g" : "")
    );
  }
  class r {
    constructor() {
      this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
    }
    // @ts-ignore
    addRule(c, u) {
      u.position = this.position++, this.matchIndexes[this.matchAt] = u, this.regexes.push([u, c]), this.matchAt += i_(c) + 1;
    }
    compile() {
      this.regexes.length === 0 && (this.exec = () => null);
      const c = this.regexes.map((u) => u[1]);
      this.matcherRe = n(c_(c), !0), this.lastIndex = 0;
    }
    /** @param {string} s */
    exec(c) {
      this.matcherRe.lastIndex = this.lastIndex;
      const u = this.matcherRe.exec(c);
      if (!u)
        return null;
      const d = u.findIndex((f, p) => p > 0 && f !== void 0), l = this.matchIndexes[d];
      return u.splice(0, d), Object.assign(u, l);
    }
  }
  class i {
    constructor() {
      this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
    }
    // @ts-ignore
    getMatcher(c) {
      if (this.multiRegexes[c])
        return this.multiRegexes[c];
      const u = new r();
      return this.rules.slice(c).forEach(([d, l]) => u.addRule(d, l)), u.compile(), this.multiRegexes[c] = u, u;
    }
    resumingScanAtSamePosition() {
      return this.regexIndex !== 0;
    }
    considerAll() {
      this.regexIndex = 0;
    }
    // @ts-ignore
    addRule(c, u) {
      this.rules.push([c, u]), u.type === "begin" && this.count++;
    }
    /** @param {string} s */
    exec(c) {
      const u = this.getMatcher(this.regexIndex);
      u.lastIndex = this.lastIndex;
      let d = u.exec(c);
      if (this.resumingScanAtSamePosition() && !(d && d.index === this.lastIndex)) {
        const l = this.getMatcher(0);
        l.lastIndex = this.lastIndex + 1, d = l.exec(c);
      }
      return d && (this.regexIndex += d.position + 1, this.regexIndex === this.count && this.considerAll()), d;
    }
  }
  function o(a) {
    const c = new i();
    return a.contains.forEach((u) => c.addRule(u.begin, { rule: u, type: "begin" })), a.terminatorEnd && c.addRule(a.terminatorEnd, { type: "end" }), a.illegal && c.addRule(a.illegal, { type: "illegal" }), c;
  }
  function s(a, c) {
    const u = (
      /** @type CompiledMode */
      a
    );
    if (a.isCompiled)
      return u;
    [
      // do this early so compiler extensions generally don't have to worry about
      // the distinction between match/begin
      N_
    ].forEach((l) => l(a, c)), e.compilerExtensions.forEach((l) => l(a, c)), a.__beforeBegin = null, [
      S_,
      // do this later so compiler extensions that come earlier have access to the
      // raw array if they wanted to perhaps manipulate it, etc.
      O_,
      // default to 1 relevance if not specified
      T_
    ].forEach((l) => l(a, c)), a.isCompiled = !0;
    let d = null;
    if (typeof a.keywords == "object" && (d = a.keywords.$pattern, delete a.keywords.$pattern), a.keywords && (a.keywords = Zu(a.keywords, e.case_insensitive)), a.lexemes && d)
      throw new Error("ERR: Prefer `keywords.$pattern` to `mode.lexemes`, BOTH are not allowed. (see mode reference) ");
    return d = d || a.lexemes || /\w+/, u.keywordPatternRe = n(d, !0), c && (a.begin || (a.begin = /\B|\b/), u.beginRe = n(a.begin), a.endSameAsBegin && (a.end = a.begin), !a.end && !a.endsWithParent && (a.end = /\B|\b/), a.end && (u.endRe = n(a.end)), u.terminatorEnd = Dn(a.end) || "", a.endsWithParent && c.terminatorEnd && (u.terminatorEnd += (a.end ? "|" : "") + c.terminatorEnd)), a.illegal && (u.illegalRe = n(
      /** @type {RegExp | string} */
      a.illegal
    )), a.contains || (a.contains = []), a.contains = [].concat(...a.contains.map(function(l) {
      return k_(l === "self" ? a : l);
    })), a.contains.forEach(function(l) {
      s(
        /** @type Mode */
        l,
        u
      );
    }), a.starts && s(a.starts, c), u.matcher = o(u), u;
  }
  if (e.compilerExtensions || (e.compilerExtensions = []), e.contains && e.contains.includes("self"))
    throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
  return e.classNameAliases = Lt(e.classNameAliases || {}), s(
    /** @type Mode */
    e
  );
}
function Qu(e) {
  return e ? e.endsWithParent || Qu(e.starts) : !1;
}
function k_(e) {
  return e.variants && !e.cachedVariants && (e.cachedVariants = e.variants.map(function(t) {
    return Lt(e, { variants: null }, t);
  })), e.cachedVariants ? e.cachedVariants : Qu(e) ? Lt(e, { starts: e.starts ? Lt(e.starts) : null }) : Object.isFrozen(e) ? Lt(e) : e;
}
var L_ = "10.7.3";
function j_(e) {
  return !!(e || e === "");
}
function F_(e) {
  const t = {
    props: ["language", "code", "autodetect"],
    data: function() {
      return {
        detectedLanguage: "",
        unknownLanguage: !1
      };
    },
    computed: {
      className() {
        return this.unknownLanguage ? "" : "hljs " + this.detectedLanguage;
      },
      highlighted() {
        if (!this.autoDetect && !e.getLanguage(this.language))
          return console.warn(`The language "${this.language}" you specified could not be found.`), this.unknownLanguage = !0, mn(this.code);
        let r = {};
        return this.autoDetect ? (r = e.highlightAuto(this.code), this.detectedLanguage = r.language) : (r = e.highlight(this.language, this.code, this.ignoreIllegals), this.detectedLanguage = this.language), r.value;
      },
      autoDetect() {
        return !this.language || j_(this.autodetect);
      },
      ignoreIllegals() {
        return !0;
      }
    },
    // this avoids needing to use a whole Vue compilation pipeline just
    // to build Highlight.js
    render(r) {
      return r("pre", {}, [
        r("code", {
          class: this.className,
          domProps: { innerHTML: this.highlighted }
        })
      ]);
    }
    // template: `<pre><code :class="className" v-html="highlighted"></code></pre>`
  };
  return { Component: t, VuePlugin: {
    install(r) {
      r.component("highlightjs", t);
    }
  } };
}
const B_ = {
  "after:highlightElement": ({ el: e, result: t, text: n }) => {
    const r = As(e);
    if (!r.length)
      return;
    const i = document.createElement("div");
    i.innerHTML = t.value, t.value = H_(r, As(i), n);
  }
};
function zo(e) {
  return e.nodeName.toLowerCase();
}
function As(e) {
  const t = [];
  return function n(r, i) {
    for (let o = r.firstChild; o; o = o.nextSibling)
      o.nodeType === 3 ? i += o.nodeValue.length : o.nodeType === 1 && (t.push({
        event: "start",
        offset: i,
        node: o
      }), i = n(o, i), zo(o).match(/br|hr|img|input/) || t.push({
        event: "stop",
        offset: i,
        node: o
      }));
    return i;
  }(e, 0), t;
}
function H_(e, t, n) {
  let r = 0, i = "";
  const o = [];
  function s() {
    return !e.length || !t.length ? e.length ? e : t : e[0].offset !== t[0].offset ? e[0].offset < t[0].offset ? e : t : t[0].event === "start" ? e : t;
  }
  function a(d) {
    function l(f) {
      return " " + f.nodeName + '="' + mn(f.value) + '"';
    }
    i += "<" + zo(d) + [].map.call(d.attributes, l).join("") + ">";
  }
  function c(d) {
    i += "</" + zo(d) + ">";
  }
  function u(d) {
    (d.event === "start" ? a : c)(d.node);
  }
  for (; e.length || t.length; ) {
    let d = s();
    if (i += mn(n.substring(r, d[0].offset)), r = d[0].offset, d === e) {
      o.reverse().forEach(c);
      do
        u(d.splice(0, 1)[0]), d = s();
      while (d === e && d.length && d[0].offset === r);
      o.reverse().forEach(a);
    } else
      d[0].event === "start" ? o.push(d[0].node) : o.pop(), u(d.splice(0, 1)[0]);
  }
  return i + mn(n.substr(r));
}
const Ms = {}, mo = (e) => {
  console.error(e);
}, Ds = (e, ...t) => {
  console.log(`WARN: ${e}`, ...t);
}, ct = (e, t) => {
  Ms[`${e}/${t}`] || (console.log(`Deprecated as of ${e}. ${t}`), Ms[`${e}/${t}`] = !0);
}, vo = mn, ks = Lt, Ls = Symbol("nomatch"), V_ = function(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null), r = [];
  let i = !0;
  const o = /(^(<[^>]+>|\t|)+|\n)/gm, s = "Could not find the language '{}', did you forget to load/include a language module?", a = { disableAutodetect: !0, name: "Plain text", contains: [] };
  let c = {
    noHighlightRe: /^(no-?highlight)$/i,
    languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
    classPrefix: "hljs-",
    tabReplace: null,
    useBR: !1,
    languages: null,
    // beta configuration options, subject to change, welcome to discuss
    // https://github.com/highlightjs/highlight.js/issues/1086
    __emitter: t_
  };
  function u(N) {
    return c.noHighlightRe.test(N);
  }
  function d(N) {
    let R = N.className + " ";
    R += N.parentNode ? N.parentNode.className : "";
    const P = c.languageDetectRe.exec(R);
    if (P) {
      const O = j(P[1]);
      return O || (Ds(s.replace("{}", P[1])), Ds("Falling back to no-highlight mode for this block.", N)), O ? P[1] : "no-highlight";
    }
    return R.split(/\s+/).find((O) => u(O) || j(O));
  }
  function l(N, R, P, O) {
    let L = "", W = "";
    typeof R == "object" ? (L = N, P = R.ignoreIllegals, W = R.language, O = void 0) : (ct("10.7.0", "highlight(lang, code, ...args) has been deprecated."), ct("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), W = N, L = R);
    const Z = {
      code: L,
      language: W
    };
    A("before:highlight", Z);
    const re = Z.result ? Z.result : f(Z.language, Z.code, P, O);
    return re.code = Z.code, A("after:highlight", re), re;
  }
  function f(N, R, P, O) {
    function L(se, ce) {
      const me = je.case_insensitive ? ce[0].toLowerCase() : ce[0];
      return Object.prototype.hasOwnProperty.call(se.keywords, me) && se.keywords[me];
    }
    function W() {
      if (!de.keywords) {
        we.addText(ye);
        return;
      }
      let se = 0;
      de.keywordPatternRe.lastIndex = 0;
      let ce = de.keywordPatternRe.exec(ye), me = "";
      for (; ce; ) {
        me += ye.substring(se, ce.index);
        const $e = L(de, ce);
        if ($e) {
          const [Ge, dt] = $e;
          if (we.addText(me), me = "", st += dt, Ge.startsWith("_"))
            me += ce[0];
          else {
            const In = je.classNameAliases[Ge] || Ge;
            we.addKeyword(ce[0], In);
          }
        } else
          me += ce[0];
        se = de.keywordPatternRe.lastIndex, ce = de.keywordPatternRe.exec(ye);
      }
      me += ye.substr(se), we.addText(me);
    }
    function Z() {
      if (ye === "")
        return;
      let se = null;
      if (typeof de.subLanguage == "string") {
        if (!t[de.subLanguage]) {
          we.addText(ye);
          return;
        }
        se = f(de.subLanguage, ye, !0, Ke[de.subLanguage]), Ke[de.subLanguage] = /** @type {CompiledMode} */
        se.top;
      } else
        se = m(ye, de.subLanguage.length ? de.subLanguage : null);
      de.relevance > 0 && (st += se.relevance), we.addSublanguage(se.emitter, se.language);
    }
    function re() {
      de.subLanguage != null ? Z() : W(), ye = "";
    }
    function fe(se) {
      return se.className && we.openNode(je.classNameAliases[se.className] || se.className), de = Object.create(se, { parent: { value: de } }), de;
    }
    function H(se, ce, me) {
      let $e = a_(se.endRe, me);
      if ($e) {
        if (se["on:end"]) {
          const Ge = new Rs(se);
          se["on:end"](ce, Ge), Ge.isMatchIgnored && ($e = !1);
        }
        if ($e) {
          for (; se.endsParent && se.parent; )
            se = se.parent;
          return se;
        }
      }
      if (se.endsWithParent)
        return H(se.parent, ce, me);
    }
    function ve(se) {
      return de.matcher.regexIndex === 0 ? (ye += se[0], 1) : (Xe = !0, 0);
    }
    function ee(se) {
      const ce = se[0], me = se.rule, $e = new Rs(me), Ge = [me.__beforeBegin, me["on:begin"]];
      for (const dt of Ge)
        if (dt && (dt(se, $e), $e.isMatchIgnored))
          return ve(ce);
      return me && me.endSameAsBegin && (me.endRe = n_(ce)), me.skip ? ye += ce : (me.excludeBegin && (ye += ce), re(), !me.returnBegin && !me.excludeBegin && (ye = ce)), fe(me), me.returnBegin ? 0 : ce.length;
    }
    function be(se) {
      const ce = se[0], me = R.substr(se.index), $e = H(de, se, me);
      if (!$e)
        return Ls;
      const Ge = de;
      Ge.skip ? ye += ce : (Ge.returnEnd || Ge.excludeEnd || (ye += ce), re(), Ge.excludeEnd && (ye = ce));
      do
        de.className && we.closeNode(), !de.skip && !de.subLanguage && (st += de.relevance), de = de.parent;
      while (de !== $e.parent);
      return $e.starts && ($e.endSameAsBegin && ($e.starts.endRe = $e.endRe), fe($e.starts)), Ge.returnEnd ? 0 : ce.length;
    }
    function Te() {
      const se = [];
      for (let ce = de; ce !== je; ce = ce.parent)
        ce.className && se.unshift(ce.className);
      se.forEach((ce) => we.openNode(ce));
    }
    let Ne = {};
    function Le(se, ce) {
      const me = ce && ce[0];
      if (ye += se, me == null)
        return re(), 0;
      if (Ne.type === "begin" && ce.type === "end" && Ne.index === ce.index && me === "") {
        if (ye += R.slice(ce.index, ce.index + 1), !i) {
          const $e = new Error("0 width match regex");
          throw $e.languageName = N, $e.badRule = Ne.rule, $e;
        }
        return 1;
      }
      if (Ne = ce, ce.type === "begin")
        return ee(ce);
      if (ce.type === "illegal" && !P) {
        const $e = new Error('Illegal lexeme "' + me + '" for mode "' + (de.className || "<unnamed>") + '"');
        throw $e.mode = de, $e;
      } else if (ce.type === "end") {
        const $e = be(ce);
        if ($e !== Ls)
          return $e;
      }
      if (ce.type === "illegal" && me === "")
        return 1;
      if (Be > 1e5 && Be > ce.index * 3)
        throw new Error("potential infinite loop, way more iterations than matches");
      return ye += me, me.length;
    }
    const je = j(N);
    if (!je)
      throw mo(s.replace("{}", N)), new Error('Unknown language: "' + N + '"');
    const Ue = D_(je, { plugins: r });
    let Pe = "", de = O || Ue;
    const Ke = {}, we = new c.__emitter(c);
    Te();
    let ye = "", st = 0, We = 0, Be = 0, Xe = !1;
    try {
      for (de.matcher.considerAll(); ; ) {
        Be++, Xe ? Xe = !1 : de.matcher.considerAll(), de.matcher.lastIndex = We;
        const se = de.matcher.exec(R);
        if (!se)
          break;
        const ce = R.substring(We, se.index), me = Le(ce, se);
        We = se.index + me;
      }
      return Le(R.substr(We)), we.closeAllNodes(), we.finalize(), Pe = we.toHTML(), {
        // avoid possible breakage with v10 clients expecting
        // this to always be an integer
        relevance: Math.floor(st),
        value: Pe,
        language: N,
        illegal: !1,
        emitter: we,
        top: de
      };
    } catch (se) {
      if (se.message && se.message.includes("Illegal"))
        return {
          illegal: !0,
          illegalBy: {
            msg: se.message,
            context: R.slice(We - 100, We + 100),
            mode: se.mode
          },
          sofar: Pe,
          relevance: 0,
          value: vo(R),
          emitter: we
        };
      if (i)
        return {
          illegal: !1,
          relevance: 0,
          value: vo(R),
          emitter: we,
          language: N,
          top: de,
          errorRaised: se
        };
      throw se;
    }
  }
  function p(N) {
    const R = {
      relevance: 0,
      emitter: new c.__emitter(c),
      value: vo(N),
      illegal: !1,
      top: a
    };
    return R.emitter.addText(N), R;
  }
  function m(N, R) {
    R = R || c.languages || Object.keys(t);
    const P = p(N), O = R.filter(j).filter(S).map(
      (fe) => f(fe, N, !1)
    );
    O.unshift(P);
    const L = O.sort((fe, H) => {
      if (fe.relevance !== H.relevance)
        return H.relevance - fe.relevance;
      if (fe.language && H.language) {
        if (j(fe.language).supersetOf === H.language)
          return 1;
        if (j(H.language).supersetOf === fe.language)
          return -1;
      }
      return 0;
    }), [W, Z] = L, re = W;
    return re.second_best = Z, re;
  }
  function v(N) {
    return c.tabReplace || c.useBR ? N.replace(o, (R) => R === `
` ? c.useBR ? "<br>" : R : c.tabReplace ? R.replace(/\t/g, c.tabReplace) : R) : N;
  }
  function _(N, R, P) {
    const O = R ? n[R] : P;
    N.classList.add("hljs"), O && N.classList.add(O);
  }
  const $ = {
    "before:highlightElement": ({ el: N }) => {
      c.useBR && (N.innerHTML = N.innerHTML.replace(/\n/g, "").replace(/<br[ /]*>/g, `
`));
    },
    "after:highlightElement": ({ result: N }) => {
      c.useBR && (N.value = N.value.replace(/\n/g, "<br>"));
    }
  }, h = /^(<[^>]+>|\t)+/gm, b = {
    "after:highlightElement": ({ result: N }) => {
      c.tabReplace && (N.value = N.value.replace(
        h,
        (R) => R.replace(/\t/g, c.tabReplace)
      ));
    }
  };
  function w(N) {
    let R = null;
    const P = d(N);
    if (u(P))
      return;
    A(
      "before:highlightElement",
      { el: N, language: P }
    ), R = N;
    const O = R.textContent, L = P ? l(O, { language: P, ignoreIllegals: !0 }) : m(O);
    A("after:highlightElement", { el: N, result: L, text: O }), N.innerHTML = L.value, _(N, P, L.language), N.result = {
      language: L.language,
      // TODO: remove with version 11.0
      re: L.relevance,
      relavance: L.relevance
    }, L.second_best && (N.second_best = {
      language: L.second_best.language,
      // TODO: remove with version 11.0
      re: L.second_best.relevance,
      relavance: L.second_best.relevance
    });
  }
  function x(N) {
    N.useBR && (ct("10.3.0", "'useBR' will be removed entirely in v11.0"), ct("10.3.0", "Please see https://github.com/highlightjs/highlight.js/issues/2559")), c = ks(c, N);
  }
  const T = () => {
    if (T.called)
      return;
    T.called = !0, ct("10.6.0", "initHighlighting() is deprecated.  Use highlightAll() instead."), document.querySelectorAll("pre code").forEach(w);
  };
  function I() {
    ct("10.6.0", "initHighlightingOnLoad() is deprecated.  Use highlightAll() instead."), k = !0;
  }
  let k = !1;
  function B() {
    if (document.readyState === "loading") {
      k = !0;
      return;
    }
    document.querySelectorAll("pre code").forEach(w);
  }
  function V() {
    k && B();
  }
  typeof window < "u" && window.addEventListener && window.addEventListener("DOMContentLoaded", V, !1);
  function z(N, R) {
    let P = null;
    try {
      P = R(e);
    } catch (O) {
      if (mo("Language definition for '{}' could not be registered.".replace("{}", N)), i)
        mo(O);
      else
        throw O;
      P = a;
    }
    P.name || (P.name = N), t[N] = P, P.rawDefinition = R.bind(null, e), P.aliases && J(P.aliases, { languageName: N });
  }
  function ne(N) {
    delete t[N];
    for (const R of Object.keys(n))
      n[R] === N && delete n[R];
  }
  function oe() {
    return Object.keys(t);
  }
  function D(N) {
    ct("10.4.0", "requireLanguage will be removed entirely in v11."), ct("10.4.0", "Please see https://github.com/highlightjs/highlight.js/pull/2844");
    const R = j(N);
    if (R)
      return R;
    throw new Error("The '{}' language is required, but not loaded.".replace("{}", N));
  }
  function j(N) {
    return N = (N || "").toLowerCase(), t[N] || t[n[N]];
  }
  function J(N, { languageName: R }) {
    typeof N == "string" && (N = [N]), N.forEach((P) => {
      n[P.toLowerCase()] = R;
    });
  }
  function S(N) {
    const R = j(N);
    return R && !R.disableAutodetect;
  }
  function Y(N) {
    N["before:highlightBlock"] && !N["before:highlightElement"] && (N["before:highlightElement"] = (R) => {
      N["before:highlightBlock"](
        Object.assign({ block: R.el }, R)
      );
    }), N["after:highlightBlock"] && !N["after:highlightElement"] && (N["after:highlightElement"] = (R) => {
      N["after:highlightBlock"](
        Object.assign({ block: R.el }, R)
      );
    });
  }
  function X(N) {
    Y(N), r.push(N);
  }
  function A(N, R) {
    const P = N;
    r.forEach(function(O) {
      O[P] && O[P](R);
    });
  }
  function F(N) {
    return ct("10.2.0", "fixMarkup will be removed entirely in v11.0"), ct("10.2.0", "Please see https://github.com/highlightjs/highlight.js/issues/2534"), v(N);
  }
  function ie(N) {
    return ct("10.7.0", "highlightBlock will be removed entirely in v12.0"), ct("10.7.0", "Please use highlightElement now."), w(N);
  }
  Object.assign(e, {
    highlight: l,
    highlightAuto: m,
    highlightAll: B,
    fixMarkup: F,
    highlightElement: w,
    // TODO: Remove with v12 API
    highlightBlock: ie,
    configure: x,
    initHighlighting: T,
    initHighlightingOnLoad: I,
    registerLanguage: z,
    unregisterLanguage: ne,
    listLanguages: oe,
    getLanguage: j,
    registerAliases: J,
    requireLanguage: D,
    autoDetection: S,
    inherit: ks,
    addPlugin: X,
    // plugins for frameworks
    vuePlugin: F_(e).VuePlugin
  }), e.debugMode = function() {
    i = !1;
  }, e.safeMode = function() {
    i = !0;
  }, e.versionString = L_;
  for (const N in nr)
    typeof nr[N] == "object" && Gu(nr[N]);
  return Object.assign(e, nr), e.addPlugin($), e.addPlugin(B_), e.addPlugin(b), e;
};
var U_ = V_({}), K_ = U_, ed = { exports: {} };
(function(e) {
  (function() {
    var t;
    t = e.exports = i, t.format = i, t.vsprintf = r, typeof console < "u" && typeof console.log == "function" && (t.printf = n);
    function n() {
      console.log(i.apply(null, arguments));
    }
    function r(o, s) {
      return i.apply(null, [o].concat(s));
    }
    function i(o) {
      for (var s = 1, a = [].slice.call(arguments), c = 0, u = o.length, d = "", l, f = !1, p, m, v = !1, _, $ = function() {
        return a[s++];
      }, h = function() {
        for (var b = ""; /\d/.test(o[c]); )
          b += o[c++], l = o[c];
        return b.length > 0 ? parseInt(b) : null;
      }; c < u; ++c)
        if (l = o[c], f)
          switch (f = !1, l == "." ? (v = !1, l = o[++c]) : l == "0" && o[c + 1] == "." ? (v = !0, c += 2, l = o[c]) : v = !0, _ = h(), l) {
            case "b":
              d += parseInt($(), 10).toString(2);
              break;
            case "c":
              p = $(), typeof p == "string" || p instanceof String ? d += p : d += String.fromCharCode(parseInt(p, 10));
              break;
            case "d":
              d += parseInt($(), 10);
              break;
            case "f":
              m = String(parseFloat($()).toFixed(_ || 6)), d += v ? m : m.replace(/^0/, "");
              break;
            case "j":
              d += JSON.stringify($());
              break;
            case "o":
              d += "0" + parseInt($(), 10).toString(8);
              break;
            case "s":
              d += $();
              break;
            case "x":
              d += "0x" + parseInt($(), 10).toString(16);
              break;
            case "X":
              d += "0x" + parseInt($(), 10).toString(16).toUpperCase();
              break;
            default:
              d += l;
              break;
          }
        else
          l === "%" ? f = !0 : d += l;
      return d;
    }
  })();
})(ed);
var W_ = ed.exports, z_ = W_, Ut = Kt(Error), G_ = Ut;
Ut.eval = Kt(EvalError);
Ut.range = Kt(RangeError);
Ut.reference = Kt(ReferenceError);
Ut.syntax = Kt(SyntaxError);
Ut.type = Kt(TypeError);
Ut.uri = Kt(URIError);
Ut.create = Kt;
function Kt(e) {
  return t.displayName = e.displayName || e.name, t;
  function t(n) {
    return n && (n = z_.apply(null, arguments)), new e(n);
  }
}
var yt = K_, dr = G_;
tn.highlight = td;
tn.highlightAuto = q_;
tn.registerLanguage = X_;
tn.listLanguages = J_;
tn.registerAlias = Z_;
At.prototype.addText = t$;
At.prototype.addKeyword = Q_;
At.prototype.addSublanguage = e$;
At.prototype.openNode = n$;
At.prototype.closeNode = r$;
At.prototype.closeAllNodes = nd;
At.prototype.finalize = nd;
At.prototype.toHTML = o$;
var Y_ = "hljs-";
function td(e, t, n) {
  var r = yt.configure({}), i = n || {}, o = i.prefix, s;
  if (typeof e != "string")
    throw dr("Expected `string` for name, got `%s`", e);
  if (!yt.getLanguage(e))
    throw dr("Unknown language: `%s` is not registered", e);
  if (typeof t != "string")
    throw dr("Expected `string` for value, got `%s`", t);
  if (o == null && (o = Y_), yt.configure({ __emitter: At, classPrefix: o }), s = yt.highlight(t, { language: e, ignoreIllegals: !0 }), yt.configure(r || {}), s.errorRaised)
    throw s.errorRaised;
  return {
    relevance: s.relevance,
    language: s.language,
    value: s.emitter.rootNode.children
  };
}
function q_(e, t) {
  var n = t || {}, r = n.subset || yt.listLanguages();
  n.prefix;
  var i = r.length, o = -1, s, a, c, u;
  if (typeof e != "string")
    throw dr("Expected `string` for value, got `%s`", e);
  for (a = { relevance: 0, language: null, value: [] }, s = { relevance: 0, language: null, value: [] }; ++o < i; )
    u = r[o], yt.getLanguage(u) && (c = td(u, e, t), c.language = u, c.relevance > a.relevance && (a = c), c.relevance > s.relevance && (a = s, s = c));
  return a.language && (s.secondBest = a), s;
}
function X_(e, t) {
  yt.registerLanguage(e, t);
}
function J_() {
  return yt.listLanguages();
}
function Z_(e, t) {
  var n = e, r;
  t && (n = {}, n[e] = t);
  for (r in n)
    yt.registerAliases(n[r], { languageName: r });
}
function At(e) {
  this.options = e, this.rootNode = { children: [] }, this.stack = [this.rootNode];
}
function Q_(e, t) {
  this.openNode(t), this.addText(e), this.closeNode();
}
function e$(e, t) {
  var n = this.stack, r = n[n.length - 1], i = e.rootNode.children, o = t ? {
    type: "element",
    tagName: "span",
    properties: { className: [t] },
    children: i
  } : i;
  r.children = r.children.concat(o);
}
function t$(e) {
  var t = this.stack, n, r;
  e !== "" && (n = t[t.length - 1], r = n.children[n.children.length - 1], r && r.type === "text" ? r.value += e : n.children.push({ type: "text", value: e }));
}
function n$(e) {
  var t = this.stack, n = this.options.classPrefix + e, r = t[t.length - 1], i = {
    type: "element",
    tagName: "span",
    properties: { className: [n] },
    children: []
  };
  r.children.push(i), t.push(i);
}
function r$() {
  this.stack.pop();
}
function o$() {
  return "";
}
function nd() {
}
const js = "[A-Za-z$_][0-9A-Za-z$_]*", i$ = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends"
], a$ = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], s$ = [
  "Intl",
  "DataView",
  "Number",
  "Math",
  "Date",
  "String",
  "RegExp",
  "Object",
  "Function",
  "Boolean",
  "Error",
  "Symbol",
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  "Proxy",
  "Reflect",
  "JSON",
  "Promise",
  "Float64Array",
  "Int16Array",
  "Int32Array",
  "Int8Array",
  "Uint16Array",
  "Uint32Array",
  "Float32Array",
  "Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "ArrayBuffer",
  "BigInt64Array",
  "BigUint64Array",
  "BigInt"
], c$ = [
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], l$ = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], u$ = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "module",
  "global"
  // Node.js
], d$ = [].concat(
  l$,
  u$,
  s$,
  c$
);
function f$(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function Fs(e) {
  return Go("(?=", e, ")");
}
function Go(...e) {
  return e.map((n) => f$(n)).join("");
}
function p$(e) {
  const t = (w, { after: x }) => {
    const T = "</" + w[0].slice(1);
    return w.input.indexOf(T, x) !== -1;
  }, n = js, r = {
    begin: "<>",
    end: "</>"
  }, i = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: (w, x) => {
      const T = w[0].length + w.index, I = w.input[T];
      if (I === "<") {
        x.ignoreMatch();
        return;
      }
      I === ">" && (t(w, { after: T }) || x.ignoreMatch());
    }
  }, o = {
    $pattern: js,
    keyword: i$,
    literal: a$,
    built_in: d$
  }, s = "[0-9](_?[0-9])*", a = `\\.(${s})`, c = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", u = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${c})((${a})|\\.)?|(${a}))[eE][+-]?(${s})\\b` },
      { begin: `\\b(${c})\\b((${a})\\b|\\.)?|(${a})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, d = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: o,
    contains: []
    // defined later
  }, l = {
    begin: "html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        e.BACKSLASH_ESCAPE,
        d
      ],
      subLanguage: "xml"
    }
  }, f = {
    begin: "css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        e.BACKSLASH_ESCAPE,
        d
      ],
      subLanguage: "css"
    }
  }, p = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      e.BACKSLASH_ESCAPE,
      d
    ]
  }, v = {
    className: "comment",
    variants: [
      e.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              className: "doctag",
              begin: "@[A-Za-z]+",
              contains: [
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: n + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      e.C_BLOCK_COMMENT_MODE,
      e.C_LINE_COMMENT_MODE
    ]
  }, _ = [
    e.APOS_STRING_MODE,
    e.QUOTE_STRING_MODE,
    l,
    f,
    p,
    u,
    e.REGEXP_MODE
  ];
  d.contains = _.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: o,
    contains: [
      "self"
    ].concat(_)
  });
  const $ = [].concat(v, d.contains), h = $.concat([
    // eat recursive parens in sub expressions
    {
      begin: /\(/,
      end: /\)/,
      keywords: o,
      contains: ["self"].concat($)
    }
  ]), b = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: o,
    contains: h
  };
  return {
    name: "Javascript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: o,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: h },
    illegal: /#(?![$_A-z])/,
    contains: [
      e.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      {
        label: "use_strict",
        className: "meta",
        relevance: 10,
        begin: /^\s*['"]use (strict|asm)['"]/
      },
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE,
      l,
      f,
      p,
      v,
      u,
      {
        // object attr container
        begin: Go(
          /[{,\n]\s*/,
          // we need to look ahead to make sure that we actually have an
          // attribute coming up so we don't steal a comma from a potential
          // "value" container
          //
          // NOTE: this might not work how you think.  We don't actually always
          // enter this mode and stay.  Instead it might merely match `,
          // <comments up next>` and then immediately end after the , because it
          // fails to find any actual attrs. But this still does the job because
          // it prevents the value contain rule from grabbing this instead and
          // prevening this rule from firing when we actually DO have keys.
          Fs(Go(
            // we also need to allow for multiple possible comments inbetween
            // the first key:value pairing
            /(((\/\/.*$)|(\/\*(\*[^/]|[^*])*\*\/))\s*)*/,
            n + "\\s*:"
          ))
        ),
        relevance: 0,
        contains: [
          {
            className: "attr",
            begin: n + Fs("\\s*:"),
            relevance: 0
          }
        ]
      },
      {
        // "value" container
        begin: "(" + e.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        contains: [
          v,
          e.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + e.UNDERSCORE_IDENT_RE + ")\\s*=>",
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: e.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: o,
                    contains: h
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            className: "",
            begin: /\s/,
            end: /\s*/,
            skip: !0
          },
          {
            // JSX
            variants: [
              { begin: r.begin, end: r.end },
              {
                begin: i.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": i.isTrulyOpeningTag,
                end: i.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: i.begin,
                end: i.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ],
        relevance: 0
      },
      {
        className: "function",
        beginKeywords: "function",
        end: /[{;]/,
        excludeEnd: !0,
        keywords: o,
        contains: [
          "self",
          e.inherit(e.TITLE_MODE, { begin: n }),
          b
        ],
        illegal: /%/
      },
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        className: "function",
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: e.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        contains: [
          b,
          e.inherit(e.TITLE_MODE, { begin: n })
        ]
      },
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        variants: [
          { begin: "\\." + n },
          { begin: "\\$" + n }
        ],
        relevance: 0
      },
      {
        // ES6 class
        className: "class",
        beginKeywords: "class",
        end: /[{;=]/,
        excludeEnd: !0,
        illegal: /[:"[\]]/,
        contains: [
          { beginKeywords: "extends" },
          e.UNDERSCORE_TITLE_MODE
        ]
      },
      {
        begin: /\b(?=constructor)/,
        end: /[{;]/,
        excludeEnd: !0,
        contains: [
          e.inherit(e.TITLE_MODE, { begin: n }),
          "self",
          b
        ]
      },
      {
        begin: "(get|set)\\s+(?=" + n + "\\()",
        end: /\{/,
        keywords: "get set",
        contains: [
          e.inherit(e.TITLE_MODE, { begin: n }),
          { begin: /\(\)/ },
          // eat to avoid empty params
          b
        ]
      },
      {
        begin: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
var g$ = p$;
const h$ = /* @__PURE__ */ Ln(g$);
function m$(e) {
  return e ? typeof e == "string" ? e : e.source : null;
}
function v$(e) {
  return b$("(?=", e, ")");
}
function b$(...e) {
  return e.map((n) => m$(n)).join("");
}
function y$(e) {
  const o = {
    $pattern: /[A-Za-z]\w+|__\w+__/,
    keyword: [
      "and",
      "as",
      "assert",
      "async",
      "await",
      "break",
      "class",
      "continue",
      "def",
      "del",
      "elif",
      "else",
      "except",
      "finally",
      "for",
      "from",
      "global",
      "if",
      "import",
      "in",
      "is",
      "lambda",
      "nonlocal|10",
      "not",
      "or",
      "pass",
      "raise",
      "return",
      "try",
      "while",
      "with",
      "yield"
    ],
    built_in: [
      "__import__",
      "abs",
      "all",
      "any",
      "ascii",
      "bin",
      "bool",
      "breakpoint",
      "bytearray",
      "bytes",
      "callable",
      "chr",
      "classmethod",
      "compile",
      "complex",
      "delattr",
      "dict",
      "dir",
      "divmod",
      "enumerate",
      "eval",
      "exec",
      "filter",
      "float",
      "format",
      "frozenset",
      "getattr",
      "globals",
      "hasattr",
      "hash",
      "help",
      "hex",
      "id",
      "input",
      "int",
      "isinstance",
      "issubclass",
      "iter",
      "len",
      "list",
      "locals",
      "map",
      "max",
      "memoryview",
      "min",
      "next",
      "object",
      "oct",
      "open",
      "ord",
      "pow",
      "print",
      "property",
      "range",
      "repr",
      "reversed",
      "round",
      "set",
      "setattr",
      "slice",
      "sorted",
      "staticmethod",
      "str",
      "sum",
      "super",
      "tuple",
      "type",
      "vars",
      "zip"
    ],
    literal: [
      "__debug__",
      "Ellipsis",
      "False",
      "None",
      "NotImplemented",
      "True"
    ],
    type: [
      "Any",
      "Callable",
      "Coroutine",
      "Dict",
      "List",
      "Literal",
      "Generic",
      "Optional",
      "Sequence",
      "Set",
      "Tuple",
      "Type",
      "Union"
    ]
  }, s = {
    className: "meta",
    begin: /^(>>>|\.\.\.) /
  }, a = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: o,
    illegal: /#/
  }, c = {
    begin: /\{\{/,
    relevance: 0
  }, u = {
    className: "string",
    contains: [e.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
        end: /'''/,
        contains: [
          e.BACKSLASH_ESCAPE,
          s
        ],
        relevance: 10
      },
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
        end: /"""/,
        contains: [
          e.BACKSLASH_ESCAPE,
          s
        ],
        relevance: 10
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'''/,
        end: /'''/,
        contains: [
          e.BACKSLASH_ESCAPE,
          s,
          c,
          a
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"""/,
        end: /"""/,
        contains: [
          e.BACKSLASH_ESCAPE,
          s,
          c,
          a
        ]
      },
      {
        begin: /([uU]|[rR])'/,
        end: /'/,
        relevance: 10
      },
      {
        begin: /([uU]|[rR])"/,
        end: /"/,
        relevance: 10
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])'/,
        end: /'/
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])"/,
        end: /"/
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'/,
        end: /'/,
        contains: [
          e.BACKSLASH_ESCAPE,
          c,
          a
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"/,
        end: /"/,
        contains: [
          e.BACKSLASH_ESCAPE,
          c,
          a
        ]
      },
      e.APOS_STRING_MODE,
      e.QUOTE_STRING_MODE
    ]
  }, d = "[0-9](_?[0-9])*", l = `(\\b(${d}))?\\.(${d})|\\b(${d})\\.`, f = {
    className: "number",
    relevance: 0,
    variants: [
      // exponentfloat, pointfloat
      // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
      // optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      // Note: no leading \b because floats can start with a decimal point
      // and we don't want to mishandle e.g. `fn(.5)`,
      // no trailing \b for pointfloat because it can end with a decimal point
      // and we don't want to mishandle e.g. `0..hex()`; this should be safe
      // because both MUST contain a decimal point and so cannot be confused with
      // the interior part of an identifier
      {
        begin: `(\\b(${d})|(${l}))[eE][+-]?(${d})[jJ]?\\b`
      },
      {
        begin: `(${l})[jJ]?`
      },
      // decinteger, bininteger, octinteger, hexinteger
      // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
      // optionally "long" in Python 2
      // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
      // decinteger is optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: "\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?\\b"
      },
      {
        begin: "\\b0[bB](_?[01])+[lL]?\\b"
      },
      {
        begin: "\\b0[oO](_?[0-7])+[lL]?\\b"
      },
      {
        begin: "\\b0[xX](_?[0-9a-fA-F])+[lL]?\\b"
      },
      // imagnumber (digitpart-based)
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b(${d})[jJ]\\b`
      }
    ]
  }, p = {
    className: "comment",
    begin: v$(/# type:/),
    end: /$/,
    keywords: o,
    contains: [
      {
        // prevent keywords from coloring `type`
        begin: /# type:/
      },
      // comment within a datatype comment includes no keywords
      {
        begin: /#/,
        end: /\b\B/,
        endsWithParent: !0
      }
    ]
  }, m = {
    className: "params",
    variants: [
      // Exclude params in functions without params
      {
        className: "",
        begin: /\(\s*\)/,
        skip: !0
      },
      {
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: o,
        contains: [
          "self",
          s,
          f,
          u,
          e.HASH_COMMENT_MODE
        ]
      }
    ]
  };
  return a.contains = [
    u,
    f,
    s
  ], {
    name: "Python",
    aliases: [
      "py",
      "gyp",
      "ipython"
    ],
    keywords: o,
    illegal: /(<\/|->|\?)|=>/,
    contains: [
      s,
      f,
      {
        // very common convention
        begin: /\bself\b/
      },
      {
        // eat "if" prior to string so that it won't accidentally be
        // labeled as an f-string
        beginKeywords: "if",
        relevance: 0
      },
      u,
      p,
      e.HASH_COMMENT_MODE,
      {
        variants: [
          {
            className: "function",
            beginKeywords: "def"
          },
          {
            className: "class",
            beginKeywords: "class"
          }
        ],
        end: /:/,
        illegal: /[${=;\n,]/,
        contains: [
          e.UNDERSCORE_TITLE_MODE,
          m,
          {
            begin: /->/,
            endsWithParent: !0,
            keywords: o
          }
        ]
      },
      {
        className: "meta",
        begin: /^[\t ]*@/,
        end: /(?=#)|$/,
        contains: [
          f,
          m,
          u
        ]
      }
    ]
  };
}
var x$ = y$;
const w$ = /* @__PURE__ */ Ln(x$);
var rd = J1(tn, {});
rd.registerLanguage = tn.registerLanguage;
const fa = rd, _$ = {
  hljs: {
    display: "block",
    background: "white",
    padding: "0.5em",
    color: "#333333",
    overflowX: "auto"
  },
  "hljs-comment": {
    color: "#969896"
  },
  "hljs-meta": {
    color: "#969896"
  },
  "hljs-variable": {
    color: "#df5000"
  },
  "hljs-template-variable": {
    color: "#df5000"
  },
  "hljs-strong": {
    color: "#df5000"
  },
  "hljs-emphasis": {
    color: "#df5000"
  },
  "hljs-quote": {
    color: "#df5000"
  },
  "hljs-keyword": {
    color: "#d73a49"
  },
  "hljs-selector-tag": {
    color: "#d73a49"
  },
  "hljs-type": {
    color: "#d73a49"
  },
  "hljs-literal": {
    color: "#0086b3"
  },
  "hljs-symbol": {
    color: "#0086b3"
  },
  "hljs-bullet": {
    color: "#0086b3"
  },
  "hljs-attribute": {
    color: "#0086b3"
  },
  "hljs-section": {
    color: "#63a35c"
  },
  "hljs-name": {
    color: "#63a35c"
  },
  "hljs-tag": {
    color: "#333333"
  },
  "hljs-title": {
    color: "#6f42c1"
  },
  "hljs-attr": {
    color: "#6f42c1"
  },
  "hljs-selector-id": {
    color: "#6f42c1"
  },
  "hljs-selector-class": {
    color: "#6f42c1"
  },
  "hljs-selector-attr": {
    color: "#6f42c1"
  },
  "hljs-selector-pseudo": {
    color: "#6f42c1"
  },
  "hljs-addition": {
    color: "#55a532",
    backgroundColor: "#eaffea"
  },
  "hljs-deletion": {
    color: "#bd2c00",
    backgroundColor: "#ffecec"
  },
  "hljs-link": {
    textDecoration: "underline"
  },
  "hljs-number": {
    color: "#005cc5"
  },
  "hljs-string": {
    color: "#032f62"
  }
}, $$ = {
  hljs: {
    display: "block",
    overflowX: "auto",
    padding: "0.5em",
    background: "#000",
    color: "#f8f8f8"
  },
  "hljs-comment": {
    color: "#7c7c7c"
  },
  "hljs-quote": {
    color: "#7c7c7c"
  },
  "hljs-meta": {
    color: "#7c7c7c"
  },
  "hljs-keyword": {
    color: "#96cbfe"
  },
  "hljs-selector-tag": {
    color: "#96cbfe"
  },
  "hljs-tag": {
    color: "#96cbfe"
  },
  "hljs-name": {
    color: "#96cbfe"
  },
  "hljs-attribute": {
    color: "#ffffb6"
  },
  "hljs-selector-id": {
    color: "#ffffb6"
  },
  "hljs-string": {
    color: "#a8ff60"
  },
  "hljs-selector-attr": {
    color: "#a8ff60"
  },
  "hljs-selector-pseudo": {
    color: "#a8ff60"
  },
  "hljs-addition": {
    color: "#a8ff60"
  },
  "hljs-subst": {
    color: "#daefa3"
  },
  "hljs-regexp": {
    color: "#e9c062"
  },
  "hljs-link": {
    color: "#e9c062"
  },
  "hljs-title": {
    color: "#ffffb6"
  },
  "hljs-section": {
    color: "#ffffb6"
  },
  "hljs-type": {
    color: "#ffffb6"
  },
  "hljs-doctag": {
    color: "#ffffb6"
  },
  "hljs-symbol": {
    color: "#c6c5fe"
  },
  "hljs-bullet": {
    color: "#c6c5fe"
  },
  "hljs-variable": {
    color: "#c6c5fe"
  },
  "hljs-template-variable": {
    color: "#c6c5fe"
  },
  "hljs-literal": {
    color: "#c6c5fe"
  },
  "hljs-number": {
    color: "#ff73fd"
  },
  "hljs-deletion": {
    color: "#ff73fd"
  },
  "hljs-emphasis": {
    fontStyle: "italic"
  },
  "hljs-strong": {
    fontWeight: "bold"
  }
};
fa.registerLanguage("javascript", h$);
fa.registerLanguage("python", w$);
const C$ = {
  light: _$,
  dark: $$
}, E$ = ({
  language: e,
  code: t,
  wrapLongLines: n,
  theme: r
}) => /* @__PURE__ */ y.jsx(
  fa,
  {
    language: e,
    style: C$[r],
    customStyle: {
      padding: 0,
      background: "transparent",
      wordBreak: n ? "break-all" : void 0
    },
    codeTagProps: {
      style: { fontSize: "inherit", background: "transparent", padding: 0 }
    },
    wrapLongLines: n,
    children: t
  }
), I$ = (e) => typeof e == "boolean" || e instanceof Boolean, S$ = (e) => typeof e == "number" || e instanceof Number, O$ = (e) => typeof e == "bigint" || e instanceof BigInt, od = (e) => !!e && e instanceof Date, N$ = (e) => typeof e == "string" || e instanceof String, T$ = (e) => Array.isArray(e), R$ = (e) => e instanceof Object && e !== null;
function P$(e) {
  const [t, n] = ue(e());
  return [t, () => n((i) => !i), n];
}
function id(e) {
  let {
    field: t,
    value: n,
    data: r,
    lastElement: i,
    openBracket: o,
    closeBracket: s,
    level: a,
    style: c,
    shouldExpandNode: u
  } = e;
  const d = U(!1), [l, f, p] = P$(() => u(a, n, t));
  te(() => {
    d.current ? p(u(a, n, t)) : d.current = !0;
  }, [u]);
  const m = l ? c.collapseIcon : c.expandIcon, v = a + 1, _ = r.length - 1, $ = (h) => {
    h.key === " " && f();
  };
  return /* @__PURE__ */ E("div", {
    className: c.basicChildStyle,
    role: "list"
  }, /* @__PURE__ */ E("span", {
    className: m,
    role: "button",
    onClick: f,
    onKeyDown: $,
    tabIndex: 0
  }), t && /* @__PURE__ */ E("span", {
    className: c.label
  }, t, ":"), /* @__PURE__ */ E("span", {
    className: c.punctuation
  }, o), l ? /* @__PURE__ */ E("div", null, r.map((h, b) => /* @__PURE__ */ E(ad, {
    key: h[0] || b,
    field: h[0],
    value: h[1],
    style: c,
    lastElement: b === _,
    level: v,
    shouldExpandNode: u
  }))) : /* @__PURE__ */ E("span", {
    className: c.collapsedContent,
    role: "button",
    tabIndex: 0,
    onClick: f,
    onKeyDown: $
  }), /* @__PURE__ */ E("span", {
    className: c.punctuation
  }, s), !i && /* @__PURE__ */ E("span", {
    className: c.punctuation
  }, ","));
}
function A$(e) {
  let {
    field: t,
    value: n,
    style: r,
    lastElement: i,
    shouldExpandNode: o,
    level: s
  } = e;
  return id({
    field: t,
    value: n,
    lastElement: i || !1,
    level: s,
    openBracket: "{",
    closeBracket: "}",
    style: r,
    shouldExpandNode: o,
    data: Object.keys(n).map((a) => [a, n[a]])
  });
}
function M$(e) {
  let {
    field: t,
    value: n,
    style: r,
    lastElement: i,
    level: o,
    shouldExpandNode: s
  } = e;
  return id({
    field: t,
    value: n,
    lastElement: i || !1,
    level: o,
    openBracket: "[",
    closeBracket: "]",
    style: r,
    shouldExpandNode: s,
    data: n.map((a) => [void 0, a])
  });
}
function D$(e) {
  let {
    field: t,
    value: n,
    style: r,
    lastElement: i
  } = e, o = n, s = r.otherValue;
  return n === null ? (o = "null", s = r.nullValue) : n === void 0 ? (o = "undefined", s = r.undefinedValue) : N$(n) ? (o = `"${n}"`, s = r.stringValue) : I$(n) ? (o = n ? "true" : "false", s = r.booleanValue) : S$(n) ? (o = n.toString(), s = r.numberValue) : O$(n) ? (o = `${n.toString()}n`, s = r.numberValue) : od(n) ? o = n.toISOString() : o = n.toString(), t === "" && (t = '""'), /* @__PURE__ */ E("div", {
    className: r.basicChildStyle,
    role: "listitem"
  }, t && /* @__PURE__ */ E("span", {
    className: r.label
  }, t, ":"), /* @__PURE__ */ E("span", {
    className: s
  }, o), !i && /* @__PURE__ */ E("span", {
    className: r.punctuation
  }, ","));
}
function ad(e) {
  const t = e.value;
  return T$(t) ? /* @__PURE__ */ E(M$, Object.assign({}, e)) : R$(t) && !od(t) ? /* @__PURE__ */ E(A$, Object.assign({}, e)) : /* @__PURE__ */ E(D$, Object.assign({}, e));
}
var nt = { "container-base": "_GzYRV", "punctuation-base": "_3eOF8", pointer: "_1MFti", "expander-base": "_f10Tu _1MFti", "expand-icon": "_1UmXx", "collapse-icon": "_1LId0", "collapsed-content-base": "_1pNG9 _1MFti", "container-light": "_2IvMF _GzYRV", "basic-element-style": "_2bkNM", "label-light": "_1MGIk", "punctuation-light": "_3uHL6 _3eOF8", "value-null-light": "_2T6PJ", "value-undefined-light": "_1Gho6", "value-string-light": "_vGjyY", "value-number-light": "_1bQdo", "value-boolean-light": "_3zQKs", "value-other-light": "_1xvuR", "collapse-icon-light": "_oLqym _f10Tu _1MFti _1LId0", "expand-icon-light": "_2AXVT _f10Tu _1MFti _1UmXx", "collapsed-content-light": "_2KJWg _1pNG9 _1MFti", "container-dark": "_11RoI _GzYRV", "expand-icon-dark": "_17H2C _f10Tu _1MFti _1UmXx", "collapse-icon-dark": "_3QHg2 _f10Tu _1MFti _1LId0", "collapsed-content-dark": "_3fDAz _1pNG9 _1MFti", "label-dark": "_2bSDX", "punctuation-dark": "_gsbQL _3eOF8", "value-null-dark": "_LaAZe", "value-undefined-dark": "_GTKgm", "value-string-dark": "_Chy1W", "value-number-dark": "_2bveF", "value-boolean-dark": "_2vRm-", "value-other-dark": "_1prJR" };
const k$ = {
  container: nt["container-light"],
  basicChildStyle: nt["basic-element-style"],
  label: nt["label-light"],
  nullValue: nt["value-null-light"],
  undefinedValue: nt["value-undefined-light"],
  stringValue: nt["value-string-light"],
  booleanValue: nt["value-boolean-light"],
  numberValue: nt["value-number-light"],
  otherValue: nt["value-other-light"],
  punctuation: nt["punctuation-light"],
  collapseIcon: nt["collapse-icon-light"],
  expandIcon: nt["expand-icon-light"],
  collapsedContent: nt["collapsed-content-light"]
}, L$ = () => !0, j$ = (e) => {
  let {
    data: t,
    style: n = k$,
    shouldExpandNode: r = L$
  } = e;
  return /* @__PURE__ */ E("div", {
    className: n.container
  }, /* @__PURE__ */ E(ad, {
    value: t,
    style: n,
    lastElement: !0,
    level: 0,
    shouldExpandNode: r
  }));
}, F$ = ({ data: e }) => /* @__PURE__ */ y.jsx(
  j$,
  {
    data: e,
    style: {
      container: g(""),
      basicChildStyle: g(
        "ui-relative ui-ml-3 ui-whitespace-nowrap ui-text-grayscale-700"
      ),
      label: g("ui-mr-1 ui-text-secondary-700"),
      nullValue: g("ui-text-critical-600"),
      undefinedValue: g("ui-text-critical-600"),
      stringValue: "",
      numberValue: g("ui-text-accent-blue-600"),
      booleanValue: g("ui-text-success-600"),
      punctuation: g("ui-text-grayscale-700"),
      otherValue: "",
      expandIcon: g(
        "ui-absolute -ui-ml-4 -ui-mt-[5px] ui-text-lg ui-text-grayscale-700 ui-opacity-70 after:ui-content-['▸'] hover:ui-opacity-100"
      ),
      collapseIcon: g(
        "ui-absolute -ui-ml-4 -ui-mt-[5px] ui-text-lg ui-text-grayscale-700 ui-opacity-70 after:ui-content-['▾'] hover:ui-opacity-100"
      ),
      collapsedContent: g(
        "ui-text-grayscale-700 ui-opacity-70 after:ui-content-['...'] hover:ui-opacity-100"
      )
    }
  }
), B$ = g(
  "ui-flex ui-flex-col ui-overflow-hidden",
  "ui-rounded-lg ui-border"
), H$ = {
  light: g("ui-border-grayscale-100 ui-bg-grayscale-50"),
  dark: g("ui-border-grayscale-700 ui-bg-grayscale-800")
}, V$ = g("ui-flex ui-gap-2 ui-p-2 ui-pl-4"), U$ = {
  light: g("ui-bg-grayscale-200 ui-text-grayscale-700"),
  dark: g("ui-bg-grayscale-700 ui-text-white")
}, K$ = g("ui-ml-auto"), W$ = g("ui-self-center ui-text-paragraph-200-medium"), z$ = g("ui-flex ui-min-h-0 ui-flex-col ui-px-4"), G$ = g("-ui-mb-3 ui-mt-3 ui-min-h-0"), Y$ = g("-ui-mx-4 -ui-mt-3 ui-min-h-0"), q$ = g(
  "ui-px-4 ui-py-3 ui-font-mono ui-text-code-200"
), X$ = g(
  "data-[orientation=horizontal]:ui-mx-3 data-[orientation=vertical]:ui-my-3"
), J$ = g("ui-flex ui-min-h-0 ui-flex-col ui-pt-3"), Z$ = (e) => {
  try {
    return JSON.parse(e);
  } catch {
    return e;
  }
}, xE = ({
  className: e,
  title: t,
  snippets: n,
  theme: r = "light"
}) => {
  const [i, o] = ue(0), s = r === "light" ? "dark" : "light", a = (u) => /* @__PURE__ */ y.jsx(
    Bn,
    {
      className: Y$,
      scrollBarClassName: X$,
      size: "sm",
      theme: s,
      children: /* @__PURE__ */ y.jsx("div", { className: q$, children: u.language === "json" ? /* @__PURE__ */ y.jsx(F$, { data: Z$(u.code) }) : /* @__PURE__ */ y.jsx(
        E$,
        {
          language: u.language,
          code: u.code,
          wrapLongLines: u.wrapLongLines,
          theme: r
        }
      ) })
    }
  ), c = Q(
    (u) => {
      const d = n[+u];
      if (d != null && d.externalLink)
        return window.open(d.externalLink);
      o(+u);
    },
    [n]
  );
  return /* @__PURE__ */ y.jsxs("div", { className: g(B$, H$[r], e), children: [
    /* @__PURE__ */ y.jsxs("div", { className: g(V$, U$[r]), children: [
      /* @__PURE__ */ y.jsx("div", { className: W$, children: t }),
      /* @__PURE__ */ y.jsx(
        a1,
        {
          className: K$,
          value: n[0].code,
          theme: r
        }
      )
    ] }),
    /* @__PURE__ */ y.jsx("div", { className: z$, children: n.length === 1 ? /* @__PURE__ */ y.jsx("div", { className: J$, children: a(n[0]) }) : /* @__PURE__ */ y.jsx(
      bb,
      {
        size: "sm",
        className: G$,
        theme: s,
        tabs: n.map((u, d) => ({
          value: String(d),
          icon: u.icon,
          trailingIcon: u.externalLink ? /* @__PURE__ */ y.jsx(Ed, {}) : void 0,
          title: u.title || "",
          content: a(u)
        })),
        activeTab: String(i),
        onActiveTabChange: c
      }
    ) })
  ] });
}, Q$ = g("ui-table-header-group"), eC = ({
  as: e,
  className: t,
  ...n
}) => {
  const r = e || "thead";
  return /* @__PURE__ */ y.jsx(
    r,
    {
      role: "rowgroup",
      ...n,
      className: g(Q$, t)
    }
  );
}, tC = g("ui-table-row-group"), nC = ({
  as: e,
  className: t,
  ...n
}) => {
  const r = e || "tbody";
  return /* @__PURE__ */ y.jsx(
    r,
    {
      role: "rowgroup",
      ...n,
      className: g(tC, t)
    }
  );
}, rC = g(
  "ui-table-cell ui-px-3 ui-py-2",
  "ui-bg-grayscale-100 ui-text-start ui-text-paragraph-200-medium ui-text-grayscale-700",
  "group-first:first:ui-rounded-tl-lg group-first:last:ui-rounded-tr-lg",
  "first:ui-pl-4 last:ui-pr-4"
), oC = g(
  "ui-group/sort -ui-mx-2 -ui-my-0.5 ui-flex ui-gap-0.5 ui-rounded ui-px-2 ui-py-0.5"
), iC = g("group-hover/sort:ui-visible", "-ui-mr-1"), aC = g("ui-invisible"), sC = ({
  as: e,
  className: t,
  sort: n,
  onSort: r,
  children: i,
  ...o
}) => {
  const s = e || "th";
  return /* @__PURE__ */ y.jsx(
    s,
    {
      role: "columnheader",
      ...o,
      className: g(rC, t),
      children: r ? /* @__PURE__ */ y.jsxs(Nc, { className: oC, onClick: r, children: [
        i,
        /* @__PURE__ */ y.jsx("div", { className: g(!n && aC, iC), children: n && n === sd.Asc ? /* @__PURE__ */ y.jsx(Pd, {}) : /* @__PURE__ */ y.jsx(zs, {}) })
      ] }) : i
    }
  );
}, cC = g(
  "ui-group ui-table-row ui-bg-white ui-outline-none focus-visible:ui-shadow-focus"
), lC = g(
  "ui-transition-colors hover:ui-bg-primary-50"
), uC = ({
  as: e,
  className: t,
  interactive: n,
  ...r
}) => {
  const i = e || "tr";
  return /* @__PURE__ */ y.jsx(
    i,
    {
      role: "row",
      ...r,
      className: g(
        cC,
        { [lC]: n },
        t
      )
    }
  );
}, dC = g(
  "ui-table-cell ui-p-3 ui-align-middle",
  "ui-border-t ui-border-grayscale-200 ui-text-paragraph-200-regular ui-text-grayscale-950",
  "group-first:ui-border-grayscale-200 group-last:first:ui-rounded-bl-[7px] group-last:last:ui-rounded-br-[7px]",
  "first:ui-pl-4 last:ui-pr-4"
), fC = g("ui-w-full ui-max-w-0"), pC = ({
  as: e,
  className: t,
  fullWidth: n,
  ...r
}) => {
  const i = e || "td";
  return /* @__PURE__ */ y.jsx(
    i,
    {
      role: "gridcell",
      colSpan: n ? 100 : void 0,
      ...r,
      className: g(
        dC,
        n ? fC : null,
        t
      )
    }
  );
};
var sd = /* @__PURE__ */ ((e) => (e.Asc = "asc", e.Desc = "desc", e))(sd || {});
const gC = g(
  "ui-overflow-hidden ui-rounded-lg ui-border ui-border-grayscale-200"
), hC = g("ui-table ui-w-full"), Kn = ({
  as: e,
  className: t,
  children: n
}) => {
  const r = e || "table";
  return /* @__PURE__ */ y.jsx(Bn, { className: g(gC, t), size: "sm", children: /* @__PURE__ */ y.jsx(r, { role: "grid", className: hC, children: n }) });
};
Kn.Header = eC;
Kn.Body = nC;
Kn.Column = sC;
Kn.Row = uC;
Kn.Cell = pC;
const mC = g(
  "ui-overflow-hidden ui-rounded-[20px] ui-bg-grayscale-100 ui-pb-4"
), vC = g(
  "ui-mb-5 ui-px-5 ui-pt-8 ui-text-heading-h2 ui-text-grayscale-950 sm:ui-px-8"
), bC = g(
  "ui-grid ui-auto-cols-[minmax(290px,1fr)] ui-grid-flow-col ui-gap-2.5 ui-px-5 ui-pb-4 ui-pt-1 sm:ui-px-8"
), yC = g("ui-snap-x ui-scroll-px-5 sm:ui-scroll-px-8"), Bs = g(
  "ui-absolute ui-inset-y-0 ui-z-10 ui-w-6",
  "ui-pointer-events-none ui-from-transparent ui-to-grayscale-400/10 ui-transition-opacity",
  "first:ui-left-0 first:ui-bg-gradient-to-l last:ui-right-0 last:ui-bg-gradient-to-r"
), xC = g(
  "ui-relative ui-h-1 ui-w-8 ui-bg-grayscale-500 ui-opacity-30 ui-outline-none ui-transition-opacity",
  "before:ui-absolute before:-ui-inset-y-2 before:ui-inset-x-0 before:ui-content-['']",
  "hover:ui-opacity-100 focus-visible:ui-shadow-focus"
), wE = ({
  children: e,
  title: t,
  className: n,
  ...r
}) => {
  const i = U(null), [o, s] = ue(!1), [a, c] = ue(!1), [u, d] = ue(0), [l, f] = ue(0), p = Q(() => {
    if (!i.current)
      return;
    const $ = i.current.offsetWidth, h = i.current.scrollWidth, b = i.current.scrollLeft, w = h - $ - b;
    s(b > 20), c(w > 20);
  }, []), m = Q(() => {
    if (!i.current)
      return;
    const $ = i.current.offsetWidth, h = i.current.scrollLeft, b = i.current.scrollWidth, w = Math.ceil(b / $);
    if (!Number.isFinite(w))
      return;
    const x = Math.floor(
      (h + $ / 2) / b * w
    );
    d(w), f(x);
  }, []), v = Q(() => {
    p(), m();
  }, [p, m]), _ = Q(
    ($) => {
      if (!i.current)
        return;
      const h = i.current.scrollWidth;
      i.current.scrollTo({
        left: h / u * $,
        behavior: "smooth"
      });
    },
    [u]
  );
  return te(() => {
    v();
    const $ = new ResizeObserver(v);
    return i.current && $.observe(i.current), () => $.disconnect();
  }, [v]), /* @__PURE__ */ y.jsxs("div", { ...r, className: g(mC, n), children: [
    /* @__PURE__ */ y.jsxs(Sc, { children: [
      /* @__PURE__ */ y.jsx(
        "div",
        {
          "aria-hidden": "true",
          className: Bs,
          style: { opacity: o ? 1 : 0 }
        }
      ),
      /* @__PURE__ */ y.jsx("h2", { className: vC, children: t }),
      /* @__PURE__ */ y.jsx(
        Oc,
        {
          ref: i,
          className: yC,
          onScroll: v,
          children: /* @__PURE__ */ y.jsx("div", { className: bC, children: e })
        }
      ),
      /* @__PURE__ */ y.jsx(Eo, { forceMount: !0, orientation: "horizontal" }),
      /* @__PURE__ */ y.jsx(
        "div",
        {
          "aria-hidden": "true",
          className: Bs,
          style: { opacity: a ? 1 : 0 }
        }
      )
    ] }),
    u > 1 ? /* @__PURE__ */ y.jsx("div", { className: "ui-flex ui-justify-center ui-gap-1 ui-py-2", children: Array(u).fill(null).map(($, h) => /* @__PURE__ */ y.jsx(
      "button",
      {
        className: xC,
        style: { opacity: l === h ? 1 : void 0 },
        onClick: () => _(h)
      },
      h
    )) }) : null
  ] });
}, wC = g(
  "-ui-m-0.5 ui-cursor-pointer ui-rounded ui-p-0.5 ui-text-paragraph-200-medium ui-underline ui-outline-none ui-transition focus-visible:ui-shadow-focus",
  "group-data-[intent=info]:hover:ui-text-primary-500 group-data-[intent=info]:active:ui-text-primary-700",
  "group-data-[intent=warning]:hover:ui-text-warning-500 group-data-[intent=warning]:active:ui-text-warning-700",
  "group-data-[intent=error]:hover:ui-text-critical-500 group-data-[intent=error]:active:ui-text-critical-700"
), _C = ({
  as: e,
  className: t,
  ...n
}) => {
  const r = e || "a";
  return /* @__PURE__ */ y.jsx(r, { ...n, className: g(wC, t) });
}, $C = g(
  "ui-group ui-flex ui-items-start ui-gap-2 ui-px-3 ui-py-2 ui-text-paragraph-200-regular"
), CC = g("ui-rounded-xl"), EC = {
  info: g("ui-bg-primary-100 ui-text-primary-900"),
  warning: g("ui-bg-warning-100 ui-text-warning-900"),
  error: g("ui-bg-critical-100 ui-text-critical-900")
}, IC = g("ui-flex-1 ui-text-center"), SC = ({
  className: e,
  intent: t = "info",
  children: n,
  onDismiss: r,
  rounded: i,
  ...o
}) => /* @__PURE__ */ y.jsxs(
  "div",
  {
    ...o,
    className: g(
      $C,
      EC[t],
      { [CC]: i },
      e
    ),
    "data-intent": t,
    role: "banner",
    children: [
      /* @__PURE__ */ y.jsx("div", { className: IC, children: n }),
      r ? /* @__PURE__ */ y.jsx(al, { padding: "sm", onClick: r, children: /* @__PURE__ */ y.jsx(Ad, { "aria-label": "Close" }) }) : null
    ]
  }
);
SC.Link = _C;
const bn = Object.keys(rr).sort(
  (e, t) => parseInt(rr[e], 10) - parseInt(rr[t], 10)
), Hs = Object.fromEntries(
  bn.map((e) => [
    e,
    `(min-width: ${rr[e]})`
  ])
), OC = Object.fromEntries(
  bn.map((e) => [e, !1])
), NC = () => {
  const [e, t] = ue(
    OC
  );
  return te(() => {
    const r = (o) => {
      const s = o.currentTarget, a = bn.filter(
        (c) => Hs[c] === s.media
      );
      a.length !== 0 && t((c) => ({
        ...c,
        ...Object.fromEntries(
          a.map((u) => [u, s.matches])
        )
      }));
    }, i = Object.entries(Hs).map(
      ([o, s]) => {
        const a = window.matchMedia(s);
        return a.addEventListener("change", r), t((c) => ({
          ...c,
          [o]: a.matches
        })), a;
      }
    );
    return () => {
      i.forEach((o) => {
        o.removeEventListener("change", r);
      });
    };
  }, []), [...bn].reverse().find((r) => e[r]);
}, _E = (e) => {
  const t = NC(), n = t ? bn.indexOf(t) : -1, i = [...bn.slice(0, n + 1)].reverse().find((o) => Object.prototype.hasOwnProperty.call(e, o));
  return e[i || "base"];
};
var TC = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var t = document.activeElement, n = [], r = 0; r < e.rangeCount; r++)
    n.push(e.getRangeAt(r));
  switch (t.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      t.blur();
      break;
    default:
      t = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || n.forEach(function(i) {
      e.addRange(i);
    }), t && t.focus();
  };
}, RC = TC, Vs = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, PC = "Copy to clipboard: #{key}, Enter";
function AC(e) {
  var t = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, t);
}
function MC(e, t) {
  var n, r, i, o, s, a, c = !1;
  t || (t = {}), n = t.debug || !1;
  try {
    i = RC(), o = document.createRange(), s = document.getSelection(), a = document.createElement("span"), a.textContent = e, a.ariaHidden = "true", a.style.all = "unset", a.style.position = "fixed", a.style.top = 0, a.style.clip = "rect(0, 0, 0, 0)", a.style.whiteSpace = "pre", a.style.webkitUserSelect = "text", a.style.MozUserSelect = "text", a.style.msUserSelect = "text", a.style.userSelect = "text", a.addEventListener("copy", function(d) {
      if (d.stopPropagation(), t.format)
        if (d.preventDefault(), typeof d.clipboardData > "u") {
          n && console.warn("unable to use e.clipboardData"), n && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var l = Vs[t.format] || Vs.default;
          window.clipboardData.setData(l, e);
        } else
          d.clipboardData.clearData(), d.clipboardData.setData(t.format, e);
      t.onCopy && (d.preventDefault(), t.onCopy(d.clipboardData));
    }), document.body.appendChild(a), o.selectNodeContents(a), s.addRange(o);
    var u = document.execCommand("copy");
    if (!u)
      throw new Error("copy command was unsuccessful");
    c = !0;
  } catch (d) {
    n && console.error("unable to copy using execCommand: ", d), n && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(t.format || "text", e), t.onCopy && t.onCopy(window.clipboardData), c = !0;
    } catch (l) {
      n && console.error("unable to copy using clipboardData: ", l), n && console.error("falling back to prompt"), r = AC("message" in t ? t.message : PC), window.prompt(r, e);
    }
  } finally {
    s && (typeof s.removeRange == "function" ? s.removeRange(o) : s.removeAllRanges()), a && document.body.removeChild(a), i();
  }
  return c;
}
var DC = MC;
const kC = /* @__PURE__ */ Ln(DC);
function cd({ timeout: e = 1500 } = {}) {
  const [t, n] = ue(!1), r = U(), i = () => {
    r.current && clearTimeout(r.current);
  }, o = (s) => {
    i(), kC(s), n(!0), r.current = setTimeout(
      () => n(!1),
      e
    );
  };
  return te(() => () => i(), []), { handleCopyToClipboard: o, isCopiedToClipboard: t };
}
export {
  tE as Alert,
  fE as AnalyticsCard,
  SC as AnnouncementBanner,
  dE as AppCard,
  WC as Avatar,
  $b as Badge,
  oE as Button,
  yi as Card,
  Lf as Checkbox,
  xE as CodeBox,
  Nc as Command,
  a1 as CopyButton,
  vE as CopyField,
  g1 as CopyTextButton,
  yE as Disclosure,
  mE as DropdownMenu,
  mh as ErrorView,
  gE as ExploreCard,
  pE as FeatureCard,
  wE as FeaturesCardDeck,
  kr as FieldInfo,
  vc as FieldInput,
  Hr as FieldLabel,
  al as IconButton,
  nE as Link,
  bc as Loading,
  uE as LowOpacityButton,
  Ov as Modal,
  eE as Radio,
  lE as ReferralButton,
  cx as ReferralIcon,
  Bn as ScrollArea,
  sE as SearchField,
  cE as SelectField,
  JC as Skeleton,
  Kn as Table,
  sd as TableSortOrder,
  bb as Tabs,
  iE as TextAreaField,
  Tb as TextField,
  GC as Toggle,
  vi as Tooltip,
  NC as useBreakpoint,
  _E as useBreakpointValue,
  cd as useCopyToClipboard
};
